import * as React from 'react';
import React__default, { useRef, useEffect, useCallback, useMemo, useState, forwardRef, useLayoutEffect, createContext, useContext, Component } from 'react';
import styled, { css as css$1, keyframes, useTheme } from 'styled-components';
import * as PropTypes from 'prop-types';
import PropTypes__default from 'prop-types';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _extends$3 = unwrapExports(_extends_1);

/**
 * Appends query parameters to a URL. Adds `?` and `&` separators as needed. Keeps the parameters present in the
 * original URL unless they are overwritten with a new parameter with the same key. Array values will be represented
 * in this format: "https://example.com/?a=1&a=2&a=3".
 * @param url The original URL.
 * @param parameters Query parameters to append or overwrite. Can contain array values.
 * @returns The new URL.
 */
const appendQueryParameters = (url, parameters = {}) => {
    const parameterEntries = Object.entries(parameters);
    if (!url || parameterEntries.length === 0) {
        return url;
    }
    const newUrl = new URL(url);
    parameterEntries.forEach(([key, value]) => {
        if (Array.isArray(value)) {
            newUrl.searchParams.delete(key);
            value.forEach((item) => newUrl.searchParams.append(key, item));
        }
        else {
            newUrl.searchParams.set(key, value);
        }
    });
    return newUrl.toString();
};

/**
 * Joins class names, excluding falsy ones.
 * @param {...any} names Any number of class names.
 * @returns {string | undefined} The joined className value.
 */
var classNames = function classNames() {
  for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
    names[_key] = arguments[_key];
  }
  return names.filter(Boolean).join(' ') || undefined;
};

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq$1(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$1;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$1 = _freeGlobal || freeSelf$1 || Function('return this')();

var _root = root$1;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$d.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$d.toString;

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$a.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$c.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$6(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$6;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$2(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$2;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$b = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$9).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var Map$1 = _getNative(_root, 'Map');

var _Map = Map$1;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }
  return hasOwnProperty$8.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$7.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = _hashClear;
Hash$1.prototype['delete'] = _hashDelete;
Hash$1.prototype.get = _hashGet;
Hash$1.prototype.has = _hashHas;
Hash$1.prototype.set = _hashSet;

var _Hash = Hash$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$1(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$1.prototype.clear = _stackClear;
Stack$1.prototype['delete'] = _stackDelete;
Stack$1.prototype.get = _stackGet;
Stack$1.prototype.has = _stackHas;
Stack$1.prototype.set = _stackSet;

var _Stack = Stack$1;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach;

var defineProperty$1 = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$1 = defineProperty$1;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty$1) {
    _defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$6.call(object, key) && eq_1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag$2;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$7.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$5.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

var isArguments_1 = isArguments;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$1 = Array.isArray;

var isArray_1 = isArray$1;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] =
typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] =
typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] =
typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] =
typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] =
typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$2] =
typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] =
typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$4] = typedArrayTags[numberTag$2] =
typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$2] =
typedArrayTags[setTag$4] = typedArrayTags[stringTag$2] =
typedArrayTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$4.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$5;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$3.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, keys_1(source), object);
}

var _baseAssign = baseAssign;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$2.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, keysIn_1(source), object);
}

var _baseAssignIn = baseAssignIn;

var _cloneBuffer = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
});

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$1;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

var stubArray_1 = stubArray;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$2.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols$1 ? stubArray_1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

var _getSymbols = getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

var _copySymbols = copySymbols;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush;

/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray_1 : function(object) {
  var result = [];
  while (object) {
    _arrayPush(result, _getSymbols(object));
    object = _getPrototype(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

var _copySymbolsIn = copySymbolsIn;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn;

/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;

/* Built-in method references that are verified to be native. */
var Promise$1 = _getNative(_root, 'Promise');

var _Promise = Promise$1;

/* Built-in method references that are verified to be native. */
var Set$1 = _getNative(_root, 'Set');

var _Set = Set$1;

/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$3 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$1 = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag$1(new _DataView(new ArrayBuffer(1))) != dataViewTag$2) ||
    (_Map && getTag$1(new _Map) != mapTag$3) ||
    (_Promise && getTag$1(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag$1(new _Set) != setTag$3) ||
    (_WeakMap && getTag$1(new _WeakMap) != weakMapTag$1)) {
  getTag$1 = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$3;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$3;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag$1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$1.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray;

/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

var _Uint8Array = Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$2 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return _cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$1:
      return _cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return _cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor;

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return _cloneRegExp(object);

    case setTag$2:
      return new Ctor;

    case symbolTag$2:
      return _cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject_1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject;

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike_1(value) && _getTag(value) == mapTag$1;
}

var _baseIsMap = baseIsMap;

/* Node.js helper references. */
var nodeIsMap = _nodeUtil && _nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;

var isMap_1 = isMap;

/** `Object#toString` result references. */
var setTag$1 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike_1(value) && _getTag(value) == setTag$1;
}

var _baseIsSet = baseIsSet;

/* Node.js helper references. */
var nodeIsSet = _nodeUtil && _nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;

var isSet_1 = isSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag$1 = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag$1] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$1,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject_1(value)) {
    return value;
  }
  var isArr = isArray_1(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer_1(value)) {
      return _cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? _copySymbolsIn(value, _baseAssignIn(result, value))
          : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet_1(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap_1(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? _getAllKeysIn : _getAllKeys)
    : (isFlat ? keysIn_1 : keys_1);

  var props = isArr ? undefined : keysFunc(value);
  _arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return _baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

var cloneDeep_1 = cloneDeep;

var HEX_REGEX = /^#([0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
var SHORT_FORM_REGEX = /^#(.)(.)(.)(.?)$/;
var RGB_A_REGEX = /rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)?(?:, ?(\d(?:\.\d?))\))?/;

/**
 * Checks if a color is a valid hex color of any length, with or without alpha, starting with #.
 * @param color {string} Color.
 * @returns {boolean} True if the color is a valid hex color.
 */
var isValidHexColor = function isValidHexColor(color) {
  return HEX_REGEX.test(color);
};

/**
 * Converts an #RGBA or #RRGGBBAA color into RRGGBBAA.
 * I.e. removes # and ensures long form.
 * @param color {string} Rgba hex color.
 * @returns {string} Rgba color.
 */
var fromRgbaHexToRgba = function fromRgbaHexToRgba(color) {
  return color.replace(SHORT_FORM_REGEX, '#$1$1$2$2$3$3$4$4').replace('#', '');
};

/**
 *  Checks if color is a valid rgb(a) color.
 * @param color {string} Color
 * @returns {boolean} True if color is valid rgb(a)
 */
var isValidRgb = function isValidRgb(color) {
  return RGB_A_REGEX.test(color);
};

/**
 * Convert rgb(a) color to hex.
 * @param rgba {string} Rgba color string.
 * @returns {string} Hex color string.
 */
var fromRgbaToHex = function fromRgbaToHex() {
  var rgba = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var rgbaValues = rgba.match(/[0-9|.]+/g) || [];
  var hexValues = rgbaValues.map(function (value, index) {
    // Alpha
    if (index === 3) {
      return ~~(value * 255);
    }
    return ~~value;
  }).map(function (value) {
    return value.toString(16).padStart(2, '0');
  }).join('');
  return "#".concat(hexValues);
};

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _typeof = unwrapExports(_typeof_1);

var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};

var NOOP = function NOOP() {
  // intentionally empty
};
var defaultFetcher = function defaultFetcher() {
  return Promise.reject(new Error('No fetcher provided.'));
};
var isFunction$1 = function isFunction(val) {
  return Object.prototype.toString.call(val) === '[object Function]';
};

var isObject$5 = function isObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
};

var isString$2 = function isString(value) {
  return typeof value === 'string' || value instanceof String;
};

var arrayWithHoles = createCommonjsModule(function (module) {
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(arrayWithHoles);

var iterableToArrayLimit = createCommonjsModule(function (module) {
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(iterableToArrayLimit);

var arrayLikeToArray = createCommonjsModule(function (module) {
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(arrayLikeToArray);

var unsupportedIterableToArray = createCommonjsModule(function (module) {
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(unsupportedIterableToArray);

var nonIterableRest = createCommonjsModule(function (module) {
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(nonIterableRest);

var slicedToArray = createCommonjsModule(function (module) {
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _slicedToArray = unwrapExports(slicedToArray);

/**
 * A simple replacement for `lodash/get` function. Gets a value from an object following the path selector
 * @param obj {Record<string,any>|undefined} An object to be analyzed
 * @param path {string | string[]} A path selector
 * @param [defValue=null] Value returned when object did not contain given property
 * @returns {any} The found value. Falls back to `defValue`.
 */
var get = function get(obj, path) {
  var defValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (!path) {
    return defValue;
  }

  // If a string was given, convert the path into an array with parts of selector separated by dots or `[]`
  var pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
  var result = pathArray.reduce(function (prevObj, key) {
    return prevObj === null || prevObj === void 0 ? void 0 : prevObj[key];
  }, obj);
  return result === undefined ? defValue : result;
};

/*
 * liquidjs@10.4.0, https://github.com/harttle/liquidjs
 * (c) 2016-2023 harttle
 * Released under the MIT License.
 */
class Token {
    constructor(kind, input, begin, end, file) {
        this.kind = kind;
        this.input = input;
        this.begin = begin;
        this.end = end;
        this.file = file;
    }
    getText() {
        return this.input.slice(this.begin, this.end);
    }
    getPosition() {
        let [row, col] = [1, 1];
        for (let i = 0; i < this.begin; i++) {
            if (this.input[i] === '\n') {
                row++;
                col = 1;
            }
            else
                col++;
        }
        return [row, col];
    }
    size() {
        return this.end - this.begin;
    }
}

class Drop {
    liquidMethodMissing(key) {
        return undefined;
    }
}

const toString$1 = Object.prototype.toString;
const toLowerCase = String.prototype.toLowerCase;
const hasOwnProperty = Object.hasOwnProperty;
function isString$1(value) {
    return typeof value === 'string';
}
// eslint-disable-next-line @typescript-eslint/ban-types
function isFunction(value) {
    return typeof value === 'function';
}
function isPromise(val) {
    return val && isFunction(val.then);
}
function isIterator(val) {
    return val && isFunction(val.next) && isFunction(val.throw) && isFunction(val.return);
}
function escapeRegex(str) {
    return str.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}
function stringify(value) {
    value = toValue(value);
    if (isString$1(value))
        return value;
    if (isNil(value))
        return '';
    if (isArray(value))
        return value.map(x => stringify(x)).join('');
    return String(value);
}
function toValue(value) {
    return (value instanceof Drop && isFunction(value.valueOf)) ? value.valueOf() : value;
}
function isNumber(value) {
    return typeof value === 'number';
}
function toLiquid(value) {
    if (value && isFunction(value.toLiquid))
        return toLiquid(value.toLiquid());
    return value;
}
function isNil(value) {
    return value == null;
}
function isArray(value) {
    // be compatible with IE 8
    return toString$1.call(value) === '[object Array]';
}
function isIterable(value) {
    return isObject$4(value) && Symbol.iterator in value;
}
/*
 * Iterates over own enumerable string keyed properties of an object and invokes iteratee for each property.
 * The iteratee is invoked with three arguments: (value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning false.
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @return {Object} Returns object.
 */
function forOwn(obj, iteratee) {
    obj = obj || {};
    for (const k in obj) {
        if (hasOwnProperty.call(obj, k)) {
            if (iteratee(obj[k], k, obj) === false)
                break;
        }
    }
    return obj;
}
function last$1(arr) {
    return arr[arr.length - 1];
}
/*
 * Checks if value is the language type of Object.
 * (e.g. arrays, functions, objects, regexes, new Number(0), and new String(''))
 * @param {any} value The value to check.
 * @return {Boolean} Returns true if value is an object, else false.
 */
function isObject$4(value) {
    const type = typeof value;
    return value !== null && (type === 'object' || type === 'function');
}
function range(start, stop, step = 1) {
    const arr = [];
    for (let i = start; i < stop; i += step) {
        arr.push(i);
    }
    return arr;
}
function padStart(str, length, ch = ' ') {
    return pad(str, length, ch, (str, ch) => ch + str);
}
function padEnd(str, length, ch = ' ') {
    return pad(str, length, ch, (str, ch) => str + ch);
}
function pad(str, length, ch, add) {
    str = String(str);
    let n = length - str.length;
    while (n-- > 0)
        str = add(str, ch);
    return str;
}
function identify(val) {
    return val;
}
function changeCase$1(str) {
    const hasLowerCase = [...str].some(ch => ch >= 'a' && ch <= 'z');
    return hasLowerCase ? str.toUpperCase() : str.toLowerCase();
}
function ellipsis(str, N) {
    return str.length > N ? str.slice(0, N - 3) + '...' : str;
}
// compare string in case-insensitive way, undefined values to the tail
function caseInsensitiveCompare(a, b) {
    if (a == null && b == null)
        return 0;
    if (a == null)
        return 1;
    if (b == null)
        return -1;
    a = toLowerCase.call(a);
    b = toLowerCase.call(b);
    if (a < b)
        return -1;
    if (a > b)
        return 1;
    return 0;
}
function argumentsToValue(fn) {
    return (...args) => fn(...args.map(toValue));
}
function escapeRegExp(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

class LiquidError extends Error {
    constructor(err, token) {
        super(err.message);
        this.originalError = err;
        this.token = token;
        this.context = '';
    }
    update() {
        const err = this.originalError;
        this.context = mkContext(this.token);
        this.message = mkMessage(err.message, this.token);
        this.stack = this.message + '\n' + this.context +
            '\n' + this.stack + '\nFrom ' + err.stack;
    }
}
class TokenizationError extends LiquidError {
    constructor(message, token) {
        super(new Error(message), token);
        this.name = 'TokenizationError';
        super.update();
    }
}
class ParseError extends LiquidError {
    constructor(err, token) {
        super(err, token);
        this.name = 'ParseError';
        this.message = err.message;
        super.update();
    }
}
class RenderError extends LiquidError {
    constructor(err, tpl) {
        super(err, tpl.token);
        this.name = 'RenderError';
        this.message = err.message;
        super.update();
    }
    static is(obj) {
        return obj.name === 'RenderError';
    }
}
class UndefinedVariableError extends LiquidError {
    constructor(err, token) {
        super(err, token);
        this.name = 'UndefinedVariableError';
        this.message = err.message;
        super.update();
    }
}
// only used internally; raised where we don't have token information,
// so it can't be an UndefinedVariableError.
class InternalUndefinedVariableError extends Error {
    constructor(variableName) {
        super(`undefined variable: ${variableName}`);
        this.name = 'InternalUndefinedVariableError';
        this.variableName = variableName;
    }
}
class AssertionError extends Error {
    constructor(message) {
        super(message);
        this.name = 'AssertionError';
        this.message = message + '';
    }
}
function mkContext(token) {
    const [line] = token.getPosition();
    const lines = token.input.split('\n');
    const begin = Math.max(line - 2, 1);
    const end = Math.min(line + 3, lines.length);
    const context = range(begin, end + 1)
        .map(lineNumber => {
        const indicator = (lineNumber === line) ? '>> ' : '   ';
        const num = padStart(String(lineNumber), String(end).length);
        const text = lines[lineNumber - 1];
        return `${indicator}${num}| ${text}`;
    })
        .join('\n');
    return context;
}
function mkMessage(msg, token) {
    if (token.file)
        msg += `, file:${token.file}`;
    const [line, col] = token.getPosition();
    msg += `, line:${line}, col:${col}`;
    return msg;
}

// **DO NOT CHANGE THIS FILE**
//
// This file is generated by bin/character-gen.js
// bitmask character types to boost performance
const TYPES = [0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 4, 4, 4, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 2, 8, 0, 0, 0, 0, 8, 0, 0, 0, 64, 0, 65, 0, 0, 33, 33, 33, 33, 33, 33, 33, 33, 33, 33, 0, 0, 2, 2, 2, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0];
const IDENTIFIER = 1;
const BLANK = 4;
const QUOTE = 8;
const INLINE_BLANK = 16;
const NUMBER = 32;
const SIGN = 64;
TYPES[160] = TYPES[5760] = TYPES[6158] = TYPES[8192] = TYPES[8193] = TYPES[8194] = TYPES[8195] = TYPES[8196] = TYPES[8197] = TYPES[8198] = TYPES[8199] = TYPES[8200] = TYPES[8201] = TYPES[8202] = TYPES[8232] = TYPES[8233] = TYPES[8239] = TYPES[8287] = TYPES[12288] = BLANK;

function assert(predicate, message) {
    if (!predicate) {
        const msg = typeof message === 'function'
            ? message()
            : (message || `expect ${predicate} to be true`);
        throw new AssertionError(msg);
    }
}

class NullDrop extends Drop {
    equals(value) {
        return isNil(toValue(value));
    }
    gt() {
        return false;
    }
    geq() {
        return false;
    }
    lt() {
        return false;
    }
    leq() {
        return false;
    }
    valueOf() {
        return null;
    }
}

class EmptyDrop extends Drop {
    equals(value) {
        if (value instanceof EmptyDrop)
            return false;
        value = toValue(value);
        if (isString$1(value) || isArray(value))
            return value.length === 0;
        if (isObject$4(value))
            return Object.keys(value).length === 0;
        return false;
    }
    gt() {
        return false;
    }
    geq() {
        return false;
    }
    lt() {
        return false;
    }
    leq() {
        return false;
    }
    valueOf() {
        return '';
    }
}

class BlankDrop extends EmptyDrop {
    equals(value) {
        if (value === false)
            return true;
        if (isNil(toValue(value)))
            return true;
        if (isString$1(value))
            return /^\s*$/.test(value);
        return super.equals(value);
    }
}

class ForloopDrop extends Drop {
    constructor(length, collection, variable) {
        super();
        this.i = 0;
        this.length = length;
        this.name = `${variable}-${collection}`;
    }
    next() {
        this.i++;
    }
    index0() {
        return this.i;
    }
    index() {
        return this.i + 1;
    }
    first() {
        return this.i === 0;
    }
    last() {
        return this.i === this.length - 1;
    }
    rindex() {
        return this.length - this.i;
    }
    rindex0() {
        return this.length - this.i - 1;
    }
    valueOf() {
        return JSON.stringify(this);
    }
}

class BlockDrop extends Drop {
    constructor(
    // the block render from layout template
    superBlockRender = () => '') {
        super();
        this.superBlockRender = superBlockRender;
    }
    /**
     * Provide parent access in child block by
     * {{ block.super }}
     */
    super() {
        return this.superBlockRender();
    }
}

function isComparable(arg) {
    return arg && isFunction(arg.equals);
}

const nil = new NullDrop();
const literalValues = {
    'true': true,
    'false': false,
    'nil': nil,
    'null': nil,
    'empty': new EmptyDrop(),
    'blank': new BlankDrop()
};

function createTrie(operators) {
    const trie = {};
    for (const [name, handler] of Object.entries(operators)) {
        let node = trie;
        for (let i = 0; i < name.length; i++) {
            const c = name[i];
            node[c] = node[c] || {};
            if (i === name.length - 1 && (TYPES[name.charCodeAt(i)] & IDENTIFIER)) {
                node[c].needBoundary = true;
            }
            node = node[c];
        }
        node.handler = handler;
        node.end = true;
    }
    return trie;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

// convert an async iterator to a Promise
function toPromise(val) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!isIterator(val))
            return val;
        let value;
        let done = false;
        let next = 'next';
        do {
            const state = val[next](value);
            done = state.done;
            value = state.value;
            next = 'next';
            try {
                if (isIterator(value))
                    value = toPromise(value);
                if (isPromise(value))
                    value = yield value;
            }
            catch (err) {
                next = 'throw';
                value = err;
            }
        } while (!done);
        return value;
    });
}
// convert an async iterator to a value in a synchronous manner
function toValueSync(val) {
    if (!isIterator(val))
        return val;
    let value;
    let done = false;
    let next = 'next';
    do {
        const state = val[next](value);
        done = state.done;
        value = state.value;
        next = 'next';
        if (isIterator(value)) {
            try {
                value = toValueSync(value);
            }
            catch (err) {
                next = 'throw';
                value = err;
            }
        }
    } while (!done);
    return value;
}

function toEnumerable(val) {
    val = toValue(val);
    if (isArray(val))
        return val;
    if (isString$1(val) && val.length > 0)
        return [val];
    if (isIterable(val))
        return Array.from(val);
    if (isObject$4(val))
        return Object.keys(val).map((key) => [key, val[key]]);
    return [];
}
function toArray(val) {
    if (isNil(val))
        return [];
    if (isArray(val))
        return val;
    return [val];
}

const rFormat$1 = /%([-_0^#:]+)?(\d+)?([EO])?(.)/;
const monthNames$1 = [
    'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
    'September', 'October', 'November', 'December'
];
const dayNames$1 = [
    'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
];
const monthNamesShort$1 = monthNames$1.map(abbr$1);
const dayNamesShort$1 = dayNames$1.map(abbr$1);
const suffixes$1 = {
    1: 'st',
    2: 'nd',
    3: 'rd',
    'default': 'th'
};
function abbr$1(str) {
    return str.slice(0, 3);
}
// prototype extensions
function daysInMonth$1(d) {
    const feb = isLeapYear$1(d) ? 29 : 28;
    return [31, feb, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
}
function getDayOfYear$1(d) {
    let num = 0;
    for (let i = 0; i < d.getMonth(); ++i) {
        num += daysInMonth$1(d)[i];
    }
    return num + d.getDate();
}
function getWeekOfYear$1(d, startDay) {
    // Skip to startDay of this week
    const now = getDayOfYear$1(d) + (startDay - d.getDay());
    // Find the first startDay of the year
    const jan1 = new Date(d.getFullYear(), 0, 1);
    const then = (7 - jan1.getDay() + startDay);
    return String(Math.floor((now - then) / 7) + 1);
}
function isLeapYear$1(d) {
    const year = d.getFullYear();
    return !!((year & 3) === 0 && (year % 100 || (year % 400 === 0 && year)));
}
function getSuffix$1(d) {
    const str = d.getDate().toString();
    const index = parseInt(str.slice(-1));
    return suffixes$1[index] || suffixes$1['default'];
}
function century$1(d) {
    return parseInt(d.getFullYear().toString().substring(0, 2), 10);
}
// default to 0
const padWidths$1 = {
    d: 2,
    e: 2,
    H: 2,
    I: 2,
    j: 3,
    k: 2,
    l: 2,
    L: 3,
    m: 2,
    M: 2,
    S: 2,
    U: 2,
    W: 2
};
// default to '0'
const padChars$1 = {
    a: ' ',
    A: ' ',
    b: ' ',
    B: ' ',
    c: ' ',
    e: ' ',
    k: ' ',
    l: ' ',
    p: ' ',
    P: ' '
};
const formatCodes$1 = {
    a: (d) => dayNamesShort$1[d.getDay()],
    A: (d) => dayNames$1[d.getDay()],
    b: (d) => monthNamesShort$1[d.getMonth()],
    B: (d) => monthNames$1[d.getMonth()],
    c: (d) => d.toLocaleString(),
    C: (d) => century$1(d),
    d: (d) => d.getDate(),
    e: (d) => d.getDate(),
    H: (d) => d.getHours(),
    I: (d) => String(d.getHours() % 12 || 12),
    j: (d) => getDayOfYear$1(d),
    k: (d) => d.getHours(),
    l: (d) => String(d.getHours() % 12 || 12),
    L: (d) => d.getMilliseconds(),
    m: (d) => d.getMonth() + 1,
    M: (d) => d.getMinutes(),
    N: (d, opts) => {
        const width = Number(opts.width) || 9;
        const str = String(d.getMilliseconds()).slice(0, width);
        return padEnd(str, width, '0');
    },
    p: (d) => (d.getHours() < 12 ? 'AM' : 'PM'),
    P: (d) => (d.getHours() < 12 ? 'am' : 'pm'),
    q: (d) => getSuffix$1(d),
    s: (d) => Math.round(d.getTime() / 1000),
    S: (d) => d.getSeconds(),
    u: (d) => d.getDay() || 7,
    U: (d) => getWeekOfYear$1(d, 0),
    w: (d) => d.getDay(),
    W: (d) => getWeekOfYear$1(d, 1),
    x: (d) => d.toLocaleDateString(),
    X: (d) => d.toLocaleTimeString(),
    y: (d) => d.getFullYear().toString().slice(2, 4),
    Y: (d) => d.getFullYear(),
    z: (d, opts) => {
        const nOffset = Math.abs(d.getTimezoneOffset());
        const h = Math.floor(nOffset / 60);
        const m = nOffset % 60;
        return (d.getTimezoneOffset() > 0 ? '-' : '+') +
            padStart(h, 2, '0') +
            (opts.flags[':'] ? ':' : '') +
            padStart(m, 2, '0');
    },
    't': () => '\t',
    'n': () => '\n',
    '%': () => '%'
};
formatCodes$1.h = formatCodes$1.b;
function strftime(d, formatStr) {
    let output = '';
    let remaining = formatStr;
    let match;
    while ((match = rFormat$1.exec(remaining))) {
        output += remaining.slice(0, match.index);
        remaining = remaining.slice(match.index + match[0].length);
        output += format$1(d, match);
    }
    return output + remaining;
}
function format$1(d, match) {
    const [input, flagStr = '', width, modifier, conversion] = match;
    const convert = formatCodes$1[conversion];
    if (!convert)
        return input;
    const flags = {};
    for (const flag of flagStr)
        flags[flag] = true;
    let ret = String(convert(d, { flags, width, modifier }));
    let padChar = padChars$1[conversion] || '0';
    let padWidth = width || padWidths$1[conversion] || 0;
    if (flags['^'])
        ret = ret.toUpperCase();
    else if (flags['#'])
        ret = changeCase$1(ret);
    if (flags['_'])
        padChar = ' ';
    else if (flags['0'])
        padChar = '0';
    if (flags['-'])
        padWidth = 0;
    return padStart(ret, padWidth, padChar);
}

// one minute in milliseconds
const OneMinute = 60000;
const hostTimezoneOffset = new Date().getTimezoneOffset();
const ISO8601_TIMEZONE_PATTERN = /([zZ]|([+-])(\d{2}):(\d{2}))$/;
/**
 * A date implementation with timezone info, just like Ruby date
 *
 * Implementation:
 * - create a Date offset by it's timezone difference, avoiding overriding a bunch of methods
 * - rewrite getTimezoneOffset() to trick strftime
 */
class TimezoneDate {
    constructor(init, timezoneOffset) {
        if (init instanceof TimezoneDate) {
            this.date = init.date;
            timezoneOffset = init.timezoneOffset;
        }
        else {
            const diff = (hostTimezoneOffset - timezoneOffset) * OneMinute;
            const time = new Date(init).getTime() + diff;
            this.date = new Date(time);
        }
        this.timezoneOffset = timezoneOffset;
    }
    getTime() {
        return this.date.getTime();
    }
    getMilliseconds() {
        return this.date.getMilliseconds();
    }
    getSeconds() {
        return this.date.getSeconds();
    }
    getMinutes() {
        return this.date.getMinutes();
    }
    getHours() {
        return this.date.getHours();
    }
    getDay() {
        return this.date.getDay();
    }
    getDate() {
        return this.date.getDate();
    }
    getMonth() {
        return this.date.getMonth();
    }
    getFullYear() {
        return this.date.getFullYear();
    }
    toLocaleTimeString(locale) {
        return this.date.toLocaleTimeString(locale);
    }
    toLocaleDateString(locale) {
        return this.date.toLocaleDateString(locale);
    }
    getTimezoneOffset() {
        return this.timezoneOffset;
    }
    /**
     * Create a Date object fixed to it's declared Timezone. Both
     * - 2021-08-06T02:29:00.000Z and
     * - 2021-08-06T02:29:00.000+08:00
     * will always be displayed as
     * - 2021-08-06 02:29:00
     * regardless timezoneOffset in JavaScript realm
     *
     * The implementation hack:
     * Instead of calling `.getMonth()`/`.getUTCMonth()` respect to `preserveTimezones`,
     * we create a different Date to trick strftime, it's both simpler and more performant.
     * Given that a template is expected to be parsed fewer times than rendered.
     */
    static createDateFixedToTimezone(dateString) {
        const m = dateString.match(ISO8601_TIMEZONE_PATTERN);
        // representing a UTC timestamp
        if (m && m[1] === 'Z') {
            return new TimezoneDate(+new Date(dateString), 0);
        }
        // has a timezone specified
        if (m && m[2] && m[3] && m[4]) {
            const [, , sign, hours, minutes] = m;
            const delta = (sign === '+' ? -1 : 1) * (parseInt(hours, 10) * 60 + parseInt(minutes, 10));
            return new TimezoneDate(+new Date(dateString), delta);
        }
        return new Date(dateString);
    }
}

class DelimitedToken extends Token {
    constructor(kind, content, input, begin, end, trimLeft, trimRight, file) {
        super(kind, input, begin, end, file);
        this.trimLeft = false;
        this.trimRight = false;
        this.content = this.getText();
        const tl = content[0] === '-';
        const tr = last$1(content) === '-';
        this.content = content
            .slice(tl ? 1 : 0, tr ? -1 : content.length)
            .trim();
        this.trimLeft = tl || trimLeft;
        this.trimRight = tr || trimRight;
    }
}

class TagToken extends DelimitedToken {
    constructor(input, begin, end, options, file) {
        const { trimTagLeft, trimTagRight, tagDelimiterLeft, tagDelimiterRight } = options;
        const value = input.slice(begin + tagDelimiterLeft.length, end - tagDelimiterRight.length);
        super(TokenKind.Tag, value, input, begin, end, trimTagLeft, trimTagRight, file);
        const tokenizer = new Tokenizer(this.content, options.operators);
        this.name = tokenizer.readTagName();
        if (!this.name)
            throw new TokenizationError(`illegal tag syntax`, this);
        tokenizer.skipBlank();
        this.args = tokenizer.remaining();
    }
}

class OutputToken extends DelimitedToken {
    constructor(input, begin, end, options, file) {
        const { trimOutputLeft, trimOutputRight, outputDelimiterLeft, outputDelimiterRight } = options;
        const value = input.slice(begin + outputDelimiterLeft.length, end - outputDelimiterRight.length);
        super(TokenKind.Output, value, input, begin, end, trimOutputLeft, trimOutputRight, file);
    }
}

class HTMLToken extends Token {
    constructor(input, begin, end, file) {
        super(TokenKind.HTML, input, begin, end, file);
        this.input = input;
        this.begin = begin;
        this.end = end;
        this.file = file;
        this.trimLeft = 0;
        this.trimRight = 0;
    }
    getContent() {
        return this.input.slice(this.begin + this.trimLeft, this.end - this.trimRight);
    }
}

class NumberToken extends Token {
    constructor(whole, decimal) {
        super(TokenKind.Number, whole.input, whole.begin, decimal ? decimal.end : whole.end, whole.file);
        this.whole = whole;
        this.decimal = decimal;
    }
}

class IdentifierToken extends Token {
    constructor(input, begin, end, file) {
        super(TokenKind.Word, input, begin, end, file);
        this.input = input;
        this.begin = begin;
        this.end = end;
        this.file = file;
        this.content = this.getText();
    }
    isNumber(allowSign = false) {
        const begin = allowSign && TYPES[this.input.charCodeAt(this.begin)] & SIGN
            ? this.begin + 1
            : this.begin;
        for (let i = begin; i < this.end; i++) {
            if (!(TYPES[this.input.charCodeAt(i)] & NUMBER))
                return false;
        }
        return true;
    }
}

class LiteralToken extends Token {
    constructor(input, begin, end, file) {
        super(TokenKind.Literal, input, begin, end, file);
        this.input = input;
        this.begin = begin;
        this.end = end;
        this.file = file;
        this.literal = this.getText();
    }
}

const operatorPrecedences = {
    '==': 2,
    '!=': 2,
    '>': 2,
    '<': 2,
    '>=': 2,
    '<=': 2,
    'contains': 2,
    'not': 1,
    'and': 0,
    'or': 0
};
const operatorTypes = {
    '==': 0 /* Binary */,
    '!=': 0 /* Binary */,
    '>': 0 /* Binary */,
    '<': 0 /* Binary */,
    '>=': 0 /* Binary */,
    '<=': 0 /* Binary */,
    'contains': 0 /* Binary */,
    'not': 1 /* Unary */,
    'and': 0 /* Binary */,
    'or': 0 /* Binary */
};
class OperatorToken extends Token {
    constructor(input, begin, end, file) {
        super(TokenKind.Operator, input, begin, end, file);
        this.input = input;
        this.begin = begin;
        this.end = end;
        this.file = file;
        this.operator = this.getText();
    }
    getPrecedence() {
        const key = this.getText();
        return key in operatorPrecedences ? operatorPrecedences[key] : 1;
    }
}

class PropertyAccessToken extends Token {
    constructor(variable, props, end) {
        super(TokenKind.PropertyAccess, variable.input, variable.begin, end, variable.file);
        this.variable = variable;
        this.props = props;
        this.propertyName = this.variable instanceof IdentifierToken
            ? this.variable.getText()
            : parseStringLiteral(this.variable.getText());
    }
}

class FilterToken extends Token {
    constructor(name, args, input, begin, end, file) {
        super(TokenKind.Filter, input, begin, end, file);
        this.name = name;
        this.args = args;
    }
}

class HashToken extends Token {
    constructor(input, begin, end, name, value, file) {
        super(TokenKind.Hash, input, begin, end, file);
        this.input = input;
        this.begin = begin;
        this.end = end;
        this.name = name;
        this.value = value;
        this.file = file;
    }
}

class QuotedToken extends Token {
    constructor(input, begin, end, file) {
        super(TokenKind.Quoted, input, begin, end, file);
        this.input = input;
        this.begin = begin;
        this.end = end;
        this.file = file;
    }
}

class RangeToken extends Token {
    constructor(input, begin, end, lhs, rhs, file) {
        super(TokenKind.Range, input, begin, end, file);
        this.input = input;
        this.begin = begin;
        this.end = end;
        this.lhs = lhs;
        this.rhs = rhs;
        this.file = file;
    }
}

class LiquidTagToken extends DelimitedToken {
    constructor(input, begin, end, options, file) {
        const value = input.slice(begin, end);
        super(TokenKind.Tag, value, input, begin, end, false, false, file);
        if (!/\S/.test(value)) {
            // A line that contains only whitespace.
            this.name = '';
            this.args = '';
        }
        else {
            const tokenizer = new Tokenizer(this.content, options.operators);
            this.name = tokenizer.readTagName();
            if (!this.name)
                throw new TokenizationError(`illegal liquid tag syntax`, this);
            tokenizer.skipBlank();
            this.args = tokenizer.remaining();
        }
    }
}

class SimpleEmitter {
    constructor() {
        this.buffer = '';
    }
    write(html) {
        this.buffer += stringify(html);
    }
}

class StreamedEmitter {
    constructor() {
        this.buffer = '';
        this.stream = null;
        throw new Error('streaming not supported in browser');
    }
}

class KeepingTypeEmitter {
    constructor() {
        this.buffer = '';
    }
    write(html) {
        html = toValue(html);
        // This will only preserve the type if the value is isolated.
        // I.E:
        // {{ my-port }} -> 42
        // {{ my-host }}:{{ my-port }} -> 'host:42'
        if (typeof html !== 'string' && this.buffer === '') {
            this.buffer = html;
        }
        else {
            this.buffer = stringify(this.buffer) + stringify(html);
        }
    }
}

class Render {
    renderTemplatesToNodeStream(templates, ctx) {
        const emitter = new StreamedEmitter();
        Promise.resolve().then(() => toPromise(this.renderTemplates(templates, ctx, emitter)))
            .then(() => emitter.end(), err => emitter.error(err));
        return emitter.stream;
    }
    *renderTemplates(templates, ctx, emitter) {
        if (!emitter) {
            emitter = ctx.opts.keepOutputType ? new KeepingTypeEmitter() : new SimpleEmitter();
        }
        for (const tpl of templates) {
            try {
                // if tpl.render supports emitter, it'll return empty `html`
                const html = yield tpl.render(ctx, emitter);
                // if not, it'll return an `html`, write to the emitter for it
                html && emitter.write(html);
                if (emitter['break'] || emitter['continue'])
                    break;
            }
            catch (e) {
                const err = RenderError.is(e) ? e : new RenderError(e, tpl);
                throw err;
            }
        }
        return emitter.buffer;
    }
}

class Expression {
    constructor(tokens) {
        this.postfix = [...toPostfix(tokens)];
    }
    *evaluate(ctx, lenient) {
        assert(ctx, 'unable to evaluate: context not defined');
        const operands = [];
        for (const token of this.postfix) {
            if (isOperatorToken(token)) {
                const r = operands.pop();
                let result;
                if (operatorTypes[token.operator] === 1 /* Unary */) {
                    result = yield ctx.opts.operators[token.operator](r, ctx);
                }
                else {
                    const l = operands.pop();
                    result = yield ctx.opts.operators[token.operator](l, r, ctx);
                }
                operands.push(result);
            }
            else {
                operands.push(yield evalToken(token, ctx, lenient && this.postfix.length === 1));
            }
        }
        return operands[0];
    }
}
function* evalToken(token, ctx, lenient = false) {
    if (isPropertyAccessToken(token))
        return yield evalPropertyAccessToken(token, ctx, lenient);
    if (isRangeToken(token))
        return yield evalRangeToken(token, ctx);
    if (isLiteralToken(token))
        return evalLiteralToken(token);
    if (isNumberToken(token))
        return evalNumberToken(token);
    if (isWordToken(token))
        return token.getText();
    if (isQuotedToken(token))
        return evalQuotedToken(token);
}
function* evalPropertyAccessToken(token, ctx, lenient) {
    const props = [];
    for (const prop of token.props) {
        props.push((yield evalToken(prop, ctx, false)));
    }
    try {
        return yield ctx._get([token.propertyName, ...props]);
    }
    catch (e) {
        if (lenient && e.name === 'InternalUndefinedVariableError')
            return null;
        throw (new UndefinedVariableError(e, token));
    }
}
function evalNumberToken(token) {
    const str = token.whole.content + '.' + (token.decimal ? token.decimal.content : '');
    return Number(str);
}
function evalQuotedToken(token) {
    return parseStringLiteral(token.getText());
}
function evalLiteralToken(token) {
    return literalValues[token.literal];
}
function* evalRangeToken(token, ctx) {
    const low = yield evalToken(token.lhs, ctx);
    const high = yield evalToken(token.rhs, ctx);
    return range(+low, +high + 1);
}
function* toPostfix(tokens) {
    const ops = [];
    for (const token of tokens) {
        if (isOperatorToken(token)) {
            while (ops.length && ops[ops.length - 1].getPrecedence() > token.getPrecedence()) {
                yield ops.pop();
            }
            ops.push(token);
        }
        else
            yield token;
    }
    while (ops.length) {
        yield ops.pop();
    }
}

function isTruthy(val, ctx) {
    return !isFalsy(val, ctx);
}
function isFalsy(val, ctx) {
    if (ctx.opts.jsTruthy) {
        return !val;
    }
    else {
        return val === false || undefined === val || val === null;
    }
}

const defaultOperators = {
    '==': (l, r) => {
        if (isComparable(l))
            return l.equals(r);
        if (isComparable(r))
            return r.equals(l);
        return toValue(l) === toValue(r);
    },
    '!=': (l, r) => {
        if (isComparable(l))
            return !l.equals(r);
        if (isComparable(r))
            return !r.equals(l);
        return toValue(l) !== toValue(r);
    },
    '>': (l, r) => {
        if (isComparable(l))
            return l.gt(r);
        if (isComparable(r))
            return r.lt(l);
        return toValue(l) > toValue(r);
    },
    '<': (l, r) => {
        if (isComparable(l))
            return l.lt(r);
        if (isComparable(r))
            return r.gt(l);
        return toValue(l) < toValue(r);
    },
    '>=': (l, r) => {
        if (isComparable(l))
            return l.geq(r);
        if (isComparable(r))
            return r.leq(l);
        return toValue(l) >= toValue(r);
    },
    '<=': (l, r) => {
        if (isComparable(l))
            return l.leq(r);
        if (isComparable(r))
            return r.geq(l);
        return toValue(l) <= toValue(r);
    },
    'contains': (l, r) => {
        l = toValue(l);
        r = toValue(r);
        return l && isFunction(l.indexOf) ? l.indexOf(r) > -1 : false;
    },
    'not': (v, ctx) => isFalsy(toValue(v), ctx),
    'and': (l, r, ctx) => isTruthy(toValue(l), ctx) && isTruthy(toValue(r), ctx),
    'or': (l, r, ctx) => isTruthy(toValue(l), ctx) || isTruthy(toValue(r), ctx)
};

class Node$1 {
    constructor(key, value, next, prev) {
        this.key = key;
        this.value = value;
        this.next = next;
        this.prev = prev;
    }
}
class LRU {
    constructor(limit, size = 0) {
        this.limit = limit;
        this.size = size;
        this.cache = {};
        this.head = new Node$1('HEAD', null, null, null);
        this.tail = new Node$1('TAIL', null, null, null);
        this.head.next = this.tail;
        this.tail.prev = this.head;
    }
    write(key, value) {
        if (this.cache[key]) {
            this.cache[key].value = value;
        }
        else {
            const node = new Node$1(key, value, this.head.next, this.head);
            this.head.next.prev = node;
            this.head.next = node;
            this.cache[key] = node;
            this.size++;
            this.ensureLimit();
        }
    }
    read(key) {
        if (!this.cache[key])
            return;
        const { value } = this.cache[key];
        this.remove(key);
        this.write(key, value);
        return value;
    }
    remove(key) {
        const node = this.cache[key];
        node.prev.next = node.next;
        node.next.prev = node.prev;
        delete this.cache[key];
        this.size--;
    }
    clear() {
        this.head.next = this.tail;
        this.tail.prev = this.head;
        this.size = 0;
        this.cache = {};
    }
    ensureLimit() {
        if (this.size > this.limit)
            this.remove(this.tail.prev.key);
    }
}

function domResolve(root, path) {
    const base = document.createElement('base');
    base.href = root;
    const head = document.getElementsByTagName('head')[0];
    head.insertBefore(base, head.firstChild);
    const a = document.createElement('a');
    a.href = path;
    const resolved = a.href;
    head.removeChild(base);
    return resolved;
}
function resolve(root, filepath, ext) {
    if (root.length && last$1(root) !== '/')
        root += '/';
    const url = domResolve(root, filepath);
    return url.replace(/^(\w+:\/\/[^/]+)(\/[^?]+)/, (str, origin, path) => {
        const last = path.split('/').pop();
        if (/\.\w+$/.test(last))
            return str;
        return origin + path + ext;
    });
}
function readFile(url) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(xhr.responseText);
                }
                else {
                    reject(new Error(xhr.statusText));
                }
            };
            xhr.onerror = () => {
                reject(new Error('An error occurred whilst receiving the response.'));
            };
            xhr.open('GET', url);
            xhr.send();
        });
    });
}
function readFileSync(url) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, false);
    xhr.send();
    if (xhr.status < 200 || xhr.status >= 300) {
        throw new Error(xhr.statusText);
    }
    return xhr.responseText;
}
function exists$1(filepath) {
    return __awaiter(this, void 0, void 0, function* () {
        return true;
    });
}
function existsSync(filepath) {
    return true;
}
function dirname(filepath) {
    return domResolve(filepath, '.');
}
const sep = '/';

var fs = /*#__PURE__*/Object.freeze({
  __proto__: null,
  resolve: resolve,
  readFile: readFile,
  readFileSync: readFileSync,
  exists: exists$1,
  existsSync: existsSync,
  dirname: dirname,
  sep: sep
});

function Default(value, defaultValue, ...args) {
    value = toValue(value);
    if (isArray(value) || isString$1(value))
        return value.length ? value : defaultValue;
    if (value === false && (new Map(args)).get('allow_false'))
        return false;
    return isFalsy(value, this.context) ? defaultValue : value;
}
function json(value) {
    return JSON.stringify(value);
}
const raw = {
    raw: true,
    handler: identify
};

const escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&#34;',
    "'": '&#39;'
};
const unescapeMap = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&#34;': '"',
    '&#39;': "'"
};
function escape(str) {
    return stringify(str).replace(/&|<|>|"|'/g, m => escapeMap[m]);
}
function unescape(str) {
    return stringify(str).replace(/&(amp|lt|gt|#34|#39);/g, m => unescapeMap[m]);
}
function escape_once(str) {
    return escape(unescape(stringify(str)));
}
function newline_to_br(v) {
    return stringify(v).replace(/\n/g, '<br />\n');
}
function strip_html(v) {
    return stringify(v).replace(/<script.*?<\/script>|<!--.*?-->|<style.*?<\/style>|<.*?>/g, '');
}

var htmlFilters = /*#__PURE__*/Object.freeze({
  __proto__: null,
  escape: escape,
  escape_once: escape_once,
  newline_to_br: newline_to_br,
  strip_html: strip_html
});

const defaultOptions = {
    root: ['.'],
    layouts: ['.'],
    partials: ['.'],
    relativeReference: true,
    jekyllInclude: false,
    cache: undefined,
    extname: '',
    fs: fs,
    dynamicPartials: true,
    jsTruthy: false,
    trimTagRight: false,
    trimTagLeft: false,
    trimOutputRight: false,
    trimOutputLeft: false,
    greedy: true,
    tagDelimiterLeft: '{%',
    tagDelimiterRight: '%}',
    outputDelimiterLeft: '{{',
    outputDelimiterRight: '}}',
    preserveTimezones: false,
    strictFilters: false,
    strictVariables: false,
    ownPropertyOnly: true,
    lenientIf: false,
    globals: {},
    keepOutputType: false,
    operators: defaultOperators
};
function normalize(options) {
    if (options.hasOwnProperty('root')) {
        if (!options.hasOwnProperty('partials'))
            options.partials = options.root;
        if (!options.hasOwnProperty('layouts'))
            options.layouts = options.root;
    }
    if (options.hasOwnProperty('cache')) {
        let cache;
        if (typeof options.cache === 'number')
            cache = options.cache > 0 ? new LRU(options.cache) : undefined;
        else if (typeof options.cache === 'object')
            cache = options.cache;
        else
            cache = options.cache ? new LRU(1024) : undefined;
        options.cache = cache;
    }
    options = Object.assign(Object.assign(Object.assign({}, defaultOptions), (options.jekyllInclude ? { dynamicPartials: false } : {})), options);
    if (!options.fs.dirname && options.relativeReference) {
        console.warn('[LiquidJS] `fs.dirname` is required for relativeReference, set relativeReference to `false` to suppress this warning, or provide implementation for `fs.dirname`');
        options.relativeReference = false;
    }
    options.root = normalizeDirectoryList(options.root);
    options.partials = normalizeDirectoryList(options.partials);
    options.layouts = normalizeDirectoryList(options.layouts);
    options.outputEscape = options.outputEscape && getOutputEscapeFunction(options.outputEscape);
    return options;
}
function getOutputEscapeFunction(nameOrFunction) {
    if (nameOrFunction === 'escape')
        return escape;
    if (nameOrFunction === 'json')
        return json;
    assert(isFunction(nameOrFunction), '`outputEscape` need to be of type string or function');
    return nameOrFunction;
}
function normalizeDirectoryList(value) {
    let list = [];
    if (isArray(value))
        list = value;
    if (isString$1(value))
        list = [value];
    return list;
}

function matchOperator(str, begin, trie, end = str.length) {
    let node = trie;
    let i = begin;
    let info;
    while (node[str[i]] && i < end) {
        node = node[str[i++]];
        if (node['end'])
            info = node;
    }
    if (!info)
        return -1;
    if (info['needBoundary'] && (TYPES[str.charCodeAt(i)] & IDENTIFIER))
        return -1;
    return i;
}

function whiteSpaceCtrl(tokens, options) {
    let inRaw = false;
    for (let i = 0; i < tokens.length; i++) {
        const token = tokens[i];
        if (!isDelimitedToken(token))
            continue;
        if (!inRaw && token.trimLeft) {
            trimLeft(tokens[i - 1], options.greedy);
        }
        if (isTagToken(token)) {
            if (token.name === 'raw')
                inRaw = true;
            else if (token.name === 'endraw')
                inRaw = false;
        }
        if (!inRaw && token.trimRight) {
            trimRight(tokens[i + 1], options.greedy);
        }
    }
}
function trimLeft(token, greedy) {
    if (!token || !isHTMLToken(token))
        return;
    const mask = greedy ? BLANK : INLINE_BLANK;
    while (TYPES[token.input.charCodeAt(token.end - 1 - token.trimRight)] & mask)
        token.trimRight++;
}
function trimRight(token, greedy) {
    if (!token || !isHTMLToken(token))
        return;
    const mask = greedy ? BLANK : INLINE_BLANK;
    while (TYPES[token.input.charCodeAt(token.begin + token.trimLeft)] & mask)
        token.trimLeft++;
    if (token.input.charAt(token.begin + token.trimLeft) === '\n')
        token.trimLeft++;
}

class Tokenizer {
    constructor(input, operators = defaultOptions.operators, file) {
        this.input = input;
        this.file = file;
        this.p = 0;
        this.rawBeginAt = -1;
        this.N = input.length;
        this.opTrie = createTrie(operators);
    }
    readExpression() {
        return new Expression(this.readExpressionTokens());
    }
    *readExpressionTokens() {
        while (this.p < this.N) {
            const operator = this.readOperator();
            if (operator) {
                yield operator;
                continue;
            }
            const operand = this.readValue();
            if (operand) {
                yield operand;
                continue;
            }
            return;
        }
    }
    readOperator() {
        this.skipBlank();
        const end = matchOperator(this.input, this.p, this.opTrie);
        if (end === -1)
            return;
        return new OperatorToken(this.input, this.p, (this.p = end), this.file);
    }
    readFilters() {
        const filters = [];
        while (true) {
            const filter = this.readFilter();
            if (!filter)
                return filters;
            filters.push(filter);
        }
    }
    readFilter() {
        this.skipBlank();
        if (this.end())
            return null;
        assert(this.peek() === '|', () => `unexpected token at ${this.snapshot()}`);
        this.p++;
        const begin = this.p;
        const name = this.readIdentifier();
        if (!name.size())
            return null;
        const args = [];
        this.skipBlank();
        if (this.peek() === ':') {
            do {
                ++this.p;
                const arg = this.readFilterArg();
                arg && args.push(arg);
                this.skipBlank();
                assert(this.end() || this.peek() === ',' || this.peek() === '|', () => `unexpected character ${this.snapshot()}`);
            } while (this.peek() === ',');
        }
        return new FilterToken(name.getText(), args, this.input, begin, this.p, this.file);
    }
    readFilterArg() {
        const key = this.readValue();
        if (!key)
            return;
        this.skipBlank();
        if (this.peek() !== ':')
            return key;
        ++this.p;
        const value = this.readValue();
        return [key.getText(), value];
    }
    readTopLevelTokens(options = defaultOptions) {
        const tokens = [];
        while (this.p < this.N) {
            const token = this.readTopLevelToken(options);
            tokens.push(token);
        }
        whiteSpaceCtrl(tokens, options);
        return tokens;
    }
    readTopLevelToken(options) {
        const { tagDelimiterLeft, outputDelimiterLeft } = options;
        if (this.rawBeginAt > -1)
            return this.readEndrawOrRawContent(options);
        if (this.match(tagDelimiterLeft))
            return this.readTagToken(options);
        if (this.match(outputDelimiterLeft))
            return this.readOutputToken(options);
        return this.readHTMLToken([tagDelimiterLeft, outputDelimiterLeft]);
    }
    readHTMLToken(stopStrings) {
        const begin = this.p;
        while (this.p < this.N) {
            if (stopStrings.some(str => this.match(str)))
                break;
            ++this.p;
        }
        return new HTMLToken(this.input, begin, this.p, this.file);
    }
    readTagToken(options = defaultOptions) {
        const { file, input } = this;
        const begin = this.p;
        if (this.readToDelimiter(options.tagDelimiterRight) === -1) {
            throw this.mkError(`tag ${this.snapshot(begin)} not closed`, begin);
        }
        const token = new TagToken(input, begin, this.p, options, file);
        if (token.name === 'raw')
            this.rawBeginAt = begin;
        return token;
    }
    readToDelimiter(delimiter) {
        while (this.p < this.N) {
            if ((this.peekType() & QUOTE)) {
                this.readQuoted();
                continue;
            }
            ++this.p;
            if (this.rmatch(delimiter))
                return this.p;
        }
        return -1;
    }
    readOutputToken(options = defaultOptions) {
        const { file, input } = this;
        const { outputDelimiterRight } = options;
        const begin = this.p;
        if (this.readToDelimiter(outputDelimiterRight) === -1) {
            throw this.mkError(`output ${this.snapshot(begin)} not closed`, begin);
        }
        return new OutputToken(input, begin, this.p, options, file);
    }
    readEndrawOrRawContent(options) {
        const { tagDelimiterLeft, tagDelimiterRight } = options;
        const begin = this.p;
        let leftPos = this.readTo(tagDelimiterLeft) - tagDelimiterLeft.length;
        while (this.p < this.N) {
            if (this.readIdentifier().getText() !== 'endraw') {
                leftPos = this.readTo(tagDelimiterLeft) - tagDelimiterLeft.length;
                continue;
            }
            while (this.p <= this.N) {
                if (this.rmatch(tagDelimiterRight)) {
                    const end = this.p;
                    if (begin === leftPos) {
                        this.rawBeginAt = -1;
                        return new TagToken(this.input, begin, end, options, this.file);
                    }
                    else {
                        this.p = leftPos;
                        return new HTMLToken(this.input, begin, leftPos, this.file);
                    }
                }
                if (this.rmatch(tagDelimiterLeft))
                    break;
                this.p++;
            }
        }
        throw this.mkError(`raw ${this.snapshot(this.rawBeginAt)} not closed`, begin);
    }
    readLiquidTagTokens(options = defaultOptions) {
        const tokens = [];
        while (this.p < this.N) {
            const token = this.readLiquidTagToken(options);
            if (token.name)
                tokens.push(token);
        }
        return tokens;
    }
    readLiquidTagToken(options) {
        const { file, input } = this;
        const begin = this.p;
        let end = this.N;
        if (this.readToDelimiter('\n') !== -1)
            end = this.p;
        return new LiquidTagToken(input, begin, end, options, file);
    }
    mkError(msg, begin) {
        return new TokenizationError(msg, new IdentifierToken(this.input, begin, this.N, this.file));
    }
    snapshot(begin = this.p) {
        return JSON.stringify(ellipsis(this.input.slice(begin), 16));
    }
    /**
     * @deprecated
     */
    readWord() {
        console.warn('Tokenizer#readWord() will be removed, use #readIdentifier instead');
        return this.readIdentifier();
    }
    readIdentifier() {
        this.skipBlank();
        const begin = this.p;
        while (this.peekType() & IDENTIFIER)
            ++this.p;
        return new IdentifierToken(this.input, begin, this.p, this.file);
    }
    readTagName() {
        this.skipBlank();
        // Handle inline comment tags
        if (this.input[this.p] === '#')
            return this.input.slice(this.p, ++this.p);
        return this.readIdentifier().getText();
    }
    readHashes(jekyllStyle) {
        const hashes = [];
        while (true) {
            const hash = this.readHash(jekyllStyle);
            if (!hash)
                return hashes;
            hashes.push(hash);
        }
    }
    readHash(jekyllStyle) {
        this.skipBlank();
        if (this.peek() === ',')
            ++this.p;
        const begin = this.p;
        const name = this.readIdentifier();
        if (!name.size())
            return;
        let value;
        this.skipBlank();
        const sep = jekyllStyle ? '=' : ':';
        if (this.peek() === sep) {
            ++this.p;
            value = this.readValue();
        }
        return new HashToken(this.input, begin, this.p, name, value, this.file);
    }
    remaining() {
        return this.input.slice(this.p);
    }
    advance(i = 1) {
        this.p += i;
    }
    end() {
        return this.p >= this.N;
    }
    readTo(end) {
        while (this.p < this.N) {
            ++this.p;
            if (this.rmatch(end))
                return this.p;
        }
        return -1;
    }
    readValue() {
        const value = this.readQuoted() || this.readRange();
        if (value)
            return value;
        if (this.peek() === '[') {
            this.p++;
            const prop = this.readQuoted();
            if (!prop)
                return;
            if (this.peek() !== ']')
                return;
            this.p++;
            return new PropertyAccessToken(prop, [], this.p);
        }
        const variable = this.readIdentifier();
        if (!variable.size())
            return;
        let isNumber = variable.isNumber(true);
        const props = [];
        while (true) {
            if (this.peek() === '[') {
                isNumber = false;
                this.p++;
                const prop = this.readValue() || new IdentifierToken(this.input, this.p, this.p, this.file);
                this.readTo(']');
                props.push(prop);
            }
            else if (this.peek() === '.' && this.peek(1) !== '.') { // skip range syntax
                this.p++;
                const prop = this.readIdentifier();
                if (!prop.size())
                    break;
                if (!prop.isNumber())
                    isNumber = false;
                props.push(prop);
            }
            else
                break;
        }
        if (!props.length && literalValues.hasOwnProperty(variable.content)) {
            return new LiteralToken(this.input, variable.begin, variable.end, this.file);
        }
        if (isNumber)
            return new NumberToken(variable, props[0]);
        return new PropertyAccessToken(variable, props, this.p);
    }
    readRange() {
        this.skipBlank();
        const begin = this.p;
        if (this.peek() !== '(')
            return;
        ++this.p;
        const lhs = this.readValueOrThrow();
        this.p += 2;
        const rhs = this.readValueOrThrow();
        ++this.p;
        return new RangeToken(this.input, begin, this.p, lhs, rhs, this.file);
    }
    readValueOrThrow() {
        const value = this.readValue();
        assert(value, () => `unexpected token ${this.snapshot()}, value expected`);
        return value;
    }
    readQuoted() {
        this.skipBlank();
        const begin = this.p;
        if (!(this.peekType() & QUOTE))
            return;
        ++this.p;
        let escaped = false;
        while (this.p < this.N) {
            ++this.p;
            if (this.input[this.p - 1] === this.input[begin] && !escaped)
                break;
            if (escaped)
                escaped = false;
            else if (this.input[this.p - 1] === '\\')
                escaped = true;
        }
        return new QuotedToken(this.input, begin, this.p, this.file);
    }
    *readFileNameTemplate(options) {
        const { outputDelimiterLeft } = options;
        const htmlStopStrings = [',', ' ', outputDelimiterLeft];
        const htmlStopStringSet = new Set(htmlStopStrings);
        // break on ',' and ' ', outputDelimiterLeft only stops HTML token
        while (this.p < this.N && !htmlStopStringSet.has(this.peek())) {
            yield this.match(outputDelimiterLeft)
                ? this.readOutputToken(options)
                : this.readHTMLToken(htmlStopStrings);
        }
    }
    match(word) {
        for (let i = 0; i < word.length; i++) {
            if (word[i] !== this.input[this.p + i])
                return false;
        }
        return true;
    }
    rmatch(pattern) {
        for (let i = 0; i < pattern.length; i++) {
            if (pattern[pattern.length - 1 - i] !== this.input[this.p - 1 - i])
                return false;
        }
        return true;
    }
    peekType(n = 0) {
        return TYPES[this.input.charCodeAt(this.p + n)];
    }
    peek(n = 0) {
        return this.input[this.p + n];
    }
    skipBlank() {
        while (this.peekType() & BLANK)
            ++this.p;
    }
}

class ParseStream {
    constructor(tokens, parseToken) {
        this.handlers = {};
        this.stopRequested = false;
        this.tokens = tokens;
        this.parseToken = parseToken;
    }
    on(name, cb) {
        this.handlers[name] = cb;
        return this;
    }
    trigger(event, arg) {
        const h = this.handlers[event];
        return h ? (h.call(this, arg), true) : false;
    }
    start() {
        this.trigger('start');
        let token;
        while (!this.stopRequested && (token = this.tokens.shift())) {
            if (this.trigger('token', token))
                continue;
            if (isTagToken(token) && this.trigger(`tag:${token.name}`, token)) {
                continue;
            }
            const template = this.parseToken(token, this.tokens);
            this.trigger('template', template);
        }
        if (!this.stopRequested)
            this.trigger('end');
        return this;
    }
    stop() {
        this.stopRequested = true;
        return this;
    }
}

class TemplateImpl {
    constructor(token) {
        this.token = token;
    }
}

class Tag extends TemplateImpl {
    constructor(token, remainTokens, liquid) {
        super(token);
        this.name = token.name;
        this.liquid = liquid;
    }
}

/**
 * Key-Value Pairs Representing Tag Arguments
 * Example:
 *    For the markup `, foo:'bar', coo:2 reversed %}`,
 *    hash['foo'] === 'bar'
 *    hash['coo'] === 2
 *    hash['reversed'] === undefined
 */
class Hash {
    constructor(markup, jekyllStyle) {
        this.hash = {};
        const tokenizer = new Tokenizer(markup, {});
        for (const hash of tokenizer.readHashes(jekyllStyle)) {
            this.hash[hash.name.content] = hash.value;
        }
    }
    *render(ctx) {
        const hash = {};
        for (const key of Object.keys(this.hash)) {
            hash[key] = this.hash[key] === undefined ? true : yield evalToken(this.hash[key], ctx);
        }
        return hash;
    }
}

function createTagClass(options) {
    return class extends Tag {
        constructor(token, tokens, liquid) {
            super(token, tokens, liquid);
            if (isFunction(options.parse)) {
                options.parse.call(this, token, tokens);
            }
        }
        *render(ctx, emitter) {
            const hash = (yield new Hash(this.token.args).render(ctx));
            return yield options.render.call(this, ctx, emitter, hash);
        }
    };
}

function isKeyValuePair(arr) {
    return isArray(arr);
}

class Filter {
    constructor(name, options, args, liquid) {
        this.name = name;
        this.handler = isFunction(options)
            ? options
            : (isFunction(options === null || options === void 0 ? void 0 : options.handler) ? options.handler : identify);
        this.raw = !isFunction(options) && !!(options === null || options === void 0 ? void 0 : options.raw);
        this.args = args;
        this.liquid = liquid;
    }
    *render(value, context) {
        const argv = [];
        for (const arg of this.args) {
            if (isKeyValuePair(arg))
                argv.push([arg[0], yield evalToken(arg[1], context)]);
            else
                argv.push(yield evalToken(arg, context));
        }
        return this.handler.apply({ context, liquid: this.liquid }, [value, ...argv]);
    }
}

class Value {
    /**
     * @param str the value to be valuated, eg.: "foobar" | truncate: 3
     */
    constructor(str, liquid) {
        this.filters = [];
        const tokenizer = new Tokenizer(str, liquid.options.operators);
        this.initial = tokenizer.readExpression();
        this.filters = tokenizer.readFilters().map(({ name, args }) => new Filter(name, this.getFilter(liquid, name), args, liquid));
    }
    *value(ctx, lenient) {
        lenient = lenient || (ctx.opts.lenientIf && this.filters.length > 0 && this.filters[0].name === 'default');
        let val = yield this.initial.evaluate(ctx, lenient);
        for (const filter of this.filters) {
            val = yield filter.render(val, ctx);
        }
        return val;
    }
    getFilter(liquid, name) {
        const impl = liquid.filters[name];
        assert(impl || !liquid.options.strictFilters, () => `undefined filter: ${name}`);
        return impl;
    }
}

class Output extends TemplateImpl {
    constructor(token, liquid) {
        var _a;
        super(token);
        this.value = new Value(token.content, liquid);
        const filters = this.value.filters;
        const outputEscape = liquid.options.outputEscape;
        if (!((_a = filters[filters.length - 1]) === null || _a === void 0 ? void 0 : _a.raw) && outputEscape) {
            filters.push(new Filter(toString.call(outputEscape), outputEscape, [], liquid));
        }
    }
    *render(ctx, emitter) {
        const val = yield this.value.value(ctx, false);
        emitter.write(val);
    }
}

class HTML extends TemplateImpl {
    constructor(token) {
        super(token);
        this.str = token.getContent();
    }
    *render(ctx, emitter) {
        emitter.write(this.str);
    }
}

var LookupType;
(function (LookupType) {
    LookupType["Partials"] = "partials";
    LookupType["Layouts"] = "layouts";
    LookupType["Root"] = "root";
})(LookupType || (LookupType = {}));
class Loader {
    constructor(options) {
        this.options = options;
        if (options.relativeReference) {
            const sep = options.fs.sep;
            assert(sep, '`fs.sep` is required for relative reference');
            const rRelativePath = new RegExp(['.' + sep, '..' + sep, './', '../'].map(prefix => escapeRegex(prefix)).join('|'));
            this.shouldLoadRelative = (referencedFile) => rRelativePath.test(referencedFile);
        }
        else {
            this.shouldLoadRelative = (referencedFile) => false;
        }
        this.contains = this.options.fs.contains || (() => true);
    }
    *lookup(file, type, sync, currentFile) {
        const { fs } = this.options;
        const dirs = this.options[type];
        for (const filepath of this.candidates(file, dirs, currentFile, type !== LookupType.Root)) {
            if (sync ? fs.existsSync(filepath) : yield fs.exists(filepath))
                return filepath;
        }
        throw this.lookupError(file, dirs);
    }
    *candidates(file, dirs, currentFile, enforceRoot) {
        const { fs, extname } = this.options;
        if (this.shouldLoadRelative(file) && currentFile) {
            const referenced = fs.resolve(this.dirname(currentFile), file, extname);
            for (const dir of dirs) {
                if (!enforceRoot || this.contains(dir, referenced)) {
                    // the relatively referenced file is within one of root dirs
                    yield referenced;
                    break;
                }
            }
        }
        for (const dir of dirs) {
            const referenced = fs.resolve(dir, file, extname);
            if (!enforceRoot || this.contains(dir, referenced)) {
                yield referenced;
            }
        }
        if (fs.fallback !== undefined) {
            const filepath = fs.fallback(file);
            if (filepath !== undefined)
                yield filepath;
        }
    }
    dirname(path) {
        const fs = this.options.fs;
        assert(fs.dirname, '`fs.dirname` is required for relative reference');
        return fs.dirname(path);
    }
    lookupError(file, roots) {
        const err = new Error('ENOENT');
        err.message = `ENOENT: Failed to lookup "${file}" in "${roots}"`;
        err.code = 'ENOENT';
        return err;
    }
}

class Parser {
    constructor(liquid) {
        this.liquid = liquid;
        this.cache = this.liquid.options.cache;
        this.fs = this.liquid.options.fs;
        this.parseFile = this.cache ? this._parseFileCached : this._parseFile;
        this.loader = new Loader(this.liquid.options);
    }
    parse(html, filepath) {
        const tokenizer = new Tokenizer(html, this.liquid.options.operators, filepath);
        const tokens = tokenizer.readTopLevelTokens(this.liquid.options);
        return this.parseTokens(tokens);
    }
    parseTokens(tokens) {
        let token;
        const templates = [];
        while ((token = tokens.shift())) {
            templates.push(this.parseToken(token, tokens));
        }
        return templates;
    }
    parseToken(token, remainTokens) {
        try {
            if (isTagToken(token)) {
                const TagClass = this.liquid.tags[token.name];
                assert(TagClass, `tag "${token.name}" not found`);
                return new TagClass(token, remainTokens, this.liquid);
            }
            if (isOutputToken(token)) {
                return new Output(token, this.liquid);
            }
            return new HTML(token);
        }
        catch (e) {
            throw new ParseError(e, token);
        }
    }
    parseStream(tokens) {
        return new ParseStream(tokens, (token, tokens) => this.parseToken(token, tokens));
    }
    *_parseFileCached(file, sync, type = LookupType.Root, currentFile) {
        const cache = this.cache;
        const key = this.loader.shouldLoadRelative(file) ? currentFile + ',' + file : type + ':' + file;
        const tpls = yield cache.read(key);
        if (tpls)
            return tpls;
        const task = this._parseFile(file, sync, type, currentFile);
        // sync mode: exec the task and cache the result
        // async mode: cache the task before exec
        const taskOrTpl = sync ? yield task : toPromise(task);
        cache.write(key, taskOrTpl);
        // note: concurrent tasks will be reused, cache for failed task is removed until its end
        try {
            return yield taskOrTpl;
        }
        catch (err) {
            cache.remove(key);
            throw err;
        }
    }
    *_parseFile(file, sync, type = LookupType.Root, currentFile) {
        const filepath = yield this.loader.lookup(file, type, sync, currentFile);
        return this.liquid.parse(sync ? this.fs.readFileSync(filepath) : yield this.fs.readFile(filepath), filepath);
    }
}

const rHex = /[\da-fA-F]/;
const rOct = /[0-7]/;
const escapeChar = {
    b: '\b',
    f: '\f',
    n: '\n',
    r: '\r',
    t: '\t',
    v: '\x0B'
};
function hexVal(c) {
    const code = c.charCodeAt(0);
    if (code >= 97)
        return code - 87;
    if (code >= 65)
        return code - 55;
    return code - 48;
}
function parseStringLiteral(str) {
    let ret = '';
    for (let i = 1; i < str.length - 1; i++) {
        if (str[i] !== '\\') {
            ret += str[i];
            continue;
        }
        if (escapeChar[str[i + 1]] !== undefined) {
            ret += escapeChar[str[++i]];
        }
        else if (str[i + 1] === 'u') {
            let val = 0;
            let j = i + 2;
            while (j <= i + 5 && rHex.test(str[j])) {
                val = val * 16 + hexVal(str[j++]);
            }
            i = j - 1;
            ret += String.fromCharCode(val);
        }
        else if (!rOct.test(str[i + 1])) {
            ret += str[++i];
        }
        else {
            let j = i + 1;
            let val = 0;
            while (j <= i + 3 && rOct.test(str[j])) {
                val = val * 8 + hexVal(str[j++]);
            }
            i = j - 1;
            ret += String.fromCharCode(val);
        }
    }
    return ret;
}

var TokenKind;
(function (TokenKind) {
    TokenKind[TokenKind["Number"] = 1] = "Number";
    TokenKind[TokenKind["Literal"] = 2] = "Literal";
    TokenKind[TokenKind["Tag"] = 4] = "Tag";
    TokenKind[TokenKind["Output"] = 8] = "Output";
    TokenKind[TokenKind["HTML"] = 16] = "HTML";
    TokenKind[TokenKind["Filter"] = 32] = "Filter";
    TokenKind[TokenKind["Hash"] = 64] = "Hash";
    TokenKind[TokenKind["PropertyAccess"] = 128] = "PropertyAccess";
    TokenKind[TokenKind["Word"] = 256] = "Word";
    TokenKind[TokenKind["Range"] = 512] = "Range";
    TokenKind[TokenKind["Quoted"] = 1024] = "Quoted";
    TokenKind[TokenKind["Operator"] = 2048] = "Operator";
    TokenKind[TokenKind["Delimited"] = 12] = "Delimited";
})(TokenKind || (TokenKind = {}));

function isDelimitedToken(val) {
    return !!(getKind(val) & TokenKind.Delimited);
}
function isOperatorToken(val) {
    return getKind(val) === TokenKind.Operator;
}
function isHTMLToken(val) {
    return getKind(val) === TokenKind.HTML;
}
function isOutputToken(val) {
    return getKind(val) === TokenKind.Output;
}
function isTagToken(val) {
    return getKind(val) === TokenKind.Tag;
}
function isQuotedToken(val) {
    return getKind(val) === TokenKind.Quoted;
}
function isLiteralToken(val) {
    return getKind(val) === TokenKind.Literal;
}
function isNumberToken(val) {
    return getKind(val) === TokenKind.Number;
}
function isPropertyAccessToken(val) {
    return getKind(val) === TokenKind.PropertyAccess;
}
function isWordToken(val) {
    return getKind(val) === TokenKind.Word;
}
function isRangeToken(val) {
    return getKind(val) === TokenKind.Range;
}
function getKind(val) {
    return val ? val.kind : -1;
}

class Context {
    constructor(env = {}, opts = defaultOptions, renderOptions = {}) {
        var _a, _b;
        /**
         * insert a Context-level empty scope,
         * for tags like `{% capture %}` `{% assign %}` to operate
         */
        this.scopes = [{}];
        this.registers = {};
        this.sync = !!renderOptions.sync;
        this.opts = opts;
        this.globals = (_a = renderOptions.globals) !== null && _a !== void 0 ? _a : opts.globals;
        this.environments = env;
        this.strictVariables = (_b = renderOptions.strictVariables) !== null && _b !== void 0 ? _b : this.opts.strictVariables;
    }
    getRegister(key) {
        return (this.registers[key] = this.registers[key] || {});
    }
    setRegister(key, value) {
        return (this.registers[key] = value);
    }
    saveRegister(...keys) {
        return keys.map(key => [key, this.getRegister(key)]);
    }
    restoreRegister(keyValues) {
        return keyValues.forEach(([key, value]) => this.setRegister(key, value));
    }
    getAll() {
        return [this.globals, this.environments, ...this.scopes]
            .reduce((ctx, val) => __assign(ctx, val), {});
    }
    /**
     * @deprecated use `_get()` instead
     */
    get(paths) {
        return toValueSync(this._get(paths));
    }
    *_get(paths) {
        const scope = this.findScope(paths[0]);
        return yield this._getFromScope(scope, paths);
    }
    /**
     * @deprecated use `_get()` instead
     */
    getFromScope(scope, paths) {
        return toValueSync(this._getFromScope(scope, paths));
    }
    *_getFromScope(scope, paths) {
        if (isString$1(paths))
            paths = paths.split('.');
        for (let i = 0; i < paths.length; i++) {
            scope = yield readProperty(scope, paths[i], this.opts.ownPropertyOnly);
            if (isNil(scope) && this.strictVariables) {
                throw new InternalUndefinedVariableError(paths.slice(0, i + 1).join('.'));
            }
        }
        return scope;
    }
    push(ctx) {
        return this.scopes.push(ctx);
    }
    pop() {
        return this.scopes.pop();
    }
    bottom() {
        return this.scopes[0];
    }
    findScope(key) {
        for (let i = this.scopes.length - 1; i >= 0; i--) {
            const candidate = this.scopes[i];
            if (key in candidate)
                return candidate;
        }
        if (key in this.environments)
            return this.environments;
        return this.globals;
    }
}
function readProperty(obj, key, ownPropertyOnly) {
    obj = toLiquid(obj);
    if (isNil(obj))
        return obj;
    if (isArray(obj) && key < 0)
        return obj[obj.length + +key];
    const value = readJSProperty(obj, key, ownPropertyOnly);
    if (value === undefined && obj instanceof Drop)
        return obj.liquidMethodMissing(key);
    if (isFunction(value))
        return value.call(obj);
    if (key === 'size')
        return readSize(obj);
    else if (key === 'first')
        return readFirst(obj);
    else if (key === 'last')
        return readLast(obj);
    return value;
}
function readJSProperty(obj, key, ownPropertyOnly) {
    if (ownPropertyOnly && !Object.hasOwnProperty.call(obj, key) && !(obj instanceof Drop))
        return undefined;
    return obj[key];
}
function readFirst(obj) {
    if (isArray(obj))
        return obj[0];
    return obj['first'];
}
function readLast(obj) {
    if (isArray(obj))
        return obj[obj.length - 1];
    return obj['last'];
}
function readSize(obj) {
    if (obj.hasOwnProperty('size') || obj['size'] !== undefined)
        return obj['size'];
    if (isArray(obj) || isString$1(obj))
        return obj.length;
    if (typeof obj === 'object')
        return Object.keys(obj).length;
}

var BlockMode;
(function (BlockMode) {
    /* store rendered html into blocks */
    BlockMode[BlockMode["OUTPUT"] = 0] = "OUTPUT";
    /* output rendered html directly */
    BlockMode[BlockMode["STORE"] = 1] = "STORE";
})(BlockMode || (BlockMode = {}));

const abs = argumentsToValue(Math.abs);
const at_least = argumentsToValue(Math.max);
const at_most = argumentsToValue(Math.min);
const ceil = argumentsToValue(Math.ceil);
const divided_by = argumentsToValue((dividend, divisor, integerArithmetic = false) => integerArithmetic ? Math.floor(dividend / divisor) : dividend / divisor);
const floor = argumentsToValue(Math.floor);
const minus = argumentsToValue((v, arg) => v - arg);
const modulo = argumentsToValue((v, arg) => v % arg);
const times = argumentsToValue((v, arg) => v * arg);
function round(v, arg = 0) {
    v = toValue(v);
    arg = toValue(arg);
    const amp = Math.pow(10, arg);
    return Math.round(v * amp) / amp;
}
function plus(v, arg) {
    v = toValue(v);
    arg = toValue(arg);
    return Number(v) + Number(arg);
}

var mathFilters = /*#__PURE__*/Object.freeze({
  __proto__: null,
  abs: abs,
  at_least: at_least,
  at_most: at_most,
  ceil: ceil,
  divided_by: divided_by,
  floor: floor,
  minus: minus,
  modulo: modulo,
  times: times,
  round: round,
  plus: plus
});

const url_decode = (x) => stringify(x).split('+').map(decodeURIComponent).join(' ');
const url_encode = (x) => stringify(x).split(' ').map(encodeURIComponent).join('+');

var urlFilters = /*#__PURE__*/Object.freeze({
  __proto__: null,
  url_decode: url_decode,
  url_encode: url_encode
});

const join = argumentsToValue((v, arg) => toArray(v).join(arg === undefined ? ' ' : arg));
const last = argumentsToValue((v) => isArray(v) ? last$1(v) : '');
const first = argumentsToValue((v) => isArray(v) ? v[0] : '');
const reverse = argumentsToValue((v) => [...toArray(v)].reverse());
function* sort(arr, property) {
    const values = [];
    for (const item of toArray(toValue(arr))) {
        values.push([
            item,
            property ? yield this.context._getFromScope(item, stringify(property).split('.')) : item
        ]);
    }
    return values.sort((lhs, rhs) => {
        const lvalue = lhs[1];
        const rvalue = rhs[1];
        return lvalue < rvalue ? -1 : (lvalue > rvalue ? 1 : 0);
    }).map(tuple => tuple[0]);
}
function sort_natural(input, property) {
    input = toValue(input);
    const propertyString = stringify(property);
    const compare = property === undefined
        ? caseInsensitiveCompare
        : (lhs, rhs) => caseInsensitiveCompare(lhs[propertyString], rhs[propertyString]);
    return [...toArray(input)].sort(compare);
}
const size = (v) => (v && v.length) || 0;
function* map(arr, property) {
    const results = [];
    for (const item of toArray(toValue(arr))) {
        results.push(yield this.context._getFromScope(item, stringify(property).split('.')));
    }
    return results;
}
function compact(arr) {
    arr = toValue(arr);
    return toArray(arr).filter(x => !isNil(toValue(x)));
}
function concat(v, arg = []) {
    v = toValue(v);
    arg = toArray(arg).map(v => toValue(v));
    return toArray(v).concat(arg);
}
function slice(v, begin, length = 1) {
    v = toValue(v);
    if (isNil(v))
        return [];
    if (!isArray(v))
        v = stringify(v);
    begin = begin < 0 ? v.length + begin : begin;
    return v.slice(begin, begin + length);
}
function* where(arr, property, expected) {
    const values = [];
    arr = toArray(toValue(arr));
    for (const item of arr) {
        values.push(yield this.context._getFromScope(item, stringify(property).split('.')));
    }
    return arr.filter((_, i) => {
        if (expected === undefined)
            return isTruthy(values[i], this.context);
        if (isComparable(expected))
            return expected.equals(values[i]);
        return values[i] === expected;
    });
}
function uniq(arr) {
    arr = toValue(arr);
    const u = {};
    return (arr || []).filter(val => {
        if (hasOwnProperty.call(u, String(val)))
            return false;
        u[String(val)] = true;
        return true;
    });
}

var arrayFilters = /*#__PURE__*/Object.freeze({
  __proto__: null,
  join: join,
  last: last,
  first: first,
  reverse: reverse,
  sort: sort,
  sort_natural: sort_natural,
  size: size,
  map: map,
  compact: compact,
  concat: concat,
  slice: slice,
  where: where,
  uniq: uniq
});

const DEFAULT_FMT = '%A, %B %-e, %Y at %-l:%M %P %z';
function date(v, format, timezoneOffset) {
    const opts = this.context.opts;
    let date;
    v = toValue(v);
    format = toValue(format);
    if (isNil(format))
        format = DEFAULT_FMT;
    else
        format = stringify(format);
    if (v === 'now' || v === 'today') {
        date = new Date();
    }
    else if (isNumber(v)) {
        date = new Date(v * 1000);
    }
    else if (isString$1(v)) {
        if (/^\d+$/.test(v)) {
            date = new Date(+v * 1000);
        }
        else if (opts.preserveTimezones) {
            date = TimezoneDate.createDateFixedToTimezone(v);
        }
        else {
            date = new Date(v);
        }
    }
    else {
        date = v;
    }
    if (!isValidDate$1(date))
        return v;
    if (timezoneOffset !== undefined) {
        date = new TimezoneDate(date, parseTimezoneOffset(date, timezoneOffset));
    }
    else if (opts.timezoneOffset !== undefined) {
        date = new TimezoneDate(date, parseTimezoneOffset(date, opts.timezoneOffset));
    }
    return strftime(date, format);
}
function isValidDate$1(date) {
    return (date instanceof Date || date instanceof TimezoneDate) && !isNaN(date.getTime());
}
/**
 * need pass in a `date` because offset is dependent on whether DST is active
 */
function parseTimezoneOffset(date, timeZone) {
    if (isNumber(timeZone))
        return timeZone;
    const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
    const tzDate = new Date(date.toLocaleString('en-US', { timeZone }));
    return (utcDate.getTime() - tzDate.getTime()) / 6e4;
}

var dateFilters = /*#__PURE__*/Object.freeze({
  __proto__: null,
  date: date
});

/**
 * String related filters
 *
 * * prefer stringify() to String() since `undefined`, `null` should eval ''
 */
function append$1(v, arg) {
    assert(arguments.length === 2, 'append expect 2 arguments');
    return stringify(v) + stringify(arg);
}
function prepend$1(v, arg) {
    assert(arguments.length === 2, 'prepend expect 2 arguments');
    return stringify(arg) + stringify(v);
}
function lstrip(v, chars) {
    if (chars) {
        chars = escapeRegExp(stringify(chars));
        return stringify(v).replace(new RegExp(`^[${chars}]+`, 'g'), '');
    }
    return stringify(v).replace(/^\s+/, '');
}
function downcase(v) {
    return stringify(v).toLowerCase();
}
function upcase(str) {
    return stringify(str).toUpperCase();
}
function remove$1(v, arg) {
    return stringify(v).split(String(arg)).join('');
}
function remove_first(v, l) {
    return stringify(v).replace(String(l), '');
}
function remove_last(v, l) {
    const str = stringify(v);
    const pattern = String(l);
    const index = str.lastIndexOf(pattern);
    if (index === -1)
        return str;
    return str.substring(0, index) + str.substring(index + pattern.length + 1);
}
function rstrip(str, chars) {
    if (chars) {
        chars = escapeRegExp(stringify(chars));
        return stringify(str).replace(new RegExp(`[${chars}]+$`, 'g'), '');
    }
    return stringify(str).replace(/\s+$/, '');
}
function split(v, arg) {
    const arr = stringify(v).split(String(arg));
    // align to ruby split, which is the behavior of shopify/liquid
    // see: https://ruby-doc.org/core-2.4.0/String.html#method-i-split
    while (arr.length && arr[arr.length - 1] === '')
        arr.pop();
    return arr;
}
function strip(v, chars) {
    if (chars) {
        chars = escapeRegExp(stringify(chars));
        return stringify(v)
            .replace(new RegExp(`^[${chars}]+`, 'g'), '')
            .replace(new RegExp(`[${chars}]+$`, 'g'), '');
    }
    return stringify(v).trim();
}
function strip_newlines(v) {
    return stringify(v).replace(/\n/g, '');
}
function capitalize(str) {
    str = stringify(str);
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
function replace(v, pattern, replacement) {
    return stringify(v).split(String(pattern)).join(replacement);
}
function replace_first(v, arg1, arg2) {
    return stringify(v).replace(String(arg1), arg2);
}
function replace_last(v, arg1, arg2) {
    const str = stringify(v);
    const pattern = String(arg1);
    const index = str.lastIndexOf(pattern);
    if (index === -1)
        return str;
    const replacement = String(arg2);
    return str.substring(0, index) + replacement + str.substring(index + pattern.length);
}
function truncate(v, l = 50, o = '...') {
    v = stringify(v);
    if (v.length <= l)
        return v;
    return v.substring(0, l - o.length) + o;
}
function truncatewords(v, words = 15, o = '...') {
    const arr = stringify(v).split(/\s+/);
    if (words <= 0)
        words = 1;
    let ret = arr.slice(0, words).join(' ');
    if (arr.length >= words)
        ret += o;
    return ret;
}

var stringFilters = /*#__PURE__*/Object.freeze({
  __proto__: null,
  append: append$1,
  prepend: prepend$1,
  lstrip: lstrip,
  downcase: downcase,
  upcase: upcase,
  remove: remove$1,
  remove_first: remove_first,
  remove_last: remove_last,
  rstrip: rstrip,
  split: split,
  strip: strip,
  strip_newlines: strip_newlines,
  capitalize: capitalize,
  replace: replace,
  replace_first: replace_first,
  replace_last: replace_last,
  truncate: truncate,
  truncatewords: truncatewords
});

const filters$1 = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, htmlFilters), mathFilters), urlFilters), arrayFilters), dateFilters), stringFilters), { json,
    raw, default: Default });

class AssignTag extends Tag {
    constructor(token, remainTokens, liquid) {
        super(token, remainTokens, liquid);
        const tokenizer = new Tokenizer(token.args, liquid.options.operators);
        this.key = tokenizer.readIdentifier().content;
        tokenizer.skipBlank();
        assert(tokenizer.peek() === '=', () => `illegal token ${token.getText()}`);
        tokenizer.advance();
        this.value = new Value(tokenizer.remaining(), this.liquid);
    }
    *render(ctx) {
        ctx.bottom()[this.key] = yield this.value.value(ctx, this.liquid.options.lenientIf);
    }
}

const MODIFIERS = ['offset', 'limit', 'reversed'];
class ForTag extends Tag {
    constructor(token, remainTokens, liquid) {
        super(token, remainTokens, liquid);
        const tokenizer = new Tokenizer(token.args, this.liquid.options.operators);
        const variable = tokenizer.readIdentifier();
        const inStr = tokenizer.readIdentifier();
        const collection = tokenizer.readValue();
        if (!variable.size() || inStr.content !== 'in' || !collection) {
            throw new Error(`illegal tag: ${token.getText()}`);
        }
        this.variable = variable.content;
        this.collection = collection;
        this.hash = new Hash(tokenizer.remaining());
        this.templates = [];
        this.elseTemplates = [];
        let p;
        const stream = this.liquid.parser.parseStream(remainTokens)
            .on('start', () => (p = this.templates))
            .on('tag:else', () => (p = this.elseTemplates))
            .on('tag:endfor', () => stream.stop())
            .on('template', (tpl) => p.push(tpl))
            .on('end', () => {
            throw new Error(`tag ${token.getText()} not closed`);
        });
        stream.start();
    }
    *render(ctx, emitter) {
        const r = this.liquid.renderer;
        let collection = toEnumerable(yield evalToken(this.collection, ctx));
        if (!collection.length) {
            yield r.renderTemplates(this.elseTemplates, ctx, emitter);
            return;
        }
        const continueKey = 'continue-' + this.variable + '-' + this.collection.getText();
        ctx.push({ continue: ctx.getRegister(continueKey) });
        const hash = yield this.hash.render(ctx);
        ctx.pop();
        const modifiers = this.liquid.options.orderedFilterParameters
            ? Object.keys(hash).filter(x => MODIFIERS.includes(x))
            : MODIFIERS.filter(x => hash[x] !== undefined);
        collection = modifiers.reduce((collection, modifier) => {
            if (modifier === 'offset')
                return offset$1(collection, hash['offset']);
            if (modifier === 'limit')
                return limit(collection, hash['limit']);
            return reversed(collection);
        }, collection);
        ctx.setRegister(continueKey, (hash['offset'] || 0) + collection.length);
        const scope = { forloop: new ForloopDrop(collection.length, this.collection.getText(), this.variable) };
        ctx.push(scope);
        for (const item of collection) {
            scope[this.variable] = item;
            yield r.renderTemplates(this.templates, ctx, emitter);
            if (emitter['break']) {
                emitter['break'] = false;
                break;
            }
            emitter['continue'] = false;
            scope.forloop.next();
        }
        ctx.pop();
    }
}
function reversed(arr) {
    return [...arr].reverse();
}
function offset$1(arr, count) {
    return arr.slice(count);
}
function limit(arr, count) {
    return arr.slice(0, count);
}

class CaptureTag extends Tag {
    constructor(tagToken, remainTokens, liquid) {
        super(tagToken, remainTokens, liquid);
        this.templates = [];
        const tokenizer = new Tokenizer(tagToken.args, this.liquid.options.operators);
        this.variable = readVariableName(tokenizer);
        assert(this.variable, () => `${tagToken.args} not valid identifier`);
        while (remainTokens.length) {
            const token = remainTokens.shift();
            if (isTagToken(token) && token.name === 'endcapture')
                return;
            this.templates.push(liquid.parser.parseToken(token, remainTokens));
        }
        throw new Error(`tag ${tagToken.getText()} not closed`);
    }
    *render(ctx) {
        const r = this.liquid.renderer;
        const html = yield r.renderTemplates(this.templates, ctx);
        ctx.bottom()[this.variable] = html;
    }
}
function readVariableName(tokenizer) {
    const word = tokenizer.readIdentifier().content;
    if (word)
        return word;
    const quoted = tokenizer.readQuoted();
    if (quoted)
        return evalQuotedToken(quoted);
}

class CaseTag extends Tag {
    constructor(tagToken, remainTokens, liquid) {
        super(tagToken, remainTokens, liquid);
        this.branches = [];
        this.elseTemplates = [];
        this.value = new Value(tagToken.args, this.liquid);
        this.elseTemplates = [];
        let p = [];
        const stream = this.liquid.parser.parseStream(remainTokens)
            .on('tag:when', (token) => {
            p = [];
            const tokenizer = new Tokenizer(token.args, this.liquid.options.operators);
            const values = [];
            while (!tokenizer.end()) {
                values.push(tokenizer.readValueOrThrow());
                tokenizer.readTo(',');
            }
            this.branches.push({
                values,
                templates: p
            });
        })
            .on('tag:else', () => (p = this.elseTemplates))
            .on('tag:endcase', () => stream.stop())
            .on('template', (tpl) => p.push(tpl))
            .on('end', () => {
            throw new Error(`tag ${tagToken.getText()} not closed`);
        });
        stream.start();
    }
    *render(ctx, emitter) {
        const r = this.liquid.renderer;
        const target = toValue(yield this.value.value(ctx, ctx.opts.lenientIf));
        let branchHit = false;
        for (const branch of this.branches) {
            for (const valueToken of branch.values) {
                const value = yield evalToken(valueToken, ctx, ctx.opts.lenientIf);
                if (target === value) {
                    yield r.renderTemplates(branch.templates, ctx, emitter);
                    branchHit = true;
                    break;
                }
            }
        }
        if (!branchHit) {
            yield r.renderTemplates(this.elseTemplates, ctx, emitter);
        }
    }
}

class CommentTag extends Tag {
    constructor(tagToken, remainTokens, liquid) {
        super(tagToken, remainTokens, liquid);
        while (remainTokens.length) {
            const token = remainTokens.shift();
            if (isTagToken(token) && token.name === 'endcomment')
                return;
        }
        throw new Error(`tag ${tagToken.getText()} not closed`);
    }
    render() { }
}

class RenderTag extends Tag {
    constructor(token, remainTokens, liquid) {
        super(token, remainTokens, liquid);
        const args = token.args;
        const tokenizer = new Tokenizer(args, this.liquid.options.operators);
        this.file = parseFilePath(tokenizer, this.liquid);
        this.currentFile = token.file;
        while (!tokenizer.end()) {
            tokenizer.skipBlank();
            const begin = tokenizer.p;
            const keyword = tokenizer.readIdentifier();
            if (keyword.content === 'with' || keyword.content === 'for') {
                tokenizer.skipBlank();
                // can be normal key/value pair, like "with: true"
                if (tokenizer.peek() !== ':') {
                    const value = tokenizer.readValue();
                    // can be normal key, like "with,"
                    if (value) {
                        const beforeAs = tokenizer.p;
                        const asStr = tokenizer.readIdentifier();
                        let alias;
                        if (asStr.content === 'as')
                            alias = tokenizer.readIdentifier();
                        else
                            tokenizer.p = beforeAs;
                        this[keyword.content] = { value, alias: alias && alias.content };
                        tokenizer.skipBlank();
                        if (tokenizer.peek() === ',')
                            tokenizer.advance();
                        continue; // matched!
                    }
                }
            }
            /**
             * restore cursor if with/for not matched
             */
            tokenizer.p = begin;
            break;
        }
        this.hash = new Hash(tokenizer.remaining());
    }
    *render(ctx, emitter) {
        const { liquid, hash } = this;
        const filepath = (yield renderFilePath(this['file'], ctx, liquid));
        assert(filepath, () => `illegal filename "${filepath}"`);
        const childCtx = new Context({}, ctx.opts, { sync: ctx.sync, globals: ctx.globals, strictVariables: ctx.strictVariables });
        const scope = childCtx.bottom();
        __assign(scope, yield hash.render(ctx));
        if (this['with']) {
            const { value, alias } = this['with'];
            scope[alias || filepath] = yield evalToken(value, ctx);
        }
        if (this['for']) {
            const { value, alias } = this['for'];
            const collection = toEnumerable(yield evalToken(value, ctx));
            scope['forloop'] = new ForloopDrop(collection.length, value.getText(), alias);
            for (const item of collection) {
                scope[alias] = item;
                const templates = (yield liquid._parsePartialFile(filepath, childCtx.sync, this['currentFile']));
                yield liquid.renderer.renderTemplates(templates, childCtx, emitter);
                scope['forloop'].next();
            }
        }
        else {
            const templates = (yield liquid._parsePartialFile(filepath, childCtx.sync, this['currentFile']));
            yield liquid.renderer.renderTemplates(templates, childCtx, emitter);
        }
    }
}
/**
 * @return null for "none",
 * @return Template[] for quoted with tags and/or filters
 * @return Token for expression (not quoted)
 * @throws TypeError if cannot read next token
 */
function parseFilePath(tokenizer, liquid) {
    if (liquid.options.dynamicPartials) {
        const file = tokenizer.readValue();
        if (file === undefined)
            throw new TypeError(`illegal argument "${tokenizer.input}"`);
        if (file.getText() === 'none')
            return;
        if (isQuotedToken(file)) {
            // for filenames like "files/{{file}}", eval as liquid template
            const templates = liquid.parse(evalQuotedToken(file));
            return optimize(templates);
        }
        return file;
    }
    const tokens = [...tokenizer.readFileNameTemplate(liquid.options)];
    const templates = optimize(liquid.parser.parseTokens(tokens));
    return templates === 'none' ? undefined : templates;
}
function optimize(templates) {
    // for filenames like "files/file.liquid", extract the string directly
    if (templates.length === 1 && isHTMLToken(templates[0].token))
        return templates[0].token.getContent();
    return templates;
}
function* renderFilePath(file, ctx, liquid) {
    if (typeof file === 'string')
        return file;
    if (Array.isArray(file))
        return liquid.renderer.renderTemplates(file, ctx);
    return yield evalToken(file, ctx);
}

class IncludeTag extends Tag {
    constructor(token, remainTokens, liquid) {
        super(token, remainTokens, liquid);
        const args = token.args;
        const tokenizer = new Tokenizer(args, this.liquid.options.operators);
        this['file'] = parseFilePath(tokenizer, this.liquid);
        this['currentFile'] = token.file;
        const begin = tokenizer.p;
        const withStr = tokenizer.readIdentifier();
        if (withStr.content === 'with') {
            tokenizer.skipBlank();
            if (tokenizer.peek() !== ':') {
                this.withVar = tokenizer.readValue();
            }
            else
                tokenizer.p = begin;
        }
        else
            tokenizer.p = begin;
        this.hash = new Hash(tokenizer.remaining(), this.liquid.options.jekyllInclude);
    }
    *render(ctx, emitter) {
        const { liquid, hash, withVar } = this;
        const { renderer } = liquid;
        const filepath = (yield renderFilePath(this['file'], ctx, liquid));
        assert(filepath, () => `illegal filename "${filepath}"`);
        const saved = ctx.saveRegister('blocks', 'blockMode');
        ctx.setRegister('blocks', {});
        ctx.setRegister('blockMode', BlockMode.OUTPUT);
        const scope = (yield hash.render(ctx));
        if (withVar)
            scope[filepath] = yield evalToken(withVar, ctx);
        const templates = (yield liquid._parsePartialFile(filepath, ctx.sync, this['currentFile']));
        ctx.push(ctx.opts.jekyllInclude ? { include: scope } : scope);
        yield renderer.renderTemplates(templates, ctx, emitter);
        ctx.pop();
        ctx.restoreRegister(saved);
    }
}

class DecrementTag extends Tag {
    constructor(token, remainTokens, liquid) {
        super(token, remainTokens, liquid);
        const tokenizer = new Tokenizer(token.args, this.liquid.options.operators);
        this.variable = tokenizer.readIdentifier().content;
    }
    render(context, emitter) {
        const scope = context.environments;
        if (!isNumber(scope[this.variable])) {
            scope[this.variable] = 0;
        }
        emitter.write(stringify(--scope[this.variable]));
    }
}

class CycleTag extends Tag {
    constructor(tagToken, remainTokens, liquid) {
        super(tagToken, remainTokens, liquid);
        this.candidates = [];
        const tokenizer = new Tokenizer(tagToken.args, this.liquid.options.operators);
        const group = tokenizer.readValue();
        tokenizer.skipBlank();
        if (group) {
            if (tokenizer.peek() === ':') {
                this.group = group;
                tokenizer.advance();
            }
            else
                this.candidates.push(group);
        }
        while (!tokenizer.end()) {
            const value = tokenizer.readValue();
            if (value)
                this.candidates.push(value);
            tokenizer.readTo(',');
        }
        assert(this.candidates.length, () => `empty candidates: ${tagToken.getText()}`);
    }
    *render(ctx, emitter) {
        const group = (yield evalToken(this.group, ctx));
        const fingerprint = `cycle:${group}:` + this.candidates.join(',');
        const groups = ctx.getRegister('cycle');
        let idx = groups[fingerprint];
        if (idx === undefined) {
            idx = groups[fingerprint] = 0;
        }
        const candidate = this.candidates[idx];
        idx = (idx + 1) % this.candidates.length;
        groups[fingerprint] = idx;
        return yield evalToken(candidate, ctx);
    }
}

class IfTag extends Tag {
    constructor(tagToken, remainTokens, liquid) {
        super(tagToken, remainTokens, liquid);
        this.branches = [];
        this.elseTemplates = [];
        let p;
        liquid.parser.parseStream(remainTokens)
            .on('start', () => this.branches.push({
            value: new Value(tagToken.args, this.liquid),
            templates: (p = [])
        }))
            .on('tag:elsif', (token) => this.branches.push({
            value: new Value(token.args, this.liquid),
            templates: (p = [])
        }))
            .on('tag:else', () => (p = this.elseTemplates))
            .on('tag:endif', function () { this.stop(); })
            .on('template', (tpl) => p.push(tpl))
            .on('end', () => { throw new Error(`tag ${tagToken.getText()} not closed`); })
            .start();
    }
    *render(ctx, emitter) {
        const r = this.liquid.renderer;
        for (const { value, templates } of this.branches) {
            const v = yield value.value(ctx, ctx.opts.lenientIf);
            if (isTruthy(v, ctx)) {
                yield r.renderTemplates(templates, ctx, emitter);
                return;
            }
        }
        yield r.renderTemplates(this.elseTemplates, ctx, emitter);
    }
}

class IncrementTag extends Tag {
    constructor(token, remainTokens, liquid) {
        super(token, remainTokens, liquid);
        const tokenizer = new Tokenizer(token.args, this.liquid.options.operators);
        this.variable = tokenizer.readIdentifier().content;
    }
    render(context, emitter) {
        const scope = context.environments;
        if (!isNumber(scope[this.variable])) {
            scope[this.variable] = 0;
        }
        const val = scope[this.variable];
        scope[this.variable]++;
        emitter.write(stringify(val));
    }
}

class LayoutTag extends Tag {
    constructor(token, remainTokens, liquid) {
        super(token, remainTokens, liquid);
        const tokenizer = new Tokenizer(token.args, this.liquid.options.operators);
        this.file = parseFilePath(tokenizer, this.liquid);
        this['currentFile'] = token.file;
        this.args = new Hash(tokenizer.remaining());
        this.templates = this.liquid.parser.parseTokens(remainTokens);
    }
    *render(ctx, emitter) {
        const { liquid, args, file } = this;
        const { renderer } = liquid;
        if (file === undefined) {
            ctx.setRegister('blockMode', BlockMode.OUTPUT);
            yield renderer.renderTemplates(this.templates, ctx, emitter);
            return;
        }
        const filepath = (yield renderFilePath(this.file, ctx, liquid));
        assert(filepath, () => `illegal filename "${filepath}"`);
        const templates = (yield liquid._parseLayoutFile(filepath, ctx.sync, this['currentFile']));
        // render remaining contents and store rendered results
        ctx.setRegister('blockMode', BlockMode.STORE);
        const html = yield renderer.renderTemplates(this.templates, ctx);
        const blocks = ctx.getRegister('blocks');
        // set whole content to anonymous block if anonymous doesn't specified
        if (blocks[''] === undefined)
            blocks[''] = (parent, emitter) => emitter.write(html);
        ctx.setRegister('blockMode', BlockMode.OUTPUT);
        // render the layout file use stored blocks
        ctx.push((yield args.render(ctx)));
        yield renderer.renderTemplates(templates, ctx, emitter);
        ctx.pop();
    }
}

class BlockTag extends Tag {
    constructor(token, remainTokens, liquid) {
        super(token, remainTokens, liquid);
        this.templates = [];
        const match = /\w+/.exec(token.args);
        this.block = match ? match[0] : '';
        while (remainTokens.length) {
            const token = remainTokens.shift();
            if (isTagToken(token) && token.name === 'endblock')
                return;
            const template = liquid.parser.parseToken(token, remainTokens);
            this.templates.push(template);
        }
        throw new Error(`tag ${token.getText()} not closed`);
    }
    *render(ctx, emitter) {
        const blockRender = this.getBlockRender(ctx);
        if (ctx.getRegister('blockMode') === BlockMode.STORE) {
            ctx.getRegister('blocks')[this.block] = blockRender;
        }
        else {
            yield blockRender(new BlockDrop(), emitter);
        }
    }
    getBlockRender(ctx) {
        const { liquid, templates } = this;
        const renderChild = ctx.getRegister('blocks')[this.block];
        const renderCurrent = function* (superBlock, emitter) {
            // add {{ block.super }} support when rendering
            ctx.push({ block: superBlock });
            yield liquid.renderer.renderTemplates(templates, ctx, emitter);
            ctx.pop();
        };
        return renderChild
            ? (superBlock, emitter) => renderChild(new BlockDrop(() => renderCurrent(superBlock, emitter)), emitter)
            : renderCurrent;
    }
}

class RawTag extends Tag {
    constructor(tagToken, remainTokens, liquid) {
        super(tagToken, remainTokens, liquid);
        this.tokens = [];
        while (remainTokens.length) {
            const token = remainTokens.shift();
            if (isTagToken(token) && token.name === 'endraw')
                return;
            this.tokens.push(token);
        }
        throw new Error(`tag ${tagToken.getText()} not closed`);
    }
    render() {
        return this.tokens.map((token) => token.getText()).join('');
    }
}

class TablerowloopDrop extends ForloopDrop {
    constructor(length, cols, collection, variable) {
        super(length, collection, variable);
        this.length = length;
        this.cols = cols;
    }
    row() {
        return Math.floor(this.i / this.cols) + 1;
    }
    col0() {
        return (this.i % this.cols);
    }
    col() {
        return this.col0() + 1;
    }
    col_first() {
        return this.col0() === 0;
    }
    col_last() {
        return this.col() === this.cols;
    }
}

class TablerowTag extends Tag {
    constructor(tagToken, remainTokens, liquid) {
        super(tagToken, remainTokens, liquid);
        const tokenizer = new Tokenizer(tagToken.args, this.liquid.options.operators);
        const variable = tokenizer.readIdentifier();
        tokenizer.skipBlank();
        const predicate = tokenizer.readIdentifier();
        const collectionToken = tokenizer.readValue();
        if (predicate.content !== 'in' || !collectionToken) {
            throw new Error(`illegal tag: ${tagToken.getText()}`);
        }
        this.variable = variable.content;
        this.collection = collectionToken;
        this.args = new Hash(tokenizer.remaining());
        this.templates = [];
        let p;
        const stream = this.liquid.parser.parseStream(remainTokens)
            .on('start', () => (p = this.templates))
            .on('tag:endtablerow', () => stream.stop())
            .on('template', (tpl) => p.push(tpl))
            .on('end', () => {
            throw new Error(`tag ${tagToken.getText()} not closed`);
        });
        stream.start();
    }
    *render(ctx, emitter) {
        let collection = toEnumerable(yield evalToken(this.collection, ctx));
        const args = (yield this.args.render(ctx));
        const offset = args.offset || 0;
        const limit = (args.limit === undefined) ? collection.length : args.limit;
        collection = collection.slice(offset, offset + limit);
        const cols = args.cols || collection.length;
        const r = this.liquid.renderer;
        const tablerowloop = new TablerowloopDrop(collection.length, cols, this.collection.getText(), this.variable);
        const scope = { tablerowloop };
        ctx.push(scope);
        for (let idx = 0; idx < collection.length; idx++, tablerowloop.next()) {
            scope[this.variable] = collection[idx];
            if (tablerowloop.col0() === 0) {
                if (tablerowloop.row() !== 1)
                    emitter.write('</tr>');
                emitter.write(`<tr class="row${tablerowloop.row()}">`);
            }
            emitter.write(`<td class="col${tablerowloop.col()}">`);
            yield r.renderTemplates(this.templates, ctx, emitter);
            emitter.write('</td>');
        }
        if (collection.length)
            emitter.write('</tr>');
        ctx.pop();
    }
}

class UnlessTag extends Tag {
    constructor(tagToken, remainTokens, liquid) {
        super(tagToken, remainTokens, liquid);
        this.branches = [];
        this.elseTemplates = [];
        let p;
        this.liquid.parser.parseStream(remainTokens)
            .on('start', () => this.branches.push({
            value: new Value(tagToken.args, this.liquid),
            test: isFalsy,
            templates: (p = [])
        }))
            .on('tag:elsif', (token) => this.branches.push({
            value: new Value(token.args, this.liquid),
            test: isTruthy,
            templates: (p = [])
        }))
            .on('tag:else', () => (p = this.elseTemplates))
            .on('tag:endunless', function () { this.stop(); })
            .on('template', (tpl) => p.push(tpl))
            .on('end', () => { throw new Error(`tag ${tagToken.getText()} not closed`); })
            .start();
    }
    *render(ctx, emitter) {
        const r = this.liquid.renderer;
        for (const { value, test, templates } of this.branches) {
            const v = yield value.value(ctx, ctx.opts.lenientIf);
            if (test(v, ctx)) {
                yield r.renderTemplates(templates, ctx, emitter);
                return;
            }
        }
        yield r.renderTemplates(this.elseTemplates, ctx, emitter);
    }
}

class BreakTag extends Tag {
    render(ctx, emitter) {
        emitter['break'] = true;
    }
}

class ContinueTag extends Tag {
    render(ctx, emitter) {
        emitter['continue'] = true;
    }
}

class EchoTag extends Tag {
    constructor(token, remainTokens, liquid) {
        super(token, remainTokens, liquid);
        this.value = new Value(token.args, this.liquid);
    }
    *render(ctx, emitter) {
        const val = yield this.value.value(ctx, false);
        emitter.write(val);
    }
}

class LiquidTag extends Tag {
    constructor(token, remainTokens, liquid) {
        super(token, remainTokens, liquid);
        const tokenizer = new Tokenizer(token.args, this.liquid.options.operators);
        const tokens = tokenizer.readLiquidTagTokens(this.liquid.options);
        this.templates = this.liquid.parser.parseTokens(tokens);
    }
    *render(ctx, emitter) {
        yield this.liquid.renderer.renderTemplates(this.templates, ctx, emitter);
    }
}

class InlineCommentTag extends Tag {
    constructor(tagToken, remainTokens, liquid) {
        super(tagToken, remainTokens, liquid);
        if (tagToken.args.search(/\n\s*[^#\s]/g) !== -1) {
            throw new Error('every line of an inline comment must start with a \'#\' character');
        }
    }
    render() { }
}

const tags = {
    assign: AssignTag,
    'for': ForTag,
    capture: CaptureTag,
    'case': CaseTag,
    comment: CommentTag,
    include: IncludeTag,
    render: RenderTag,
    decrement: DecrementTag,
    increment: IncrementTag,
    cycle: CycleTag,
    'if': IfTag,
    layout: LayoutTag,
    block: BlockTag,
    raw: RawTag,
    tablerow: TablerowTag,
    unless: UnlessTag,
    'break': BreakTag,
    'continue': ContinueTag,
    echo: EchoTag,
    liquid: LiquidTag,
    '#': InlineCommentTag
};

class Liquid {
    constructor(opts = {}) {
        this.renderer = new Render();
        this.filters = {};
        this.tags = {};
        this.options = normalize(opts);
        this.parser = new Parser(this);
        forOwn(tags, (conf, name) => this.registerTag(name, conf));
        forOwn(filters$1, (handler, name) => this.registerFilter(name, handler));
    }
    parse(html, filepath) {
        return this.parser.parse(html, filepath);
    }
    _render(tpl, scope, renderOptions) {
        const ctx = scope instanceof Context ? scope : new Context(scope, this.options, renderOptions);
        return this.renderer.renderTemplates(tpl, ctx);
    }
    render(tpl, scope, renderOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            return toPromise(this._render(tpl, scope, Object.assign(Object.assign({}, renderOptions), { sync: false })));
        });
    }
    renderSync(tpl, scope, renderOptions) {
        return toValueSync(this._render(tpl, scope, Object.assign(Object.assign({}, renderOptions), { sync: true })));
    }
    renderToNodeStream(tpl, scope, renderOptions = {}) {
        const ctx = new Context(scope, this.options, renderOptions);
        return this.renderer.renderTemplatesToNodeStream(tpl, ctx);
    }
    _parseAndRender(html, scope, renderOptions) {
        const tpl = this.parse(html);
        return this._render(tpl, scope, renderOptions);
    }
    parseAndRender(html, scope, renderOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            return toPromise(this._parseAndRender(html, scope, Object.assign(Object.assign({}, renderOptions), { sync: false })));
        });
    }
    parseAndRenderSync(html, scope, renderOptions) {
        return toValueSync(this._parseAndRender(html, scope, Object.assign(Object.assign({}, renderOptions), { sync: true })));
    }
    _parsePartialFile(file, sync, currentFile) {
        return this.parser.parseFile(file, sync, LookupType.Partials, currentFile);
    }
    _parseLayoutFile(file, sync, currentFile) {
        return this.parser.parseFile(file, sync, LookupType.Layouts, currentFile);
    }
    _parseFile(file, sync, lookupType, currentFile) {
        return this.parser.parseFile(file, sync, lookupType, currentFile);
    }
    parseFile(file, lookupType) {
        return __awaiter(this, void 0, void 0, function* () {
            return toPromise(this.parser.parseFile(file, false, lookupType));
        });
    }
    parseFileSync(file, lookupType) {
        return toValueSync(this.parser.parseFile(file, true, lookupType));
    }
    *_renderFile(file, ctx, renderFileOptions) {
        const templates = (yield this._parseFile(file, renderFileOptions.sync, renderFileOptions.lookupType));
        return yield this._render(templates, ctx, renderFileOptions);
    }
    renderFile(file, ctx, renderFileOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            return toPromise(this._renderFile(file, ctx, Object.assign(Object.assign({}, renderFileOptions), { sync: false })));
        });
    }
    renderFileSync(file, ctx, renderFileOptions) {
        return toValueSync(this._renderFile(file, ctx, Object.assign(Object.assign({}, renderFileOptions), { sync: true })));
    }
    renderFileToNodeStream(file, scope, renderOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const templates = yield this.parseFile(file);
            return this.renderToNodeStream(templates, scope, renderOptions);
        });
    }
    _evalValue(str, scope) {
        const value = new Value(str, this);
        const ctx = scope instanceof Context ? scope : new Context(scope, this.options);
        return value.value(ctx);
    }
    evalValue(str, scope) {
        return __awaiter(this, void 0, void 0, function* () {
            return toPromise(this._evalValue(str, scope));
        });
    }
    evalValueSync(str, scope) {
        return toValueSync(this._evalValue(str, scope));
    }
    registerFilter(name, filter) {
        this.filters[name] = filter;
    }
    registerTag(name, tag) {
        this.tags[name] = isFunction(tag) ? tag : createTagClass(tag);
    }
    plugin(plugin) {
        return plugin.call(this, Liquid);
    }
    express() {
        const self = this; // eslint-disable-line
        let firstCall = true;
        return function (filePath, ctx, callback) {
            if (firstCall) {
                firstCall = false;
                const dirs = normalizeDirectoryList(this.root);
                self.options.root.unshift(...dirs);
                self.options.layouts.unshift(...dirs);
                self.options.partials.unshift(...dirs);
            }
            self.renderFile(filePath, ctx).then(html => callback(null, html), callback);
        };
    }
}

var arrayWithoutHoles = createCommonjsModule(function (module) {
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(arrayWithoutHoles);

var iterableToArray = createCommonjsModule(function (module) {
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(iterableToArray);

var nonIterableSpread = createCommonjsModule(function (module) {
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(nonIterableSpread);

var toConsumableArray = createCommonjsModule(function (module) {
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _toConsumableArray = unwrapExports(toConsumableArray);

var isString = function isString(value) {
  var toStr = Object.prototype.toString;
  return toStr.call(value) === '[object String]';
};
var changeCase = function changeCase(str) {
  var hasLowerCase = _toConsumableArray(str).some(function (ch) {
    return ch >= 'a' && ch <= 'z';
  });
  return hasLowerCase ? str.toUpperCase() : str.toLowerCase();
};

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var rFormat = /%([-_0^#:]+)?(\d+)?([EO])?(.)/;

// TODO: Translations for these values.
var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

// TODO: Translations for these values.
var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var abbr = function abbr(str) {
  return str.slice(0, 3);
};
var monthNamesShort = monthNames.map(abbr);
var dayNamesShort = dayNames.map(abbr);
var suffixes = {
  1: 'st',
  2: 'nd',
  3: 'rd',
  "default": 'th'
};
var isLeapYear = function isLeapYear(d) {
  var year = d.getUTCFullYear();

  // eslint-disable-next-line no-bitwise
  return !!((year & 3) === 0 && (year % 100 || year % 400 === 0 && year));
};

// prototype extensions
var daysInMonth = function daysInMonth(d) {
  var feb = isLeapYear(d) ? 29 : 28;
  return [31, feb, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
};
var getDayOfYear = function getDayOfYear(d) {
  var num = 0;

  // eslint-disable-next-line no-plusplus
  for (var i = 0; i < d.getUTCMonth(); ++i) {
    num += daysInMonth(d)[i];
  }
  return num + d.getUTCDate();
};
var getWeekOfYear = function getWeekOfYear(d, startDay) {
  // Skip to startDay of this week
  var now = getDayOfYear(d) + (startDay - d.getUTCDay());
  // Find the first startDay of the year
  var jan1 = new Date(d.getUTCFullYear(), 0, 1);
  var then = 7 - jan1.getUTCDay() + startDay;
  return String(Math.floor((now - then) / 7) + 1);
};
var getSuffix = function getSuffix(d) {
  var str = d.getUTCDate().toString();
  // eslint-disable-next-line radix
  var index = parseInt(str.slice(-1));
  return suffixes[index] || suffixes["default"];
};
var century = function century(d) {
  return parseInt(d.getUTCFullYear().toString().substring(0, 2), 10);
};

// default to 0
var padWidths = {
  d: 2,
  e: 2,
  H: 2,
  I: 2,
  j: 3,
  k: 2,
  l: 2,
  L: 3,
  m: 2,
  M: 2,
  S: 2,
  U: 2,
  W: 2
};

// default to '0'
var padChars = {
  a: ' ',
  A: ' ',
  b: ' ',
  B: ' ',
  c: ' ',
  e: ' ',
  k: ' ',
  l: ' ',
  p: ' ',
  P: ' '
};
var formatCodes = {
  a: function a(d) {
    return dayNamesShort[d.getUTCDay()];
  },
  A: function A(d) {
    return dayNames[d.getUTCDay()];
  },
  b: function b(d) {
    return monthNamesShort[d.getUTCMonth()];
  },
  B: function B(d) {
    return monthNames[d.getUTCMonth()];
  },
  c: function c(d) {
    return d.toUTCString();
  },
  C: function C(d) {
    return century(d);
  },
  d: function d(_d) {
    return _d.getUTCDate();
  },
  e: function e(d) {
    return d.getUTCDate();
  },
  H: function H(d) {
    return d.getUTCHours();
  },
  I: function I(d) {
    return String(d.getUTCHours() % 12 || 12);
  },
  j: function j(d) {
    return getDayOfYear(d);
  },
  k: function k(d) {
    return d.getUTCHours();
  },
  l: function l(d) {
    return String(d.getUTCHours() % 12 || 12);
  },
  L: function L(d) {
    return d.getUTCMilliseconds();
  },
  m: function m(d) {
    return d.getUTCMonth() + 1;
  },
  M: function M(d) {
    return d.getUTCMinutes();
  },
  N: function N(d, opts) {
    var width = Number(opts.width) || 9;
    var str = String(d.getUTCMilliseconds()).substr(0, width);
    return str.padEnd(width, '0');
  },
  // TODO: Translations for these values.
  p: function p(d) {
    return d.getUTCHours() < 12 ? 'AM' : 'PM';
  },
  P: function P(d) {
    return d.getUTCHours() < 12 ? 'am' : 'pm';
  },
  q: function q(d) {
    return getSuffix(d);
  },
  s: function s(d) {
    return Math.round(d.valueOf() / 1000);
  },
  S: function S(d) {
    return d.getUTCSeconds();
  },
  u: function u(d) {
    return d.getUTCDay() || 7;
  },
  U: function U(d) {
    return getWeekOfYear(d, 0);
  },
  w: function w(d) {
    return d.getUTCDay();
  },
  W: function W(d) {
    return getWeekOfYear(d, 1);
  },
  y: function y(d) {
    return d.getUTCFullYear().toString().substring(2, 4);
  },
  Y: function Y(d) {
    return d.getUTCFullYear();
  },
  t: function t() {
    return '\t';
  },
  n: function n() {
    return '\n';
  },
  '%': function _() {
    return '%';
  }
};
formatCodes.h = formatCodes.b;
var format = function format(d, match) {
  var _match = _slicedToArray(match, 5),
    input = _match[0],
    _match$ = _match[1],
    flagStr = _match$ === void 0 ? '' : _match$,
    width = _match[2],
    modifier = _match[3],
    conversion = _match[4];
  var convert = formatCodes[conversion];
  if (!convert) {
    return input;
  }
  var flags = {};

  // eslint-disable-next-line no-restricted-syntax
  var _iterator = _createForOfIteratorHelper(flagStr),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var flag = _step.value;
      flags[flag] = true;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var ret = String(convert(d, {
    flags: flags,
    width: width,
    modifier: modifier
  }));
  var padChar = padChars[conversion] || '0';
  var padWidth = width || padWidths[conversion] || 0;
  if (flags['^']) {
    ret = ret.toUpperCase();
  } else if (flags['#']) {
    ret = changeCase(ret);
  }
  if (flags._) {
    padChar = ' ';
  } else if (flags['0']) {
    padChar = '0';
  }
  if (flags['-']) {
    padWidth = 0;
  }
  return ret.padStart(padWidth, padChar);
};
var strftimeUtc = (function (d, formatStr) {
  var output = '';
  var remaining = formatStr;
  var match;

  // eslint-disable-next-line no-cond-assign
  while (match = rFormat.exec(remaining)) {
    output += remaining.slice(0, match.index);
    remaining = remaining.slice(match.index + match[0].length);
    output += format(d, match);
  }
  return output + remaining;
});

var isValidDate = function isValidDate(date) {
  return date instanceof Date && !Number.isNaN(date.getTime());
};
var dateUTC = function dateUTC(v, arg) {
  var date = v;
  if (v === 'now' || v === 'today') {
    date = new Date();
  } else if (Number.isFinite(v)) {
    date = new Date(v * 1000);
  } else if (isString(v)) {
    date = /^\d+$/.test(v) ? new Date(+v * 1000) : new Date(v);
  }
  return isValidDate(date) ? strftimeUtc(date, arg) : v;
};
var dateUTC$1 = {
  name: 'dateUTC',
  filter: dateUTC
};

var filters = [dateUTC$1];
var registerFilters = function registerFilters(engine) {
  filters.forEach(function (_ref) {
    var name = _ref.name,
      filter = _ref.filter;
    return engine.registerFilter(name, filter);
  });
};
var getLiquidEngine = function getLiquidEngine() {
  var engine = new Liquid();
  registerFilters(engine);
  return engine;
};

var liquidEngine = getLiquidEngine();
var FormattingTypes = {
  DurationSeconds: 'DURATION_SECONDS',
  DateTime: 'DATE_TIME'
};

// The duration format should come as a configuration.
var formatDuration = function formatDuration(value) {
  if (!Number.isInteger(value)) {
    console.error('Expected to format a number', value);
    return '';
  }

  // Less than a minute
  if (value <= 60) {
    return "".concat(value, "sec");
  }

  // Less than a 10 minutes
  if (value <= 600) {
    var _min = Math.floor(value / 60);
    var sec = value % 60;
    return "".concat(_min, "m ").concat(sec, "s");
  }

  // Less than a hour
  if (value <= 3600) {
    return "".concat(Math.floor(value / 60), "m");
  }
  var hour = Math.floor(value / 3600);
  var min = Math.floor(value / 60) % 60;
  return "".concat(hour, "h ").concat(min, "min");
};
var formatValue = function formatValue(format, value) {
  if (!value || !format) {
    return value;
  }
  switch (format) {
    case FormattingTypes.DurationSeconds:
      {
        return formatDuration(Number(value));
      }
    case FormattingTypes.DateTime:
      // TODO: use moment.js or date-fns here
      return new Date(value).toString();
    default:
      return value;
  }
};

/**
 * Apply databinding on a value based on context with optional formatting.
 *
 * @param {object} params Parameters object.
 * @param {string} params.value Binding expression.
 * @param {object} params.context Binding context.
 * @param {FormattingTypes} [params.format] Format for dates, durations, etc.
 * @returns {string} The databound result.
 */
var applyDatabinding = function applyDatabinding(_ref) {
  var value = _ref.value,
    format = _ref.format,
    context = _ref.context;
  if (!value || typeof value !== 'string') {
    return value;
  }
  var dataValue;
  try {
    dataValue = liquidEngine.parseAndRenderSync(value, context);
  } catch (ex) {
    dataValue = value;
  }
  return formatValue(format, dataValue);
};

/**
 * Apply databinding on an object, going prop by prop, recursively if needed.
 * Does not support formatting.
 *
 * @param {object} object Object containing binding expressions in some of its props. Must not contain circular references.
 * @param {object} context Binding context.
 * @returns {object} New object with the same keys and databound values.
 */
var databindObject = function databindObject(object, context) {
  if (!object) {
    return object;
  }
  var res = {};
  Object.entries(object).forEach(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      val = _ref3[1];
    if (typeof val === 'string') {
      res[key] = applyDatabinding({
        value: val,
        context: context
      });
    } else if (Array.isArray(val)) {
      res[key] = val.map(function (el) {
        if (typeof el === 'string') {
          return applyDatabinding({
            value: el,
            context: context
          });
        }
        if (_typeof(el) === 'object') {
          return databindObject(el, context);
        }
        return el;
      });
    } else if (_typeof(val) === 'object') {
      res[key] = databindObject(val, context);
    } else {
      res[key] = val;
    }
  });
  return res;
};
var convertBindingToKeyPath = function convertBindingToKeyPath(context) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!value || typeof value !== 'string') {
    return value;
  }

  /**
   * If value is templated string e.g. {{ item.id }}
   * Leading/trailing curly braces will be removed first
   */
  var fixedValue = value.replace(/[{}\s]/g, '');
  return get(context, fixedValue, value);
};

var isTypeViewSize = function isTypeViewSize(_ref) {
  var type = _ref.type;
  return type === 'VIEW_SIZE';
};
var viewSizeMap = {
  xs: 0,
  sm: 1,
  md: 2,
  lg: 3,
  xl: 4,
  xxl: 5
};
var getMappedViewSize = function getMappedViewSize(value) {
  var ALLOWED_LENGTH = 2;
  var valueArr = isString$2(value) && value.split('.');
  return valueArr.length === ALLOWED_LENGTH && viewSizeMap[valueArr[1]];
};
var ConditionTypes = {
  Exists: 'EXISTS',
  Equal: 'EQ',
  NotEqual: 'NE',
  GreaterOrEqualThan: 'GTE',
  LessOrEqualThan: 'LTE',
  GreaterThan: 'GT',
  LessThan: 'LT',
  And: 'AND',
  Or: 'OR',
  In: 'IN',
  NotIn: 'NIN',
  DoesIntersect: 'DOES_INTERSECT',
  DoesNotIntersect: 'DOES_NOT_INTERSECT'
};
var isBooleanString = function isBooleanString(value) {
  return value === 'true' || value === 'false';
};
var isNullish = function isNullish(value) {
  return value === null || value === undefined;
};

// Check if value contains liquid syntax and if so, evaluate it and return result
var evaluateLiquid = function evaluateLiquid(value) {
  if (typeof value === 'string' && value.indexOf('{{') > -1) {
    // We are evaluating the value with no context data. This looks strange, but
    // it is absolutely fine to evaluate things like `{{ 'now' | date: '%s' }}`
    return applyDatabinding({
      value: value,
      context: {}
    });
  }
  return value;
};

// Returns whether two arrays are considered intersecting
var isIntersecting = function isIntersecting(subject, value) {
  // keypaths can point to anything else. invalid keypaths are left as strings. if not arrays, fallback to empty.
  var subjectArray = Array.isArray(subject) ? subject : [];
  var valueSet = new Set(Array.isArray(value) ? value : []);
  if (subjectArray.length === 0 && valueSet.size === 0) {
    // spec says that we should consider 2 empty arrays intersecting.
    return true;
  }

  // do they have at least one shared item?
  return !!subjectArray.find(function (item) {
    return valueSet.has(item);
  });
};
var exists = function exists(subject, value) {
  if (!isBooleanString(value)) {
    console.warn("Value of ".concat(ConditionTypes.Exists, " condition type must be \"true\" or \"false\""));
    return false;
  }
  var result = !isNullish(subject);
  return value === 'true' ? result : !result;
};

/**
 * Converts a literal value to the appropriate type.
 * @param {string} value the literal value as string.
 * @param {*} toMatch the context item whose type the literal value should be converted to.
 */
var convertLiteralValue = function convertLiteralValue(value, toMatch) {
  if (!isString$2(value)) {
    console.warn("Literal value \"".concat(value, "\" (").concat(_typeof(value), ") must be string"));
    return;
  }
  if (isString$2(toMatch)) {
    return value;
  }
  if (isBoolean(toMatch) && isBooleanString(value)) {
    return value === 'true';
  }
  if (Number.isFinite(toMatch)) {
    var result = parseFloat(value);
    if (!Number.isNaN(result)) {
      return result;
    }
  }
};

/**
 * Checks for data types.
 * @param {string} type the condition type.
 * @param {*} subject the parameter.
 * @param {*} value the value that the subject should evaluate against.
 */
var withDataType = function withDataType(type, subject, value) {
  if (isObject$5(value) && isTypeViewSize(value)) {
    var viewSizeValue = value.value;
    return {
      type: type,
      subject: getMappedViewSize(subject),
      value: viewSizeMap[viewSizeValue]
    };
  }
  if (!isNullish(subject) && !isNullish(value) || type === ConditionTypes.Exists) {
    return {
      type: type,
      subject: subject,
      value: value
    };
  }
};

/**
 * Evaluates subject and value by the type of condition.
 * @param {Object} conditionObj the condition object.
 * @param {string} conditionObj.type the condition type.
 * @param {*} conditionObj.subject the parameter.
 * @param {*} conditionObj.value the value that the subject should evaluate against.
 */
var evaluateByType = function evaluateByType(conditionObj) {
  if (!conditionObj) {
    return false;
  }
  var type = conditionObj.type,
    subject = conditionObj.subject,
    value = conditionObj.value;
  switch (type) {
    case ConditionTypes.Exists:
      return exists(subject, value);
    case ConditionTypes.Equal:
      return subject === value;
    case ConditionTypes.NotEqual:
      return subject !== value;
    case ConditionTypes.GreaterOrEqualThan:
      return subject >= value;
    case ConditionTypes.LessOrEqualThan:
      return subject <= value;
    case ConditionTypes.GreaterThan:
      return subject > value;
    case ConditionTypes.LessThan:
      return subject < value;
    case ConditionTypes.In:
      return Array.isArray(value) && value.some(function (item) {
        return item === convertLiteralValue(subject, item);
      });
    case ConditionTypes.NotIn:
      return Array.isArray(value) && value.every(function (item) {
        return item !== convertLiteralValue(subject, item);
      });
    case ConditionTypes.DoesIntersect:
      return isIntersecting(subject, value);
    case ConditionTypes.DoesNotIntersect:
      return !isIntersecting(subject, value);
    default:
      console.warn('Unsupported condition type', type);
      return false;
    // Failed to parse the condition.
  }
};

/**
 * Evaluates the condition with the context.
 *
 * Example of a membership operator condition:
 *
 * {
 *   type: 'IN',
 *   subject: '1',
 *   value: 'item.genres'
 * }
 *
 * "value" is a key path referring to a property in the context.
 *
 * Example of other operator conditions:
 *
 * {
 *   type: 'GT',
 *   subject: 'item.season.number',
 *   value: '3'
 * }
 *
 * "subject" is a key path referring to a property in the context.
 *
 * @param {*} condition
 * @param {*} context
 */
var evaluateCondition = function evaluateCondition(condition, context) {
  var type = condition.type,
    subject = condition.subject,
    value = condition.value,
    negate = condition.negate,
    conditions = condition.conditions;
  var result = false;
  if (type === ConditionTypes.And) {
    result = Array.isArray(conditions) && conditions.every(function (subCondition) {
      return evaluateCondition(subCondition, context);
    });
  } else if (type === ConditionTypes.Or) {
    result = Array.isArray(conditions) && conditions.find(function (subCondition) {
      return evaluateCondition(subCondition, context);
    });
  } else if (type === ConditionTypes.Exists) {
    var contextSubject = get(context, subject);
    result = evaluateByType(withDataType(type, contextSubject, value));
  } else if ([ConditionTypes.In, ConditionTypes.NotIn, ConditionTypes.DoesIntersect, ConditionTypes.DoesNotIntersect].includes(type)) {
    var contextValue = convertBindingToKeyPath(context, value);
    var _contextSubject = convertBindingToKeyPath(context, subject);
    result = evaluateByType(withDataType(type, _contextSubject, contextValue));
  } else {
    var _contextSubject2 = get(context, subject);
    if (_contextSubject2 === undefined) {
      console.warn("Can't get value of key path \"".concat(subject, "\""));
    } else {
      var literalValue = convertLiteralValue(evaluateLiquid(value), _contextSubject2);
      result = evaluateByType(withDataType(type, _contextSubject2, literalValue));
    }
  }
  return negate ? !result : result;
};
var getItemTemplate = function getItemTemplate(item, index, itemTemplateRules) {
  var skipConditions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return itemTemplateRules.find(function (rule) {
    var condition = rule.condition;
    return !condition || !skipConditions && evaluateCondition(condition, {
      item: item,
      params: {
        index: index
      },
      viewContext: {
        index: index
      }
    });
  });
};

var ContentModes;
(function (ContentModes) {
    ContentModes["Fill"] = "SCALE_ASPECT_FILL";
    ContentModes["Fit"] = "SCALE_ASPECT_FIT";
})(ContentModes || (ContentModes = {}));

var HeightAndWidthTypes;
(function (HeightAndWidthTypes) {
    HeightAndWidthTypes["FillParent"] = "FILL_PARENT";
    HeightAndWidthTypes["FitContent"] = "FIT_CONTENT";
})(HeightAndWidthTypes || (HeightAndWidthTypes = {}));

var Positions;
(function (Positions) {
    Positions["Top"] = "TOP";
    Positions["Bottom"] = "BOTTOM";
    Positions["Center"] = "CENTER";
    Positions["Start"] = "START";
    Positions["End"] = "END";
})(Positions || (Positions = {}));
var IconPositions;
(function (IconPositions) {
    IconPositions["Start"] = "START";
    IconPositions["End"] = "END";
})(IconPositions || (IconPositions = {}));
var Alignment;
(function (Alignment) {
    Alignment["Start"] = "START";
    Alignment["Center"] = "CENTER";
    Alignment["End"] = "END";
})(Alignment || (Alignment = {}));
var GravityTypes;
(function (GravityTypes) {
    GravityTypes["Start"] = "START";
    GravityTypes["Center"] = "CENTER";
    GravityTypes["End"] = "END";
    GravityTypes["SpaceBetween"] = "SPACE_BETWEEN";
})(GravityTypes || (GravityTypes = {}));
var Directions;
(function (Directions) {
    Directions["Up"] = "UP";
    Directions["Down"] = "DOWN";
    Directions["Left"] = "LEFT";
    Directions["Right"] = "RIGHT";
})(Directions || (Directions = {}));

const growthMap = {
    [Directions.Up]: 'column-reverse',
    [Directions.Down]: 'column',
    [Directions.Left]: 'row-reverse',
    [Directions.Right]: 'row',
};
const gravityMap = {
    [GravityTypes.Start]: 'flex-start',
    [GravityTypes.Center]: 'center',
    [GravityTypes.End]: 'flex-end',
    [GravityTypes.SpaceBetween]: 'space-between',
};
const alignmentMap = {
    [Positions.Top]: 'flex-start',
    [Positions.Bottom]: 'flex-end',
    [Positions.Center]: 'center',
    [Positions.Start]: 'flex-start',
    [Positions.End]: 'flex-end',
};
const gradientDirectionMap = {
    [Directions.Up]: '0deg,',
    [Directions.Down]: '180deg,',
    [Directions.Left]: '270deg,',
    [Directions.Right]: '90deg,',
};

let baseFontSize = 0;
const rem = (px, base = baseFontSize) => px / base;
const remToPx = (remValue) => remValue * baseFontSize;
const SizeTypes = {
    None: 0,
    ExtraSmall: 1,
    Small: 2,
    Medium: 3,
    Large: 4,
    ExtraLarge: 5,
    XXLarge: 6,
};
var GutterSize;
(function (GutterSize) {
    GutterSize["None"] = "NONE";
    GutterSize["Small"] = "SMALL";
    GutterSize["Medium"] = "MEDIUM";
    GutterSize["Large"] = "LARGE";
})(GutterSize || (GutterSize = {}));
var CornerRadius;
(function (CornerRadius) {
    CornerRadius["None"] = "NONE";
    CornerRadius["Small"] = "SMALL";
    CornerRadius["Medium"] = "MEDIUM";
    CornerRadius["Large"] = "LARGE";
})(CornerRadius || (CornerRadius = {}));
/**
 * The previous usage of IconSizesRem is through SizeTypes enum (see above)
 * which has values 0 to 6
 * Based on spec document, we should be using text enums and they are limited to SMALL / MEDIUM / LARGE
 * But to support larger sizes for features like Watch History and Favorites pages' empty state,
 * we will add more values in text enums. See below
 */
var IconSize;
(function (IconSize) {
    IconSize["xsmall"] = "XSMALL";
    IconSize["small"] = "SMALL";
    IconSize["medium"] = "MEDIUM";
    IconSize["large"] = "LARGE";
    IconSize["xlarge"] = "XLARGE";
    IconSize["xxlarge"] = "XXLARGE";
    IconSize["xxxlarge"] = "XXXLARGE";
})(IconSize || (IconSize = {}));
const gutterSizesRem = {
    [GutterSize.None]: 0,
};
const cornerRadiiRem = {
    [GutterSize.None]: 0,
};
const IconSizesRem = {};
const FontSizesRem = {};
// copy source or default value, converted to rems, into target, for one key
const set = (target, source, key, defaultValue) => {
    var _a;
    target[key] = rem((_a = source === null || source === void 0 ? void 0 : source[key]) !== null && _a !== void 0 ? _a : defaultValue);
};
/**
 * The rem method and the values in this file are used for rendering in many parts
 * of dynamic ui.
 * setSizes is exposed to provide a way to set custom values by consuming client.
 * Intention is that setSizes is called to set custom values once after dynamic ui
 * has been loaded, before using dynamic ui for any rendering.
 */
const setSizes = (values = {}) => {
    baseFontSize = values.baseFontSize || 18;
    set(gutterSizesRem, values.gutterSizesRem, GutterSize.Small, 11); //  ~10px, +1 to account for rounding loss
    set(gutterSizesRem, values.gutterSizesRem, GutterSize.Medium, 17); // ~15px, +2 to account for rounding loss
    set(gutterSizesRem, values.gutterSizesRem, GutterSize.Large, 28); //   ~25px, +3 to account for rounding loss
    set(cornerRadiiRem, values.cornerRadiiRem, CornerRadius.Small, 5);
    set(cornerRadiiRem, values.cornerRadiiRem, CornerRadius.Medium, 15);
    set(cornerRadiiRem, values.cornerRadiiRem, CornerRadius.Large, 25);
    set(IconSizesRem, values.IconSizesRem, IconSize.xsmall, 6);
    set(IconSizesRem, values.IconSizesRem, IconSize.small, 12);
    set(IconSizesRem, values.IconSizesRem, IconSize.medium, 24);
    set(IconSizesRem, values.IconSizesRem, IconSize.large, 36);
    set(IconSizesRem, values.IconSizesRem, IconSize.xlarge, 42);
    set(IconSizesRem, values.IconSizesRem, IconSize.xxlarge, 54);
    set(IconSizesRem, values.IconSizesRem, IconSize.xxxlarge, 118);
    set(FontSizesRem, values.FontSizesRem, SizeTypes.ExtraSmall, 11);
    set(FontSizesRem, values.FontSizesRem, SizeTypes.Small, 13);
    set(FontSizesRem, values.FontSizesRem, SizeTypes.Medium, 17);
    set(FontSizesRem, values.FontSizesRem, SizeTypes.Large, 22);
    set(FontSizesRem, values.FontSizesRem, SizeTypes.ExtraLarge, 34);
    set(FontSizesRem, values.FontSizesRem, SizeTypes.XXLarge, 42);
};
// set default sizes
setSizes();

/**
 * Enum with supported breakpoint names
 */
var BreakpointKeys;
(function (BreakpointKeys) {
    BreakpointKeys["XS"] = "xs";
    BreakpointKeys["SM"] = "sm";
    BreakpointKeys["MD"] = "md";
    BreakpointKeys["LG"] = "lg";
    BreakpointKeys["XL"] = "xl";
    BreakpointKeys["XXL"] = "xxl";
})(BreakpointKeys || (BreakpointKeys = {}));
/**
 * Array of the breakpoint keys in order from XS to XXL.
 */
const breakpointOrder = [
    BreakpointKeys.XS,
    BreakpointKeys.SM,
    BreakpointKeys.MD,
    BreakpointKeys.LG,
    BreakpointKeys.XL,
    BreakpointKeys.XXL,
];
/**
 * Object mapping the breakpoint key to the width in pixels.
 */
const breakpoints$1 = {
    [BreakpointKeys.XXL]: null,
    [BreakpointKeys.XL]: 1600,
    [BreakpointKeys.LG]: 1200,
    [BreakpointKeys.MD]: 992,
    [BreakpointKeys.SM]: 768,
    [BreakpointKeys.XS]: 576,
};
/**
 * Array of key-value objects mapping breakpoint key to width in pixels, in order from XS to XXL.
 */
const OrderedBreakpoints = breakpointOrder.map((key) => ({
    key,
    value: breakpoints$1[key],
}));
/**
 * Wraps a CSS style in a media query with the breakpoint as the `max-width`.
 * @param {BreakpointKeys} breakpointKey The breakpoint key.
 * @param {string} style The style block to wrap.
 * @returns {string} Media query.
 */
const styleUntilBreakpoint = (breakpointKey, style) => {
    if (breakpointKey === BreakpointKeys.XXL) {
        return style;
    }
    return `
    @media screen and (max-width: ${breakpoints$1[breakpointKey]}px) {
      ${style}
    }
  `;
};
/**
 * Get the value from a responsive property based on the current breakpoint.
 * @template T
 * @param {ResponsiveProp<T>} responsiveProp Responsive property object.
 * @param {BreakpointKeys} breakpoint Key of the current breakpoint.
 * @returns {T | null} The value of the property for the current breakpoint.
 */
const getSettingsForBreakpoint = (responsiveProp, breakpoint) => {
    if (!responsiveProp) {
        return null;
    }
    const breakpointIndex = breakpointOrder.indexOf(breakpoint);
    const breakpointWithSettings = breakpointOrder.find((p, index) => index >= breakpointIndex && responsiveProp[p]);
    return responsiveProp[breakpointWithSettings]; // TODO: Fix me
};

// This is factory method and because of that `react/display-name` rule does not make sense here
// eslint-disable-next-line react/display-name
var ItemFactory = function ItemFactory(TemplateRenderer) {
  return function (props) {
    return /*#__PURE__*/React__default.createElement(TemplateRenderer, _extends$3({}, props, {
      "data-cy": "Item_Item_TemplateRenderer"
    }));
  };
};

var aspectRatios = {};

// aspectRatio is expected to be a string like "16:9"
function percentFromAspectRatio(aspectRatio) {
  if (aspectRatio && !aspectRatios[aspectRatio]) {
    var _String$split = String(aspectRatio).split(':'),
      _String$split2 = _slicedToArray(_String$split, 2),
      w = _String$split2[0],
      h = _String$split2[1];
    var percent = Number(h) / Number(w) * 100;
    if (!Number.isNaN(percent)) {
      aspectRatios[aspectRatio] = "".concat(percent, "%");
    }
  }
  return aspectRatios[aspectRatio];
}

var InnerContent = styled('div').withConfig({
  displayName: "AspectRatio__InnerContent",
  componentId: "sc-1nt6mj4-0"
})(["position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;width:100%;height:100%;", ""], function (_ref) {
  var $corner = _ref.$corner;
  return "border-radius: ".concat($corner || 0, "rem;");
});
InnerContent.displayName = 'InnerContent';
var AspectRatio = styled(function (_ref2) {
  var className = _ref2.className,
    children = _ref2.children,
    cornerRadiusRem = _ref2.cornerRadiusRem,
    dataDyn = _ref2['data-dyn'];
  return /*#__PURE__*/React__default.createElement("div", {
    className: className,
    "data-dyn": dataDyn,
    "data-cy": "AspectRatio_AspectRatio_div"
  }, /*#__PURE__*/React__default.createElement(InnerContent, {
    $corner: cornerRadiusRem,
    "data-cy": "AspectRatio_AspectRatio_InnerContent"
  }, children));
}).withConfig({
  displayName: "AspectRatio",
  componentId: "sc-1nt6mj4-1"
})(["position:", ";padding-top:", ";"], function (_ref3) {
  var position = _ref3.position;
  return position || 'relative';
}, function (_ref4) {
  var aspectRatio = _ref4.aspectRatio;
  return percentFromAspectRatio(aspectRatio);
});
AspectRatio.displayName = 'AspectRatio';

// The questions about hoverZoom/activeZoom are still open.
// In the meantime we want a simpler solution that we can use today.
var cssSimpleHoverZoom = css$1([".hoverZoomContainer{overflow:hidden;isolation:isolate;img{transition-duration:150ms;transition-property:transform,filter;transition-timing-function:ease-in-out;}&:hover img{transform:scale3d(1.03,1.03,1);filter:brightness(1.04);}}"]);

/**
 * Empty styled component to generate a shared item classname.
 * This is used for animations to trigger with item-hover effects and
 * as a shared class between Slider and Grid items for centralised styling.
 */
var ItemWrapper = styled.div.withConfig({
  displayName: "ItemWrapper",
  componentId: "sc-mu2koe-0"
})([":empty{padding-top:", ";}", ""], function (_ref) {
  var $aspectRatio = _ref.$aspectRatio;
  return percentFromAspectRatio($aspectRatio);
}, cssSimpleHoverZoom);

var AnimationTypes;
(function (AnimationTypes) {
    AnimationTypes["FadeIn"] = "FADE_IN";
    AnimationTypes["SlideIn"] = "SLIDE_IN";
})(AnimationTypes || (AnimationTypes = {}));
var SlideInDirections;
(function (SlideInDirections) {
    SlideInDirections["Up"] = "UP";
    SlideInDirections["Down"] = "DOWN";
    SlideInDirections["Left"] = "LEFT";
    SlideInDirections["Right"] = "RIGHT";
})(SlideInDirections || (SlideInDirections = {}));
const slideDirections = {
    [SlideInDirections.Up]: 'translateY(100%);',
    [SlideInDirections.Down]: 'translateY(-100%);',
    [SlideInDirections.Left]: 'translateX(100%);',
    [SlideInDirections.Right]: 'translateX(-100%);',
};
/**
 * Creates a slide in animation when the item is hovered.
 * @param {*} direction the direction that the component should slide.
 */
const animateSlide = (direction) => {
    return `
    ${ItemWrapper} & {
      opacity: 0;
      transform: ${slideDirections[direction]}
      transition: opacity .2s ease-out,transform .2s ease-out;
    }

    ${ItemWrapper}:hover & {
      opacity: 1;
      transform: translateY(0);
    }
  `;
};
/**
 * Creates a fade in animation when the item is hovered.
 */
const animateFadeIn = () => {
    return `
    ${ItemWrapper} & {
      opacity: 0;
    }

    ${ItemWrapper}:hover & {
      animation: fadein 0.2s;
      animation-fill-mode: forwards;
      animation-delay: 200ms;

      @keyframes fadein {
        0% {
          opacity: 0;
        }

        100% {
          opacity: 1;
          transform: scale(1);
        }
      }
    }
  `;
};
/**
 * Adds animations to the component if they have been set.
 */
const animations = ({ animation }) => {
    if (!animation) {
        return '';
    }
    const { type, direction } = animation;
    if (type === AnimationTypes.FadeIn) {
        return animateFadeIn();
    }
    if (type === AnimationTypes.SlideIn) {
        return animateSlide(direction);
    }
    return '';
};

const getResponsiveValue = (responsiveValues = {}, breakpoint = 'xxl') => {
    return responsiveValues[breakpoint] || responsiveValues.xxl;
};
const getStyleForResponsivePropValue = ({ props, propName, valueTransformer = rem, styleName = propName, styleSuffix = 'rem', }) => {
    if (!props) {
        return '';
    }
    const prop = props[propName];
    const value = getResponsiveValue(prop);
    const transformedValue = valueTransformer(value);
    return transformedValue
        ? `${styleName}: ${transformedValue}${styleSuffix};`
        : '';
};
const marginRightFunc = ({ margin }) => getStyleForResponsivePropValue({
    props: margin,
    propName: 'right',
    styleName: 'margin-right',
});
const marginLeftFunc = ({ margin }) => getStyleForResponsivePropValue({
    props: margin,
    propName: 'left',
    styleName: 'margin-left',
});
const marginTopFunc = ({ margin }) => getStyleForResponsivePropValue({
    props: margin,
    propName: 'top',
    styleName: 'margin-top',
});
const marginBottomFunc = ({ margin }) => getStyleForResponsivePropValue({
    props: margin,
    propName: 'bottom',
    styleName: 'margin-bottom',
});
const addMargins = (props) => {
    return `
  ${marginRightFunc(props)}
  ${marginLeftFunc(props)}
  ${marginTopFunc(props)}
  ${marginBottomFunc(props)}
`;
};
// Paddings
const paddingRightFunc = ({ padding }) => getStyleForResponsivePropValue({
    props: padding,
    propName: 'right',
    styleName: 'padding-right',
});
const paddingLeftFunc = ({ padding }) => getStyleForResponsivePropValue({
    props: padding,
    propName: 'left',
    styleName: 'padding-left',
});
const paddingTopFunc = ({ padding }) => getStyleForResponsivePropValue({
    props: padding,
    propName: 'top',
    styleName: 'padding-top',
});
const paddingBottomFunc = ({ padding }) => getStyleForResponsivePropValue({
    props: padding,
    propName: 'bottom',
    styleName: 'padding-bottom',
});
const addPaddings = (props) => {
    return `
    ${paddingRightFunc(props)}
    ${paddingLeftFunc(props)}
    ${paddingTopFunc(props)}
    ${paddingBottomFunc(props)}
  `;
};
/**
 * Set the weight.
 *
 * @param {*} weight can either be a string or an object with responsive weights.
 */
const addWeight = (weight) => {
    if (!weight) {
        return '';
    }
    if (typeof weight === 'number') {
        return `flex: ${weight};`;
    }
    if (typeof weight === 'object') {
        // Going though a reversed order of breakpoints so the css is applied in the correct order.
        return OrderedBreakpoints.filter(({ key }) => weight[key] >= 0) // TODO: Fix me
            .map(({ key }) => styleUntilBreakpoint(key, `flex: ${weight[key]};`))
            .reverse()
            .join('\n');
    }
    const errorMessage = `Cannot parse the weight of type ${typeof weight}`;
    console.error(errorMessage, weight);
    throw Error(errorMessage);
};
// ('width', width, contentWidth) OR ('height', height, contentHeight)
const getDimension = (dimension, size, contentSize) => {
    if (contentSize) {
        return `${dimension}: ${rem(getResponsiveValue(contentSize))}rem;`;
    }
    if (size === HeightAndWidthTypes.FillParent) {
        return `${dimension}: 100%;`;
    }
    return '';
};
const generalUtils = (props) => {
    const { height, width, contentHeight, contentWidth, weight, action } = props;
    return `
    box-sizing: border-box;
    ${getDimension('height', height, contentHeight)}
    ${getDimension('width', width, contentWidth)}
    ${addWeight(weight)}
    ${addMargins(props)}
    ${addPaddings(props)}
    ${animations(props)}
    ${action ? 'cursor: pointer; outline: none;' : ''}
  `;
};

/**
 * Gets value for corner radius (in rem) basing on the component properties
 * and theme from the context. `cornerRadius` defined in properties takes precedence
 * And corner radius will be applied only when `applyCornerRadius` is set on the
 * properties level
 */
function getCornerRadiusRem(props, theme) {
    if (!props) {
        return 0;
    }
    const cornerRadius = props.cornerRadius || (theme === null || theme === void 0 ? void 0 : theme.cornerRadius);
    return (props.applyCornerRadius && cornerRadiiRem[cornerRadius]) || 0;
}

/**
 * Creates placeholder template and items, based on the real item template.
 * @param {number} count Number of placeholder items to create.
 * @param {Object} realItemTemplate The real item template. Usually `itemTemplateRules[0].template`.
 * @param {Object} [context] Context object, for rounded corners and other context-based features.
 * @returns {Object} Object containing `placeholderTemplate` object and `placeholders` arrays.
 */
var createItemPlaceholders = function createItemPlaceholders(count, realItemTemplate) {
  var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _ref = realItemTemplate || {},
    aspectRatio = _ref.aspectRatio,
    aspectRatios = _ref.aspectRatios;
  var placeholderTemplate = {
    id: 'template-item-placeholder',
    aspectRatio: aspectRatio,
    aspectRatios: aspectRatios,
    component: {
      type: 'GROUP',
      properties: {
        width: HeightAndWidthTypes.FillParent,
        height: HeightAndWidthTypes.FillParent,
        applyCornerRadius: true
      },
      children: [{
        type: 'IMAGE',
        properties: {
          value: '',
          width: HeightAndWidthTypes.FillParent,
          height: HeightAndWidthTypes.FillParent,
          applyCornerRadius: true
        }
      }]
    }
  };
  var placeholders = _toConsumableArray(new Array(count)).map(function (_, index) {
    return {
      id: "placeholder-".concat(index),
      templateRule: {
        template: placeholderTemplate
      },
      context: _extends$3({}, context, {
        item: {}
      })
    };
  });
  return {
    placeholderTemplate: placeholderTemplate,
    placeholders: placeholders
  };
};

/**
 * Returns `data-dyn` DOM attribute if applicable.
 * This allows automated test cases to select a DOM elemnt based on the DynUi layout id.
 * Usage: <SomeComp {...dataDyn(props)} />
 * @param props {object} The main `props` object (ie: NOT `props.properties`)
 * @returns {object|null} Object with an `data-dyn` prop, or null.
 */
var dataDyn = function dataDyn(props) {
  if (!(props !== null && props !== void 0 && props.id)) {
    return null;
  }
  return {
    'data-dyn': props.id
  };
};

var ariaProps = ['alt', 'aria-label', 'tabIndex', 'role'];
var jsxProps = ['children', 'className', 'onClick', 'onKeyDown', 'onMouseDown', 'style', 'src', 'type'].concat(ariaProps);
var slickProps = ['afterChange', 'arrows', 'autoplay', 'beforeChange', 'centerMode', 'centerPadding', 'dots', 'infinite', 'nextArrow', 'prevArrow', 'responsive', 'speed', 'slidesToScroll', 'slidesToShow'];

// TODO: find a different solution for this
// updating this list doesn't seem to be maintainable
var dynamicUiProps = ['action', 'alignment', 'animate', 'aspectRatio', 'aspectRatios', 'autoslide', 'backgroundColor', 'clicked', 'color', 'columnWeight', 'containerType', 'contentHeight', 'contentMode', 'contentWidth', 'cornerRadius', 'currentBreakpoint', 'direction', 'dynamicSearch', 'externalFeedType', 'filter', 'fontSize', 'gradient', 'gradientColor', 'gravity', 'growth', 'gutter', 'gutterRem', 'height', 'imagePath', 'imagePosition', 'isHeading', 'isHidden', 'limit', 'margin', 'marginBottom', 'marginLeft', 'marginRight', 'marginTop', 'maxLines', 'menu', 'navBar', 'navigationBar', 'orderBy', 'padding', 'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop', 'pageType', 'parentCollectionId', 'position', 'roundedCorners', 'searchInput', 'searchQuery', 'selectedQuery', 'showProgress', 'size', 'templateId', 'textOverlayEnabled', 'textClassStyles', 'title', 'topContainerShouldNotOverlap', 'value', 'visibility', 'weight', 'weightSum', 'width'];
var allowed = [].concat(_toConsumableArray(jsxProps), slickProps);
var dynamicUiPropsSet = new Set(dynamicUiProps);
var allowedSet = new Set(allowed);
var filterProperties = (function (properties) {
  var tempProps = {};
  Object.keys(properties).forEach(function (key) {
    if (
    // transient props are managed by styled-components,
    // but we still need to filter them out here
    !key.startsWith('$') && !dynamicUiPropsSet.has(key)) {
      tempProps[key] = properties[key];
      if (!key.startsWith('aria-') && !key.startsWith('data-') && !allowedSet.has(key)) {
        // warning for unexpected props
        console.warn("Unknown property \"".concat(key, "\" being passed to DOM element"));
      }
    }
  });
  return tempProps;
});

// returns an object only containing the aria-related props
var filterAriaProperties = function filterAriaProperties(props) {
  return Object.fromEntries(Object.entries(props).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      key = _ref2[0];
    return ariaProps.includes(key);
  }));
};

var toPrimitive = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(toPrimitive);

var toPropertyKey = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];

function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(toPropertyKey);

var defineProperty = createCommonjsModule(function (module) {
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _defineProperty = unwrapExports(defineProperty);

var engine = getLiquidEngine();
var getTemplateValue = function getTemplateValue(feed, ctx, key) {
  try {
    return engine.parseAndRenderSync(feed, _extends$3({}, key ? _defineProperty({}, key, ctx) : ctx));
  } catch (ex) {
    return feed;
  }
};

var spin = keyframes(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var SpinnerContainer = styled.div.withConfig({
  displayName: "Spinner__SpinnerContainer",
  componentId: "sc-vibhdq-0"
})(["display:flex;align-items:center;justify-content:center;width:100%;height:3rem;line-height:3rem;& svg{animation:", " 1500ms linear infinite;}"], spin);
SpinnerContainer.displayName = 'SpinnerContainer';
var Spinner = function Spinner(_ref) {
  var Icon = _ref.Icon;
  if (!Icon) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(SpinnerContainer, {
    "data-cy": "helpers_Spinner_SpinnerContainer"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "spinner",
    "data-cy": "helpers_Spinner_Icon"
  }));
};
Spinner.propTypes = {
  Icon: PropTypes__default.elementType
};

// create a color getter function for styled components
// ex: `color: ${themeColor('textBody', 'sliderArrow', DEFAULT_ARROW_COLOR)};`
// TODO: for renamed colors. don' use this anymore, and remove in the long term.
var themeColor = function themeColor(name, oldName, fallbackColor) {
  return function (_ref) {
    var _theme$color;
    var theme = _ref.theme;
    var color = theme === null || theme === void 0 ? void 0 : (_theme$color = theme.color) === null || _theme$color === void 0 ? void 0 : _theme$color[name];
    var oldColor = theme === null || theme === void 0 ? void 0 : theme[oldName];
    return color || oldColor || fallbackColor;
  };
};

/**
 * Hook to observe when an HTML element enters the view.
 * @param {Object} params Parameters object.
 * @param {React.RefObject<HTMLElement>} params.targetRef Ref of the HTML element to observe.
 * @param {boolean} [params.enabled] Handlers won't be called if this is false.
 * @param {string} [params.rootMargin] Additional margin around the hitbox.
 * @param {Function} [params.onFirstEnterView] Handler to call when the element enters the view for the first time.
 * @param {Function} [params.onEnterView] Handler to call every time when the element enters the view.
 * @returns void
 */
var useIntersection = function useIntersection(_ref) {
  var targetRef = _ref.targetRef,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    rootMargin = _ref.rootMargin,
    rootElement = _ref.rootElement,
    _ref$onFirstEnterView = _ref.onFirstEnterView,
    onFirstEnterView = _ref$onFirstEnterView === void 0 ? NOOP : _ref$onFirstEnterView,
    _ref$onEnterView = _ref.onEnterView,
    onEnterView = _ref$onEnterView === void 0 ? NOOP : _ref$onEnterView;
  var wasOnScreen = useRef(false);
  useEffect(function () {
    if (!targetRef.current || !enabled) {
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      var _entries = _slicedToArray(entries, 1),
        _entries$ = _entries[0],
        firstEntry = _entries$ === void 0 ? {} : _entries$;
      var isIntersecting = firstEntry.isIntersecting,
        intersectionRatio = firstEntry.intersectionRatio;
      if (isIntersecting || isIntersecting === undefined && intersectionRatio > 0) {
        if (!wasOnScreen.current) {
          wasOnScreen.current = true;
          onFirstEnterView();
        }
        onEnterView();
      }
    }, {
      root: rootElement || document,
      threshold: 0,
      rootMargin: rootMargin
    });
    observer.observe(targetRef.current);
    return function () {
      return observer.disconnect();
    };
  }, [targetRef, enabled, rootElement, rootMargin, onEnterView, onFirstEnterView]);
};

var isVisible = function isVisible(props, context) {
  var _properties$visibilit;
  var _props$properties = props.properties,
    properties = _props$properties === void 0 ? {} : _props$properties,
    visibility = props.visibility;

  // visbility condition can be found in two places now based on the item type
  var visibilityCondition = (_properties$visibilit = properties.visibility) !== null && _properties$visibilit !== void 0 ? _properties$visibilit : visibility;
  return visibilityCondition ? evaluateCondition(visibilityCondition, context) : true;
};

// Terminology:
// Event handlers: that we will put on DOM elements to handle actions, like a button `onClick`.
// Action handlers: that the application passed in (in the `actions` property) to handle actions, like the `navigate`

// Here we generate an object with event handlers that will call the respective action handlers.
// For example an `onClick` handler, that will call the provided `navigate` function on the application side.

/**
 * TODO#actions2: We will slowly transition to an upper snake-casing format ActionTypes
 * Kindly remove this TODO comment block once done with all the changes
 * Remove ActionTypes and all reference to action.type once all templates are using action.kind
 */
var ActionTypes = {
  Navigate: 'navigate',
  Play: 'play',
  Rate: 'rate',
  Share: 'share',
  Authenticate: 'authenticate',
  Purchase: 'purchase',
  AddToFavorites: 'ADD_TO_FAVORITES',
  RemoveFromFavorites: 'REMOVE_FROM_FAVORITES',
  OpenPrivacyLawSettings: 'openPrivacyLawSettings',
  ItemAction: 'itemAction',
  NavigateExternal: 'NAVIGATE_TO_EXTERNAL_LINK',
  NavigatePage: 'NAVIGATE_TO_PAGE',
  NavigateInternal: 'NAVIGATE_TO_INTERNAL_VIEW',
  Register: 'REGISTER'
};

// ActionKind should contain all the supported action kinds from spec
// https://github.com/Accedo-Products/one-dynamic-ui-specification/blob/master/docs/components.md#action-kind-enum
var ActionKind = {
  ItemAction: 'ITEM_ACTION',
  NavigateExternal: 'NAVIGATE_TO_EXTERNAL_LINK',
  NavigatePage: 'NAVIGATE_TO_PAGE',
  NavigateInternal: 'NAVIGATE_TO_INTERNAL_VIEW',
  Register: 'REGISTER',
  AddToFavorites: 'ADD_TO_FAVORITES',
  RemoveFromFavorites: 'REMOVE_FROM_FAVORITES',
  OpenPrivacyLawSettings: 'OPEN_PRIVACY_LAW_SETTINGS',
  Purchase: 'PURCHASE',
  Play: 'PLAY',
  Share: 'SHARE',
  Login: 'LOGIN',
  Logout: 'LOGOUT'
};

// TODO#actions2: AuthView is obsolete. Remove it when `Authenticate` is removed
var AuthView = {
  Login: 'LOGIN',
  Registration: 'REGISTER'
};
var MediaType = {
  Item: 'ITEM',
  Collection: 'COLLECTION'
};
var ActionDestinationTypes = {
  Page: 'PAGE'
};
var actionNoop = function actionNoop() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  console.warn('Missing action handler', args);
};
var actionDetails = function actionDetails(action) {
  return {
    actionName: action.kind || action.type,
    ActionNames: action.kind ? ActionKind : ActionTypes
  };
};
var eventHandlers = function eventHandlers() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var action = arguments.length > 2 ? arguments[2] : undefined;
  if (!action) {
    return null;
  }

  // TODO#actions2: `kind` should be always used once deprecated actions are removed.
  // `actionName` should be `action.kind` and `ActionNames` should be `ActionKind`.
  var _actionDetails = actionDetails(action),
    actionName = _actionDetails.actionName,
    ActionNames = _actionDetails.ActionNames;

  // When we see itemAction action then we need to extract the action details
  // from the given path and then use the new action instead
  if (actionName === ActionNames.ItemAction) {
    var _action$params, _action$parameters;
    var selector = ((_action$params = action.params) === null || _action$params === void 0 ? void 0 : _action$params.path) || ((_action$parameters = action.parameters) === null || _action$parameters === void 0 ? void 0 : _action$parameters.path);
    var nextAction = get(context, selector);
    if (!nextAction) {
      console.warn("action type \"".concat(actionName, "\" required resolving an action from \"").concat(selector, "\", but it wasn't possible. Maybe path selector was wrong? Context:"), context);
      return;
    }
    action = nextAction;
    var _actionDetails2 = actionDetails(nextAction);
    actionName = _actionDetails2.actionName;
    ActionNames = _actionDetails2.ActionNames;
  }
  var handlers = {};

  // create a click handler that will forward all params to the action handler and stop propagation only if the
  // action and action handler are properly configured. otherwise ignore, and allow propagation.
  var makeClickHandler = function makeClickHandler() {
    for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      params[_key2] = arguments[_key2];
    }
    return function (event) {
      // `kind` is the new one. it should take precedence. if it's missing,
      // or the action it points to is not implemented yet, fall back to `type`.
      var actionHandler = actions[action.kind] || actions[action.type];
      if (!actionHandler) {
        return actionNoop;
      }
      actionHandler.apply(void 0, params);
      event === null || event === void 0 ? void 0 : event.stopPropagation();
    };
  };

  // TODO#actions2: params are @deprecated. Remove it in the future
  var parameters = _extends$3({}, action.params, action.parameters);

  // evaluate the item id & type binding expressions from the action.parameters
  var bindItemParams = function bindItemParams() {
    // spec: `itemId`, deprecated: `videoId`.
    // TODO: remove `videoId` when the layouts migrated to `itemId`
    var resourceId = applyDatabinding({
      value: parameters.itemId || parameters.videoId || '{{item.id}}',
      context: context
    }) || undefined;
    // spec: `itemType`, fallback to `{{item.type}}`, then `ITEM`
    var resourceType = applyDatabinding({
      value: parameters.itemType || '{{item.type}}',
      context: context
    }) || 'ITEM';
    return {
      resourceId: resourceId,
      resourceType: resourceType
    };
  };
  if (actionName === ActionNames.NavigateExternal) {
    var link = applyDatabinding({
      value: parameters.link || '',
      context: context
    });
    handlers.onClick = makeClickHandler(link, context.item, parameters);
  } else if (actionName === ActionNames.NavigateInternal) {
    var view = applyDatabinding({
      value: parameters.view || '',
      context: context
    });
    handlers.onClick = makeClickHandler(view, context.item, parameters);
  } else if (actionName === ActionNames.NavigatePage) {
    var _dataBoundParameters$;
    var dataBoundParameters = databindObject(parameters, context);

    // objectType has to be lowercase to ensure no breaking changes out of Dynamic UI
    if (dataBoundParameters !== null && dataBoundParameters !== void 0 && (_dataBoundParameters$ = dataBoundParameters.context) !== null && _dataBoundParameters$ !== void 0 && _dataBoundParameters$.objectType) {
      dataBoundParameters.context.objectType = dataBoundParameters.context.objectType.toLowerCase();
    }
    handlers.onClick = makeClickHandler(dataBoundParameters, context.item);
  } else if (actionName === ActionNames.Navigate) {
    var _destination$id, _context$item, _context$item2, _context$item2$type;
    var destination = parameters.destination || {};
    var destinationId = applyDatabinding({
      value: destination.id,
      context: context
    });

    // TODO: only temporary solution for navigating to browse page
    var pageId = (_destination$id = destination.id) !== null && _destination$id !== void 0 && _destination$id.match('^{{item.description}}$') ? "/page/".concat(destinationId) : destinationId;
    var navigationType = destination.type;
    var resourceId = (_context$item = context.item) === null || _context$item === void 0 ? void 0 : _context$item.id;
    var resourceType = (_context$item2 = context.item) === null || _context$item2 === void 0 ? void 0 : (_context$item2$type = _context$item2.type) === null || _context$item2$type === void 0 ? void 0 : _context$item2$type.toLowerCase();
    handlers.onClick = makeClickHandler(pageId, resourceId, resourceType, navigationType, context.item);
  } else if (actionName === ActionNames.Share) {
    // Note: we don't need the URL param from the action, because we always share the current URL.
    var paramUrl = parameters.url;
    handlers.onClick = makeClickHandler(paramUrl, context.item);
  } else if ([ActionNames.Purchase, ActionNames.Register, ActionNames.Login, ActionNames.Rate, ActionNames.Play].includes(actionName)) {
    var _bindItemParams = bindItemParams(),
      _resourceId = _bindItemParams.resourceId,
      _resourceType = _bindItemParams.resourceType;
    handlers.onClick = makeClickHandler(_resourceId, _resourceType, context.item);
  } else if (actionName === ActionNames.Authenticate) {
    var initialView = parameters.initialView;
    handlers.onClick = makeClickHandler(initialView);
  } else if ([ActionNames.AddToFavorites, ActionNames.RemoveFromFavorites].includes(actionName)) {
    var itemId = parameters.itemId,
      itemType = parameters.itemType;
    var finalItemId = applyDatabinding({
      value: itemId,
      context: context
    });
    var finalItemType = applyDatabinding({
      value: itemType,
      context: context
    });
    handlers.onClick = makeClickHandler(finalItemId, finalItemType);
  } else if ([ActionNames.OpenPrivacyLawSettings, ActionNames.Logout].includes(actionName)) {
    handlers.onClick = makeClickHandler();
  } else {
    // to prevent silent fail in case of deprecated `onEvent` action still in use
    var actionJson = JSON.stringify(action);
    throw new Error("action type \"".concat(actionName, "\" not supported: ").concat(actionJson));
  }

  // Because we do not have content items represented as links nor buttons, we need to emulate them as
  // such. Adding tabindex allows user to focus the element, but still a click needs to be triggered somehow
  // TODO: Please remove this workaround once components are correctly transitioned to links / buttons
  handlers.onKeyDown = function (e) {
    if (e.key === 'Enter') {
      var _e$currentTarget;
      // Stop bubbling up to the parent elements
      e.stopPropagation();

      // Our fix really applies to the containers. We don't want this on buttons for example
      if (((_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 ? void 0 : _e$currentTarget.tagName) === 'DIV') {
        e.currentTarget.click();
      }
    }
  };
  return handlers;
};

var classCallCheck = createCommonjsModule(function (module) {
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _classCallCheck = unwrapExports(classCallCheck);

var createClass = createCommonjsModule(function (module) {
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _createClass = unwrapExports(createClass);

var Button = styled.button.withConfig({
  displayName: "Button",
  componentId: "sc-w4clsr-0"
})(["display:inline-flex;align-items:center;border:none;border-radius:100rem;outline:none;font-size:inherit;cursor:pointer;padding:0.5rem 2rem;background-color:#427dee;color:white;"]);
Button.displayName = 'Button';

var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _objectWithoutPropertiesLoose = unwrapExports(objectWithoutPropertiesLoose);

var objectWithoutProperties = createCommonjsModule(function (module) {
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _objectWithoutProperties = unwrapExports(objectWithoutProperties);

var setPrototypeOf = createCommonjsModule(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(setPrototypeOf);

var inheritsLoose = createCommonjsModule(function (module) {
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}
module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _inheritsLoose = unwrapExports(inheritsLoose);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

/*!
 * content-type
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */

/**
 * RegExp to match *( ";" parameter ) in RFC 7231 sec 3.1.1.1
 *
 * parameter     = token "=" ( token / quoted-string )
 * token         = 1*tchar
 * tchar         = "!" / "#" / "$" / "%" / "&" / "'" / "*"
 *               / "+" / "-" / "." / "^" / "_" / "`" / "|" / "~"
 *               / DIGIT / ALPHA
 *               ; any VCHAR, except delimiters
 * quoted-string = DQUOTE *( qdtext / quoted-pair ) DQUOTE
 * qdtext        = HTAB / SP / %x21 / %x23-5B / %x5D-7E / obs-text
 * obs-text      = %x80-FF
 * quoted-pair   = "\" ( HTAB / SP / VCHAR / obs-text )
 */
var PARAM_REGEXP = /; *([!#$%&'*+.^_`|~0-9A-Za-z-]+) *= *("(?:[\u000b\u0020\u0021\u0023-\u005b\u005d-\u007e\u0080-\u00ff]|\\[\u000b\u0020-\u00ff])*"|[!#$%&'*+.^_`|~0-9A-Za-z-]+) */g;

/**
 * RegExp to match quoted-pair in RFC 7230 sec 3.2.6
 *
 * quoted-pair = "\" ( HTAB / SP / VCHAR / obs-text )
 * obs-text    = %x80-FF
 */
var QESC_REGEXP = /\\([\u000b\u0020-\u00ff])/g;

/**
 * RegExp to match type in RFC 7231 sec 3.1.1.1
 *
 * media-type = type "/" subtype
 * type       = token
 * subtype    = token
 */
var TYPE_REGEXP = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+\/[!#$%&'*+.^_`|~0-9A-Za-z-]+$/;
var parse_1 = parse;

/**
 * Parse media type to object.
 *
 * @param {string|object} string
 * @return {Object}
 * @public
 */

function parse (string) {
  if (!string) {
    throw new TypeError('argument string is required')
  }

  // support req/res-like objects as argument
  var header = typeof string === 'object'
    ? getcontenttype(string)
    : string;

  if (typeof header !== 'string') {
    throw new TypeError('argument string is required to be a string')
  }

  var index = header.indexOf(';');
  var type = index !== -1
    ? header.substr(0, index).trim()
    : header.trim();

  if (!TYPE_REGEXP.test(type)) {
    throw new TypeError('invalid media type')
  }

  var obj = new ContentType(type.toLowerCase());

  // parse parameters
  if (index !== -1) {
    var key;
    var match;
    var value;

    PARAM_REGEXP.lastIndex = index;

    while ((match = PARAM_REGEXP.exec(header))) {
      if (match.index !== index) {
        throw new TypeError('invalid parameter format')
      }

      index += match[0].length;
      key = match[1].toLowerCase();
      value = match[2];

      if (value[0] === '"') {
        // remove quotes and escapes
        value = value
          .substr(1, value.length - 2)
          .replace(QESC_REGEXP, '$1');
      }

      obj.parameters[key] = value;
    }

    if (index !== header.length) {
      throw new TypeError('invalid parameter format')
    }
  }

  return obj
}

/**
 * Get content-type from req/res objects.
 *
 * @param {object}
 * @return {Object}
 * @private
 */

function getcontenttype (obj) {
  var header;

  if (typeof obj.getHeader === 'function') {
    // res-like
    header = obj.getHeader('content-type');
  } else if (typeof obj.headers === 'object') {
    // req-like
    header = obj.headers && obj.headers['content-type'];
  }

  if (typeof header !== 'string') {
    throw new TypeError('content-type header is missing from object')
  }

  return header
}

/**
 * Class to represent a content type.
 * @private
 */
function ContentType (type) {
  this.parameters = Object.create(null);
  this.type = type;
}

var cache = new Map();

var cloneSvg = function cloneSvg(sourceSvg) {
  return sourceSvg.cloneNode(true);
};

var isLocal = function isLocal() {
  return window.location.protocol === 'file:';
};

var makeAjaxRequest = function makeAjaxRequest(url, httpRequestWithCredentials, callback) {
  var httpRequest = new XMLHttpRequest();
  httpRequest.onreadystatechange = function () {
    try {
      if (!/\.svg/i.test(url) && httpRequest.readyState === 2) {
        var contentType = httpRequest.getResponseHeader('Content-Type');
        if (!contentType) {
          throw new Error('Content type not found');
        }
        var type = parse_1(contentType).type;
        if (!(type === 'image/svg+xml' || type === 'text/plain')) {
          throw new Error("Invalid content type: ".concat(type));
        }
      }
      if (httpRequest.readyState === 4) {
        if (httpRequest.status === 404 || httpRequest.responseXML === null) {
          throw new Error(isLocal() ? 'Note: SVG injection ajax calls do not work locally without ' + 'adjusting security settings in your browser. Or consider ' + 'using a local webserver.' : 'Unable to load SVG file: ' + url);
        }
        if (httpRequest.status === 200 || isLocal() && httpRequest.status === 0) {
          callback(null, httpRequest);
        } else {
          throw new Error('There was a problem injecting the SVG: ' + httpRequest.status + ' ' + httpRequest.statusText);
        }
      }
    } catch (error) {
      httpRequest.abort();
      if (error instanceof Error) {
        callback(error, httpRequest);
      } else {
        throw error;
      }
    }
  };
  httpRequest.open('GET', url);
  httpRequest.withCredentials = httpRequestWithCredentials;
  if (httpRequest.overrideMimeType) {
    httpRequest.overrideMimeType('text/xml');
  }
  httpRequest.send();
};

var requestQueue = {};
var queueRequest = function queueRequest(url, callback) {
  requestQueue[url] = requestQueue[url] || [];
  requestQueue[url].push(callback);
};
var processRequestQueue = function processRequestQueue(url) {
  var _loop_1 = function _loop_1(i, len) {
    setTimeout(function () {
      if (Array.isArray(requestQueue[url])) {
        var cacheValue = cache.get(url);
        var callback = requestQueue[url][i];
        if (cacheValue instanceof SVGSVGElement) {
          callback(null, cloneSvg(cacheValue));
        }
        if (cacheValue instanceof Error) {
          callback(cacheValue);
        }
        if (i === requestQueue[url].length - 1) {
          delete requestQueue[url];
        }
      }
    }, 0);
  };
  for (var i = 0, len = requestQueue[url].length; i < len; i++) {
    _loop_1(i);
  }
};

var loadSvgCached = function loadSvgCached(url, httpRequestWithCredentials, callback) {
  if (cache.has(url)) {
    var cacheValue = cache.get(url);
    if (cacheValue === undefined) {
      queueRequest(url, callback);
      return;
    }
    if (cacheValue instanceof SVGSVGElement) {
      callback(null, cloneSvg(cacheValue));
      return;
    }
  }
  cache.set(url, undefined);
  queueRequest(url, callback);
  makeAjaxRequest(url, httpRequestWithCredentials, function (error, httpRequest) {
    var _a;
    if (error) {
      cache.set(url, error);
    } else if (((_a = httpRequest.responseXML) === null || _a === void 0 ? void 0 : _a.documentElement) instanceof SVGSVGElement) {
      cache.set(url, httpRequest.responseXML.documentElement);
    }
    processRequestQueue(url);
  });
};

var loadSvgUncached = function loadSvgUncached(url, httpRequestWithCredentials, callback) {
  makeAjaxRequest(url, httpRequestWithCredentials, function (error, httpRequest) {
    var _a;
    if (error) {
      callback(error);
    } else if (((_a = httpRequest.responseXML) === null || _a === void 0 ? void 0 : _a.documentElement) instanceof SVGSVGElement) {
      callback(null, httpRequest.responseXML.documentElement);
    }
  });
};

var idCounter = 0;
var uniqueId = function uniqueId() {
  return ++idCounter;
};

var injectedElements = [];
var ranScripts = {};
var svgNamespace$1 = 'http://www.w3.org/2000/svg';
var xlinkNamespace$1 = 'http://www.w3.org/1999/xlink';
var injectElement = function injectElement(el, evalScripts, renumerateIRIElements, cacheRequests, httpRequestWithCredentials, beforeEach, callback) {
  var elUrl = el.getAttribute('data-src') || el.getAttribute('src');
  if (!elUrl) {
    callback(new Error('Invalid data-src or src attribute'));
    return;
  }
  if (injectedElements.indexOf(el) !== -1) {
    injectedElements.splice(injectedElements.indexOf(el), 1);
    el = null;
    return;
  }
  injectedElements.push(el);
  el.setAttribute('src', '');
  var loadSvg = cacheRequests ? loadSvgCached : loadSvgUncached;
  loadSvg(elUrl, httpRequestWithCredentials, function (error, svg) {
    if (!svg) {
      injectedElements.splice(injectedElements.indexOf(el), 1);
      el = null;
      callback(error);
      return;
    }
    var elId = el.getAttribute('id');
    if (elId) {
      svg.setAttribute('id', elId);
    }
    var elTitle = el.getAttribute('title');
    if (elTitle) {
      svg.setAttribute('title', elTitle);
    }
    var elWidth = el.getAttribute('width');
    if (elWidth) {
      svg.setAttribute('width', elWidth);
    }
    var elHeight = el.getAttribute('height');
    if (elHeight) {
      svg.setAttribute('height', elHeight);
    }
    var mergedClasses = Array.from(new Set(__spreadArray(__spreadArray(__spreadArray([], (svg.getAttribute('class') || '').split(' '), true), ['injected-svg'], false), (el.getAttribute('class') || '').split(' '), true))).join(' ').trim();
    svg.setAttribute('class', mergedClasses);
    var elStyle = el.getAttribute('style');
    if (elStyle) {
      svg.setAttribute('style', elStyle);
    }
    svg.setAttribute('data-src', elUrl);
    var elData = [].filter.call(el.attributes, function (at) {
      return /^data-\w[\w-]*$/.test(at.name);
    });
    Array.prototype.forEach.call(elData, function (dataAttr) {
      if (dataAttr.name && dataAttr.value) {
        svg.setAttribute(dataAttr.name, dataAttr.value);
      }
    });
    if (renumerateIRIElements) {
      var iriElementsAndProperties_1 = {
        clipPath: ['clip-path'],
        'color-profile': ['color-profile'],
        cursor: ['cursor'],
        filter: ['filter'],
        linearGradient: ['fill', 'stroke'],
        marker: ['marker', 'marker-start', 'marker-mid', 'marker-end'],
        mask: ['mask'],
        path: [],
        pattern: ['fill', 'stroke'],
        radialGradient: ['fill', 'stroke']
      };
      var element_1;
      var elements_1;
      var properties_1;
      var currentId_1;
      var newId_1;
      Object.keys(iriElementsAndProperties_1).forEach(function (key) {
        element_1 = key;
        properties_1 = iriElementsAndProperties_1[key];
        elements_1 = svg.querySelectorAll(element_1 + '[id]');
        var _loop_1 = function _loop_1(a, elementsLen) {
          currentId_1 = elements_1[a].id;
          newId_1 = currentId_1 + '-' + uniqueId();
          var referencingElements;
          Array.prototype.forEach.call(properties_1, function (property) {
            referencingElements = svg.querySelectorAll('[' + property + '*="' + currentId_1 + '"]');
            for (var b = 0, referencingElementLen = referencingElements.length; b < referencingElementLen; b++) {
              var attrValue = referencingElements[b].getAttribute(property);
              if (attrValue && !attrValue.match(new RegExp('url\\("?#' + currentId_1 + '"?\\)'))) {
                continue;
              }
              referencingElements[b].setAttribute(property, 'url(#' + newId_1 + ')');
            }
          });
          var allLinks = svg.querySelectorAll('[*|href]');
          var links = [];
          for (var c = 0, allLinksLen = allLinks.length; c < allLinksLen; c++) {
            var href = allLinks[c].getAttributeNS(xlinkNamespace$1, 'href');
            if (href && href.toString() === '#' + elements_1[a].id) {
              links.push(allLinks[c]);
            }
          }
          for (var d = 0, linksLen = links.length; d < linksLen; d++) {
            links[d].setAttributeNS(xlinkNamespace$1, 'href', '#' + newId_1);
          }
          elements_1[a].id = newId_1;
        };
        for (var a = 0, elementsLen = elements_1.length; a < elementsLen; a++) {
          _loop_1(a);
        }
      });
    }
    svg.removeAttribute('xmlns:a');
    var scripts = svg.querySelectorAll('script');
    var scriptsToEval = [];
    var script;
    var scriptType;
    for (var i = 0, scriptsLen = scripts.length; i < scriptsLen; i++) {
      scriptType = scripts[i].getAttribute('type');
      if (!scriptType || scriptType === 'application/ecmascript' || scriptType === 'application/javascript' || scriptType === 'text/javascript') {
        script = scripts[i].innerText || scripts[i].textContent;
        if (script) {
          scriptsToEval.push(script);
        }
        svg.removeChild(scripts[i]);
      }
    }
    if (scriptsToEval.length > 0 && (evalScripts === 'always' || evalScripts === 'once' && !ranScripts[elUrl])) {
      for (var l = 0, scriptsToEvalLen = scriptsToEval.length; l < scriptsToEvalLen; l++) {
        new Function(scriptsToEval[l])(window);
      }
      ranScripts[elUrl] = true;
    }
    var styleTags = svg.querySelectorAll('style');
    Array.prototype.forEach.call(styleTags, function (styleTag) {
      styleTag.textContent += '';
    });
    svg.setAttribute('xmlns', svgNamespace$1);
    svg.setAttribute('xmlns:xlink', xlinkNamespace$1);
    beforeEach(svg);
    if (!el.parentNode) {
      injectedElements.splice(injectedElements.indexOf(el), 1);
      el = null;
      callback(new Error('Parent node is null'));
      return;
    }
    el.parentNode.replaceChild(svg, el);
    injectedElements.splice(injectedElements.indexOf(el), 1);
    el = null;
    callback(null, svg);
  });
};

var SVGInjector = function SVGInjector(elements, _a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.afterAll,
    afterAll = _c === void 0 ? function () {
      return undefined;
    } : _c,
    _d = _b.afterEach,
    afterEach = _d === void 0 ? function () {
      return undefined;
    } : _d,
    _e = _b.beforeEach,
    beforeEach = _e === void 0 ? function () {
      return undefined;
    } : _e,
    _f = _b.cacheRequests,
    cacheRequests = _f === void 0 ? true : _f,
    _g = _b.evalScripts,
    evalScripts = _g === void 0 ? 'never' : _g,
    _h = _b.httpRequestWithCredentials,
    httpRequestWithCredentials = _h === void 0 ? false : _h,
    _j = _b.renumerateIRIElements,
    renumerateIRIElements = _j === void 0 ? true : _j;
  if (elements && 'length' in elements) {
    var elementsLoaded_1 = 0;
    for (var i = 0, j = elements.length; i < j; i++) {
      injectElement(elements[i], evalScripts, renumerateIRIElements, cacheRequests, httpRequestWithCredentials, beforeEach, function (error, svg) {
        afterEach(error, svg);
        if (elements && 'length' in elements && elements.length === ++elementsLoaded_1) {
          afterAll(elementsLoaded_1);
        }
      });
    }
  } else if (elements) {
    injectElement(elements, evalScripts, renumerateIRIElements, cacheRequests, httpRequestWithCredentials, beforeEach, function (error, svg) {
      afterEach(error, svg);
      afterAll(1);
      elements = null;
    });
  } else {
    afterAll(0);
  }
};

// Hat-tip: https://github.com/developit/preact-compat/blob/master/src/index.js#L402.
var shallowDiffers = function shallowDiffers(a, b) {
  for (var i in a) {
    if (!(i in b)) {
      return true;
    }
  }

  for (var _i in b) {
    if (a[_i] !== b[_i]) {
      return true;
    }
  }

  return false;
};

var _excluded$b = ["afterInjection", "beforeInjection", "evalScripts", "fallback", "httpRequestWithCredentials", "loading", "renumerateIRIElements", "src", "useRequestCache", "wrapper"];
var svgNamespace = 'http://www.w3.org/2000/svg';
var xlinkNamespace = 'http://www.w3.org/1999/xlink';
var ReactSVG = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReactSVG, _React$Component);

  function ReactSVG() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.initialState = {
      hasError: false,
      isLoading: true
    };
    _this.state = _this.initialState;
    _this._isMounted = false;
    _this.reactWrapper = void 0;
    _this.nonReactWrapper = void 0;

    _this.refCallback = function (reactWrapper) {
      _this.reactWrapper = reactWrapper;
    };

    return _this;
  }

  var _proto = ReactSVG.prototype;

  _proto.renderSVG = function renderSVG() {
    var _this2 = this;

    /* istanbul ignore else */
    if (this.reactWrapper instanceof Node) {
      var _this$props = this.props,
          beforeInjection = _this$props.beforeInjection,
          evalScripts = _this$props.evalScripts,
          httpRequestWithCredentials = _this$props.httpRequestWithCredentials,
          renumerateIRIElements = _this$props.renumerateIRIElements,
          src = _this$props.src,
          useRequestCache = _this$props.useRequestCache;
      /* eslint-disable @typescript-eslint/no-non-null-assertion */

      var afterInjection = this.props.afterInjection;
      var wrapper = this.props.wrapper;
      /* eslint-enable @typescript-eslint/no-non-null-assertion */

      var nonReactWrapper;
      var nonReactTarget;

      if (wrapper === 'svg') {
        nonReactWrapper = document.createElementNS(svgNamespace, wrapper);
        nonReactWrapper.setAttribute('xmlns', svgNamespace);
        nonReactWrapper.setAttribute('xmlns:xlink', xlinkNamespace);
        nonReactTarget = document.createElementNS(svgNamespace, wrapper);
      } else {
        nonReactWrapper = document.createElement(wrapper);
        nonReactTarget = document.createElement(wrapper);
      }

      nonReactWrapper.appendChild(nonReactTarget);
      nonReactTarget.dataset.src = src;
      this.nonReactWrapper = this.reactWrapper.appendChild(nonReactWrapper);

      var afterEach = function afterEach(error, svg) {
        if (error) {
          _this2.removeSVG();

          if (!_this2._isMounted) {
            afterInjection(error);
            return;
          }
        } // TODO (Tane): It'd be better to cleanly unsubscribe from SVGInjector
        // callbacks instead of tracking a property like this.


        if (_this2._isMounted) {
          _this2.setState(function () {
            return {
              hasError: !!error,
              isLoading: false
            };
          }, function () {
            afterInjection(error, svg);
          });
        }
      };

      SVGInjector(nonReactTarget, {
        afterEach: afterEach,
        beforeEach: beforeInjection,
        cacheRequests: useRequestCache,
        evalScripts: evalScripts,
        httpRequestWithCredentials: httpRequestWithCredentials,
        renumerateIRIElements: renumerateIRIElements
      });
    }
  };

  _proto.removeSVG = function removeSVG() {
    var _this$nonReactWrapper;

    if ((_this$nonReactWrapper = this.nonReactWrapper) != null && _this$nonReactWrapper.parentNode) {
      this.nonReactWrapper.parentNode.removeChild(this.nonReactWrapper);
      this.nonReactWrapper = null;
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this.renderSVG();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this3 = this;

    if (shallowDiffers(prevProps, this.props)) {
      this.setState(function () {
        return _this3.initialState;
      }, function () {
        _this3.removeSVG();

        _this3.renderSVG();
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this.removeSVG();
  };

  _proto.render = function render() {
    /* eslint-disable @typescript-eslint/no-unused-vars */
    var _this$props2 = this.props;
        _this$props2.afterInjection;
        _this$props2.beforeInjection;
        _this$props2.evalScripts;
        var Fallback = _this$props2.fallback;
        _this$props2.httpRequestWithCredentials;
        var Loading = _this$props2.loading;
        _this$props2.renumerateIRIElements;
        _this$props2.src;
        _this$props2.useRequestCache;
        var wrapper = _this$props2.wrapper,
        rest = _objectWithoutPropertiesLoose(_this$props2, _excluded$b);
    /* eslint-enable @typescript-eslint/no-unused-vars */
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion


    var Wrapper = wrapper;
    return /*#__PURE__*/React.createElement(Wrapper, _extends$3({}, rest, {
      ref: this.refCallback
    }, wrapper === 'svg' ? {
      xmlns: svgNamespace,
      xmlnsXlink: xlinkNamespace
    } : {}), this.state.isLoading && Loading && /*#__PURE__*/React.createElement(Loading, null), this.state.hasError && Fallback && /*#__PURE__*/React.createElement(Fallback, null));
  };

  return ReactSVG;
}(React.Component);
ReactSVG.defaultProps = {
  afterInjection: function afterInjection() {
    return undefined;
  },
  beforeInjection: function beforeInjection() {
    return undefined;
  },
  evalScripts: 'never',
  fallback: null,
  httpRequestWithCredentials: false,
  loading: null,
  renumerateIRIElements: true,
  useRequestCache: true,
  wrapper: 'div'
};
ReactSVG.propTypes = {
  afterInjection: PropTypes.func,
  beforeInjection: PropTypes.func,
  evalScripts: PropTypes.oneOf(['always', 'once', 'never']),
  fallback: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.string]),
  httpRequestWithCredentials: PropTypes.bool,
  loading: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.string]),
  renumerateIRIElements: PropTypes.bool,
  src: PropTypes.string.isRequired,
  useRequestCache: PropTypes.bool,
  wrapper: PropTypes.oneOf(['div', 'span', 'svg'])
} ;

var _excluded$a = ["name", "className", "subType", "iconStyle"];

/* eslint-disable no-console,react/prop-types */

var IconSubTypes = {
  NORMAL: 'NORMAL',
  PG: 'PG'
};
var IconStyles = {
  Fill: 'FILL',
  Outline: 'OUTLINE',
  Modern: 'MODERN'
};

// the editor is currently using different names for some icons.
var editorAliases = {
  left: 'arrow_left',
  right: 'arrow_right'
};
var Icon = function Icon(props) {
  var _theme$staticPathIcon, _ref, _theme$icon, _theme$icon$iconType;
  var name = props.name,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$subType = props.subType,
    subType = _props$subType === void 0 ? IconSubTypes.NORMAL : _props$subType,
    iconStyle = props.iconStyle,
    rest = _objectWithoutProperties(props, _excluded$a);
  var theme = useTheme();
  var iconType = subType === IconSubTypes.PG ? 'parentalGuidance' : 'navigation';
  var staticPathIcon = (_theme$staticPathIcon = theme === null || theme === void 0 ? void 0 : theme.staticPathIcon) !== null && _theme$staticPathIcon !== void 0 ? _theme$staticPathIcon : '/icons/';
  var style = (_ref = iconStyle !== null && iconStyle !== void 0 ? iconStyle : theme === null || theme === void 0 ? void 0 : (_theme$icon = theme.icon) === null || _theme$icon === void 0 ? void 0 : (_theme$icon$iconType = _theme$icon[iconType]) === null || _theme$icon$iconType === void 0 ? void 0 : _theme$icon$iconType.style) !== null && _ref !== void 0 ? _ref : IconStyles.Fill;
  var fixedName = editorAliases[name] || name;
  var iconName = fixedName === null || fixedName === void 0 ? void 0 : fixedName.replace(/(_fill|_outline|_system)$/, '');
  var iconPath = "".concat(staticPathIcon).concat(iconType, "/").concat(style.toLowerCase(), "/").concat(iconName, ".svg");
  return /*#__PURE__*/React__default.createElement(ReactSVG, _extends$3({
    focusable: "false"
  }, filterProperties(rest), {
    className: "icon ".concat(className),
    "data-icon": fixedName,
    src: iconPath,
    "data-cy": "components_Icon_ReactSVG"
  }));
};
Icon.propTypes = {
  name: PropTypes__default.string.isRequired,
  className: PropTypes__default.string,
  subType: PropTypes__default.oneOf(Object.values(IconSubTypes)),
  iconStyle: PropTypes__default.oneOf(Object.values(IconStyles))
};
var DefaultIcon = styled(Icon).withConfig({
  displayName: "Icon",
  componentId: "sc-v4w6d5-0"
})(["display:inline-block;width:1.5rem;height:1.5rem;> div{width:auto;height:100%;display:flex;}svg{width:auto;height:100%;path:not(.keep-color){fill:", ";}}"], function (_ref2) {
  var color = _ref2.color;
  return color || 'currentColor';
});

var _MOBILE_TABLET_SCALIN, _defaultFontScaleOpti, _weightNameMap;
var TextClasses = {
  Headline: 'HEADLINE',
  Title1: 'TITLE_1',
  Title2: 'TITLE_2',
  Title3: 'TITLE_3',
  Title: 'TITLE',
  Body: 'BODY',
  Callout: 'CALLOUT',
  Subtitle: 'SUBTITLE',
  Footnote: 'FOOTNOTE',
  Caption1: 'CAPTION_1',
  Caption2: 'CAPTION_2'
};

// TODO: Should this be a common enum somewhere? It's not really tied to the typography/font.
var FormFactor = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  Desktop: 'desktop',
  Tv: 'tv'
};

// Below are the default scaling factors for each text class, which are multiplied with the current font size to scale them per each form factor.
// These can be overridden by calling "setFontScaleOptions" when creating the dynamic UI builder.

// Currently, mobile and tablet are scaled the same way. Split up later if needed.
var MOBILE_TABLET_SCALING = (_MOBILE_TABLET_SCALIN = {}, _defineProperty(_MOBILE_TABLET_SCALIN, TextClasses.Headline, 0.55), _defineProperty(_MOBILE_TABLET_SCALIN, TextClasses.Title1, 0.75), _defineProperty(_MOBILE_TABLET_SCALIN, TextClasses.Title2, 0.75), _defineProperty(_MOBILE_TABLET_SCALIN, TextClasses.Title3, 0.75), _defineProperty(_MOBILE_TABLET_SCALIN, TextClasses.Title, 0.75), _defineProperty(_MOBILE_TABLET_SCALIN, TextClasses.Body, 0.75), _defineProperty(_MOBILE_TABLET_SCALIN, TextClasses.Callout, 0.75), _defineProperty(_MOBILE_TABLET_SCALIN, TextClasses.Subtitle, 0.8), _defineProperty(_MOBILE_TABLET_SCALIN, TextClasses.Footnote, 0.8), _defineProperty(_MOBILE_TABLET_SCALIN, TextClasses.Caption1, 1), _defineProperty(_MOBILE_TABLET_SCALIN, TextClasses.Caption2, 1), _MOBILE_TABLET_SCALIN);
var NO_SCALING = Object.fromEntries(Object.values(TextClasses).map(function (TextClass) {
  return [TextClass, 1];
}));
var defaultFontScaleOptions = (_defaultFontScaleOpti = {}, _defineProperty(_defaultFontScaleOpti, FormFactor.Mobile, MOBILE_TABLET_SCALING), _defineProperty(_defaultFontScaleOpti, FormFactor.Tablet, MOBILE_TABLET_SCALING), _defineProperty(_defaultFontScaleOpti, FormFactor.Desktop, NO_SCALING), _defineProperty(_defaultFontScaleOpti, FormFactor.Tv, NO_SCALING), _defaultFontScaleOpti);
var FontTypes = {
  Heading: 'heading',
  Paragraph: 'paragraph'
};
var FontStyles = {
  Normal: 'normal',
  Italic: 'italic'
};
var FontWeights = {
  Thin: 'thin',
  ExtraLight: 'extralight',
  Light: 'light',
  Regular: 'regular',
  Medium: 'medium',
  SemiBold: 'semibold',
  Bold: 'bold',
  ExtraBold: 'extrabold',
  Black: 'black'
};
var weightNameMap = (_weightNameMap = {}, _defineProperty(_weightNameMap, FontWeights.Thin, 100), _defineProperty(_weightNameMap, FontWeights.ExtraLight, 200), _defineProperty(_weightNameMap, FontWeights.Light, 300), _defineProperty(_weightNameMap, FontWeights.Regular, 400), _defineProperty(_weightNameMap, FontWeights.Medium, 500), _defineProperty(_weightNameMap, FontWeights.SemiBold, 600), _defineProperty(_weightNameMap, FontWeights.Bold, 700), _defineProperty(_weightNameMap, FontWeights.ExtraBold, 800), _defineProperty(_weightNameMap, FontWeights.Black, 900), _weightNameMap);

var _textClasses, _defaultFontConfig;
var fromEntries = function fromEntries() {
  var entries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return entries.reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return _extends$3({}, acc, _defineProperty({}, key, value));
  }, {});
};
var parseTextClasses = function parseTextClasses(fontConfig, fontScaleOptions) {
  return fromEntries(Object.entries(fontConfig.textClasses).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      textClass = _ref4[1];
    return [key, {
      family: fontConfig[textClass.type],
      lineHeight: textClass.lineHeight,
      sizeRem: rem(fontScaleOptions ? textClass.size * fontScaleOptions[key] : textClass.size),
      style: textClass.style || FontStyles.Normal,
      weight: weightNameMap[textClass.weight] || FontWeights.Regular,
      type: textClass.type
    }];
  }));
};
var defaultFontConfig = (_defaultFontConfig = {}, _defineProperty(_defaultFontConfig, FontTypes.Heading, 'Source Sans Pro'), _defineProperty(_defaultFontConfig, FontTypes.Paragraph, 'Source Sans Pro'), _defineProperty(_defaultFontConfig, "textClasses", (_textClasses = {}, _defineProperty(_textClasses, TextClasses.Headline, {
  size: 48,
  lineHeight: 1.13,
  type: FontTypes.Heading,
  style: FontStyles.Normal,
  weight: FontWeights.Bold
}), _defineProperty(_textClasses, TextClasses.Title1, {
  size: 29,
  lineHeight: 1.17,
  type: FontTypes.Heading,
  style: FontStyles.Normal,
  weight: FontWeights.Bold
}), _defineProperty(_textClasses, TextClasses.Title2, {
  size: 26,
  lineHeight: 1.23,
  type: FontTypes.Heading,
  style: FontStyles.Normal,
  weight: FontWeights.Bold
}), _defineProperty(_textClasses, TextClasses.Title3, {
  size: 23,
  lineHeight: 1.3,
  type: FontTypes.Heading,
  style: FontStyles.Normal,
  weight: FontWeights.Bold
}), _defineProperty(_textClasses, TextClasses.Title, {
  size: 20,
  lineHeight: 1.4,
  type: FontTypes.Heading,
  style: FontStyles.Normal,
  weight: FontWeights.Bold
}), _defineProperty(_textClasses, TextClasses.Body, {
  size: 20,
  lineHeight: 1.4,
  type: FontTypes.Paragraph,
  style: FontStyles.Normal,
  weight: FontWeights.Regular
}), _defineProperty(_textClasses, TextClasses.Callout, {
  size: 18,
  lineHeight: 1.33,
  type: FontTypes.Paragraph,
  style: FontStyles.Normal,
  weight: FontWeights.Regular
}), _defineProperty(_textClasses, TextClasses.Subtitle, {
  size: 16,
  lineHeight: 1.5,
  type: FontTypes.Paragraph,
  style: FontStyles.Normal,
  weight: FontWeights.Regular
}), _defineProperty(_textClasses, TextClasses.Footnote, {
  size: 15,
  lineHeight: 1.6,
  type: FontTypes.Paragraph,
  style: FontStyles.Normal,
  weight: FontWeights.Regular
}), _defineProperty(_textClasses, TextClasses.Caption1, {
  size: 12,
  lineHeight: 1.67,
  type: FontTypes.Paragraph,
  style: FontStyles.Normal,
  weight: FontWeights.Regular
}), _defineProperty(_textClasses, TextClasses.Caption2, {
  size: 11,
  lineHeight: 1.82,
  type: FontTypes.Paragraph,
  style: FontStyles.Normal,
  weight: FontWeights.Regular
}), _textClasses)), _defaultFontConfig);
var defaultTextClasses = parseTextClasses(defaultFontConfig);

/* eslint-disable react/prop-types */
var withPropDatabinding = function withPropDatabinding() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    propsToBind = _ref.propsToBind,
    _ref$translations = _ref.translations,
    translations = _ref$translations === void 0 ? {} : _ref$translations,
    _ref$databinder = _ref.databinder,
    databinder = _ref$databinder === void 0 ? applyDatabinding : _ref$databinder;
  return function (Component) {
    var C = function C(props) {
      var _props$properties = props.properties,
        properties = _props$properties === void 0 ? {} : _props$properties,
        _props$context = props.context,
        context = _props$context === void 0 ? {} : _props$context;
      var format = properties.format;
      var getDataboundProperty = useCallback(function (name, value) {
        return databinder({
          name: name,
          value: value,
          format: name === 'value' ? format : null,
          context: _extends$3({
            translations: translations
          }, context)
        });
      }, [context, format]);
      var databoundProps = useMemo(function () {
        var _propsToBind = propsToBind || Object.keys(properties);
        return _propsToBind.reduce(function (acc, name) {
          // Supports nested property databinding.
          // In such cases propsToBind property must be specified because
          // by default the script will only pick the top level properties.
          if (name.includes('.')) {
            var valueSplit = name.split('.');

            // If given properties do not exist we are not appending the accumulator
            if (Object.hasOwn(properties, valueSplit[0]) && Object.hasOwn(properties[valueSplit[0]], valueSplit[1])) {
              acc[valueSplit[0]] = _extends$3({}, properties[valueSplit[0]], _defineProperty({}, valueSplit[1], getDataboundProperty(valueSplit[1], properties[valueSplit[0]][valueSplit[1]])));
            }
            return acc;
          }
          if (properties[name]) {
            acc[name] = getDataboundProperty(name, properties[name]);
          }
          return acc;
        }, {});
      }, [properties, getDataboundProperty]);
      return /*#__PURE__*/React__default.createElement(Component, _extends$3({}, props, {
        properties: _extends$3({}, properties, databoundProps),
        "data-cy": "hocs_withPropDatabinding_Component"
      }));
    };
    C.displayName = "withPropDatabinding(".concat(Component.displayName || Component.name, ")");
    C.propTypes = {
      properties: PropTypes__default.object,
      context: PropTypes__default.object
    };
    return C;
  };
};

var queryType = PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.object, PropTypes__default.arrayOf(PropTypes__default.object.isRequired)]);
({
  defaultMatches: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.objectOf(PropTypes__default.bool)]),
  query: queryType,
  queries: PropTypes__default.objectOf(queryType),
  render: PropTypes__default.func,
  children: PropTypes__default.oneOfType([PropTypes__default.node, PropTypes__default.func]),
  targetWindow: PropTypes__default.object,
  onChange: PropTypes__default.func
});

var _MEDIA_QUERIES;
(_MEDIA_QUERIES = {}, _defineProperty(_MEDIA_QUERIES, BreakpointKeys.XS, "(max-width: ".concat(breakpoints$1[BreakpointKeys.XS], "px)")), _defineProperty(_MEDIA_QUERIES, BreakpointKeys.SM, "(max-width: ".concat(breakpoints$1[BreakpointKeys.SM], "px)")), _defineProperty(_MEDIA_QUERIES, BreakpointKeys.MD, "(max-width: ".concat(breakpoints$1[BreakpointKeys.MD], "px)")), _defineProperty(_MEDIA_QUERIES, BreakpointKeys.LG, "(max-width: ".concat(breakpoints$1[BreakpointKeys.LG], "px)")), _defineProperty(_MEDIA_QUERIES, BreakpointKeys.XL, "(max-width: ".concat(breakpoints$1[BreakpointKeys.XL], "px)")), _defineProperty(_MEDIA_QUERIES, BreakpointKeys.XXL, "(min-width: ".concat(breakpoints$1[BreakpointKeys.XL] + 1, "px)")), _MEDIA_QUERIES);

/**
 * Icon Factory producing Icons
 * @param IconBase
 * @param parentalSystem System name of the parental system
 * @returns
 */
const IconFactory = (IconBase, parentalSystem) => {
    const Icon = styled(IconBase) `
    ${({ size }) => IconSizesRem[size] &&
        `
      height: ${IconSizesRem[size]}rem;
      width: auto;
    `}
    ${({ alignment }) => alignment && `text-align: ${alignment}; width: 100%;`}
    ${({ color }) => (color ? `color: ${color};` : '')}

    ${generalUtils}
  `;
    Icon.displayName = 'Icon';
    const IconComponent = (props) => {
        const { className, properties, actions = {}, context } = props;
        const { size, action, value } = properties;
        if (!value) {
            return null;
        }
        return (React__default.createElement(Icon, Object.assign({}, dataDyn(props), { className: className }, properties, { name: value, size: size }, eventHandlers(context, actions, action))));
    };
    IconComponent.displayName = 'IconComponent';
    // Business logic defined on the confluence page
    const chooseParentalRating = (parentalRatings) => {
        // 1. If there is only one rating type available → show that rating
        if (parentalRatings.length === 1) {
            return parentalRatings[0];
        }
        // 2. If there are multiple rating types available
        // 2a. I got a config on appstart that told me which system is preferred
        if (parentalSystem) {
            // 2aI. Is there a rating matching that → show that rating (returning a match)
            // 2aII. No match → don't show any rating (returning undefined)
            return parentalRatings.find((rating) => rating.type === parentalSystem);
        }
        // 2b. No config at appstart related to parental guidance → show the first rating
        return parentalRatings[0];
    };
    // Business logic to convert a parental rating object to an icon name
    // ex: { type: "US_TV_FCC", "value": "TV-MA" } --> "us_tv_fcc_tv_ma"
    const ratingToIconName = (rating) => {
        if (!rating) {
            return '';
        }
        const { type = '', value = '' } = rating;
        if (type === 'UNKNOWN') {
            return '';
        }
        return [type, value]
            .join('_')
            .replace(/-/g, '_')
            .replace(/\+/g, 'plus')
            .toLowerCase();
    };
    // Value can be a keypath, that points to the item's parental ratings in the context.
    return withPropDatabinding({
        propsToBind: ['value', 'color'],
        databinder: ({ name, value, context }) => {
            const databoundValue = applyDatabinding({ value, context });
            // parental icon biding for the `value` prop
            if (name === 'value') {
                const parentalRatings = get(context, databoundValue);
                if (Array.isArray(parentalRatings) && parentalRatings.length > 0) {
                    const selectedRating = chooseParentalRating(parentalRatings);
                    return ratingToIconName(selectedRating);
                }
                return value;
            }
            // normal binding result for other props
            return databoundValue;
        },
    })(IconComponent);
};

var actionPropType = PropTypes__default.shape({
  type: PropTypes__default.string.isRequired,
  params: PropTypes__default.shape({
    destination: PropTypes__default.shape({
      type: PropTypes__default.string.isRequired,
      id: PropTypes__default.string.isRequired
    }),
    videoId: PropTypes__default.string
  })
});

var actionsPropType = PropTypes__default.shape({
  navigate: PropTypes__default.func,
  play: PropTypes__default.func,
  rate: PropTypes__default.func
});

/**
 * PropType for a responsive prop with a given data type.
 * @example Usage
 * Component.propTypes = {
 *   gutter: responsivePropType(PropTypes.number)
 * }
 * @example Meaning
 * PropTypes.shape({ xs: PropTypes.number, sm: PropTypes.number, ... })
 * @param dataPropType PropType of each field.
 * @returns {Requireable<any>}
 */
var responsivePropType = function responsivePropType(dataPropType) {
  return PropTypes__default.shape({
    xxl: dataPropType,
    xl: dataPropType,
    lg: dataPropType,
    md: dataPropType,
    sm: dataPropType,
    xs: dataPropType
  });
};

var purify = createCommonjsModule(function (module, exports) {
/*! @license DOMPurify 2.4.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.3/LICENSE */

(function (global, factory) {
  module.exports = factory() ;
})(commonjsGlobal, (function () {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create; // eslint-disable-line import/no-mutable-exports

  var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;

  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }

  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }

  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }

  if (!construct) {
    construct = function construct(Func, args) {
      return _construct(Func, _toConsumableArray(args));
    };
  }

  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);
  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringToString = unapply(String.prototype.toString);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);
  var regExpTest = unapply(RegExp.prototype.test);
  var typeErrorCreate = unconstruct(TypeError);
  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return apply(func, thisArg, args);
    };
  }
  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return construct(func, args);
    };
  }
  /* Add properties to a lookup table */

  function addToSet(set, array, transformCaseFunc) {
    transformCaseFunc = transformCaseFunc ? transformCaseFunc : stringToLowerCase;

    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }

    var l = array.length;

    while (l--) {
      var element = array[l];

      if (typeof element === 'string') {
        var lcElement = transformCaseFunc(element);

        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }

          element = lcElement;
        }
      }

      set[element] = true;
    }

    return set;
  }
  /* Shallow clone an object */

  function clone(object) {
    var newObject = create(null);
    var property;

    for (property in object) {
      if (apply(hasOwnProperty, object, [property]) === true) {
        newObject[property] = object[property];
      }
    }

    return newObject;
  }
  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */

  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);

      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }

        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }

      object = getPrototypeOf(object);
    }

    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }

    return fallbackValue;
  }

  var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']); // SVG

  var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']); // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.

  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
  var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']); // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.

  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
  var text = freeze(['#text']);

  var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
  var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
  var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode

  var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
  var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape

  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape

  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );
  var DOCTYPE_NAME = seal(/^html$/i);

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };
  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */


  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    } // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.


    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';

    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }

    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html) {
          return html;
        },
        createScriptURL: function createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };

  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };
    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */


    DOMPurify.version = '2.4.3';
    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */

    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;
      return DOMPurify;
    }

    var originalDocument = window.document;
    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        HTMLFormElement = window.HTMLFormElement,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;
    var ElementPrototype = Element.prototype;
    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode'); // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.

    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');

      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }

    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);

    var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
    var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;
    var documentMode = {};

    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}

    var hooks = {};
    /**
     * Expose whether this browser supports running the full DOMPurify.
     */

    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && typeof implementation.createHTMLDocument !== 'undefined' && documentMode !== 9;
    var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
        ERB_EXPR$1 = ERB_EXPR,
        TMPLIT_EXPR$1 = TMPLIT_EXPR,
        DATA_ATTR$1 = DATA_ATTR,
        ARIA_ATTR$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$1 = ATTR_WHITESPACE;
    var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */

    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
    /* Allowed attribute names */

    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
    /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */

    var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */

    var FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */

    var FORBID_ATTR = null;
    /* Decide if ARIA attributes are okay */

    var ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */

    var ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */

    var ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */

    var SAFE_FOR_TEMPLATES = false;
    /* Decide if document with <html>... should be returned */

    var WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */

    var SET_CONFIG = false;
    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */

    var FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */

    var RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */

    var RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */

    var RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */

    var SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */

    var SANITIZE_NAMED_PROPS = false;
    var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */

    var KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */

    var IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */

    var USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */

    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
    /* Tags that are safe for data: URIs */

    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
    /* Attributes safe for values like "javascript:" */

    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */

    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */

    var ALLOWED_NAMESPACES = null;
    var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
    /* Parsing of strict XHTML documents */

    var PARSER_MEDIA_TYPE;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc;
    /* Keep a reference to config to pass to hooks */

    var CONFIG = null;
    /* Ideally, do not touch anything below this line */

    /* ______________________________________________ */

    var formElement = document.createElement('form');

    var isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity


    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }
      /* Shield configuration object from tampering */


      if (!cfg || _typeof(cfg) !== 'object') {
        cfg = {};
      }
      /* Shield configuration object from prototype pollution */


      cfg = clone(cfg);
      PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.

      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
      /* Set configuration parameters */

      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
      ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
      cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
      cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true

      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true

      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false

      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false

      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false

      RETURN_DOM = cfg.RETURN_DOM || false; // Default false

      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false

      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false

      FORCE_BODY = cfg.FORCE_BODY || false; // Default false

      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true

      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false

      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true

      IN_PLACE = cfg.IN_PLACE || false; // Default false

      IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }

      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }

      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }
      /* Parse profile info */


      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
        ALLOWED_ATTR = [];

        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }

        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }
      /* Merge configuration parameters */


      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }

        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }

      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }

        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }

      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
      }

      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }

        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
      }
      /* Add #text in case KEEP_CONTENT is set to true */


      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }
      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */


      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }
      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */


      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      } // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.


      if (freeze) {
        freeze(cfg);
      }

      CONFIG = cfg;
    };

    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
    var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']); // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.

    var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */

    var ALL_SVG_TAGS = addToSet({}, svg$1);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);
    var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */

    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.

      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: NAMESPACE,
          tagName: 'template'
        };
      }

      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);

      if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
        return false;
      }

      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        } // The only way to switch from MathML to SVG is via`
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.


        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        } // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.


        return Boolean(ALL_SVG_TAGS[tagName]);
      }

      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        } // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points


        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        } // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.


        return Boolean(ALL_MATHML_TAGS[tagName]);
      }

      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        } // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace


        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
      } // For XHTML and XML documents that support custom namespaces


      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
        return true;
      } // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
      // Return false just in case.


      return false;
    };
    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */


    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, {
        element: node
      });

      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };
    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */


    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }

      node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes

      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };
    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */


    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc;
      var leadingWhitespace;

      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }

      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }

      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */

      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }
      /* Use createHTMLDocument in case DOMParser is not available */


      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);

        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
        } catch (_) {// Syntax error if dirtyPayload is invalid xml
        }
      }

      var body = doc.body || doc.documentElement;

      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }
      /* Work on whole document or just its body */


      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }

      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */


    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
    };
    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */


    var _isClobbered = function _isClobbered(elm) {
      return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
    };
    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */


    var _isNode = function _isNode(object) {
      return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };
    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */


    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }

      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };
    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */


    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeElements', currentNode, null);
      /* Check if element is clobbered or can clobber */


      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Check if tagname contains Unicode */


      if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Now let's check the element's type and name */


      var tagName = transformCaseFunc(currentNode.nodeName);
      /* Execute a hook if present */

      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });
      /* Detect mXSS attempts abusing namespace confusion */


      if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Mitigate a problem with templates inside select */


      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Remove element if anything forbids its presence */


      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Check if we have a custom element to handle */
        if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }
        /* Keep content except for bad-listed elements */


        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;

          if (childNodes && parentNode) {
            var childCount = childNodes.length;

            for (var i = childCount - 1; i >= 0; --i) {
              parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
            }
          }
        }

        _forceRemove(currentNode);

        return true;
      }
      /* Check whether element has a valid namespace */


      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }

      if ((tagName === 'noscript' || tagName === 'noembed') && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Sanitize element content to be template-safe */


      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
        content = stringReplace(content, ERB_EXPR$1, ' ');
        content = stringReplace(content, TMPLIT_EXPR$1, ' ');

        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, {
            element: currentNode.cloneNode()
          });
          currentNode.textContent = content;
        }
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeElements', currentNode, null);

      return false;
    };
    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity


    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }
      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */


      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if ( // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */

      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if (!value) ; else {
        return false;
      }

      return true;
    };
    /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */


    var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
      return tagName.indexOf('-') > 0;
    };
    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */


    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr;
      var value;
      var lcName;
      var l;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeAttributes', currentNode, null);

      var attributes = currentNode.attributes;
      /* Check if we have attributes; if not we might have a text node */

      if (!attributes) {
        return;
      }

      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;
      /* Go backwards over all attributes; safely remove bad ones */

      while (l--) {
        attr = attributes[l];
        var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;
        value = name === 'value' ? attr.value : stringTrim(attr.value);
        lcName = transformCaseFunc(name);
        /* Execute a hook if present */

        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set

        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);

        value = hookEvent.attrValue;
        /* Did the hooks approve of the attribute? */

        if (hookEvent.forceKeepAttr) {
          continue;
        }
        /* Remove attribute */


        _removeAttribute(name, currentNode);
        /* Did the hooks approve of the attribute? */


        if (!hookEvent.keepAttr) {
          continue;
        }
        /* Work around a security issue in jQuery 3.0 */


        if (regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);

          continue;
        }
        /* Sanitize attribute content to be template-safe */


        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
          value = stringReplace(value, ERB_EXPR$1, ' ');
          value = stringReplace(value, TMPLIT_EXPR$1, ' ');
        }
        /* Is `value` valid for this attribute? */


        var lcTag = transformCaseFunc(currentNode.nodeName);

        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }
        /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */


        if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
          // Remove the attribute with this value
          _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value


          value = SANITIZE_NAMED_PROPS_PREFIX + value;
        }
        /* Handle attributes that require Trusted Types */


        if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
          if (namespaceURI) ; else {
            switch (trustedTypes.getAttributeType(lcTag, lcName)) {
              case 'TrustedHTML':
                value = trustedTypesPolicy.createHTML(value);
                break;

              case 'TrustedScriptURL':
                value = trustedTypesPolicy.createScriptURL(value);
                break;
            }
          }
        }
        /* Handle invalid data-* attribute set by try-catching it */


        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }

          arrayPop(DOMPurify.removed);
        } catch (_) {}
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeAttributes', currentNode, null);
    };
    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */


    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode;

      var shadowIterator = _createIterator(fragment);
      /* Execute a hook if present */


      _executeHook('beforeSanitizeShadowDOM', fragment, null);

      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);
        /* Sanitize tags and elements */


        if (_sanitizeElements(shadowNode)) {
          continue;
        }
        /* Deep shadow DOM detected */


        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(shadowNode);
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };
    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity


    DOMPurify.sanitize = function (dirty) {
      var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body;
      var importedNode;
      var currentNode;
      var oldNode;
      var returnNode;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */

      IS_EMPTY_INPUT = !dirty;

      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }
      /* Stringify, in case dirty is an object */


      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        // eslint-disable-next-line no-negated-condition
        if (typeof dirty.toString !== 'function') {
          throw typeErrorCreate('toString is not a function');
        } else {
          dirty = dirty.toString();

          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        }
      }
      /* Check we can run. Otherwise fall back or ignore */


      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }

          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }

        return dirty;
      }
      /* Assign config vars */


      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }
      /* Clean up removed elements */


      DOMPurify.removed = [];
      /* Check if dirty is correctly typed for IN_PLACE */

      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }

      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          var tagName = transformCaseFunc(dirty.nodeName);

          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);

        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }
        /* Initialize the document to work on */


        body = _initDocument(dirty);
        /* Check we have a DOM node from the data */

        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }
      /* Remove first element node (ours) if FORCE_BODY is set */


      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }
      /* Get node iterator */


      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
      /* Now start iterating over the created document */


      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }
        /* Sanitize tags and elements */


        if (_sanitizeElements(currentNode)) {
          continue;
        }
        /* Shadow DOM detected, sanitize it */


        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(currentNode);

        oldNode = currentNode;
      }

      oldNode = null;
      /* If we sanitized `dirty` in-place, return it. */

      if (IN_PLACE) {
        return dirty;
      }
      /* Return sanitized string or DOM */


      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);

          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }

        if (ALLOWED_ATTR.shadowroot) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }

        return returnNode;
      }

      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
      /* Serialize doctype if allowed */

      if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
        serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
      }
      /* Sanitize final string template-safe */


      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
      }

      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };
    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */


    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);

      SET_CONFIG = true;
    };
    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */


    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };
    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */


    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }

      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };
    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */


    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }

      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };
    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */


    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        return arrayPop(hooks[entryPoint]);
      }
    };
    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */


    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };
    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */


    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };

    return DOMPurify;
  }

  var purify = createDOMPurify();

  return purify;

}));

});

var HeadingTag;
(function (HeadingTag) {
    HeadingTag["H1"] = "h1";
    HeadingTag["H2"] = "h2";
    HeadingTag["H3"] = "h3";
    HeadingTag["H4"] = "h4";
    HeadingTag["H5"] = "h5";
    HeadingTag["H6"] = "h6";
})(HeadingTag || (HeadingTag = {}));
// this can be rendered `as` any of the heading tags, without additional user-agent styles.
const H1 = styled.h1 `
  all: inherit;
  display: contents;
`;
const getTag = (isDetailsPage, containerIndex, itemIndex) => {
    // details page, main item
    if (isDetailsPage &&
        containerIndex === undefined &&
        itemIndex === undefined) {
        return HeadingTag.H1;
    }
    // browse page, first container, first item
    if (!isDetailsPage && containerIndex === 0 && itemIndex === 0) {
        return HeadingTag.H1;
    }
    // browse page, first container, rest of the items
    if (!isDetailsPage && containerIndex === 0 && itemIndex !== undefined) {
        return HeadingTag.H3;
    }
    // browse & details pages, container titles
    if (containerIndex !== undefined && itemIndex === undefined) {
        return HeadingTag.H2;
    }
    // browse & details pages, item titles
    if (containerIndex !== undefined && itemIndex !== undefined) {
        return HeadingTag.H3;
    }
    // otherwise it shouldn't be a heading
    return undefined;
};
const Heading = ({ containerIndex, itemIndex, isDetailsPage, isHeading, children, }) => {
    const tag = getTag(isDetailsPage, containerIndex, itemIndex);
    if (!isHeading || !tag) {
        return React__default.createElement(React__default.Fragment, null, children);
    }
    return React__default.createElement(H1, { as: tag }, children);
};

var _excluded$9 = ["textClass", "textStyle", "value", "action", "isHeading"];
var TextFactory = function TextFactory() {
  var textClasses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTextClasses;
  var translations = arguments.length > 1 ? arguments[1] : undefined;
  var translate = arguments.length > 2 ? arguments[2] : undefined;
  var TextElement = styled(function (props) {
    return /*#__PURE__*/React__default.createElement("span", _extends$3({
      // TODO: do we really need html in here?
      dangerouslySetInnerHTML: {
        __html: purify.sanitize(props.value)
      }
    }, filterProperties(props), {
      "data-cy": "Text_Text_span"
    }));
  }).withConfig({
    displayName: "Text__TextElement",
    componentId: "sc-1dw4nh4-0"
  })(["display:block;", " ", " ", " ", " ", " overflow:hidden;text-overflow:ellipsis;", ""], function (_ref) {
    var textClassStyles = _ref.textClassStyles;
    var family = textClassStyles.family,
      sizeRem = textClassStyles.sizeRem,
      style = textClassStyles.style,
      weight = textClassStyles.weight;
    return "font: ".concat(style, " normal ").concat(weight, " ").concat(sizeRem, "rem ").concat(family, ";");
  }, function (_ref2) {
    var alignment = _ref2.alignment;
    return alignment && "text-align: ".concat(alignment, ";");
  }, function (_ref3) {
    var backgroundColor = _ref3.backgroundColor;
    return backgroundColor && "background-color: ".concat(backgroundColor, ";");
  }, function (_ref4) {
    var _theme$color;
    var colorProp = _ref4.color,
      textClassStyles = _ref4.textClassStyles,
      theme = _ref4.theme;
    var isHeading = textClassStyles.type === FontTypes.Heading;
    var themeColorName = isHeading ? 'pageHeadingForeground' : 'pageParagraphForeground';
    var themeColor = theme === null || theme === void 0 ? void 0 : (_theme$color = theme.color) === null || _theme$color === void 0 ? void 0 : _theme$color[themeColorName];
    return "color: ".concat(colorProp || themeColor, ";");
  }, generalUtils, function (_ref5) {
    var _ref5$textClassStyles = _ref5.textClassStyles,
      sizeRem = _ref5$textClassStyles.sizeRem,
      _ref5$textClassStyles2 = _ref5$textClassStyles.lineHeight,
      lineHeight = _ref5$textClassStyles2 === void 0 ? 1.2 : _ref5$textClassStyles2,
      maxLines = _ref5.maxLines;
    return maxLines && "\n      display: -webkit-box;\n      -webkit-box-orient: vertical;\n      -webkit-line-clamp: ".concat(maxLines, ";\n      line-height: ").concat(lineHeight, ";\n      /* fallback */\n      max-height: ").concat(maxLines * sizeRem * lineHeight, "rem;\n    ");
  });
  TextElement.displayName = 'TextElement';
  var Text = function Text(props) {
    var _props$properties = props.properties,
      properties = _props$properties === void 0 ? {} : _props$properties,
      _props$actions = props.actions,
      actions = _props$actions === void 0 ? {} : _props$actions,
      context = props.context,
      className = props.className;
    var textClass = properties.textClass;
      properties.textStyle;
      var value = properties.value,
      action = properties.action,
      isHeading = properties.isHeading,
      rest = _objectWithoutProperties(properties, _excluded$9);
    var textClassStyles = textClasses[textClass] || textClasses[TextClasses.Body];
    return /*#__PURE__*/React__default.createElement(Heading, {
      containerIndex: context === null || context === void 0 ? void 0 : context.containerIndex,
      isDetailsPage: context === null || context === void 0 ? void 0 : context.isDetailsPage,
      isHeading: isHeading,
      itemIndex: context === null || context === void 0 ? void 0 : context.itemIndex,
      "data-cy": "Text_Text_Heading"
    }, /*#__PURE__*/React__default.createElement(TextElement, _extends$3({}, dataDyn(props), {
      className: className,
      textClassStyles: textClassStyles
    }, rest, eventHandlers(context, actions, action), {
      value: translate ? translate(value, context) : value,
      "data-cy": "Text_Text_TextElement"
    })));
  };
  Text.displayName = 'Text';
  Text.propTypes = {
    properties: PropTypes__default.shape({
      value: PropTypes__default.any,
      // TODO:DEPRECATED `textStyle` will be renamed to `textClass` in 2.0.0
      // was left out from `ONEDYNUIWEB-10` because further discussion needed
      textStyle: PropTypes__default.string,
      textClass: PropTypes__default.string,
      fontSize: PropTypes__default.string,
      fontWeight: PropTypes__default.number,
      // Amount of rows that should be dispalyed before elipsing the text.
      maxLines: PropTypes__default.number,
      color: PropTypes__default.string,
      backgroundColor: PropTypes__default.string,
      // Alignment of the text.
      alignment: PropTypes__default.string,
      // Size of the component when it is placed within a group with multiple components.
      weight: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.object]),
      // Width behaviour for the component.
      width: PropTypes__default.oneOf(Object.values(HeightAndWidthTypes)),
      height: PropTypes__default.oneOf(Object.values(HeightAndWidthTypes)),
      action: actionPropType,
      isHeading: PropTypes__default.bool
    }),
    actions: actionsPropType,
    context: PropTypes__default.object,
    className: PropTypes__default.string
  };
  return withPropDatabinding({
    translations: translations
  })(Text);
};

var _excluded$8 = ["buttonTheme", "design", "icon", "action", "textStyle", "value", "fontSize"];
var _actionTypeTranslatio;

// unlike other components, no `padding` prop doesn't mean "zero padding"
var defaultPadding = {
  top: {
    xxl: 10
  },
  left: {
    xxl: 10
  },
  bottom: {
    xxl: 10
  },
  right: {
    xxl: 10
  }
};

// translation keys used to make icon-only buttons accessible based on their
var actionTypeTranslations = (_actionTypeTranslatio = {}, _defineProperty(_actionTypeTranslatio, ActionTypes.Navigate, null), _defineProperty(_actionTypeTranslatio, ActionTypes.Play, 'button.play'), _defineProperty(_actionTypeTranslatio, ActionTypes.Rate, 'button.rate'), _defineProperty(_actionTypeTranslatio, ActionTypes.Share, 'button.share'), _defineProperty(_actionTypeTranslatio, ActionTypes.AddToFavorites, 'button.addToFavorites'), _defineProperty(_actionTypeTranslatio, ActionTypes.RemoveFromFavorites, 'button.removeFromFavorites'), _actionTypeTranslatio);

/**
 * Button Factory will create a dynamic UI Button component.
 * @param {*} ButtonBase A button base component which supports themes changed by the "variant" property.
 * @param {*} IconBase Icon base component rendering icons on "type" property.
 */
var ButtonFactory = function ButtonFactory(ButtonBase, IconBase, textClasses, translations, translate) {
  var StyledButton = styled(ButtonBase).withConfig({
    displayName: "Button__StyledButton",
    componentId: "sc-dgmqvy-0"
  })(["", " ", " ", " ", " ", " ", " & > span{color:inherit;}"], function (_ref) {
    var fontSize = _ref.fontSize;
    return FontSizesRem[fontSize] ? "font-size: ".concat(FontSizesRem[fontSize], "rem;") : '';
  }, function (_ref2) {
    var color = _ref2.color;
    return color ? "color: ".concat(color, ";") : '';
  }, function (_ref3) {
    var _ref3$alignment = _ref3.alignment,
      alignment = _ref3$alignment === void 0 ? Alignment.Center : _ref3$alignment;
    return "justify-content: ".concat(alignmentMap[alignment], ";");
  }, function (_ref4) {
    var isReversed = _ref4.isReversed;
    return isReversed ? 'flex-direction: row-reverse;' : '';
  }, function (props) {
    return generalUtils(_extends$3({}, props, {
      padding: _extends$3({}, defaultPadding, props.padding)
    }));
  }, function (_ref5) {
    var isIconOnly = _ref5.isIconOnly;
    return isIconOnly ? 'border-radius: 100rem;' : '';
  });
  StyledButton.displayName = 'StyledButton';
  var Icon = styled(IconFactory(IconBase)).withConfig({
    displayName: "Button__Icon",
    componentId: "sc-dgmqvy-1"
  })(["", ""], function (_ref6) {
    var _ref6$applyPositionMa = _ref6.applyPositionMargin,
      applyPositionMargin = _ref6$applyPositionMa === void 0 ? true : _ref6$applyPositionMa,
      _ref6$properties$posi = _ref6.properties.position,
      position = _ref6$properties$posi === void 0 ? IconPositions.Start : _ref6$properties$posi;
    return applyPositionMargin ? "margin-inline-".concat(position === IconPositions.End ? 'start' : 'end', ": 0.2rem;") : '';
  });
  Icon.displayName = 'Icon';
  var Text = TextFactory(textClasses, translate);
  var Button = function Button(props) {
    var _props$properties = props.properties,
      properties = _props$properties === void 0 ? {} : _props$properties,
      _props$actions = props.actions,
      actions = _props$actions === void 0 ? {} : _props$actions,
      context = props.context;
    var buttonTheme = properties.buttonTheme,
      design = properties.design,
      icon = properties.icon,
      action = properties.action,
      textStyle = properties.textStyle,
      value = properties.value,
      fontSize = properties.fontSize,
      rest = _objectWithoutProperties(properties, _excluded$8);
    var isReversed = icon && icon.position === IconPositions.End;
    var label = translate ? translate(value, context) : value;
    var ariaLabel = label || action && (translate === null || translate === void 0 ? void 0 : translate(actionTypeTranslations[action.type])) || null;
    var isIconOnly = icon && !label;
    return /*#__PURE__*/React__default.createElement(StyledButton, _extends$3({}, dataDyn(props), {
      isIconOnly: isIconOnly,
      isReversed: isReversed,
      variant: buttonTheme || design
    }, rest, {
      "aria-label": ariaLabel
    }, eventHandlers(context, actions, action), {
      "data-cy": "Button_Button_StyledButton"
    }), icon && /*#__PURE__*/React__default.createElement(Icon, {
      applyPositionMargin: !!label,
      properties: icon,
      "data-cy": "Button_Button_Icon"
    }), label && /*#__PURE__*/React__default.createElement(Text, {
      properties: {
        value: label,
        textStyle: textStyle,
        fontSize: fontSize
      },
      "data-cy": "Button_Button_Text"
    }));
  };
  Button.propTypes = {
    properties: PropTypes__default.shape({
      value: PropTypes__default.string,
      alignment: PropTypes__default.string,
      design: PropTypes__default.string,
      icon: PropTypes__default.shape({
        value: PropTypes__default.string,
        position: PropTypes__default.oneOf(Object.values(Alignment))
      }),
      // Size of the component when it is placed within a group with multiple components.
      weight: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.object]),
      // Width behaviour for the component.
      width: PropTypes__default.oneOf(Object.values(HeightAndWidthTypes)),
      // Height behaviour for the component.
      height: PropTypes__default.oneOf(Object.values(HeightAndWidthTypes)),
      // Event that should be sent when the button is triggered.
      action: actionPropType
    }),
    actions: actionsPropType,
    context: PropTypes__default.object
  };
  return withPropDatabinding({
    translations: translations
  })(Button);
};

var squash = keyframes(["0%{opacity:1;}100%{height:0;opacity:0.1;}"]);
var CollectionItemWrapper = styled.div.withConfig({
  displayName: "ContainerItem__CollectionItemWrapper",
  componentId: "sc-1by5mfc-0"
})(["width:100%;opacity:1;z-index:1;", ""], function (_ref) {
  var $isHidden = _ref.$isHidden,
    $height = _ref.$height;
  return $isHidden && css$1(["overflow:hidden;height:", ";animation:", " 250ms ease-in-out forwards;"], $height, squash);
});
var CollectionItem = function CollectionItem(_ref2) {
  var children = _ref2.children,
    debugInfo = _ref2.debugInfo,
    onHeightChange = _ref2.onHeightChange;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHidden = _useState2[0],
    setIsHidden = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  var ref = useRef();
  var onRemoveContainer = useCallback(function () {
    var element = ref.current;
    if (!element) {
      return;
    }

    // start animation - we need the current height
    setHeight(getComputedStyle(element).height);
    setIsHidden(true);

    // display none after the animation
    element.onanimationend = function () {
      element.style.display = 'none';
    };
    console.debug('Removed empty container', debugInfo);
  }, [debugInfo]);
  var childrenWithProps = React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.cloneElement(child, {
      onRemoveContainer: onRemoveContainer
    });
  });

  // observe our height changes if our parent is interested
  useEffect(function () {
    if (!onHeightChange || !window.ResizeObserver) {
      return;
    }
    var resizeObserver = new ResizeObserver(function (entries) {
      var entry = entries[0];
      var newHeight = entry !== null && entry !== void 0 && entry.contentBoxSize ? entry === null || entry === void 0 ? void 0 : entry.contentBoxSize[0].blockSize : entry === null || entry === void 0 ? void 0 : entry.contentRect.height;
      onHeightChange(newHeight);
    });
    resizeObserver.observe(ref.current);
    return function () {
      return resizeObserver.disconnect();
    };
  }, [onHeightChange]);
  return /*#__PURE__*/React__default.createElement(CollectionItemWrapper, {
    $height: height,
    $isHidden: isHidden,
    ref: ref,
    "data-cy": "ContainerCollection_ContainerItem_CollectionItemWrapper"
  }, childrenWithProps);
};
CollectionItem.propTypes = {
  children: PropTypes__default.element,
  debugInfo: PropTypes__default.any,
  onHeightChange: PropTypes__default.func
};

var _excluded$7 = ["template"],
  _excluded2$2 = ["properties", "context", "id"],
  _excluded3$2 = ["containerCollections"];
var getItemTemplateRules = function getItemTemplateRules(containerEntity, formFactor, v2Templates) {
  var _containerEntity$temp, _v2Templates$id;
  var formFactorTemplate = containerEntity === null || containerEntity === void 0 ? void 0 : (_containerEntity$temp = containerEntity.templates) === null || _containerEntity$temp === void 0 ? void 0 : _containerEntity$temp[formFactor];
  if (!formFactorTemplate) {
    // v1
    return containerEntity === null || containerEntity === void 0 ? void 0 : containerEntity.itemTemplateRules;
  }
  var id = formFactorTemplate.id,
    itemTemplateRules = formFactorTemplate.itemTemplateRules;
  var v2ItemTemplateRules = v2Templates === null || v2Templates === void 0 ? void 0 : (_v2Templates$id = v2Templates[id]) === null || _v2Templates$id === void 0 ? void 0 : _v2Templates$id.itemTemplateRules;
  return (v2ItemTemplateRules === null || v2ItemTemplateRules === void 0 ? void 0 : v2ItemTemplateRules.map(function (_ref) {
    var template = _ref.template,
      rest = _objectWithoutProperties(_ref, _excluded$7);
    return _extends$3({}, rest, {
      template: v2Templates[template.id]
    });
  })) || itemTemplateRules;
};

/**
 * Component responsible for rendering the collection of containers.
 * @param {*} Container TemplateRenderer that can render a container.
 */
var ContainerCollectionFactory = function ContainerCollectionFactory(Container) {
  /**
   * Render a container
   * @param {*} containerEntity The container to render.
   * @param {*} context The context received from the page.
   * @param {*} generalProps General component options e.g. actions and options.
   * @param {number} index Index of the container.
   */
  var renderContainer = function renderContainer(containerEntity, context, generalProps, index) {
    var id = containerEntity.id,
      template = containerEntity.template,
      templates = containerEntity.templates,
      data = containerEntity.data;
    var formFactor = generalProps.formFactor,
      v2Templates = generalProps.v2Templates;
    var itemTemplateRules = getItemTemplateRules(containerEntity, formFactor, v2Templates);
    if (!containerEntity || !isVisible(containerEntity, context)) {
      return null;
    }
    return /*#__PURE__*/React__default.createElement(CollectionItem, {
      debugInfo: {
        id: id,
        index: index
      },
      "data-cy": "ContainerCollection_ContainerCollection_CollectionItem"
    }, /*#__PURE__*/React__default.createElement(Container, _extends$3({
      context: _extends$3({}, context, {
        containerIndex: index
      }),
      data: data,
      formFactor: formFactor,
      itemTemplateRules: itemTemplateRules,
      key: id,
      template: template,
      templates: templates,
      v2Templates: v2Templates
    }, generalProps, {
      // This makes all children of the container collection share the same stacking context,
      // ensuring that any container (with negative top margin) can cover the container before
      // them in the DOM. This wouldn't be the case with `auto`.
      zIndex: 1,
      "data-cy": "ContainerCollection_ContainerCollection_Container"
    })));
  };
  var ContainerCollection = function ContainerCollection(_ref2) {
    _ref2.properties;
      var _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? {} : _ref2$context,
      id = _ref2.id,
      generalProps = _objectWithoutProperties(_ref2, _excluded2$2);
    var _context$containerCol = context.containerCollections,
      containerCollections = _context$containerCol === void 0 ? [] : _context$containerCol,
      restOfContext = _objectWithoutProperties(context, _excluded3$2);
    var containerCollection = containerCollections.find(function (collection) {
      return collection.componentId === id;
    });

    // Logs a warning if a collection with the given componentId doesn't exist.
    if (!containerCollection || !containerCollection.containers) {
      console.warn("Container Collection doesn't exist", id);
      return null;
    }
    return containerCollection.containers.map(function (containerEntity, containerIndex) {
      return renderContainer(containerEntity, restOfContext, generalProps, containerIndex);
    });
  };
  ContainerCollection.propTypes = {
    id: PropTypes__default.string,
    properties: PropTypes__default.shape({
      collectionId: PropTypes__default.string
    }),
    context: PropTypes__default.object
  };
  return ContainerCollection;
};

var itemWidthByColumns = function itemWidthByColumns(columnWeight, columns) {
  var widthInPercentage = columnWeight && columns && columnWeight < columns ? columnWeight / columns * 100 : 100;
  return "width: ".concat(widthInPercentage, "%;");
};
var breakpointWidths = function breakpointWidths(_ref) {
  var columnWeight = _ref.columnWeight,
    weightSum = _ref.weightSum;
  return Object.keys(breakpoints$1).filter(function (key) {
    return weightSum[key];
  }).map(function (key) {
    return styleUntilBreakpoint(key, itemWidthByColumns(columnWeight, weightSum[key]));
  });
};
var GridItem = styled(function (props) {
  return /*#__PURE__*/React__default.createElement("div", _extends$3({}, filterProperties(props), {
    "data-cy": "Grid_GridItem_div"
  }));
}).withConfig({
  displayName: "GridItem",
  componentId: "sc-j8wjsf-0"
})(["position:relative;", " box-sizing:border-box;overflow:hidden;float:left;", " ", ""], function (_ref2) {
  var gutterRem = _ref2.gutterRem;
  return gutterRem && "padding: 0 ".concat(gutterRem / 2, "rem;\n     margin-bottom: ").concat(gutterRem, "rem;");
}, function (_ref3) {
  var columnWeight = _ref3.columnWeight,
    weightSum = _ref3.weightSum;
  return itemWidthByColumns(columnWeight, weightSum.xxl);
}, breakpointWidths);
GridItem.displayName = 'GridItem';

var ScrollDetectorPosition = {
  Top: 'top',
  Bottom: 'bottom'
};
var Marker = styled.div.withConfig({
  displayName: "ScrollDetector__Marker",
  componentId: "sc-12b4yvz-0"
})(["", ""], function (_ref) {
  var $position = _ref.$position,
    $size = _ref.$size;
  return css$1(["position:absolute;", ":0;height:", "vh;left:0;right:0;pointer-events:none;"], $position, $size);
});
Marker.displayName = 'Marker';
var ScrollDetector = function ScrollDetector(_ref2) {
  var _ref2$enabled = _ref2.enabled,
    enabled = _ref2$enabled === void 0 ? true : _ref2$enabled,
    _ref2$position = _ref2.position,
    position = _ref2$position === void 0 ? ScrollDetectorPosition.Bottom : _ref2$position,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 0.5 : _ref2$size,
    onEnterView = _ref2.onEnterView;
  var refMarker = useRef(null);
  useIntersection({
    targetRef: refMarker,
    // no rootMargin here, as Marker already includes the margin
    enabled: enabled,
    onEnterView: onEnterView
  });
  if (!enabled) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(Marker, {
    $position: position,
    $size: size,
    ref: refMarker,
    "data-cy": "Grid_ScrollDetector_Marker"
  });
};
ScrollDetector.propTypes = {
  enabled: PropTypes__default.bool,
  position: PropTypes__default.oneOf(Object.values(ScrollDetectorPosition)),
  size: PropTypes__default.number,
  onEnterView: PropTypes__default.func.isRequired
};

var usePagination$1 = function usePagination(_ref) {
  var _initial$length;
  var feed = _ref.feed,
    collectionId = _ref.collectionId,
    serviceId = _ref.serviceId,
    initial = _ref.initial,
    _ref$pageInfo = _ref.pageInfo,
    pageInfo = _ref$pageInfo === void 0 ? {} : _ref$pageInfo,
    _ref$fetcher = _ref.fetcher,
    fetcher = _ref$fetcher === void 0 ? defaultFetcher : _ref$fetcher;
  var initialLength = (_initial$length = initial === null || initial === void 0 ? void 0 : initial.length) !== null && _initial$length !== void 0 ? _initial$length : 0;
  // for missing pageInfo, we fall back to single page, no pagination
  var _pageInfo$pageSize = pageInfo.pageSize,
    pageSize = _pageInfo$pageSize === void 0 ? initialLength : _pageInfo$pageSize,
    _pageInfo$total = pageInfo.total,
    total = _pageInfo$total === void 0 ? initialLength : _pageInfo$total;
  var page = initialLength ? pageInfo.page || 1 : 0;

  // currently fetched data
  var _useState = useState(initial),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showNextSpinner = _useState4[0],
    setShowNextSpinner = _useState4[1];

  // other that we don't need in state.
  var createInfo = useCallback(function () {
    return {
      // 1-based. first page we have fetched currently. this will stay at 1 for now, but when we'll drop top pages when scrolling
      // down, this will be increassed. then when scrolling up again, these pages will be re-fetched as needed.
      firstFetchedPage: page,
      // 1-based. last page we have fetched currently.
      lastFetchedPage: page,
      // total number of pages in the dataset that we could fetch.
      totalPageCount: Math.ceil(total / pageSize),
      // is previous/next fetching in progress?
      pendingPrevious: false,
      pendingNext: false,
      // did previous/next fetch fail?
      failedPrevious: false,
      failedNext: false
    };
  }, [page, pageSize, total]);
  var info = useRef(createInfo());

  // init/re-init whenewer initial data or page info changes
  useEffect(function () {
    if (!initial) {
      return;
    }
    setData(initial);
    info.current = createInfo();
  }, [initial, createInfo]);

  // methods
  var hasMorePrevious = function hasMorePrevious() {
    return !info.current.failedPrevious && info.current.firstFetchedPage > 1;
  };
  var hasMoreNext = function hasMoreNext() {
    return !info.current.failedNext && (info.current.lastFetchedPage === 0 || info.current.lastFetchedPage < info.current.totalPageCount);
  };
  var fetchPrevious = function fetchPrevious() {
    // TODO: for now, we keep all fethced items. when scrolling down, we should drop items from the top,
    //  then fetch them again when scrolling back up. and vice versa.
  };
  var fetchNext = function fetchNext() {
    if (!hasMoreNext() || info.current.pendingNext) {
      return Promise.resolve();
    }
    info.current.pendingNext = true;
    setShowNextSpinner(true);
    var start = info.current.lastFetchedPage * pageSize;
    return fetcher({
      feed: feed,
      collectionId: collectionId,
      serviceId: serviceId,
      opts: {
        start: start,
        size: pageSize
      },
      componentType: 'GRID'
    }).then(function (res) {
      info.current.lastFetchedPage += 1;
      info.current.totalPageCount = Math.ceil(res.pageInfo.total / res.pageInfo.pageSize);
      var newData = [].concat(_toConsumableArray(data !== null && data !== void 0 ? data : []), _toConsumableArray(res.data));
      setData(newData);
      return newData.length;
    })["catch"](function () {
      info.current.failedNext = true;
      return 0;
    }).then(function (newLength) {
      setShowNextSpinner(false);
      info.current.pendingNext = false;
      return newLength;
    });
  };

  // return api
  return {
    // states
    data: data,
    showNextSpinner: showNextSpinner,
    // methods
    hasMorePrevious: hasMorePrevious,
    hasMoreNext: hasMoreNext,
    fetchPrevious: fetchPrevious,
    fetchNext: fetchNext,
    debug: function debug() {
      return {
        info: info.current,
        hasMorePrevious: hasMorePrevious(),
        hasMoreNext: hasMoreNext(),
        dataLength: data.length
      };
    }
  };
};

var INTERSECTION_MARGIN$2 = '20%'; // root margin for intersection observer (margin-like, px or %)

var GridListDiv = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement("div", _extends$3({
    ref: ref
  }, filterProperties(props), {
    "data-cy": "Grid_Grid_div"
  }));
});
GridListDiv.displayName = 'GridListDiv';
var GridList = styled(GridListDiv).withConfig({
  displayName: "Grid__GridList",
  componentId: "sc-1vquwb7-0"
})(["", " ", " ", " ", " position:relative;overflow:hidden;"], function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor && "background-color: ".concat(backgroundColor, ";");
}, function (_ref2) {
  var height = _ref2.height;
  return height === HeightAndWidthTypes.FillParent && "height: 100%;";
}, function (_ref3) {
  var width = _ref3.width,
    _ref3$gutterRem = _ref3.gutterRem,
    gutterRem = _ref3$gutterRem === void 0 ? 0 : _ref3$gutterRem;
  return width === HeightAndWidthTypes.FillParent && "width: calc(100% + ".concat(gutterRem, "rem);");
}, function (_ref4) {
  var gutterRem = _ref4.gutterRem;
  return gutterRem && "margin: 0 -".concat(gutterRem / 2, "rem;");
});
GridList.displayName = 'GridList';
var DEFAULT_FETCH_MARGIN = 50; // how much before the bottom do we start fetching the next page, in `vh` units

var getColumnsForBreakpoint = function getColumnsForBreakpoint(weightSum, currentBreakpoint) {
  return {
    xxl: getSettingsForBreakpoint(weightSum, currentBreakpoint)
  };
};
var GridFactory = function GridFactory(Item, Icon, factoryFetcher) {
  var rootElement = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : document;
  var Grid = function Grid(props) {
    var _pagination$data2, _ref5, _pagination$data3;
    var _props$data = props.data,
      data = _props$data === void 0 ? {} : _props$data,
      itemTemplateRules = props.itemTemplateRules,
      properties = props.properties,
      context = props.context,
      _props$options = props.options,
      options = _props$options === void 0 ? {} : _props$options,
      _props$actions = props.actions,
      actions = _props$actions === void 0 ? {} : _props$actions,
      v2Templates = props.v2Templates,
      formFactorTemplateProperties = props.formFactorTemplateProperties,
      _props$fetchMargin = props.fetchMargin,
      fetchMargin = _props$fetchMargin === void 0 ? DEFAULT_FETCH_MARGIN : _props$fetchMargin,
      _props$fetcher = props.fetcher,
      fetcher = _props$fetcher === void 0 ? factoryFetcher : _props$fetcher,
      _props$onRemoveContai = props.onRemoveContainer,
      onRemoveContainer = _props$onRemoveContai === void 0 ? NOOP : _props$onRemoveContai;
    var containerRef = useRef(null);

    // pagination controller
    var serviceId = context.serviceId;
    var feed = data.feed,
      collectionId = data.collectionId,
      initial = data.initial,
      pageInfo = data.pageInfo;
    var pagination = usePagination$1({
      feed: feed,
      collectionId: collectionId,
      serviceId: serviceId,
      initial: initial,
      pageInfo: pageInfo,
      fetcher: fetcher
    });

    // if no initial data, fetch it when first entering the view
    useIntersection({
      targetRef: containerRef,
      rootMargin: INTERSECTION_MARGIN$2,
      rootElement: rootElement,
      onFirstEnterView: useCallback(function () {
        var _pagination$data;
        if ((_pagination$data = pagination.data) !== null && _pagination$data !== void 0 && _pagination$data.length) {
          return;
        }
        pagination.fetchNext().then(function (newLength) {
          if (newLength === 0) {
            onRemoveContainer();
          }
        });
      }, [pagination, onRemoveContainer])
    });
    var _properties$gutter = properties.gutter,
      gutter = _properties$gutter === void 0 ? GutterSize.None : _properties$gutter,
      _properties$weightSum = properties.weightSum,
      weightSum = _properties$weightSum === void 0 ? {} : _properties$weightSum;
    var currentBreakpoint = options.currentBreakpoint;
    var gutterRem = gutterSizesRem[gutter];
    var responsiveColumns = currentBreakpoint ? getColumnsForBreakpoint(weightSum, currentBreakpoint) : weightSum;

    // placeholder items
    var showPlaceholders = !((_pagination$data2 = pagination.data) !== null && _pagination$data2 !== void 0 && _pagination$data2.length);
    var columns = Object.values(responsiveColumns).pop();
    var placeholderCount = showPlaceholders ? (_ref5 = columns * 4 || pageInfo.pageSize || pageInfo.total) !== null && _ref5 !== void 0 ? _ref5 : 1 : 0;
    var _createItemPlaceholde = createItemPlaceholders(placeholderCount, itemTemplateRules[0].template, context),
      placeholderTemplate = _createItemPlaceholde.placeholderTemplate,
      placeholders = _createItemPlaceholde.placeholders;
    var itemsToRender = showPlaceholders ? placeholders : pagination.data;

    // props for rendering placeholders or real items
    var getTemplateProps = function getTemplateProps(item, index) {
      if (showPlaceholders) {
        return {
          columnWeight: 1,
          template: placeholderTemplate
        };
      }
      var templateRule = getItemTemplate(item, index, itemTemplateRules);
      var _templateRule$columnW = templateRule.columnWeight,
        columnWeight = _templateRule$columnW === void 0 ? 1 : _templateRule$columnW,
        _templateRule$templat = templateRule.templateWeights,
        _templateRule$templat2 = _templateRule$templat === void 0 ? {} : _templateRule$templat,
        columnWeightXxl = _templateRule$templat2.xxl,
        template = templateRule.template;
      return {
        columnWeight: columnWeightXxl || columnWeight,
        template: template
      };
    };
    return /*#__PURE__*/React__default.createElement(GridList, _extends$3({
      ref: containerRef
    }, dataDyn(props), properties, {
      gutterRem: gutterRem,
      "data-cy": "Grid_Grid_GridList"
    }), itemsToRender.map(function (item, index) {
      var _getTemplateProps = getTemplateProps(item, index),
        columnWeight = _getTemplateProps.columnWeight,
        template = _getTemplateProps.template;
      var itemTitle = item === null || item === void 0 ? void 0 : item.title;
      return /*#__PURE__*/React__default.createElement(GridItem, _extends$3({}, dataDyn(item), {
        "aria-label": itemTitle,
        columnWeight: columnWeight,
        currentBreakpoint: currentBreakpoint,
        gutterRem: gutterRem,
        key: item.id,
        weightSum: responsiveColumns,
        "data-cy": "Grid_Grid_GridItem"
      }), /*#__PURE__*/React__default.createElement(ItemWrapper, {
        "data-cy": "Grid_Grid_ItemWrapper"
      }, /*#__PURE__*/React__default.createElement(Item, {
        actions: actions,
        context: _extends$3({}, context, {
          item: item,
          itemIndex: index
        }),
        formFactorTemplateProperties: formFactorTemplateProperties,
        template: template,
        v2Templates: v2Templates,
        "data-cy": "Grid_Grid_Item"
      })));
    }), /*#__PURE__*/React__default.createElement(ScrollDetector, {
      enabled: !!((_pagination$data3 = pagination.data) !== null && _pagination$data3 !== void 0 && _pagination$data3.length) && pagination.hasMoreNext(),
      onEnterView: function onEnterView() {
        pagination.fetchNext().then();
      },
      position: ScrollDetectorPosition.Bottom,
      size: fetchMargin,
      "data-cy": "Grid_Grid_ScrollDetector"
    }), pagination.showNextSpinner && /*#__PURE__*/React__default.createElement(Spinner, {
      Icon: Icon,
      "data-cy": "Grid_Grid_Spinner"
    }));
  };
  Grid.displayName = 'Grid';
  Grid.propTypes = {
    data: PropTypes__default.shape({
      feed: PropTypes__default.string,
      initial: PropTypes__default.arrayOf(PropTypes__default.shape({
        id: PropTypes__default.string
      })),
      collectionId: PropTypes__default.string,
      pageInfo: PropTypes__default.shape({
        total: PropTypes__default.number,
        hasMore: PropTypes__default.bool,
        page: PropTypes__default.number,
        pageSize: PropTypes__default.number
      })
    }),
    properties: PropTypes__default.shape({
      gutter: PropTypes__default.oneOf(Object.values(GutterSize)),
      cornerRadius: PropTypes__default.oneOf(Object.values(CornerRadius)),
      weightSum: PropTypes__default.shape({
        xxl: PropTypes__default.number,
        xl: PropTypes__default.number,
        lg: PropTypes__default.number,
        md: PropTypes__default.number,
        sm: PropTypes__default.number,
        xs: PropTypes__default.number
      }),
      wrap: PropTypes__default.bool
    }),
    itemTemplateRules: PropTypes__default.arrayOf(PropTypes__default.shape({
      template: PropTypes__default.object
    })),
    context: PropTypes__default.object,
    options: PropTypes__default.shape({
      currentBreakpoint: PropTypes__default.string
    }),
    actions: actionsPropType,
    v2Templates: PropTypes__default.object,
    formFactorTemplateProperties: PropTypes__default.object,
    fetchMargin: PropTypes__default.number,
    fetcher: PropTypes__default.func,
    onRemoveContainer: PropTypes__default.func
  };
  return Grid;
};
GridFactory.displayName = 'GridFactory';

var _excluded$6 = ["applyCornerRadius", "hoverZoomContainer"];
var getGradient = function getGradient(color, direction) {
  var dir = gradientDirectionMap[direction];
  return "background-image: linear-gradient(".concat(dir || '', " ").concat(color, ", transparent);");
};
var applyGradient = function applyGradient(_ref) {
  var gradientColor = _ref.gradientColor,
    _ref$gradientDirectio = _ref.gradientDirection,
    gradientDirection = _ref$gradientDirectio === void 0 ? Directions.Up : _ref$gradientDirectio,
    _ref$gradient = _ref.gradient,
    gradient = _ref$gradient === void 0 ? {} : _ref$gradient;
  var _gradient$color = gradient.color,
    color = _gradient$color === void 0 ? gradientColor : _gradient$color,
    _gradient$direction = gradient.direction,
    direction = _gradient$direction === void 0 ? gradientDirection : _gradient$direction;
  return color ? getGradient(color, direction) : '';
};
var GroupComponent = styled(function (props) {
  return /*#__PURE__*/React__default.createElement("div", _extends$3({}, filterProperties(props), {
    "data-cy": "Group_Group_div"
  }));
}).withConfig({
  displayName: "Group__GroupComponent",
  componentId: "sc-el8msh-0"
})(["display:flex;", " ", " ", " ", " ", " ", " ", " ", " ", ""], function (_ref2) {
  var _ref2$growth = _ref2.growth,
    growth = _ref2$growth === void 0 ? Directions.Down : _ref2$growth;
  return "flex-direction: ".concat(growthMap[growth], ";");
}, function (_ref3) {
  var _ref3$gravity = _ref3.gravity,
    gravity = _ref3$gravity === void 0 ? GravityTypes.Start : _ref3$gravity;
  return "justify-content: ".concat(gravityMap[gravity], ";");
}, function (_ref4) {
  var _ref4$alignment = _ref4.alignment,
    alignment = _ref4$alignment === void 0 ? Alignment.Start : _ref4$alignment;
  return "align-items: ".concat(alignmentMap[alignment], ";");
}, function (_ref5) {
  var backgroundColor = _ref5.backgroundColor;
  return backgroundColor && "background-color: ".concat(backgroundColor, ";");
}, function (_ref6) {
  var wrap = _ref6.wrap;
  return wrap && "flex-wrap: wrap;";
}, applyGradient, generalUtils, function (_ref7) {
  var $corner = _ref7.$corner;
  return "border-radius: ".concat($corner || 0, "rem;");
}, function (_ref8) {
  var $zIndex = _ref8.$zIndex;
  return $zIndex && "z-index: ".concat($zIndex, ";");
});
GroupComponent.displayName = 'GroupComponent';
var Group = function Group(props) {
  var children = props.children,
    properties = props.properties,
    _props$actions = props.actions,
    actions = _props$actions === void 0 ? {} : _props$actions,
    _props$context = props.context,
    context = _props$context === void 0 ? {} : _props$context,
    zIndex = props.zIndex;

  // It's like this because we don't want to pass applyCornerRadius to the div element
  properties.applyCornerRadius;
    var hoverZoomContainerProp = properties.hoverZoomContainer,
    restProps = _objectWithoutProperties(properties, _excluded$6);
  var cornerRadiusRem = getCornerRadiusRem(properties, context.theme);
  var hoverZoomContainer = String(hoverZoomContainerProp) === 'true';
  return /*#__PURE__*/React__default.createElement(GroupComponent, _extends$3({}, dataDyn(props), restProps, eventHandlers(context, actions, properties.action), {
    $corner: cornerRadiusRem,
    $zIndex: zIndex,
    className: classNames(hoverZoomContainer && 'hoverZoomContainer'),
    "data-cy": "Group_Group_GroupComponent"
  }), children);
};
Group.propTypes = {
  children: PropTypes__default.node,
  properties: PropTypes__default.shape({
    gravity: PropTypes__default.string,
    growth: PropTypes__default.oneOf(Object.values(Directions)),
    alignment: PropTypes__default.oneOf(Object.values(Positions)),
    backgroundColor: PropTypes__default.string,
    gradientColor: PropTypes__default.string,
    gradientDirection: PropTypes__default.oneOf(Object.values(Directions)),
    // Width of the component when it is placed within a group with multiple components.
    weight: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.object]),
    width: PropTypes__default.oneOf(Object.values(HeightAndWidthTypes)),
    height: PropTypes__default.oneOf(Object.values(HeightAndWidthTypes)),
    // Toggle to wrap the elements within a group when they overflow the row/column.
    wrap: PropTypes__default.bool,
    action: actionPropType,
    cornerRadius: PropTypes__default.oneOf(Object.values(CornerRadius)),
    applyCornerRadius: PropTypes__default.bool,
    // Temporary undocumented prop to enable simplified hover zoom. Can be string "true" if coming through container props.
    hoverZoomContainer: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.string])
  }),
  actions: actionsPropType,
  context: PropTypes__default.object,
  zIndex: PropTypes__default.number
};
var Group$1 = withPropDatabinding({
  propsToBind: ['backgroundColor', 'gradientColor', 'gradient.color']
})(Group);

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var PlaceholderIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React__default.createElement("svg", _extends$2({
  xmlns: "http://www.w3.org/2000/svg",
  width: "300",
  height: "300",
  viewBox: "0 0 400 400"
}, props), /*#__PURE__*/React__default.createElement("g", {
  fill: "#D8D8D8"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M93.316 278.478c2.386 2.34 5.189 2.257 7.396 1.177a6.756 6.756 0 001.698-1.174c.426-.393.8-.816 1.22-1.342l.419-.538a68.24 68.24 0 001.864-2.62l1.157-1.716c1.562-2.344 3.554-5.432 5.986-9.275l2.655-4.218c4.832-7.71 11.051-17.805 18.66-30.286l6.232-10.248 29.635 37.598a10.057 10.057 0 002.3 2.13l.444.281c4.655 2.779 10.647 1.363 13.582-3.138l.214-.343 43.643-73.105 54.33 66.564-.136.218a118.33 118.33 0 01-14.11 18.03l-1.357 1.403c-32.625 33.2-81.183 43.814-124.216 28.32a6.403 6.403 0 10-4.338 12.048c47.696 17.173 101.524 5.407 137.687-31.393 50.634-51.525 49.914-134.338-1.607-184.968-51.521-50.63-134.334-49.904-184.968 1.62-50.633 51.526-49.914 134.339 1.61 184.975zm3.866-14.476l-.251-.278c-41.097-45.99-39.941-116.623 3.908-161.245 45.677-46.481 120.383-47.136 166.86-1.463 36.717 36.082 44.832 90.283 24.101 134.373l-.37.767-53.563-65.625c-3.428-4.2-9.544-4.912-13.837-1.682l-.319.25a10.075 10.075 0 00-1.963 2.144l-.314.493-43.609 73.042-29.612-37.573c-3.356-4.258-9.459-5.075-13.807-1.918l-.323.244a10.053 10.053 0 00-2.374 2.685l-8.138 13.386c-7.666 12.577-13.917 22.723-18.75 30.435l-3.127 4.96a559.765 559.765 0 01-3.938 6.132l-.574.873z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M184.085 119.317c10.608 0 19.208 8.6 19.208 19.207 0 10.608-8.6 19.208-19.208 19.208-10.608 0-19.207-8.6-19.207-19.208 0-10.608 8.6-19.207 19.207-19.207zm0 12.805a6.403 6.403 0 10.001 12.805 6.403 6.403 0 00-.001-12.805z"
}))));

var q=["0","1","2","3","4","5","6","7","8","9","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z","#","$","%","*","+",",","-",".",":",";","=","?","@","[","]","^","_","{","|","}","~"],x=t=>{let e=0;for(let r=0;r<t.length;r++){let n=t[r],l=q.indexOf(n);e=e*83+l;}return e};var f=t=>{let e=t/255;return e<=.04045?e/12.92:Math.pow((e+.055)/1.055,2.4)},h=t=>{let e=Math.max(0,Math.min(1,t));return e<=.0031308?Math.trunc(e*12.92*255+.5):Math.trunc((1.055*Math.pow(e,.4166666666666667)-.055)*255+.5)},F=t=>t<0?-1:1,M=(t,e)=>F(t)*Math.pow(Math.abs(t),e);var d=class extends Error{constructor(e){super(e),this.name="ValidationError",this.message=e;}};var C=t=>{if(!t||t.length<6)throw new d("The blurhash string must be at least 6 characters");let e=x(t[0]),r=Math.floor(e/9)+1,n=e%9+1;if(t.length!==4+2*n*r)throw new d(`blurhash length mismatch: length is ${t.length} but it should be ${4+2*n*r}`)},z=t=>{let e=t>>16,r=t>>8&255,n=t&255;return [f(e),f(r),f(n)]},L=(t,e)=>{let r=Math.floor(t/361),n=Math.floor(t/19)%19,l=t%19;return [M((r-9)/9,2)*e,M((n-9)/9,2)*e,M((l-9)/9,2)*e]},U=(t,e,r,n)=>{C(t),n=n|1;let l=x(t[0]),m=Math.floor(l/9)+1,b=l%9+1,i=(x(t[1])+1)/166,u=new Array(b*m);for(let o=0;o<u.length;o++)if(o===0){let a=x(t.substring(2,6));u[o]=z(a);}else {let a=x(t.substring(4+o*2,6+o*2));u[o]=L(a,i*n);}let c=e*4,s=new Uint8ClampedArray(c*r);for(let o=0;o<r;o++)for(let a=0;a<e;a++){let y=0,B=0,R=0;for(let w=0;w<m;w++)for(let P=0;P<b;P++){let G=Math.cos(Math.PI*a*P/e)*Math.cos(Math.PI*o*w/r),T=u[P+w*b];y+=T[0]*G,B+=T[1]*G,R+=T[2]*G;}let V=h(y),I=h(B),E=h(R);s[4*a+0+o*c]=V,s[4*a+1+o*c]=I,s[4*a+2+o*c]=E,s[4*a+3+o*c]=255;}return s},j=U;

const blurhashDefaultProps = {
    height: 128,
    width: 128,
    resolutionX: 32,
    resolutionY: 32,
};
const blurhashCanvasDefaultProps = {
    loading: 'lazy',
    width: 128,
    height: 128,
};

let worker = undefined;
let workerPromise = undefined;
class CorsWorker {
    constructor(url) {
        const absoluteUrl = new URL(url, window.location.href).toString();
        const workerSource = `\
      const urlString = ${JSON.stringify(absoluteUrl)}
      const originURL = new URL(urlString)
      const isValidUrl = (urlString) => {
        try { return Boolean(new URL(urlString, originURL)) } catch(e){ return false }
      }
      const originalImportScripts = self.importScripts
      self.importScripts = (url) => {
        if(url.startsWith("blob:") && isValidUrl(url.replace("blob:", ""))){
          const urlWithoutBlob = url.replace("blob:", "")
          const { pathname } = new URL(urlWithoutBlob, originURL)
          url = pathname && pathname.substring(1)
        }
        originalImportScripts.call(self, new URL(url, originURL).toString())
      }
      importScripts(urlString);
      self.postMessage('settled');
    `;
        const blob = new Blob([workerSource], { type: 'application/javascript' });
        const objectURL = URL.createObjectURL(blob);
        this.internalWorker = new Worker(objectURL);
        URL.revokeObjectURL(objectURL);
    }
    getWorker() {
        return this.internalWorker;
    }
}
const getWorker = () => {
    if (worker) {
        return Promise.resolve(worker);
    }
    if (workerPromise) {
        return workerPromise;
    }
    if (typeof window === 'undefined') {
        return Promise.reject(new Error('Window is undefined, worker is not supported'));
    }
    workerPromise = new Promise((resolve, reject) => {
        // Avoid this promising running forever, if it takes longer than 200ms kill it.
        const timer = setTimeout(() => {
            reject(new Error(`Promise timed out after 200 ms`));
        }, 200);
        const corsWorker = new CorsWorker(new URL('./workers/Blurhash.worker', import.meta.url)).getWorker();
        if (!corsWorker) {
            workerPromise = undefined;
            clearTimeout(timer);
            return reject(new Error('Unknown error, worker was not able to be created.'));
        }
        corsWorker.onmessage = ({ data }) => {
            if (data === 'settled') {
                worker = corsWorker;
                clearTimeout(timer);
                return resolve(worker);
            }
            worker = undefined;
            workerPromise = undefined;
            clearTimeout(timer);
            return reject(new Error('Unknown error, worker did not settle as expected.'));
        };
        corsWorker.onerror = ({ message }) => {
            worker = undefined;
            workerPromise = undefined;
            clearTimeout(timer);
            return reject(new Error(message));
        };
    });
    return workerPromise;
};

const isOffscreenSupport = typeof OffscreenCanvas !== 'undefined';
let idGen = 0;
const BlurhashCanvasWorker = (_a) => {
    var { loading, hash, width, height, punch, imageRef, worker } = _a, props = __rest(_a, ["loading", "hash", "width", "height", "punch", "imageRef", "worker"]);
    const ref = useRef(null);
    const offCanvasRef = useRef();
    const isTransferedCanvasRef = useRef();
    const id = useMemo(() => (idGen += 1), []);
    useEffect(() => {
        var _a;
        if (((_a = imageRef === null || imageRef === void 0 ? void 0 : imageRef.current) === null || _a === void 0 ? void 0 : _a.complete) || !worker) {
            return;
        }
        const canvas = ref.current;
        if (!canvas) {
            return;
        }
        const isTransfered = isTransferedCanvasRef.current;
        if (!isTransfered) {
            offCanvasRef.current = canvas.transferControlToOffscreen();
        }
        const offCanvas = offCanvasRef.current;
        const msg = { width, height, punch, hash, id };
        worker.postMessage(isTransfered ? msg : Object.assign(Object.assign({}, msg), { canvas: offCanvas }), isTransfered ? [] : [offCanvas]);
        isTransferedCanvasRef.current = true;
    }, [hash, width, height, punch, imageRef, id, worker]);
    return React__default.createElement("canvas", Object.assign({}, props, { height: height, ref: ref, width: width }));
};
const BlurhashCanvasFallback = (_a) => {
    var { loading, hash, width, height, punch, imageRef } = _a, props = __rest(_a, ["loading", "hash", "width", "height", "punch", "imageRef"]);
    const ref = useRef(null);
    useEffect(() => {
        var _a;
        if ((_a = imageRef === null || imageRef === void 0 ? void 0 : imageRef.current) === null || _a === void 0 ? void 0 : _a.complete) {
            return;
        }
        const draw = () => {
            const canvas = ref.current;
            if (!canvas) {
                return;
            }
            const pixels = j(hash, width, height, punch);
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                return;
            }
            const imageData = ctx.createImageData(width, height);
            imageData.data.set(pixels);
            ctx.putImageData(imageData, 0, 0);
        };
        if (loading === 'lazy') {
            const timeout = setTimeout(draw, 0);
            return () => clearTimeout(timeout);
        }
        else {
            draw();
        }
    }, [hash, width, height, punch, imageRef, loading]);
    return React__default.createElement("canvas", Object.assign({}, props, { height: height, ref: ref, width: width }));
};
const BlurhashCanvas = (_a) => {
    var { loading } = _a, props = __rest(_a, ["loading"]);
    const [canUseWorker, setCanUseWorker] = useState(null);
    const [worker, setWorker] = useState();
    useEffect(() => {
        getWorker()
            .then((tempWorker) => {
            setWorker(tempWorker);
            setCanUseWorker(isOffscreenSupport && !!tempWorker && loading === 'lazy');
        })
            .catch(() => {
            setCanUseWorker(false);
        });
    }, [loading]);
    if (canUseWorker === null) {
        return null;
    }
    const Component = canUseWorker
        ? BlurhashCanvasWorker
        : BlurhashCanvasFallback;
    return React__default.createElement(Component, Object.assign({ loading: loading, worker: worker }, props));
};
BlurhashCanvas.defaultProps = blurhashCanvasDefaultProps;

const absoluteStyle = {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    height: '100%',
};
const defaultStyle = {
    display: 'inline-block',
    position: 'relative',
};

const Blurhash = (_a) => {
    var { loading, hash, height, width, punch, resolutionX = 128, resolutionY = 128, style, imageRef } = _a, props = __rest(_a, ["loading", "hash", "height", "width", "punch", "resolutionX", "resolutionY", "style", "imageRef"]);
    return (React__default.createElement("div", Object.assign({}, props, { style: Object.assign(Object.assign(Object.assign({}, defaultStyle), { width, height }), style) }),
        React__default.createElement(BlurhashCanvas, { hash: hash, height: resolutionY, imageRef: imageRef, loading: loading, punch: punch, style: absoluteStyle, width: resolutionX })));
};
Blurhash.defaultProps = blurhashDefaultProps;

var applyImageTransformations = function applyImageTransformations(_ref) {
  var src = _ref.src,
    _ref$transformations = _ref.transformations,
    transformations = _ref$transformations === void 0 ? [] : _ref$transformations;
  return transformations.length ? appendQueryParameters(src, {
    t: transformations.filter(Boolean).join('|')
  }) : src;
};

/**
 * Creates an array of sources and widths pair for given parameters of image
 * @param {{
 *  src: string
 *  imgToWindowRatio: string
 *  transformations: string[]
 *  sizes: string[]
 *  cropTransformation: string
 *  imgRefRatio: string
 * }} params Image parameters
 * @returns {{src: string, width: string}[]} Array of src and width pairs
 */
var createSourcesForBreakpoints = function createSourcesForBreakpoints(_ref2) {
  var src = _ref2.src,
    imgToWindowRatio = _ref2.imgToWindowRatio,
    transformations = _ref2.transformations,
    sizes = _ref2.sizes,
    cropTransformation = _ref2.cropTransformation,
    imgRefRatio = _ref2.imgRefRatio;
  if (!src) {
    return null;
  }
  var sortedSizes = sizes ? sizes.sort(function (a, b) {
    return a.width - b.width;
  }) : [];

  // Extend list with 2K screen to better support 2x density screens
  return [].concat(_toConsumableArray(OrderedBreakpoints), [{
    value: 2560
  }]).map(function (_ref3) {
    var key = _ref3.key,
      value = _ref3.value;
    // BreakpointKeys.XXL does not have any value by default
    var viewportWidth = key === BreakpointKeys.XXL ? 1920 : value;
    var resizeWidth = Math.round(viewportWidth * imgToWindowRatio);
    /**
     * If we'd like to use landscape images for a portrait size it needs
     * to have some additional adjustment based on the ratio.
     * Mostly used as a fallback calculation if there is no proper sizes
     * are available for the image.
     */
    var estimatedMaxHeight = imgRefRatio < 1 ? resizeWidth : resizeWidth * imgRefRatio * imgRefRatio;
    var standardWidth = sortedSizes.find(function (standardSize) {
      return standardSize.width > resizeWidth && standardSize.height > estimatedMaxHeight;
    }) || sortedSizes[sortedSizes.length - 1];
    /**
     * Uses closest standard width which is from the sizes array.
     * If not found use the estimated height based on the previous
     * calculations (estimation).
     */
    var width = standardWidth ? standardWidth.width : Math.round(estimatedMaxHeight);
    var calculatedTransformations = ["resize:w".concat(width)].concat(_toConsumableArray(transformations));
    if (standardWidth) {
      calculatedTransformations.push(cropTransformation);
    }
    return {
      src: applyImageTransformations({
        src: src,
        transformations: calculatedTransformations
      }),
      width: width
    };
  });
};
var getGradientTransformations = function getGradientTransformations(gradients) {
  var transformations = [];
  if (!gradients) {
    return transformations;
  }
  gradients.forEach(function (gradient) {
    var _gradient$colors;
    // Core API expects colors as RRGGBB[AA]. Without #, alpha last, long form.
    // Dynamic UI spec uses #RGB[A] or #RRGGBB[AA] so we need to remove # and ensure long form.
    // V1 version of gradients object, remove when no longer in use.
    var v1Color = isValidHexColor(gradient.color) && fromRgbaHexToRgba(gradient.color);
    var colors = [];
    (_gradient$colors = gradient.colors) === null || _gradient$colors === void 0 ? void 0 : _gradient$colors.forEach(function (_ref4) {
      var color = _ref4.color,
        position = _ref4.position;
      if (!isValidHexColor(color)) {
        return;
      }
      colors.push("".concat(isValidHexColor(color) && fromRgbaHexToRgba(color)).concat(position ? ".".concat(position) : ''));
    });
    var colorToUse = colors.length ? colors.join('~') : v1Color;
    if (!colorToUse) {
      return;
    }
    var direction = gradient.direction.toLowerCase();
    var size = gradient.size;
    transformations.push("gradient:".concat(direction, ",").concat(colorToUse, ",").concat(size));
  });
  return transformations;
};

/**
 * Creates the srcset based on the given urls for each widths
 * @param {{src: string;width: string;}[]} pictureSources
 * @returns {string} srcset used for the image element
 */
var getImageSrcSet = function getImageSrcSet(pictureSources) {
  var srcSet = [];
  if (!pictureSources) {
    return '';
  }
  pictureSources.forEach(function (pictureSource, index) {
    var _ref5 = pictureSource || {},
      src = _ref5.src,
      width = _ref5.width;
    var prevWidth = index > 0 ? pictureSources[index - 1].width : width;

    // If previous width is same as the current width we are observing here then
    // we remove the previous source and width pair and create a new one with the larger widht
    // This is to avoid duplicating the srcSet value for different max widths
    // Fo example is we have the following srcset:
    // srcset="img1?w=256 100w, img1?w=256 200w"
    // Then the first rule which would apply at 100w is obsolete
    if (width === prevWidth && srcSet.length > 0) {
      srcSet.pop();
    }
    srcSet.push("".concat(src, " ").concat(width, "w"));
  });
  return srcSet.join(', ');
};
var mapAspectRatio = function mapAspectRatio(ratio, fallback) {
  var defaultRatio = {
    ratio: ratio,
    isRatioMapped: true
  };
  switch (ratio) {
    case '1:1':
      defaultRatio.ratio = 'square';
      break;
    case '2:3':
      defaultRatio.ratio = 'portrait';
      break;
    case '5:2':
      defaultRatio.ratio = 'wide';
      break;
    case '16:9':
      defaultRatio.ratio = 'landscape';
      break;
    default:
      defaultRatio.ratio = fallback !== null && fallback !== void 0 ? fallback : ratio;
      defaultRatio.isRatioMapped = false;
      break;
  }
  return defaultRatio;
};

/**
 * Get image type name and ratio from the images of the context based on the url provided for the Image component
 * @param {
 *  {
 *  [key: string]: {
 *    [key: string]: {
 *      url: string
 *     }[]
 *    }
 *  }[]
 * } imageList Array of object containing image sources from context
 * @param {string} url Image url to search for in the image list
 * @example
 * const imagesList = {
 *   background: {landscape: [{url: 'image-background-landscape.jpeg'}]},
 *   poster: {landscape: [{url: 'image-poster-landscape.jpeg'}]}
 * }
 * const url = `image-poster-landscape.jpeg`
 * getImageTypeRatio(imageList, url) // Returns type: `poster`, ratio: 'landscape'
 */
var getImageTypeRatio = function getImageTypeRatio(imageList, url) {
  var ratio;
  var type = Object.keys(imageList).find(function (imageType) {
    return Object.keys(imageList[imageType]).some(function (imageRatioName) {
      return imageList[imageType][imageRatioName].some(function (imageObj) {
        var matches = imageObj.url === url;
        if (matches) {
          ratio = imageRatioName;
        }
        return matches;
      });
    });
  });
  return {
    ratio: ratio,
    type: type
  };
};

var _excluded$5 = ["color"];
var INTERSECTION_MARGIN$1 = '100px';
var BLURHASH_RESOLUTION = 128;
var ImageContainer = styled.div.withConfig({
  displayName: "Image__ImageContainer",
  componentId: "sc-1n0ke4m-0"
})(["position:relative;padding-top:", ";@supports (aspect-ratio:1/1){aspect-ratio:", ";padding-top:0;}", " ", " ", " overflow:hidden;", " ", ""], function (_ref) {
  var aspectRatio = _ref.aspectRatio;
  return percentFromAspectRatio(aspectRatio);
}, function (_ref2) {
  var aspectRatio = _ref2.aspectRatio;
  return aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.replace(':', '/');
}, function (_ref3) {
  var weight = _ref3.weight;
  return weight && "flex: ".concat(weight, ";");
}, function (_ref4) {
  var width = _ref4.width;
  return width === HeightAndWidthTypes.FillParent && "width: 100%;";
}, function (_ref5) {
  var contentMode = _ref5.contentMode;
  if (contentMode) {
    return "\n        display: flex;\n        width: 100%;\n        height: 100%;\n        justify-content: center;\n       ";
  }
}, generalUtils, function (_ref6) {
  var $corner = _ref6.$corner;
  return "border-radius: ".concat($corner || 0, "rem;");
});
ImageContainer.displayName = 'ImageContainer';
var ImageElement = styled.img.withConfig({
  displayName: "Image__ImageElement",
  componentId: "sc-1n0ke4m-1"
})(["&:not([src]){visibility:hidden;opacity:0;}font-size:0;width:100%;height:100%;", ""], function (_ref7) {
  var contentMode = _ref7.contentMode;
  if (contentMode === ContentModes.Fill) {
    return 'object-fit: cover;';
  }
  if (contentMode === ContentModes.Fit) {
    return 'object-fit: contain;';
  }
  return "\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      margin: auto;\n    ";
});
ImageElement.displayName = 'ImageElement';
var placeholderAnimation = keyframes(["0%{opacity:0.2;}50%{opacity:0.3;}100%{opacity:0.2;}"]);

// TODO - Placeholder image and background color should be passed in from consuming app.
var PlaceholderCenter = styled.div.withConfig({
  displayName: "Image__PlaceholderCenter",
  componentId: "sc-1n0ke4m-2"
})(["position:absolute;display:flex;justify-content:center;align-items:center;", " ", " height:100%;top:0;bottom:0;right:0;left:0;", " ", ""], function (_ref8) {
  var $hasBlurHash = _ref8.$hasBlurHash;
  return !$hasBlurHash && "opacity: 0.2; background: #9a9a9a;";
}, function (_ref9) {
  var $width = _ref9.$width;
  return $width && "width: 100%;";
}, function (_ref10) {
  var animate = _ref10.animate,
    $hasBlurHash = _ref10.$hasBlurHash;
  return animate && !$hasBlurHash && css$1(["animation:", " 1.5s infinite;"], placeholderAnimation);
}, function (_ref11) {
  var $corner = _ref11.$corner;
  return "border-radius: ".concat($corner || 0, "rem;");
});
PlaceholderCenter.displayName = 'PlaceholderCenter';
var PlaceholderImage = styled(PlaceholderIcon).withConfig({
  displayName: "Image__PlaceholderImage",
  componentId: "sc-1n0ke4m-3"
})(["height:30%;width:auto;"]);
PlaceholderImage.displayName = 'PlaceholderImage';
var Placeholder = function Placeholder(_ref12) {
  var animate = _ref12.animate,
    blurhash = _ref12.blurhash,
    className = _ref12.className,
    cornerRadiusRem = _ref12.cornerRadiusRem,
    width = _ref12.width,
    showImage = _ref12.showImage;
  return /*#__PURE__*/React__default.createElement(PlaceholderCenter, {
    $corner: cornerRadiusRem,
    $hasBlurHash: !!blurhash,
    $width: width,
    animate: animate,
    className: className,
    "data-cy": "Image_Image_PlaceholderCenter"
  }, blurhash && !showImage && /*#__PURE__*/React__default.createElement(Blurhash, {
    hash: blurhash,
    height: "100%",
    resolutionX: BLURHASH_RESOLUTION,
    resolutionY: BLURHASH_RESOLUTION,
    width: "100%",
    "data-cy": "Image_Image_Blurhash"
  }), showImage && /*#__PURE__*/React__default.createElement(PlaceholderImage, {
    "data-cy": "Image_Image_PlaceholderImage"
  }));
};
Placeholder.displayName = 'Placeholder';
Placeholder.propTypes = {
  animate: PropTypes__default.bool,
  blurhash: PropTypes__default.string,
  className: PropTypes__default.string,
  cornerRadiusRem: PropTypes__default.number,
  width: PropTypes__default.string,
  showImage: PropTypes__default.bool
};

/**
 * Extracts item title from context. For movies it's just an item's title,
 * but for TV shows it's a combination of TV show name and episode title.
 * @param {*} context
 * @returns {string} Alternate text meaningful for screen readers
 */
function getAltText(context) {
  var _context$item$tvShow;
  if (!(context !== null && context !== void 0 && context.item)) {
    return '';
  }
  if (context.item.subtype === 'TV_SHOW_EPISODE' && (_context$item$tvShow = context.item.tvShow) !== null && _context$item$tvShow !== void 0 && _context$item$tvShow.title) {
    return "".concat(context.item.tvShow.title, ": ").concat(context.item.title);
  }
  return context.item.title || '';
}

// Use a single observer for all images
var imageObserver = null;

/**
 * Initializes the image observer used for lazy loading
 * @param {HTMLElement} rootElement
 */
var createImageObserver = function createImageObserver(rootElement) {
  return new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var imageContainer = entry.target;
        // the image can be a direct child, or wrapped in a heading
        var imageElement = imageContainer.querySelector('img');
        if (imageElement) {
          // Sizes must come first! Otherwise, Safari loads the fallback image first and then
          // the correct image based on the "sizes" attribute
          imageElement.sizes = imageElement.dataset.sizes;
          imageElement.srcset = imageElement.dataset.srcset;
          imageElement.src = imageElement.dataset.src;
        }
        imageObserver.unobserve(imageContainer);
      }
    });
  }, {
    root: rootElement || document,
    rootMargin: INTERSECTION_MARGIN$1,
    threshold: 0
  });
};
var ImageFactory = function ImageFactory() {
  var rootElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  // Checks if browser supports aspect-ratio property
  // Only use lazy-loading (IntersectionObserver) if it is available otherwise
  // there's a high of cumulative layout shifting.
  // It could happen if loading state is turned to `true` while padding is still applied
  // to the image container for a fragment of a second which HIGHLY affects the performance score.
  var supportsAspectRatio = CSS.supports('aspect-ratio: 1/1');
  if (!imageObserver && supportsAspectRatio) {
    imageObserver = createImageObserver(rootElement);
  }
  var MainImage = function MainImage(props) {
    var _context$item;
    var className = props.className,
      properties = props.properties,
      _props$context = props.context,
      context = _props$context === void 0 ? {} : _props$context,
      _props$actions = props.actions,
      actions = _props$actions === void 0 ? {} : _props$actions,
      observerRootElement = props.observerRootElement,
      _props$onError = props.onError,
      onError = _props$onError === void 0 ? NOOP : _props$onError;
    var _context$useStaticImg = context.useStaticImgSrc,
      useStaticImgSrc = _context$useStaticImg === void 0 ? false : _context$useStaticImg,
      theme = context.theme;
    var ariaProps = filterAriaProperties(props);
    var _aspectRatio = properties.aspectRatio,
      aspectRatios = properties.aspectRatios,
      contentMode = properties.contentMode,
      weight = properties.weight,
      width = properties.width,
      height = properties.height,
      contentWidth = properties.contentWidth,
      contentHeight = properties.contentHeight,
      action = properties.action,
      value = properties.value,
      alt = properties.alt,
      gradients = properties.gradients,
      isHeading = properties.isHeading;
    var imageList = ((_context$item = context.item) === null || _context$item === void 0 ? void 0 : _context$item.images) || {};

    // `imageType` is one of `background`, `poster`, `still` or `thumbnail`
    // based on the `value` as image url provided to the Image component
    var _getImageTypeRatio = getImageTypeRatio(imageList, value),
      imageType = _getImageTypeRatio.type,
      ratio = _getImageTypeRatio.ratio;
    // TODO: make the aspect ratio selection based on breakpoint (same as in TemplateRenderer)
    var aspectRatio = (aspectRatios === null || aspectRatios === void 0 ? void 0 : aspectRatios.xxl) || _aspectRatio;
    var _mapAspectRatio = mapAspectRatio(aspectRatio, ratio),
      aspectRatioName = _mapAspectRatio.ratio,
      isRatioMapped = _mapAspectRatio.isRatioMapped;
    var _ref13 = get(imageList, "".concat(imageType, ".").concat(aspectRatioName, ".0")) || {},
      sizes = _ref13.sizes,
      blurhash = _ref13.blurhash;
    var imgContainerRef = useRef();

    // null=loading, true=success, false=error
    var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      loaded = _useState2[0],
      setLoaded = _useState2[1];
    var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      imgToWindowRatio = _useState4[0],
      setImgToWindowRatio = _useState4[1];
    var _useState5 = useState(eventHandlers(context, actions, action)),
      _useState6 = _slicedToArray(_useState5, 1),
      actionHandlers = _useState6[0];
    var _useMemo = useMemo(function () {
        if (!(imgToWindowRatio && imgContainerRef.current)) {
          return {};
        }
        var imgRefRatio = imgContainerRef.current.offsetHeight / imgContainerRef.current.offsetWidth;
        var transformations = getGradientTransformations(gradients);
        var cropTransformation = isRatioMapped ? "crop:".concat(aspectRatioName) : '';
        return {
          imgSrc: applyImageTransformations({
            src: value,
            transformations: transformations
          }),
          pictureSources: useStaticImgSrc ? undefined : createSourcesForBreakpoints({
            src: value,
            sizes: sizes,
            imgToWindowRatio: imgToWindowRatio,
            transformations: transformations,
            cropTransformation: cropTransformation,
            imgRefRatio: imgRefRatio
          })
        };
      }, [value, imgToWindowRatio, useStaticImgSrc, isRatioMapped, gradients, aspectRatioName, sizes]),
      imgSrc = _useMemo.imgSrc,
      pictureSources = _useMemo.pictureSources;
    useEffect(function () {
      var _imageObserver;
      if (!imgContainerRef.current) {
        return;
      }
      var imgWidth = imgContainerRef.current.offsetWidth;
      var windowWidth = window.innerWidth;
      setImgToWindowRatio(imgWidth / windowWidth);
      if (observerRootElement && supportsAspectRatio) {
        createImageObserver(observerRootElement).observe(imgContainerRef.current);
        return;
      }
      if (!imgSrc) {
        return;
      }
      (_imageObserver = imageObserver) === null || _imageObserver === void 0 ? void 0 : _imageObserver.observe(imgContainerRef.current);

      // We need to listen to value changes for Admin UI purposes. When user changes image path in Editor (i.e. from still to poster) => image observer
      // should be recreated to update image src (see new IntersectionObserver callback function above)
    }, [imgSrc, observerRootElement, value]);
    var onDragStart = useCallback(function (e) {
      return e.preventDefault();
    }, []);
    var handleError = useCallback(function () {
      if (loaded === null) {
        setLoaded(false);
        onError(props.id);
      }
    }, [loaded, onError, props.id]);
    var handleLoad = useCallback(function () {
      return setLoaded(true);
    }, []);
    var cornerRadiusRem = getCornerRadiusRem(properties, theme);
    var srcSet = getImageSrcSet(pictureSources);
    return /*#__PURE__*/React__default.createElement(ImageContainer, _extends$3({}, dataDyn(props), _extends$3({
      // workaround: only apply aspect ratio based padding when we're displaying the placeholder while not supporting css aspect-ratio (loading or error states).
      aspectRatio: loaded === true && !supportsAspectRatio ? null : aspectRatio,
      weight: weight,
      width: width,
      height: height,
      contentWidth: contentWidth,
      contentHeight: contentHeight,
      contentMode: contentMode
    }, ariaProps), {
      $corner: cornerRadiusRem,
      className: className,
      ref: imgContainerRef
    }, actionHandlers, {
      "data-cy": "Image_Image_ImageContainer"
    }), imgSrc && loaded !== false && /*#__PURE__*/React__default.createElement(Heading, {
      containerIndex: context === null || context === void 0 ? void 0 : context.containerIndex,
      isDetailsPage: context === null || context === void 0 ? void 0 : context.isDetailsPage,
      isHeading: isHeading,
      itemIndex: context === null || context === void 0 ? void 0 : context.itemIndex,
      "data-cy": "Image_Image_Heading"
    }, /*#__PURE__*/React__default.createElement(ImageElement, _extends$3({
      alt: alt || getAltText(context),
      contentMode: contentMode
    }, supportsAspectRatio ? {
      'data-sizes': "".concat(Math.floor(imgToWindowRatio * 100), "vw"),
      'data-src': imgSrc,
      'data-srcset': srcSet
    } : {
      sizes: "".concat(Math.floor(imgToWindowRatio * 100), "vw"),
      src: imgSrc,
      srcset: srcSet
    }, {
      // fixes the issue when image-only slider items are being dragged instead of swiped on desktop
      draggable: false,
      loaded: loaded
      // fixes the same issue on Firefox
      ,
      onDragStart: onDragStart,
      onError: handleError,
      onLoad: handleLoad,
      "data-cy": "Image_Image_ImageElement"
    }))), loaded !== true && /*#__PURE__*/React__default.createElement(Placeholder, {
      animate: !!imgSrc && loaded === null,
      blurhash: blurhash,
      cornerRadiusRem: cornerRadiusRem,
      showImage: loaded === false,
      width: width,
      "data-cy": "Image_Image_Placeholder"
    }));
  };
  MainImage.displayName = 'MainImage';
  MainImage.propTypes = {
    id: PropTypes__default.string,
    className: PropTypes__default.string,
    properties: PropTypes__default.shape({
      aspectRatio: PropTypes__default.string,
      aspectRatios: PropTypes__default.object,
      contentMode: PropTypes__default.oneOf(Object.values(ContentModes)),
      contentWidth: responsivePropType(PropTypes__default.number),
      contentHeight: responsivePropType(PropTypes__default.number),
      value: PropTypes__default.string,
      height: PropTypes__default.oneOf(Object.values(HeightAndWidthTypes)),
      weight: PropTypes__default.number,
      width: PropTypes__default.oneOf(Object.values(HeightAndWidthTypes)),
      action: actionPropType,
      alt: PropTypes__default.string,
      cornerRadius: PropTypes__default.oneOf(Object.values(CornerRadius)),
      applyCornerRadius: PropTypes__default.bool,
      gradients: PropTypes__default.arrayOf(PropTypes__default.shape({
        color: PropTypes__default.string,
        direction: PropTypes__default.string,
        size: PropTypes__default.number
      })),
      isHeading: PropTypes__default.bool
    }),
    actions: actionsPropType,
    context: PropTypes__default.object,
    // Lazy loading (Intersection observer) is not working properly in the Slider component
    // if the root element is set to document. The root element has to be set to the direct
    // ancestors in order to trigger the observer when the observer element (Image) enters the viewport.
    observerRootElement: PropTypes__default.object,
    // For when clients use the component directly.
    onError: PropTypes__default.func
  };
  return withPropDatabinding({
    propsToBind: ['value', 'gradients', 'aspectRatios'],
    databinder: function databinder(_ref14) {
      var name = _ref14.name,
        value = _ref14.value,
        context = _ref14.context;
      var databoundValue = applyDatabinding({
        value: value,
        context: context
      });

      // `value` can be a keypath, pointing to an image array in context.
      // we are just selecting the first one from the array.
      // TODO: better selection logic
      if (name === 'value') {
        var imageArray = get(context, databoundValue);
        if (Array.isArray(imageArray) && imageArray.length > 0) {
          return imageArray[0].url;
        }

        // TODO: this won't handle relative URLs
        return value !== null && value !== void 0 && value.startsWith('http') ? value : null;
      }

      // `gradients` can have databound colors nested in it
      if (name === 'gradients' && Array.isArray(value)) {
        value.forEach(function (item) {
          var _item$colors;
          // Usage of color is restricted to v1 version of image gradients and will be removed when no longer used.
          var color = applyDatabinding({
            value: item.color,
            context: context
          });
          item.color = isValidRgb(color) ? fromRgbaToHex(color) : color;
          var colors = (_item$colors = item.colors) === null || _item$colors === void 0 ? void 0 : _item$colors.map(function (_ref15) {
            var newColor = _ref15.color,
              rest = _objectWithoutProperties(_ref15, _excluded$5);
            var databoundColor = applyDatabinding({
              value: newColor,
              context: context
            });
            databoundColor = isValidRgb(databoundColor) ? fromRgbaToHex(databoundColor) : databoundColor;
            return _extends$3({
              color: databoundColor
            }, rest);
          });
          item.colors = colors;
        });
        return value;
      }

      // `aspectRatios` is a responsive object of values like "16:9"
      // or expressions like "{% if X %}16:9{% else %}2:3{% endif %}"
      if (name === 'aspectRatios') {
        return databindObject(value, context);
      }

      // other props
      return databoundValue;
    }
  })(MainImage);
};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject$3(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now$1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$1());
  }

  function debounced() {
    var time = now$1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject$3(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$3(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$3(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$3(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_throttle = throttle;

var _AngleByDirection$1;

/** *
 * IMPORTANT
 *
 * This file is almost a 1:1 copy of `src/Slider/Arrow.jsx`,
 * the only differences being:
 * - how we handle the visibility of `ArrowButton`
 * - the top position of `ArrowButton`
 * - the paddings of `ArrowButton`
 * - remifying pixel values of `ArrowButton`
 *
 * This is a quick temporary solution to avoid having to export more things from
 * `@dynamic/core-slider` with all of its possible downsides (eg. circular reference).
 *
 * There are two options here:
 * 1.) If the differences between `Slider` and `MultiView` arrows are negligible,
 * move out `Arrow` from both and release it as a separate package,
 * so that both components can switch to that shared version.
 * 2.) If we need to add further changes to the `MultiView` arrows (which seems to be the case),
 * rewrite this file as we need to without depending on the `Slider` implementation.
 *
 * TODO: pick an option, then do the necessary changes.
 */

var DEFAULT_GRADIENT_COLOR$1 = 'rgba(0, 0, 0, 0.6)';
var DEFAULT_ARROW_COLOR$1 = '#e3e8f0';
var AngleByDirection$1 = (_AngleByDirection$1 = {}, _defineProperty(_AngleByDirection$1, Directions.Left, '90deg'), _defineProperty(_AngleByDirection$1, Directions.Right, '270deg'), _AngleByDirection$1);
var ArrowButton = styled(function (props) {
  return /*#__PURE__*/React__default.createElement("button", _extends$3({}, filterProperties(props), {
    "data-cy": "MultiView_Arrow_button"
  }));
}).withConfig({
  displayName: "Arrow__ArrowButton",
  componentId: "sc-1wyheng-0"
})(["&&&{position:absolute;top:-", "rem;", " z-index:1;width:auto;height:100%;border:none;outline:none;font-size:", "rem;cursor:pointer;color:", ";", " opacity:1;background:linear-gradient( ", ",", ",transparent );}"], rem(4), function (_ref) {
  var gutter = _ref.gutter,
    direction = _ref.direction;
  return direction === Directions.Left ? "left: -".concat(gutter / 2, "rem;\n           padding: 0 ").concat(rem(40), "rem 0 0;\n          ") : "right: -".concat(gutter / 2, "rem;\n           padding: 0 0 0 ").concat(rem(40), "rem;\n          ");
}, rem(50), themeColor('pageParagraphForeground', 'textBody', DEFAULT_ARROW_COLOR$1), function (_ref2) {
  var isHidden = _ref2.isHidden;
  return isHidden && 'display: none;';
}, function (_ref3) {
  var direction = _ref3.direction;
  return AngleByDirection$1[direction];
}, themeColor('pageBackground', 'sliderArrowBackground', DEFAULT_GRADIENT_COLOR$1));
ArrowButton.displayName = 'ArrowButton';
var ArrowFactory$1 = function ArrowFactory(Icon) {
  var Arrow = function Arrow(_ref4) {
    var direction = _ref4.direction,
      gutter = _ref4.gutter,
      isHidden = _ref4.isHidden,
      onClick = _ref4.onClick;
    // TODO:DEPRECATED `Icon.type` will be removed in 2.0.0
    // TODO:DEPRECATED `left` and `right` icon names will be removed in 2.0.0
    return /*#__PURE__*/React__default.createElement(ArrowButton, {
      direction: direction,
      gutter: gutter,
      isHidden: isHidden,
      onClick: onClick,
      type: "link",
      "data-cy": "MultiView_Arrow_ArrowButton"
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: direction.toLowerCase(),
      type: direction.toLowerCase(),
      "data-cy": "MultiView_Arrow_Icon"
    }));
  };
  Arrow.propTypes = {
    gutter: PropTypes__default.number,
    isHidden: PropTypes__default.bool,
    direction: PropTypes__default.oneOf([Directions.Left, Directions.Right]),
    onClick: PropTypes__default.func
  };
  return Arrow;
};

var DEFAULT_PAGE_SIZE = 20;
var useFeedData = function useFeedData(_ref) {
  var feed = _ref.feed,
    serviceId = _ref.serviceId,
    _ref$initial = _ref.initial,
    initial = _ref$initial === void 0 ? [] : _ref$initial,
    _ref$pageSize = _ref.pageSize,
    pageSize = _ref$pageSize === void 0 ? DEFAULT_PAGE_SIZE : _ref$pageSize,
    _ref$fetcher = _ref.fetcher,
    fetcher = _ref$fetcher === void 0 ? defaultFetcher : _ref$fetcher;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    feedData = _useState2[0],
    setFeedData = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    activeViewId = _useState4[0],
    setActiveViewId = _useState4[1];

  // fetch a tab's feed
  var fetchFeedData = useCallback(function (item) {
    var feedUrl = getTemplateValue(feed, item, 'item');
    fetcher({
      feed: feedUrl,
      serviceId: serviceId,
      collectionId: item.id,
      // size might be overwritten on the client-side.
      opts: {
        start: 0,
        size: pageSize
      },
      componentType: 'MULTI_VIEW'
    }).then(function (_ref2) {
      var data = _ref2.data,
        id = _ref2.collection.id,
        pageInfo = _ref2.pageInfo;
      setFeedData({
        feed: feedUrl,
        collectionId: id,
        initial: data,
        pageInfo: pageInfo
      });
      setActiveViewId(id);
    })["catch"](function (err) {
      console.error("Failed to fetch view data due to: ".concat(err));
    });
  }, [feed, pageSize, serviceId, fetcher]);

  // fetch initial tab's feed
  useEffect(function () {
    if (initial.length) {
      fetchFeedData(initial[0]);
    }
  }, [initial, fetchFeedData]);
  return {
    feedData: feedData,
    activeViewId: activeViewId,
    fetchFeedData: fetchFeedData
  };
};

var _excluded$4 = ["containerId", "viewId", "onChange", "checked", "clicked", "properties"],
  _excluded2$1 = ["feed", "viewTitle"],
  _excluded3$1 = ["data", "itemTemplateRules", "properties", "component", "context", "fetcher"];

// we don't need a default color for `tabMenuBackground`
// if it's missing, we set no background color for the menu items
var DEFAULT_COLORS = {
  tabMenuForeground: '#FFFFFF',
  tabMenuHighlightBackground: '#FFFFFF'
};
var safelyGetColor = function safelyGetColor(property, colorKey) {
  return function (_ref) {
    var _theme$color;
    var theme = _ref.theme;
    var color = (theme === null || theme === void 0 ? void 0 : (_theme$color = theme.color) === null || _theme$color === void 0 ? void 0 : _theme$color[colorKey]) || DEFAULT_COLORS[colorKey];
    return color ? "".concat(property, ": ").concat(color, ";") : '';
  };
};
var MultiViewContainer = styled.div.withConfig({
  displayName: "MultiView__MultiViewContainer",
  componentId: "sc-1mwy680-0"
})(["display:flex;flex-direction:column;width:100%;min-height:", "px;", ""], function (_ref2) {
  var $minHeight = _ref2.$minHeight;
  return $minHeight || 0;
}, generalUtils);
MultiViewContainer.displayName = 'MultiViewContainer';
var TabMenuContainer = styled.div.withConfig({
  displayName: "MultiView__TabMenuContainer",
  componentId: "sc-1mwy680-1"
})(["position:relative;", ";"], safelyGetColor('background', 'tabMenuBackground'));
TabMenuContainer.displayName = 'TabMenuContainer';
var TabContainer = styled.div.withConfig({
  displayName: "MultiView__TabContainer",
  componentId: "sc-1mwy680-2"
})(["display:flex;align-items:center;overflow-x:hidden;scroll-behavior:smooth;"]);
TabContainer.displayName = 'TabContainer';
var underlineKeyframes = keyframes(["0%{width:0;}100%{width:100%;}"]);
var underlineAnimation = css$1(["animation:", " 0.25s ease-out forwards;"], underlineKeyframes);
var Tab = styled(function (props) {
  return /*#__PURE__*/React__default.createElement("div", _extends$3({}, filterProperties(props), {
    "data-cy": "MultiView_MultiView_div"
  }));
}).withConfig({
  displayName: "MultiView__Tab",
  componentId: "sc-1mwy680-3"
})(["margin:", "rem ", "rem;&:first-of-type{margin-left:0;}&:last-of-type{margin-right:0;}& input{display:none;:enabled + label{cursor:pointer;}+ label > div{position:relative;width:max-content;:after{content:'';position:absolute;left:0;bottom:-", "rem;height:", "rem;pointer-events:none;", " width:0;", "}}}& input:checked + label > div:after{", "}"], rem(28), rem(24), rem(10), rem(2), safelyGetColor('background', 'tabMenuHighlightBackground'), function (_ref3) {
  var clicked = _ref3.clicked;
  return clicked && underlineAnimation;
}, underlineAnimation);
Tab.displayName = 'Tab';

// This is a fake Container that we use to keep the height of the previously selected tab's content while fetching the
// new tab to prevent jumping/flicker. The reason it's not just a styled component is that ContainerItem will put an
// onRemoveContainer on it (just like on normal Containers) that we have to ignore to prevent unknown DOM event warning.
var PreserveHeight = function PreserveHeight(_ref4) {
  var height = _ref4.height,
    children = _ref4.children;
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: height || 'auto'
    },
    "data-cy": "MultiView_MultiView_div"
  }, children);
};
PreserveHeight.propTypes = {
  children: PropTypes__default.element,
  height: PropTypes__default.number,
  onRemoveContainer: PropTypes__default.func
};

// In addition to using PreserveHeight while fetching, We also need to set a temporary min-height on the MultiView
// container while switching to a new tab. Otherwise, it will collapse for a split second, because the Container reports
// a small initial height before reporting the final height, despite the actual Grid only rendering once, with the data
// already fetched. This is why we need to throttle it, so we only use the final height.
var throttledSetMinHeight = lodash_throttle(function (container, minHeight) {
  if (!container) {
    return;
  }
  container.style.minHeight = "".concat(minHeight, "px");
}, 1000, {
  leading: false,
  trailing: true
});
var MultiViewFactory = function MultiViewFactory(Container, Icon, textClasses, translations, translate, factoryFetcher) {
  var Arrow = ArrowFactory$1(Icon);
  var Text = TextFactory(textClasses, translations, translate);
  var TabText = styled(Text).withConfig({
    displayName: "MultiView__TabText",
    componentId: "sc-1mwy680-4"
  })(["", ";input:enabled + label > div > &:hover{opacity:0.7;}"], safelyGetColor('color', 'tabMenuForeground'));
  TabText.displayName = 'TabText';
  var TabMenuItem = function TabMenuItem(_ref5) {
    var containerId = _ref5.containerId,
      viewId = _ref5.viewId,
      onChange = _ref5.onChange,
      checked = _ref5.checked,
      clicked = _ref5.clicked,
      properties = _ref5.properties,
      rest = _objectWithoutProperties(_ref5, _excluded$4);
    var tabId = "".concat(containerId, "_").concat(viewId);
    return /*#__PURE__*/React__default.createElement(Tab, {
      clicked: clicked,
      "data-cy": "MultiView_MultiView_Tab"
    }, /*#__PURE__*/React__default.createElement("input", {
      checked: checked,
      disabled: checked,
      id: tabId,
      name: containerId,
      onChange: onChange,
      type: "radio",
      "data-cy": "MultiView_MultiView_input"
    }), /*#__PURE__*/React__default.createElement("label", {
      htmlFor: tabId,
      "data-cy": "MultiView_MultiView_label"
    }, /*#__PURE__*/React__default.createElement("div", {
      "data-cy": "MultiView_MultiView_div"
    }, /*#__PURE__*/React__default.createElement(TabText, _extends$3({
      properties: _extends$3({}, properties, {
        textClass: TextClasses.Subtitle
      })
    }, rest, {
      "data-cy": "MultiView_MultiView_TabText"
    })))));
  };
  TabMenuItem.propTypes = {
    containerId: PropTypes__default.string.isRequired,
    viewId: PropTypes__default.string.isRequired,
    onChange: PropTypes__default.func.isRequired,
    checked: PropTypes__default.bool.isRequired,
    clicked: PropTypes__default.bool.isRequired,
    properties: PropTypes__default.object
  };
  TabMenuItem.displayName = 'TabMenuItem';
  var TabMenu = function TabMenu(_ref6) {
    var children = _ref6.children;
    var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      tabContainer = _useState2[0],
      setTabContainer = _useState2[1];
    var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      scrollPosition = _useState4[0],
      setScrollPosition = _useState4[1];
    var scroll = function scroll(toLeft) {
      if (!tabContainer) {
        return;
      }
      var extra = 150; // prevent the arrows from completely blocking an item

      var targetPosition = tabContainer.scrollLeft + (tabContainer.offsetWidth - extra) * (toLeft ? -1 : 1);
      var adjustedPosition = Math.max(Math.min(targetPosition, tabContainer.scrollWidth - tabContainer.offsetWidth), 0);
      tabContainer.scrollLeft = adjustedPosition;
      // trigger a re-render
      setScrollPosition(adjustedPosition);
    };
    var scrollLeft = function scrollLeft() {
      scroll(true);
    };
    var scrollRight = function scrollRight() {
      scroll(false);
    };
    var isLeftArrowHidden = !scrollPosition;
    var isRightArrowHidden = !tabContainer || scrollPosition + tabContainer.offsetWidth >= tabContainer.scrollWidth;
    return /*#__PURE__*/React__default.createElement(TabMenuContainer, {
      "data-cy": "MultiView_MultiView_TabMenuContainer"
    }, /*#__PURE__*/React__default.createElement(TabContainer, {
      ref: setTabContainer,
      "data-cy": "MultiView_MultiView_TabContainer"
    }, children), /*#__PURE__*/React__default.createElement(Arrow, {
      direction: Directions.Left,
      gutter: 0.8,
      isHidden: isLeftArrowHidden,
      onClick: scrollLeft,
      "data-cy": "MultiView_MultiView_Arrow"
    }), /*#__PURE__*/React__default.createElement(Arrow, {
      direction: Directions.Right,
      gutter: 0.8,
      isHidden: isRightArrowHidden,
      onClick: scrollRight,
      "data-cy": "MultiView_MultiView_Arrow"
    }));
  };
  TabMenu.propTypes = {
    children: PropTypes__default.node
  };
  TabMenu.displayName = 'TabMenu';
  var MultiView = function MultiView(props) {
    var _container$title;
    var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      clickedViewId = _useState6[0],
      setClickedViewId = _useState6[1];
    var containerRef = useRef(null);

    // keep track of the current content's height for the PreserveHeight component
    var contentHeightRef = useRef(0);
    var onContentHeightChange = useCallback(function (newHeight) {
      contentHeightRef.current = newHeight;
      throttledSetMinHeight(containerRef.current, newHeight);
    }, []);
    var _props$data = props.data,
      data = _props$data === void 0 ? {} : _props$data,
      itemTemplateRules = props.itemTemplateRules,
      _props$properties = props.properties,
      _props$properties2 = _props$properties === void 0 ? {} : _props$properties,
      feed = _props$properties2.feed,
      viewTitle = _props$properties2.viewTitle,
      restOfProperties = _objectWithoutProperties(_props$properties2, _excluded2$1);
      props.component;
      var _props$context = props.context,
      context = _props$context === void 0 ? {} : _props$context,
      _props$fetcher = props.fetcher,
      fetcher = _props$fetcher === void 0 ? factoryFetcher : _props$fetcher,
      rest = _objectWithoutProperties(props, _excluded3$1);
    var _data$initial = data.initial,
      initial = _data$initial === void 0 ? [] : _data$initial,
      _data$pageInfo = data.pageInfo,
      _data$pageInfo2 = _data$pageInfo === void 0 ? {} : _data$pageInfo,
      pageSize = _data$pageInfo2.pageSize;
    var serviceId = context.serviceId,
      _context$container = context.container,
      container = _context$container === void 0 ? {} : _context$container;
    var _useFeedData = useFeedData({
        feed: feed,
        serviceId: serviceId,
        initial: initial,
        pageSize: pageSize,
        fetcher: fetcher
      }),
      feedData = _useFeedData.feedData,
      activeViewId = _useFeedData.activeViewId,
      fetchFeedData = _useFeedData.fetchFeedData;
    useEffect(function () {
      // This use effect is for Admin UI purposes. If user updates the feed or switches locale => initial array is changed,
      // and we need to reset clickedViewId to be equal activeViewId after feedData is re-fetched otherwise we will be stuck with infinite spinner.
      if (initial.length && activeViewId !== clickedViewId) {
        setClickedViewId(activeViewId);
      }
    }, [initial, activeViewId]);
    if (!initial.length || !feedData) {
      return null;
    }
    var containerId = container.id || ((_container$title = container.title) === null || _container$title === void 0 ? void 0 : _container$title.replace(/ /g, '-')) || 'Unknown-Container';
    var getTabChangeHandler = function getTabChangeHandler(view) {
      return function () {
        fetchFeedData(view);
        setClickedViewId(view.id);
      };
    };
    var viewTabsToRender = initial.map(function (view) {
      return /*#__PURE__*/React__default.createElement(TabMenuItem, {
        checked: view.id === (clickedViewId || activeViewId),
        clicked: view.id === clickedViewId,
        containerId: containerId,
        context: {
          item: view
        },
        key: view.id,
        onChange: getTabChangeHandler(view),
        properties: {
          value: viewTitle
        },
        viewId: view.id,
        "data-cy": "MultiView_MultiView_TabMenuItem"
      });
    });
    var isFetchingTab = clickedViewId && clickedViewId !== activeViewId;
    return /*#__PURE__*/React__default.createElement(MultiViewContainer, _extends$3({
      $minHeight: contentHeightRef.current,
      ref: containerRef
    }, dataDyn(props), filterProperties(restOfProperties), {
      "data-cy": "MultiView_MultiView_MultiViewContainer"
    }), /*#__PURE__*/React__default.createElement(TabMenu, {
      "data-cy": "MultiView_MultiView_TabMenu"
    }, viewTabsToRender), isFetchingTab && /*#__PURE__*/React__default.createElement(CollectionItem, {
      debugInfo: {
        clickedViewId: clickedViewId
      },
      key: clickedViewId,
      "data-cy": "MultiView_MultiView_CollectionItem"
    }, /*#__PURE__*/React__default.createElement(PreserveHeight, {
      height: contentHeightRef.current,
      "data-cy": "MultiView_MultiView_PreserveHeight"
    }, /*#__PURE__*/React__default.createElement(Spinner, {
      Icon: Icon,
      "data-cy": "MultiView_MultiView_Spinner"
    }))), !isFetchingTab && /*#__PURE__*/React__default.createElement(CollectionItem, {
      debugInfo: {
        activeViewId: activeViewId
      },
      key: activeViewId,
      onHeightChange: onContentHeightChange,
      "data-cy": "MultiView_MultiView_CollectionItem"
    }, /*#__PURE__*/React__default.createElement(Container, _extends$3({
      context: context,
      data: feedData,
      fetcher: fetcher,
      itemTemplateRules: itemTemplateRules,
      key: "container-".concat(activeViewId),
      template: props
    }, rest, {
      "data-cy": "MultiView_MultiView_Container"
    }))));
  };
  MultiView.displayName = 'MultiView';
  MultiView.propTypes = {
    context: PropTypes__default.object,
    data: PropTypes__default.shape({
      feed: PropTypes__default.string,
      initial: PropTypes__default.arrayOf(PropTypes__default.shape({}))
    }),
    properties: PropTypes__default.shape({
      feed: PropTypes__default.string,
      viewTitle: PropTypes__default.string
    }),
    id: PropTypes__default.string,
    component: PropTypes__default.object,
    itemTemplateRules: PropTypes__default.arrayOf(PropTypes__default.shape({
      template: PropTypes__default.object
    })),
    fetcher: PropTypes__default.func
  };
  return MultiView;
};
MultiViewFactory.displayName = 'MultiViewFactory';

var defaults$1 = {
  FG_COLOR: '#FFFFFF',
  BG_COLOR: '#FFFFFF33',
  CONTENT: '\\0020',
  HEIGHT: '7px',
  BORDER_RADIUS: '49px'
};

// render progress and fallback
// to default if value does not satisfy conditions
var renderProgress = function renderProgress(context, value) {
  var parsedValue = parseInt(get(context, String(value), String(value)), 10);
  return Math.min(Math.max(parsedValue || 0, 0), 100);
};
var renderFGColor = function renderFGColor(value) {
  return value || defaults$1.FG_COLOR;
};

// render color and fall back to default if value is not present
var renderBGColor = function renderBGColor(value) {
  return value || defaults$1.BG_COLOR;
};
var ProgressBarParent = styled.div.withConfig({
  displayName: "ProgressBar__ProgressBarParent",
  componentId: "sc-1qim86x-0"
})(["width:100%;position:relative;overflow:hidden;height:", ";border-radius:", ";"], defaults$1.HEIGHT, defaults$1.BORDER_RADIUS);
var ProgressBarBackground = styled(function (props) {
  return /*#__PURE__*/React__default.createElement("div", _extends$3({}, filterProperties(props), {
    "data-cy": "ProgressBar_ProgressBar_div"
  }));
}).withConfig({
  displayName: "ProgressBar__ProgressBarBackground",
  componentId: "sc-1qim86x-1"
})(["position:absolute;width:100%;height:", ";", ""], defaults$1.HEIGHT, function (_ref) {
  var _ref$theme = _ref.theme,
    _ref$theme2 = _ref$theme === void 0 ? {} : _ref$theme,
    _ref$theme2$color = _ref$theme2.color,
    _ref$theme2$color2 = _ref$theme2$color === void 0 ? {} : _ref$theme2$color,
    imageOverlayHeadingForeground = _ref$theme2$color2.imageOverlayHeadingForeground;
  return "background-color: ".concat(renderBGColor(imageOverlayHeadingForeground), ";\n    opacity: 0.2;");
});
var ProgressBarComponent = styled(function (props) {
  return /*#__PURE__*/React__default.createElement("div", _extends$3({}, filterProperties(props), {
    "data-cy": "ProgressBar_ProgressBar_div"
  }));
}).withConfig({
  displayName: "ProgressBar__ProgressBarComponent",
  componentId: "sc-1qim86x-2"
})(["position:absolute;content:'", "';height:", ";border-radius:", ";", " ", ""], defaults$1.CONTENT, defaults$1.HEIGHT, defaults$1.BORDER_RADIUS, function (_ref2) {
  var value = _ref2.value;
  return "width: ".concat(value, "%;");
}, function (_ref3) {
  var _ref3$theme = _ref3.theme,
    _ref3$theme2 = _ref3$theme === void 0 ? {} : _ref3$theme,
    _ref3$theme2$color = _ref3$theme2.color,
    _ref3$theme2$color2 = _ref3$theme2$color === void 0 ? {} : _ref3$theme2$color,
    imageOverlayHeadingForeground = _ref3$theme2$color2.imageOverlayHeadingForeground;
  return "background-color: ".concat(renderFGColor(imageOverlayHeadingForeground), ";");
});
var ProgressBar = function ProgressBar(props) {
  var _props$properties = props.properties,
    properties = _props$properties === void 0 ? {} : _props$properties,
    id = props.id,
    _props$context = props.context,
    context = _props$context === void 0 ? {} : _props$context;
  var _properties$value = properties.value,
    value = _properties$value === void 0 ? 0 : _properties$value;
  Object.assign(properties, {
    value: renderProgress(context, value)
  });
  return /*#__PURE__*/React__default.createElement(ProgressBarParent, _extends$3({}, dataDyn(props), {
    id: id,
    "data-cy": "ProgressBar_ProgressBar_ProgressBarParent"
  }), /*#__PURE__*/React__default.createElement(ProgressBarBackground, _extends$3({}, properties, {
    "data-cy": "ProgressBar_ProgressBar_ProgressBarBackground"
  })), /*#__PURE__*/React__default.createElement(ProgressBarComponent, _extends$3({}, properties, {
    "data-cy": "ProgressBar_ProgressBar_ProgressBarComponent"
  })));
};
ProgressBar.propTypes = {
  id: PropTypes__default.string,
  properties: PropTypes__default.shape({
    // either an integer between 0-100 or a key path to that
    value: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.string]),
    width: PropTypes__default.oneOf(Object.values(HeightAndWidthTypes))
  }),
  context: PropTypes__default.object
};

var asyncToGenerator = createCommonjsModule(function (module) {
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _asyncToGenerator = unwrapExports(asyncToGenerator);

var regeneratorRuntime$1 = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];
function _regeneratorRuntime() {
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(regeneratorRuntime$1);

// TODO(Babel 8): Remove this file.

var runtime = regeneratorRuntime$1();
var regenerator = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "/**\n * Swiper 8.4.6\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * https://swiperjs.com\n *\n * Copyright 2014-2023 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: January 17, 2023\n */\n\n@font-face {\n  font-family: 'swiper-icons';\n  src: url('data:application/font-woff;charset=utf-8;base64, d09GRgABAAAAAAZgABAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAAGRAAAABoAAAAci6qHkUdERUYAAAWgAAAAIwAAACQAYABXR1BPUwAABhQAAAAuAAAANuAY7+xHU1VCAAAFxAAAAFAAAABm2fPczU9TLzIAAAHcAAAASgAAAGBP9V5RY21hcAAAAkQAAACIAAABYt6F0cBjdnQgAAACzAAAAAQAAAAEABEBRGdhc3AAAAWYAAAACAAAAAj//wADZ2x5ZgAAAywAAADMAAAD2MHtryVoZWFkAAABbAAAADAAAAA2E2+eoWhoZWEAAAGcAAAAHwAAACQC9gDzaG10eAAAAigAAAAZAAAArgJkABFsb2NhAAAC0AAAAFoAAABaFQAUGG1heHAAAAG8AAAAHwAAACAAcABAbmFtZQAAA/gAAAE5AAACXvFdBwlwb3N0AAAFNAAAAGIAAACE5s74hXjaY2BkYGAAYpf5Hu/j+W2+MnAzMYDAzaX6QjD6/4//Bxj5GA8AuRwMYGkAPywL13jaY2BkYGA88P8Agx4j+/8fQDYfA1AEBWgDAIB2BOoAeNpjYGRgYNBh4GdgYgABEMnIABJzYNADCQAACWgAsQB42mNgYfzCOIGBlYGB0YcxjYGBwR1Kf2WQZGhhYGBiYGVmgAFGBiQQkOaawtDAoMBQxXjg/wEGPcYDDA4wNUA2CCgwsAAAO4EL6gAAeNpj2M0gyAACqxgGNWBkZ2D4/wMA+xkDdgAAAHjaY2BgYGaAYBkGRgYQiAHyGMF8FgYHIM3DwMHABGQrMOgyWDLEM1T9/w8UBfEMgLzE////P/5//f/V/xv+r4eaAAeMbAxwIUYmIMHEgKYAYjUcsDAwsLKxc3BycfPw8jEQA/gZBASFhEVExcQlJKWkZWTl5BUUlZRVVNXUNTQZBgMAAMR+E+gAEQFEAAAAKgAqACoANAA+AEgAUgBcAGYAcAB6AIQAjgCYAKIArAC2AMAAygDUAN4A6ADyAPwBBgEQARoBJAEuATgBQgFMAVYBYAFqAXQBfgGIAZIBnAGmAbIBzgHsAAB42u2NMQ6CUAyGW568x9AneYYgm4MJbhKFaExIOAVX8ApewSt4Bic4AfeAid3VOBixDxfPYEza5O+Xfi04YADggiUIULCuEJK8VhO4bSvpdnktHI5QCYtdi2sl8ZnXaHlqUrNKzdKcT8cjlq+rwZSvIVczNiezsfnP/uznmfPFBNODM2K7MTQ45YEAZqGP81AmGGcF3iPqOop0r1SPTaTbVkfUe4HXj97wYE+yNwWYxwWu4v1ugWHgo3S1XdZEVqWM7ET0cfnLGxWfkgR42o2PvWrDMBSFj/IHLaF0zKjRgdiVMwScNRAoWUoH78Y2icB/yIY09An6AH2Bdu/UB+yxopYshQiEvnvu0dURgDt8QeC8PDw7Fpji3fEA4z/PEJ6YOB5hKh4dj3EvXhxPqH/SKUY3rJ7srZ4FZnh1PMAtPhwP6fl2PMJMPDgeQ4rY8YT6Gzao0eAEA409DuggmTnFnOcSCiEiLMgxCiTI6Cq5DZUd3Qmp10vO0LaLTd2cjN4fOumlc7lUYbSQcZFkutRG7g6JKZKy0RmdLY680CDnEJ+UMkpFFe1RN7nxdVpXrC4aTtnaurOnYercZg2YVmLN/d/gczfEimrE/fs/bOuq29Zmn8tloORaXgZgGa78yO9/cnXm2BpaGvq25Dv9S4E9+5SIc9PqupJKhYFSSl47+Qcr1mYNAAAAeNptw0cKwkAAAMDZJA8Q7OUJvkLsPfZ6zFVERPy8qHh2YER+3i/BP83vIBLLySsoKimrqKqpa2hp6+jq6RsYGhmbmJqZSy0sraxtbO3sHRydnEMU4uR6yx7JJXveP7WrDycAAAAAAAH//wACeNpjYGRgYOABYhkgZgJCZgZNBkYGLQZtIJsFLMYAAAw3ALgAeNolizEKgDAQBCchRbC2sFER0YD6qVQiBCv/H9ezGI6Z5XBAw8CBK/m5iQQVauVbXLnOrMZv2oLdKFa8Pjuru2hJzGabmOSLzNMzvutpB3N42mNgZGBg4GKQYzBhYMxJLMlj4GBgAYow/P/PAJJhLM6sSoWKfWCAAwDAjgbRAAB42mNgYGBkAIIbCZo5IPrmUn0hGA0AO8EFTQAA');\n  font-weight: 400;\n  font-style: normal;\n}\n:root {\n  --swiper-theme-color: #007aff;\n}\n.swiper {\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  /* Fix of Webkit flickering */\n  z-index: 1;\n}\n.swiper-vertical > .swiper-wrapper {\n  flex-direction: column;\n}\n.swiper-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform;\n  box-sizing: content-box;\n}\n.swiper-android .swiper-slide,\n.swiper-wrapper {\n  transform: translate3d(0px, 0, 0);\n}\n.swiper-pointer-events {\n  touch-action: pan-y;\n}\n.swiper-pointer-events.swiper-vertical {\n  touch-action: pan-x;\n}\n.swiper-slide {\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transition-property: transform;\n}\n.swiper-slide-invisible-blank {\n  visibility: hidden;\n}\n/* Auto Height */\n.swiper-autoheight,\n.swiper-autoheight .swiper-slide {\n  height: auto;\n}\n.swiper-autoheight .swiper-wrapper {\n  align-items: flex-start;\n  transition-property: transform, height;\n}\n.swiper-backface-hidden .swiper-slide {\n  transform: translateZ(0);\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n}\n/* 3D Effects */\n.swiper-3d,\n.swiper-3d.swiper-css-mode .swiper-wrapper {\n  perspective: 1200px;\n}\n.swiper-3d .swiper-wrapper,\n.swiper-3d .swiper-slide,\n.swiper-3d .swiper-slide-shadow,\n.swiper-3d .swiper-slide-shadow-left,\n.swiper-3d .swiper-slide-shadow-right,\n.swiper-3d .swiper-slide-shadow-top,\n.swiper-3d .swiper-slide-shadow-bottom,\n.swiper-3d .swiper-cube-shadow {\n  transform-style: preserve-3d;\n}\n.swiper-3d .swiper-slide-shadow,\n.swiper-3d .swiper-slide-shadow-left,\n.swiper-3d .swiper-slide-shadow-right,\n.swiper-3d .swiper-slide-shadow-top,\n.swiper-3d .swiper-slide-shadow-bottom {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 10;\n}\n.swiper-3d .swiper-slide-shadow {\n  background: rgba(0, 0, 0, 0.15);\n}\n.swiper-3d .swiper-slide-shadow-left {\n  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-3d .swiper-slide-shadow-right {\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-3d .swiper-slide-shadow-top {\n  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n.swiper-3d .swiper-slide-shadow-bottom {\n  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n/* CSS Mode */\n.swiper-css-mode > .swiper-wrapper {\n  overflow: auto;\n  scrollbar-width: none;\n  /* For Firefox */\n  -ms-overflow-style: none;\n  /* For Internet Explorer and Edge */\n}\n.swiper-css-mode > .swiper-wrapper::-webkit-scrollbar {\n  display: none;\n}\n.swiper-css-mode > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: start start;\n}\n.swiper-horizontal.swiper-css-mode > .swiper-wrapper {\n  scroll-snap-type: x mandatory;\n}\n.swiper-vertical.swiper-css-mode > .swiper-wrapper {\n  scroll-snap-type: y mandatory;\n}\n.swiper-centered > .swiper-wrapper::before {\n  content: '';\n  flex-shrink: 0;\n  order: 9999;\n}\n.swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-child {\n  margin-inline-start: var(--swiper-centered-offset-before);\n}\n.swiper-centered.swiper-horizontal > .swiper-wrapper::before {\n  height: 100%;\n  min-height: 1px;\n  width: var(--swiper-centered-offset-after);\n}\n.swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-child {\n  margin-block-start: var(--swiper-centered-offset-before);\n}\n.swiper-centered.swiper-vertical > .swiper-wrapper::before {\n  width: 100%;\n  min-width: 1px;\n  height: var(--swiper-centered-offset-after);\n}\n.swiper-centered > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: center center;\n  scroll-snap-stop: always;\n}\n.swiper-virtual .swiper-slide {\n  -webkit-backface-visibility: hidden;\n  transform: translateZ(0);\n}\n.swiper-virtual.swiper-css-mode .swiper-wrapper::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n}\n.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after {\n  height: 1px;\n  width: var(--swiper-virtual-size);\n}\n.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after {\n  width: 1px;\n  height: var(--swiper-virtual-size);\n}\n:root {\n  --swiper-navigation-size: 44px;\n  /*\n  --swiper-navigation-color: var(--swiper-theme-color);\n  */\n}\n.swiper-button-prev,\n.swiper-button-next {\n  position: absolute;\n  top: 50%;\n  width: calc(var(--swiper-navigation-size) / 44 * 27);\n  height: var(--swiper-navigation-size);\n  margin-top: calc(0px - (var(--swiper-navigation-size) / 2));\n  z-index: 10;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--swiper-navigation-color, var(--swiper-theme-color));\n}\n.swiper-button-prev.swiper-button-disabled,\n.swiper-button-next.swiper-button-disabled {\n  opacity: 0.35;\n  cursor: auto;\n  pointer-events: none;\n}\n.swiper-button-prev.swiper-button-hidden,\n.swiper-button-next.swiper-button-hidden {\n  opacity: 0;\n  cursor: auto;\n  pointer-events: none;\n}\n.swiper-navigation-disabled .swiper-button-prev,\n.swiper-navigation-disabled .swiper-button-next {\n  display: none !important;\n}\n.swiper-button-prev:after,\n.swiper-button-next:after {\n  font-family: swiper-icons;\n  font-size: var(--swiper-navigation-size);\n  text-transform: none !important;\n  letter-spacing: 0;\n  font-variant: initial;\n  line-height: 1;\n}\n.swiper-button-prev,\n.swiper-rtl .swiper-button-next {\n  left: 10px;\n  right: auto;\n}\n.swiper-button-prev:after,\n.swiper-rtl .swiper-button-next:after {\n  content: 'prev';\n}\n.swiper-button-next,\n.swiper-rtl .swiper-button-prev {\n  right: 10px;\n  left: auto;\n}\n.swiper-button-next:after,\n.swiper-rtl .swiper-button-prev:after {\n  content: 'next';\n}\n.swiper-button-lock {\n  display: none;\n}\n:root {\n  /*\n  --swiper-pagination-color: var(--swiper-theme-color);\n  --swiper-pagination-bullet-size: 8px;\n  --swiper-pagination-bullet-width: 8px;\n  --swiper-pagination-bullet-height: 8px;\n  --swiper-pagination-bullet-inactive-color: #000;\n  --swiper-pagination-bullet-inactive-opacity: 0.2;\n  --swiper-pagination-bullet-opacity: 1;\n  --swiper-pagination-bullet-horizontal-gap: 4px;\n  --swiper-pagination-bullet-vertical-gap: 6px;\n  */\n}\n.swiper-pagination {\n  position: absolute;\n  text-align: center;\n  transition: 300ms opacity;\n  transform: translate3d(0, 0, 0);\n  z-index: 10;\n}\n.swiper-pagination.swiper-pagination-hidden {\n  opacity: 0;\n}\n.swiper-pagination-disabled > .swiper-pagination,\n.swiper-pagination.swiper-pagination-disabled {\n  display: none !important;\n}\n/* Common Styles */\n.swiper-pagination-fraction,\n.swiper-pagination-custom,\n.swiper-horizontal > .swiper-pagination-bullets,\n.swiper-pagination-bullets.swiper-pagination-horizontal {\n  bottom: 10px;\n  left: 0;\n  width: 100%;\n}\n/* Bullets */\n.swiper-pagination-bullets-dynamic {\n  overflow: hidden;\n  font-size: 0;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transform: scale(0.33);\n  position: relative;\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {\n  transform: scale(1);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {\n  transform: scale(0.33);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {\n  transform: scale(0.66);\n}\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {\n  transform: scale(0.33);\n}\n.swiper-pagination-bullet {\n  width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));\n  height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));\n  display: inline-block;\n  border-radius: 50%;\n  background: var(--swiper-pagination-bullet-inactive-color, #000);\n  opacity: var(--swiper-pagination-bullet-inactive-opacity, 0.2);\n}\nbutton.swiper-pagination-bullet {\n  border: none;\n  margin: 0;\n  padding: 0;\n  box-shadow: none;\n  -webkit-appearance: none;\n          appearance: none;\n}\n.swiper-pagination-clickable .swiper-pagination-bullet {\n  cursor: pointer;\n}\n.swiper-pagination-bullet:only-child {\n  display: none !important;\n}\n.swiper-pagination-bullet-active {\n  opacity: var(--swiper-pagination-bullet-opacity, 1);\n  background: var(--swiper-pagination-color, var(--swiper-theme-color));\n}\n.swiper-vertical > .swiper-pagination-bullets,\n.swiper-pagination-vertical.swiper-pagination-bullets {\n  right: 10px;\n  top: 50%;\n  transform: translate3d(0px, -50%, 0);\n}\n.swiper-vertical > .swiper-pagination-bullets .swiper-pagination-bullet,\n.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: var(--swiper-pagination-bullet-vertical-gap, 6px) 0;\n  display: block;\n}\n.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,\n.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  top: 50%;\n  transform: translateY(-50%);\n  width: 8px;\n}\n.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,\n.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  display: inline-block;\n  transition: 200ms transform, 200ms top;\n}\n.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,\n.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px);\n}\n.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,\n.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n}\n.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,\n.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transition: 200ms transform, 200ms left;\n}\n.swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transition: 200ms transform, 200ms right;\n}\n/* Progress */\n.swiper-pagination-progressbar {\n  background: rgba(0, 0, 0, 0.25);\n  position: absolute;\n}\n.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  background: var(--swiper-pagination-color, var(--swiper-theme-color));\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  transform: scale(0);\n  transform-origin: left top;\n}\n.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  transform-origin: right top;\n}\n.swiper-horizontal > .swiper-pagination-progressbar,\n.swiper-pagination-progressbar.swiper-pagination-horizontal,\n.swiper-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,\n.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite {\n  width: 100%;\n  height: 4px;\n  left: 0;\n  top: 0;\n}\n.swiper-vertical > .swiper-pagination-progressbar,\n.swiper-pagination-progressbar.swiper-pagination-vertical,\n.swiper-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,\n.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite {\n  width: 4px;\n  height: 100%;\n  left: 0;\n  top: 0;\n}\n.swiper-pagination-lock {\n  display: none;\n}\n/* Scrollbar */\n.swiper-scrollbar {\n  border-radius: 10px;\n  position: relative;\n  -ms-touch-action: none;\n  background: rgba(0, 0, 0, 0.1);\n}\n.swiper-scrollbar-disabled > .swiper-scrollbar,\n.swiper-scrollbar.swiper-scrollbar-disabled {\n  display: none !important;\n}\n.swiper-horizontal > .swiper-scrollbar,\n.swiper-scrollbar.swiper-scrollbar-horizontal {\n  position: absolute;\n  left: 1%;\n  bottom: 3px;\n  z-index: 50;\n  height: 5px;\n  width: 98%;\n}\n.swiper-vertical > .swiper-scrollbar,\n.swiper-scrollbar.swiper-scrollbar-vertical {\n  position: absolute;\n  right: 3px;\n  top: 1%;\n  z-index: 50;\n  width: 5px;\n  height: 98%;\n}\n.swiper-scrollbar-drag {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 10px;\n  left: 0;\n  top: 0;\n}\n.swiper-scrollbar-cursor-drag {\n  cursor: move;\n}\n.swiper-scrollbar-lock {\n  display: none;\n}\n.swiper-zoom-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n.swiper-zoom-container > img,\n.swiper-zoom-container > svg,\n.swiper-zoom-container > canvas {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n.swiper-slide-zoomed {\n  cursor: move;\n}\n/* Preloader */\n:root {\n  /*\n  --swiper-preloader-color: var(--swiper-theme-color);\n  */\n}\n.swiper-lazy-preloader {\n  width: 42px;\n  height: 42px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: -21px;\n  margin-top: -21px;\n  z-index: 10;\n  transform-origin: 50%;\n  box-sizing: border-box;\n  border: 4px solid var(--swiper-preloader-color, var(--swiper-theme-color));\n  border-radius: 50%;\n  border-top-color: transparent;\n}\n.swiper:not(.swiper-watch-progress) .swiper-lazy-preloader,\n.swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader {\n  animation: swiper-preloader-spin 1s infinite linear;\n}\n.swiper-lazy-preloader-white {\n  --swiper-preloader-color: #fff;\n}\n.swiper-lazy-preloader-black {\n  --swiper-preloader-color: #000;\n}\n@keyframes swiper-preloader-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n/* a11y */\n.swiper .swiper-notification {\n  position: absolute;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  opacity: 0;\n  z-index: -1000;\n}\n.swiper-free-mode > .swiper-wrapper {\n  transition-timing-function: ease-out;\n  margin: 0 auto;\n}\n.swiper-grid > .swiper-wrapper {\n  flex-wrap: wrap;\n}\n.swiper-grid-column > .swiper-wrapper {\n  flex-wrap: wrap;\n  flex-direction: column;\n}\n.swiper-fade.swiper-free-mode .swiper-slide {\n  transition-timing-function: ease-out;\n}\n.swiper-fade .swiper-slide {\n  pointer-events: none;\n  transition-property: opacity;\n}\n.swiper-fade .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-fade .swiper-slide-active,\n.swiper-fade .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-cube {\n  overflow: visible;\n}\n.swiper-cube .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  z-index: 1;\n  visibility: hidden;\n  transform-origin: 0 0;\n  width: 100%;\n  height: 100%;\n}\n.swiper-cube .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-cube.swiper-rtl .swiper-slide {\n  transform-origin: 100% 0;\n}\n.swiper-cube .swiper-slide-active,\n.swiper-cube .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-cube .swiper-slide-active,\n.swiper-cube .swiper-slide-next,\n.swiper-cube .swiper-slide-prev,\n.swiper-cube .swiper-slide-next + .swiper-slide {\n  pointer-events: auto;\n  visibility: visible;\n}\n.swiper-cube .swiper-slide-shadow-top,\n.swiper-cube .swiper-slide-shadow-bottom,\n.swiper-cube .swiper-slide-shadow-left,\n.swiper-cube .swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n}\n.swiper-cube .swiper-cube-shadow {\n  position: absolute;\n  left: 0;\n  bottom: 0px;\n  width: 100%;\n  height: 100%;\n  opacity: 0.6;\n  z-index: 0;\n}\n.swiper-cube .swiper-cube-shadow:before {\n  content: '';\n  background: #000;\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  filter: blur(50px);\n}\n.swiper-flip {\n  overflow: visible;\n}\n.swiper-flip .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  z-index: 1;\n}\n.swiper-flip .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n.swiper-flip .swiper-slide-active,\n.swiper-flip .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n.swiper-flip .swiper-slide-shadow-top,\n.swiper-flip .swiper-slide-shadow-bottom,\n.swiper-flip .swiper-slide-shadow-left,\n.swiper-flip .swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n}\n.swiper-creative .swiper-slide {\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  overflow: hidden;\n  transition-property: transform, opacity, height;\n}\n.swiper-cards {\n  overflow: visible;\n}\n.swiper-cards .swiper-slide {\n  transform-origin: center bottom;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  overflow: hidden;\n}\n";
styleInject(css_248z);

/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */
/* eslint-disable no-param-reassign */
function isObject$2(obj) {
    return (obj !== null &&
        typeof obj === 'object' &&
        'constructor' in obj &&
        obj.constructor === Object);
}
function extend$2(target = {}, src = {}) {
    Object.keys(src).forEach((key) => {
        if (typeof target[key] === 'undefined')
            target[key] = src[key];
        else if (isObject$2(src[key]) &&
            isObject$2(target[key]) &&
            Object.keys(src[key]).length > 0) {
            extend$2(target[key], src[key]);
        }
    });
}

const ssrDocument = {
    body: {},
    addEventListener() { },
    removeEventListener() { },
    activeElement: {
        blur() { },
        nodeName: '',
    },
    querySelector() {
        return null;
    },
    querySelectorAll() {
        return [];
    },
    getElementById() {
        return null;
    },
    createEvent() {
        return {
            initEvent() { },
        };
    },
    createElement() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute() { },
            getElementsByTagName() {
                return [];
            },
        };
    },
    createElementNS() {
        return {};
    },
    importNode() {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
};
function getDocument() {
    const doc = typeof document !== 'undefined' ? document : {};
    extend$2(doc, ssrDocument);
    return doc;
}

const ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: '',
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
    history: {
        replaceState() { },
        pushState() { },
        go() { },
        back() { },
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener() { },
    removeEventListener() { },
    getComputedStyle() {
        return {
            getPropertyValue() {
                return '';
            },
        };
    },
    Image() { },
    Date() { },
    screen: {},
    setTimeout() { },
    clearTimeout() { },
    matchMedia() {
        return {};
    },
    requestAnimationFrame(callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame(id) {
        if (typeof setTimeout === 'undefined') {
            return;
        }
        clearTimeout(id);
    },
};
function getWindow() {
    const win = typeof window !== 'undefined' ? window : {};
    extend$2(win, ssrWindow);
    return win;
}

/**
 * Dom7 4.0.4
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2022, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: January 11, 2022
 */

/* eslint-disable no-proto */
function makeReactive(obj) {
  const proto = obj.__proto__;
  Object.defineProperty(obj, '__proto__', {
    get() {
      return proto;
    },

    set(value) {
      proto.__proto__ = value;
    }

  });
}

class Dom7 extends Array {
  constructor(items) {
    if (typeof items === 'number') {
      super(items);
    } else {
      super(...(items || []));
      makeReactive(this);
    }
  }

}

function arrayFlat(arr = []) {
  const res = [];
  arr.forEach(el => {
    if (Array.isArray(el)) {
      res.push(...arrayFlat(el));
    } else {
      res.push(el);
    }
  });
  return res;
}
function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
  const uniqueArray = [];

  for (let i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }

  return uniqueArray;
}

// eslint-disable-next-line

function qsa(selector, context) {
  if (typeof selector !== 'string') {
    return [selector];
  }

  const a = [];
  const res = context.querySelectorAll(selector);

  for (let i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }

  return a;
}

function $(selector, context) {
  const window = getWindow();
  const document = getDocument();
  let arr = [];

  if (!context && selector instanceof Dom7) {
    return selector;
  }

  if (!selector) {
    return new Dom7(arr);
  }

  if (typeof selector === 'string') {
    const html = selector.trim();

    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
      let toCreate = 'div';
      if (html.indexOf('<li') === 0) toCreate = 'ul';
      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
      if (html.indexOf('<tbody') === 0) toCreate = 'table';
      if (html.indexOf('<option') === 0) toCreate = 'select';
      const tempParent = document.createElement(toCreate);
      tempParent.innerHTML = html;

      for (let i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document);
    } // arr = qsa(selector, document);

  } else if (selector.nodeType || selector === window || selector === document) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }

  return new Dom7(arrayUnique(arr));
}

$.fn = Dom7.prototype;

// eslint-disable-next-line

function addClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    el.classList.add(...classNames);
  });
  return this;
}

function removeClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    el.classList.remove(...classNames);
  });
  return this;
}

function toggleClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    classNames.forEach(className => {
      el.classList.toggle(className);
    });
  });
}

function hasClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  return arrayFilter(this, el => {
    return classNames.filter(className => el.classList.contains(className)).length > 0;
  }).length > 0;
}

function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs


  for (let i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      for (const attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }

  return this;
}

function removeAttr(attr) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }

  return this;
}

function transform(transform) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.transform = transform;
  }

  return this;
}

function transition$1(duration) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.transitionDuration = typeof duration !== 'string' ? `${duration}ms` : duration;
  }

  return this;
}

function on(...args) {
  let [eventType, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }

  if (!capture) capture = false;

  function handleLiveEvent(e) {
    const target = e.target;
    if (!target) return;
    const eventData = e.target.dom7EventData || [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
      const parents = $(target).parents(); // eslint-disable-line

      for (let k = 0; k < parents.length; k += 1) {
        if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
      }
    }
  }

  function handleEvent(e) {
    const eventData = e && e.target ? e.target.dom7EventData || [] : [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    listener.apply(this, eventData);
  }

  const events = eventType.split(' ');
  let j;

  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        const event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        const event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
        el.dom7LiveListeners[event].push({
          listener,
          proxyListener: handleLiveEvent
        });
        el.addEventListener(event, handleLiveEvent, capture);
      }
    }
  }

  return this;
}

function off(...args) {
  let [eventType, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }

  if (!capture) capture = false;
  const events = eventType.split(' ');

  for (let i = 0; i < events.length; i += 1) {
    const event = events[i];

    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];
      let handlers;

      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }

      if (handlers && handlers.length) {
        for (let k = handlers.length - 1; k >= 0; k -= 1) {
          const handler = handlers[k];

          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }

  return this;
}

function trigger(...args) {
  const window = getWindow();
  const events = args[0].split(' ');
  const eventData = args[1];

  for (let i = 0; i < events.length; i += 1) {
    const event = events[i];

    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];

      if (window.CustomEvent) {
        const evt = new window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter((data, dataIndex) => dataIndex > 0);
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }

  return this;
}

function transitionEnd$1(callback) {
  const dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionend', fireCallBack);
  }

  if (callback) {
    dom.on('transitionend', fireCallBack);
  }

  return this;
}

function outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles = this.styles();
      return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
    }

    return this[0].offsetWidth;
  }

  return null;
}

function outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles = this.styles();
      return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
    }

    return this[0].offsetHeight;
  }

  return null;
}

function offset() {
  if (this.length > 0) {
    const window = getWindow();
    const document = getDocument();
    const el = this[0];
    const box = el.getBoundingClientRect();
    const body = document.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window ? window.scrollY : el.scrollTop;
    const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }

  return null;
}

function styles() {
  const window = getWindow();
  if (this[0]) return window.getComputedStyle(this[0], null);
  return {};
}

function css(props, value) {
  const window = getWindow();
  let i;

  if (arguments.length === 1) {
    if (typeof props === 'string') {
      // .css('width')
      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      // .css({ width: '100px' })
      for (i = 0; i < this.length; i += 1) {
        for (const prop in props) {
          this[i].style[prop] = props[prop];
        }
      }

      return this;
    }
  }

  if (arguments.length === 2 && typeof props === 'string') {
    // .css('width', '100px')
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }

    return this;
  }

  return this;
}

function each(callback) {
  if (!callback) return this;
  this.forEach((el, index) => {
    callback.apply(el, [el, index]);
  });
  return this;
}

function filter(callback) {
  const result = arrayFilter(this, callback);
  return $(result);
}

function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : null;
  }

  for (let i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }

  return this;
}

function text(text) {
  if (typeof text === 'undefined') {
    return this[0] ? this[0].textContent.trim() : null;
  }

  for (let i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }

  return this;
}

function is(selector) {
  const window = getWindow();
  const document = getDocument();
  const el = this[0];
  let compareWith;
  let i;
  if (!el || typeof selector === 'undefined') return false;

  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = $(selector);

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  if (selector === document) {
    return el === document;
  }

  if (selector === window) {
    return el === window;
  }

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  return false;
}

function index() {
  let child = this[0];
  let i;

  if (child) {
    i = 0; // eslint-disable-next-line

    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }

    return i;
  }

  return undefined;
}

function eq(index) {
  if (typeof index === 'undefined') return this;
  const length = this.length;

  if (index > length - 1) {
    return $([]);
  }

  if (index < 0) {
    const returnIndex = length + index;
    if (returnIndex < 0) return $([]);
    return $([this[returnIndex]]);
  }

  return $([this[index]]);
}

function append(...els) {
  let newChild;
  const document = getDocument();

  for (let k = 0; k < els.length; k += 1) {
    newChild = els[k];

    for (let i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;

        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (let j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}

function prepend(newChild) {
  const document = getDocument();
  let i;
  let j;

  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = newChild;

      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }

  return this;
}

function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return $([this[0].nextElementSibling]);
      }

      return $([]);
    }

    if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
    return $([]);
  }

  return $([]);
}

function nextAll(selector) {
  const nextEls = [];
  let el = this[0];
  if (!el) return $([]);

  while (el.nextElementSibling) {
    const next = el.nextElementSibling; // eslint-disable-line

    if (selector) {
      if ($(next).is(selector)) nextEls.push(next);
    } else nextEls.push(next);

    el = next;
  }

  return $(nextEls);
}

function prev(selector) {
  if (this.length > 0) {
    const el = this[0];

    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return $([el.previousElementSibling]);
      }

      return $([]);
    }

    if (el.previousElementSibling) return $([el.previousElementSibling]);
    return $([]);
  }

  return $([]);
}

function prevAll(selector) {
  const prevEls = [];
  let el = this[0];
  if (!el) return $([]);

  while (el.previousElementSibling) {
    const prev = el.previousElementSibling; // eslint-disable-line

    if (selector) {
      if ($(prev).is(selector)) prevEls.push(prev);
    } else prevEls.push(prev);

    el = prev;
  }

  return $(prevEls);
}

function parent(selector) {
  const parents = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }

  return $(parents);
}

function parents(selector) {
  const parents = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    let parent = this[i].parentNode; // eslint-disable-line

    while (parent) {
      if (selector) {
        if ($(parent).is(selector)) parents.push(parent);
      } else {
        parents.push(parent);
      }

      parent = parent.parentNode;
    }
  }

  return $(parents);
}

function closest(selector) {
  let closest = this; // eslint-disable-line

  if (typeof selector === 'undefined') {
    return $([]);
  }

  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }

  return closest;
}

function find(selector) {
  const foundElements = [];

  for (let i = 0; i < this.length; i += 1) {
    const found = this[i].querySelectorAll(selector);

    for (let j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }

  return $(foundElements);
}

function children(selector) {
  const children = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    const childNodes = this[i].children;

    for (let j = 0; j < childNodes.length; j += 1) {
      if (!selector || $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }

  return $(children);
}

function remove() {
  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }

  return this;
}

const Methods = {
  addClass,
  removeClass,
  hasClass,
  toggleClass,
  attr,
  removeAttr,
  transform,
  transition: transition$1,
  on,
  off,
  trigger,
  transitionEnd: transitionEnd$1,
  outerWidth,
  outerHeight,
  styles,
  offset,
  css,
  each,
  html,
  text,
  is,
  index,
  eq,
  append,
  prepend,
  next,
  nextAll,
  prev,
  prevAll,
  parent,
  parents,
  closest,
  find,
  children,
  filter,
  remove
};
Object.keys(Methods).forEach(methodName => {
  Object.defineProperty($.fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});

function deleteProps(obj) {
  const object = obj;
  Object.keys(object).forEach(key => {
    try {
      object[key] = null;
    } catch (e) {// no getter for object
    }

    try {
      delete object[key];
    } catch (e) {// something got wrong
    }
  });
}

function nextTick(callback, delay = 0) {
  return setTimeout(callback, delay);
}

function now() {
  return Date.now();
}

function getComputedStyle$1(el) {
  const window = getWindow();
  let style;

  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }

  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }

  if (!style) {
    style = el.style;
  }

  return style;
}

function getTranslate(el, axis = 'x') {
  const window = getWindow();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = getComputedStyle$1(el);

  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;

    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(a => a.replace(',', '.')).join(', ');
    } // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case


    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }

  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
    else curTransform = parseFloat(matrix[4]);
  }

  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
    else curTransform = parseFloat(matrix[5]);
  }

  return curTransform || 0;
}

function isObject$1(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }

  return node && (node.nodeType === 1 || node.nodeType === 11);
}

function extend$1(...args) {
  const to = Object(args[0]);
  const noExtend = ['__proto__', 'constructor', 'prototype'];

  for (let i = 1; i < args.length; i += 1) {
    const nextSource = args[i];

    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter(key => noExtend.indexOf(key) < 0);

      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

        if (desc !== undefined && desc.enumerable) {
          if (isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            to[nextKey] = {};

            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }

  return to;
}

function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}

function animateCSSModeScroll({
  swiper,
  targetPosition,
  side
}) {
  const window = getWindow();
  const startPosition = -swiper.translate;
  let startTime = null;
  let time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = 'none';
  window.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? 'next' : 'prev';

  const isOutOfBound = (current, target) => {
    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
  };

  const animate = () => {
    time = new Date().getTime();

    if (startTime === null) {
      startTime = time;
    }

    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);

    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }

    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });

    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.scrollSnapType = '';
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = '';
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }

    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
  };

  animate();
}

let support;

function calcSupport() {
  const window = getWindow();
  const document = getDocument();
  return {
    smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
    passiveListener: function checkPassiveListener() {
      let supportsPassive = false;

      try {
        const opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get() {
            supportsPassive = true;
          }

        });
        window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {// No support
      }

      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return 'ongesturestart' in window;
    }()
  };
}

function getSupport() {
  if (!support) {
    support = calcSupport();
  }

  return support;
}

let deviceCached;

function calcDevice({
  userAgent
} = {}) {
  const support = getSupport();
  const window = getWindow();
  const platform = window.navigator.platform;
  const ua = userAgent || window.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === 'Win32';
  let macos = platform === 'MacIntel'; // iPadOs 13 fix

  const iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

  if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  } // Android


  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }

  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  } // Export object


  return device;
}

function getDevice(overrides = {}) {
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }

  return deviceCached;
}

let browser;

function calcBrowser() {
  const window = getWindow();

  function isSafari() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }

  return {
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}

function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }

  return browser;
}

function Resize({
  swiper,
  on,
  emit
}) {
  const window = getWindow();
  let observer = null;
  let animationFrame = null;

  const resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('beforeResize');
    emit('resize');
  };

  const createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver(entries => {
      animationFrame = window.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach(({
          contentBoxSize,
          contentRect,
          target
        }) => {
          if (target && target !== swiper.el) return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });

        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };

  const removeObserver = () => {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
    }

    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };

  const orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('orientationchange');
  };

  on('init', () => {
    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
      createObserver();
      return;
    }

    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', orientationChangeHandler);
  });
  on('destroy', () => {
    removeObserver();
    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('orientationchange', orientationChangeHandler);
  });
}

function Observer({
  swiper,
  extendParams,
  on,
  emit
}) {
  const observers = [];
  const window = getWindow();

  const attach = (target, options = {}) => {
    const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    const observer = new ObserverFunc(mutations => {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        emit('observerUpdate', mutations[0]);
        return;
      }

      const observerUpdate = function observerUpdate() {
        emit('observerUpdate', mutations[0]);
      };

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    observers.push(observer);
  };

  const init = () => {
    if (!swiper.params.observer) return;

    if (swiper.params.observeParents) {
      const containerParents = swiper.$el.parents();

      for (let i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    } // Observe container


    attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    }); // Observe wrapper

    attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  };

  const destroy = () => {
    observers.forEach(observer => {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };

  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on('init', init);
  on('destroy', destroy);
}

/* eslint-disable no-underscore-dangle */
var eventsEmitter = {
  on(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(event => {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },

  once(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;

    function onceHandler(...args) {
      self.off(events, onceHandler);

      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }

      handler.apply(self, args);
    }

    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },

  onAny(handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';

    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }

    return self;
  },

  offAny(handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsAnyListeners) return self;
    const index = self.eventsAnyListeners.indexOf(handler);

    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }

    return self;
  },

  off(events, handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(event => {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach((eventHandler, index) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },

  emit(...args) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    let events;
    let data;
    let context;

    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }

    data.unshift(context);
    const eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(event => {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(eventHandler => {
          eventHandler.apply(context, [event, ...data]);
        });
      }

      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(eventHandler => {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }

};

function updateSize() {
  const swiper = this;
  let width;
  let height;
  const $el = swiper.$el;

  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }

  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }

  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  } // Subtract paddings


  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}

function updateSlides() {
  const swiper = this;

  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    } // prettier-ignore


    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }

  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }

  const params = swiper.params;
  const {
    $wrapperEl,
    size: swiperSize,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;

  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  let offsetAfter = params.slidesOffsetAfter;

  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.slidesGrid.length;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index = 0;

  if (typeof swiperSize === 'undefined') {
    return;
  }

  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween; // reset margins

  if (rtl) slides.css({
    marginLeft: '',
    marginBottom: '',
    marginTop: ''
  });else slides.css({
    marginRight: '',
    marginBottom: '',
    marginTop: ''
  }); // reset cssMode offsets

  if (params.centeredSlides && params.cssMode) {
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', '');
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', '');
  }

  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;

  if (gridEnabled) {
    swiper.grid.initSlides(slidesLength);
  } // Calc slides


  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(key => {
    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
  }).length > 0;

  for (let i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    const slide = slides.eq(i);

    if (gridEnabled) {
      swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
    }

    if (slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      if (shouldResetSlideSize) {
        slides[i].style[getDirectionLabel('width')] = ``;
      }

      const slideStyles = getComputedStyle(slide[0]);
      const currentTransform = slide[0].style.transform;
      const currentWebKitTransform = slide[0].style.webkitTransform;

      if (currentTransform) {
        slide[0].style.transform = 'none';
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = 'none';
      }

      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        const width = getDirectionPropertyValue(slideStyles, 'width');
        const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        const boxSizing = slideStyles.getPropertyValue('box-sizing');

        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide[0];
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }

      if (currentTransform) {
        slide[0].style.transform = currentTransform;
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = currentWebKitTransform;
      }

      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        slides[i].style[getDirectionLabel('width')] = `${slideSize}px`;
      }
    }

    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }

    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }

  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({
      width: `${swiper.virtualSize + params.spaceBetween}px`
    });
  }

  if (params.setWrapperSize) {
    $wrapperEl.css({
      [getDirectionLabel('width')]: `${swiper.virtualSize + params.spaceBetween}px`
    });
  }

  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
  } // Remove last grid elements depending on width


  if (!params.centeredSlides) {
    const newSlidesGrid = [];

    for (let i = 0; i < snapGrid.length; i += 1) {
      let slidesGridItem = snapGrid[i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);

      if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }

    snapGrid = newSlidesGrid;

    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }

  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
    slides.filter((_, slideIndex) => {
      if (!params.cssMode) return true;

      if (slideIndex === slides.length - 1) {
        return false;
      }

      return true;
    }).css({
      [key]: `${spaceBetween}px`
    });
  }

  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    const maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(snap => {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }

  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;

    if (allSlidesSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });

  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0];
    const addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map(v => v + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map(v => v + addToSlidesGrid);
  }

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }

  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }

  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }

  if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);

    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.$el.removeClass(backFaceHiddenClass);
    }
  }
}

function updateAutoHeight(speed) {
  const swiper = this;
  const activeSlides = [];
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0;
  let i;

  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }

  const getSlideByIndex = index => {
    if (isVirtual) {
      return swiper.slides.filter(el => parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index)[0];
    }

    return swiper.slides.eq(index)[0];
  }; // Find slides currently in view


  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || $([])).each(slide => {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        const index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  } // Find new height from highest slide in view


  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      const height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  } // Update Height


  if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', `${newHeight}px`);
}

function updateSlidesOffset() {
  const swiper = this;
  const slides = swiper.slides;

  for (let i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}

function updateSlidesProgress(translate = this && this.translate || 0) {
  const swiper = this;
  const params = swiper.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  let offsetCenter = -translate;
  if (rtl) offsetCenter = translate; // Visible Slides

  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (let i = 0; i < slides.length; i += 1) {
    const slide = slides[i];
    let slideOffset = slide.swiperSlideOffset;

    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }

    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

    if (isVisible) {
      swiper.visibleSlides.push(slide);
      swiper.visibleSlidesIndexes.push(i);
      slides.eq(i).addClass(params.slideVisibleClass);
    }

    slide.progress = rtl ? -slideProgress : slideProgress;
    slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }

  swiper.visibleSlides = $(swiper.visibleSlides);
}

function updateProgress(translate) {
  const swiper = this;

  if (typeof translate === 'undefined') {
    const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }

  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd
  } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;

  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }

  Object.assign(swiper, {
    progress,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }

  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }

  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}

function updateSlidesClasses() {
  const swiper = this;
  const {
    slides,
    params,
    $wrapperEl,
    activeIndex,
    realIndex
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
  let activeSlide;

  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
  } else {
    activeSlide = slides.eq(activeIndex);
  } // Active classes


  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    }
  } // Next Slide


  let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);

  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  } // Prev Slide


  let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);

  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }

  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
    }

    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    }
  }

  swiper.emitSlidesClasses();
}

function updateActiveIndex(newActiveIndex) {
  const swiper = this;
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    slidesGrid,
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;

  if (typeof activeIndex === 'undefined') {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    } // Normalize slideIndex


    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }

  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }

  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }

    return;
  } // Get real index


  const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
  Object.assign(swiper, {
    snapIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');

  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }

  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}

function updateClickedSlide(e) {
  const swiper = this;
  const params = swiper.params;
  const slide = $(e).closest(`.${params.slideClass}`)[0];
  let slideFound = false;
  let slideIndex;

  if (slide) {
    for (let i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;

    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }

  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide
};

function getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
  const swiper = this;
  const {
    params,
    rtlTranslate: rtl,
    translate,
    $wrapperEl
  } = swiper;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  if (params.cssMode) {
    return translate;
  }

  let currentTranslate = getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}

function setTranslate(translate, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl,
    params,
    $wrapperEl,
    wrapperEl,
    progress
  } = swiper;
  let x = 0;
  let y = 0;
  const z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
  }

  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate() {
  return -this.snapGrid[0];
}

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

function translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
  const swiper = this;
  const {
    params,
    wrapperEl
  } = swiper;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  const minTranslate = swiper.minTranslate();
  const maxTranslate = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

  swiper.updateProgress(newTranslate);

  if (params.cssMode) {
    const isH = swiper.isHorizontal();

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? 'left' : 'top'
        });
        return true;
      }

      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: -newTranslate,
        behavior: 'smooth'
      });
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;

          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }

  return true;
}

var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo
};

function setTransition(duration, byController) {
  const swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}

function transitionEmit({
  swiper,
  runCallbacks,
  direction,
  step
}) {
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit(`transition${step}`);

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit(`slideResetTransition${step}`);
      return;
    }

    swiper.emit(`slideChangeTransition${step}`);

    if (dir === 'next') {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}

function transitionStart(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  if (params.cssMode) return;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'Start'
  });
}

function transitionEnd(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'End'
  });
}

var transition = {
  setTransition,
  transitionStart,
  transitionEnd
};

function slideTo(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
  if (typeof index !== 'number' && typeof index !== 'string') {
    throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
  }

  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    const indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    const isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  const swiper = this;
  let slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;

  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }

  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  const translate = -snapGrid[snapIndex]; // Normalize slideIndex

  if (params.normalizeSlideIndex) {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      const normalizedTranslate = -Math.floor(translate * 100);
      const normalizedGrid = Math.floor(slidesGrid[i] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  } // Directions locks


  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }

    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  } // Update progress


  swiper.updateProgress(translate);
  let direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex); // Update Height

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    swiper.updateSlidesClasses();

    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }

    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }

    return false;
  }

  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    const t = rtl ? translate : -translate;

    if (speed === 0) {
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;

      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = 'none';
        swiper._immediateVirtual = true;
      }

      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;

      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = '';
          swiper._swiperImmediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: t,
          side: isH ? 'left' : 'top'
        });
        return true;
      }

      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: t,
        behavior: 'smooth'
      });
    }

    return true;
  }

  swiper.setTransition(speed);
  swiper.setTranslate(translate);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit('beforeTransitionStart', speed, internal);
  swiper.transitionStart(runCallbacks, direction);

  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;

    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
        if (!swiper || swiper.destroyed) return;
        if (e.target !== this) return;
        swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }

    swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
  }

  return true;
}

function slideToLoop(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    const indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    const isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  const swiper = this;
  let newIndex = index;

  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideNext(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    animating,
    enabled,
    params
  } = swiper;
  if (!enabled) return swiper;
  let perGroup = params.slidesPerGroup;

  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
  }

  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }

  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    params,
    animating,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return swiper;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  const translate = rtlTranslate ? swiper.translate : -swiper.translate;

  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }

  const normalizedTranslate = normalize(translate);
  const normalizedSnapGrid = snapGrid.map(val => normalize(val));
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

  if (typeof prevSnap === 'undefined' && params.cssMode) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        // prevSnap = snap;
        prevSnapIndex = snapIndex;
      }
    });

    if (typeof prevSnapIndex !== 'undefined') {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }

  let prevIndex = 0;

  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;

    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }

  if (params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  }

  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
  const swiper = this;
  let index = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];

    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];

    if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide() {
  const swiper = this;
  const {
    params,
    $wrapperEl
  } = swiper;
  const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.clickedIndex;
  let realIndex;

  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
        nextTick(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
      nextTick(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide
};

function loopCreate() {
  const swiper = this;
  const document = getDocument();
  const {
    params,
    $wrapperEl
  } = swiper; // Remove duplicated slides

  const $selector = $wrapperEl.children().length > 0 ? $($wrapperEl.children()[0].parentNode) : $wrapperEl;
  $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
  let slides = $selector.children(`.${params.slideClass}`);

  if (params.loopFillGroupWithBlank) {
    const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

    if (blankSlidesNum !== params.slidesPerGroup) {
      for (let i = 0; i < blankSlidesNum; i += 1) {
        const blankNode = $(document.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
        $selector.append(blankNode);
      }

      slides = $selector.children(`.${params.slideClass}`);
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;

  if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) {
    swiper.loopedSlides = slides.length;
  }

  const prependSlides = [];
  const appendSlides = [];
  slides.each((el, index) => {
    const slide = $(el);
    slide.attr('data-swiper-slide-index', index);
  });

  for (let i = 0; i < swiper.loopedSlides; i += 1) {
    const index = i - Math.floor(i / slides.length) * slides.length;
    appendSlides.push(slides.eq(index)[0]);
    prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
  }

  for (let i = 0; i < appendSlides.length; i += 1) {
    $selector.append($(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }

  for (let i = prependSlides.length - 1; i >= 0; i -= 1) {
    $selector.prepend($(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}

function loopFix$1() {
  const swiper = this;
  swiper.emit('beforeLoopFix');
  const {
    activeIndex,
    slides,
    loopedSlides,
    allowSlidePrev,
    allowSlideNext,
    snapGrid,
    rtlTranslate: rtl
  } = swiper;
  let newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  const snapTranslate = -snapGrid[activeIndex];
  const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }

  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit('loopFix');
}

function loopDestroy() {
  const swiper = this;
  const {
    $wrapperEl,
    params,
    slides
  } = swiper;
  $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
  slides.removeAttr('data-swiper-slide-index');
}

var loop = {
  loopCreate,
  loopFix: loopFix$1,
  loopDestroy
};

function setGrabCursor(moving) {
  const swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
  el.style.cursor = 'move';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}

function unsetGrabCursor() {
  const swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}

var grabCursor = {
  setGrabCursor,
  unsetGrabCursor
};

function closestElement(selector, base = this) {
  function __closestFrom(el) {
    if (!el || el === getDocument() || el === getWindow()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    const found = el.closest(selector);

    if (!found && !el.getRootNode) {
      return null;
    }

    return found || __closestFrom(el.getRootNode().host);
  }

  return __closestFrom(base);
}

function onTouchStart(event) {
  const swiper = this;
  const document = getDocument();
  const window = getWindow();
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled) return;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }

  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }

  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  let $targetEl = $(e.target);

  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }

  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return; // change target el for shadow root component

  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ''; // eslint-disable-next-line

  const eventPath = event.composedPath ? event.composedPath() : event.path;

  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
    $targetEl = $(eventPath[0]);
  }

  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = true;
    return;
  }

  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
    } else {
      return;
    }
  }

  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;

  if (e.type !== 'touchstart') {
    let preventDefault = true;

    if ($targetEl.is(data.focusableElements)) {
      preventDefault = false;

      if ($targetEl[0].nodeName === 'SELECT') {
        data.isTouched = false;
      }
    }

    if (document.activeElement && $(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
      document.activeElement.blur();
    }

    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e.preventDefault();
    }
  }

  if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }

  swiper.emit('touchStart', e);
}

function onTouchMove(event) {
  const document = getDocument();
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled) return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    return;
  }

  if (data.isTouchEvent && e.type !== 'touchmove') return;
  const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }

  if (!swiper.allowTouchMove) {
    if (!$(e.target).is(data.focusableElements)) {
      swiper.allowClick = false;
    }

    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = now();
    }

    return;
  }

  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }

  if (data.isTouchEvent && document.activeElement) {
    if (e.target === document.activeElement && $(e.target).is(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }

  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }

  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    let touchAngle;

    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }

  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }

  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }

  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }

  if (!data.startMoving) {
    return;
  }

  swiper.allowClick = false;

  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }

  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop && !params.cssMode) {
      swiper.loopFix();
    }

    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);

    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }

    data.allowMomentumBounce = false; // Grab Cursor

    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }

    swiper.emit('sliderFirstMove', e);
  }

  swiper.emit('sliderMove', e);
  data.isMoved = true;
  let diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) diff = -diff;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;

  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }

  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  } // Directions locks


  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  } // Threshold


  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  } // Update progress


  swiper.updateProgress(data.currentTranslate); // Update translate

  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd(event) {
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled) return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }

  data.allowTouchCallbacks = false;

  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }

    data.isMoved = false;
    data.startMoving = false;
    return;
  } // Return Grab Cursor


  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  } // Time diff


  const touchEndTime = now();
  const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

  if (swiper.allowClick) {
    const pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
    swiper.emit('tap click', e);

    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }

  data.lastClickTime = now();
  nextTick(() => {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  let currentPos;

  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.cssMode) {
    return;
  }

  if (swiper.params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  } // Find current slide


  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];

  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (typeof slidesGrid[i + increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }

  let rewindFirstIndex = null;
  let rewindLastIndex = null;

  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  } // Find current slide size


  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
    }

    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }

      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize() {
  const swiper = this;
  const {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0) return; // Breakpoints

  if (params.breakpoints) {
    swiper.setBreakpoint();
  } // Save locks


  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper; // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();

  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }

  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  } // Return locks after resize


  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick(e) {
  const swiper = this;
  if (!swiper.enabled) return;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function onScroll() {
  const swiper = this;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;

  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  } // eslint-disable-next-line


  if (swiper.translate === 0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }

  swiper.emit('setTranslate', swiper.translate, false);
}

let dummyEventAttached = false;

function dummyEventListener() {}

const events = (swiper, method) => {
  const document = getDocument();
  const {
    params,
    touchEvents,
    el,
    wrapperEl,
    device,
    support
  } = swiper;
  const capture = !!params.nested;
  const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
  const swiperMethod = method; // Touch Events

  if (!support.touch) {
    el[domMethod](touchEvents.start, swiper.onTouchStart, false);
    document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
    document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
  } else {
    const passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
    el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
      passive: false,
      capture
    } : capture);
    el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);

    if (touchEvents.cancel) {
      el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl[domMethod]('scroll', swiper.onScroll);
  } // Resize handler


  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper[swiperMethod]('observerUpdate', onResize, true);
  }
};

function attachEvents() {
  const swiper = this;
  const document = getDocument();
  const {
    params,
    support
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);

  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);

  if (support.touch && !dummyEventAttached) {
    document.addEventListener('touchstart', dummyEventListener);
    dummyEventAttached = true;
  }

  events(swiper, 'on');
}

function detachEvents() {
  const swiper = this;
  events(swiper, 'off');
}

var events$1 = {
  attachEvents,
  detachEvents
};

const isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};

function setBreakpoint() {
  const swiper = this;
  const {
    activeIndex,
    initialized,
    loopedSlides = 0,
    params,
    $el
  } = swiper;
  const breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

  const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
  const wasMultiRow = isGridEnabled(swiper, params);
  const isMultiRow = isGridEnabled(swiper, breakpointParams);
  const wasEnabled = params.enabled;

  if (wasMultiRow && !isMultiRow) {
    $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass(`${params.containerModifierClass}grid`);

    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
      $el.addClass(`${params.containerModifierClass}grid-column`);
    }

    swiper.emitContainerClasses();
  } // Toggle navigation, pagination, scrollbar


  ['navigation', 'pagination', 'scrollbar'].forEach(prop => {
    const wasModuleEnabled = params[prop] && params[prop].enabled;
    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;

    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }

    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

  if (directionChanged && initialized) {
    swiper.changeDirection();
  }

  extend$1(swiper.params, breakpointParams);
  const isEnabled = swiper.params.enabled;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });

  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }

  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);

  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }

  swiper.emit('breakpoint', breakpointParams);
}

function getBreakpoint(breakpoints, base = 'window', containerEl) {
  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  let breakpoint = false;
  const window = getWindow();
  const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints).map(point => {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }

    return {
      value: point,
      point
    };
  });
  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));

  for (let i = 0; i < points.length; i += 1) {
    const {
      point,
      value
    } = points[i];

    if (base === 'window') {
      if (window.matchMedia(`(min-width: ${value}px)`).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }

  return breakpoint || 'max';
}

var breakpoints = {
  setBreakpoint,
  getBreakpoint
};

function prepareClasses(entries, prefix) {
  const resultClasses = [];
  entries.forEach(item => {
    if (typeof item === 'object') {
      Object.keys(item).forEach(classNames => {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}

function addClasses() {
  const swiper = this;
  const {
    classNames,
    params,
    rtl,
    $el,
    device,
    support
  } = swiper; // prettier-ignore

  const suffixes = prepareClasses(['initialized', params.direction, {
    'pointer-events': !support.touch
  }, {
    'free-mode': swiper.params.freeMode && params.freeMode.enabled
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'grid': params.grid && params.grid.rows > 1
  }, {
    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }, {
    'centered': params.cssMode && params.centeredSlides
  }, {
    'watch-progress': params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push(...suffixes);
  $el.addClass([...classNames].join(' '));
  swiper.emitContainerClasses();
}

function removeClasses() {
  const swiper = this;
  const {
    $el,
    classNames
  } = swiper;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}

var classes = {
  addClasses,
  removeClasses
};

function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  const window = getWindow();
  let image;

  function onReady() {
    if (callback) callback();
  }

  const isPicture = $(imageEl).parent('picture')[0];

  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new window.Image();
      image.onload = onReady;
      image.onerror = onReady;

      if (sizes) {
        image.sizes = sizes;
      }

      if (srcset) {
        image.srcset = srcset;
      }

      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}

function preloadImages() {
  const swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');

  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }

  for (let i = 0; i < swiper.imagesToLoad.length; i += 1) {
    const imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}

var images = {
  loadImage,
  preloadImages
};

function checkOverflow() {
  const swiper = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper;
  const {
    slidesOffsetBefore
  } = params;

  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1;
    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }

  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }

  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }

  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
  }
}

var checkOverflow$1 = {
  checkOverflow
};

var defaults = {
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'wrapper',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopedSlidesLimit: true,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: 'swiper-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};

function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj = {}) {
    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];

    if (typeof moduleParams !== 'object' || moduleParams === null) {
      extend$1(allModulesParams, obj);
      return;
    }

    if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
      params[moduleParamName] = {
        auto: true
      };
    }

    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
      extend$1(allModulesParams, obj);
      return;
    }

    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }

    if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }

    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    extend$1(allModulesParams, obj);
  };
}

/* eslint no-param-reassign: "off" */
const prototypes = {
  eventsEmitter,
  update,
  translate,
  transition,
  slide,
  loop,
  grabCursor,
  events: events$1,
  breakpoints,
  checkOverflow: checkOverflow$1,
  classes,
  images
};
const extendedDefaults = {};

class Swiper$1 {
  constructor(...args) {
    let el;
    let params;

    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      [el, params] = args;
    }

    if (!params) params = {};
    params = extend$1({}, params);
    if (el && !params.el) params.el = el;

    if (params.el && $(params.el).length > 1) {
      const swipers = [];
      $(params.el).each(containerEl => {
        const newParams = extend$1({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper$1(newParams));
      }); // eslint-disable-next-line no-constructor-return

      return swipers;
    } // Swiper Instance


    const swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];

    if (params.modules && Array.isArray(params.modules)) {
      swiper.modules.push(...params.modules);
    }

    const allModulesParams = {};
    swiper.modules.forEach(mod => {
      mod({
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    }); // Extend defaults with modules params

    const swiperParams = extend$1({}, defaults, allModulesParams); // Extend defaults with passed params

    swiper.params = extend$1({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = extend$1({}, swiper.params);
    swiper.passedParams = extend$1({}, params); // add event listeners

    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(eventName => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }

    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    } // Save Dom lib


    swiper.$ = $; // Extend Swiper

    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: $(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],

      // isDirection
      isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },

      isVertical() {
        return swiper.params.direction === 'vertical';
      },

      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        const touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        const desktop = ['pointerdown', 'pointermove', 'pointerup'];
        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: now(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit('_swiper'); // Init

    if (swiper.params.init) {
      swiper.init();
    } // Return app instance
    // eslint-disable-next-line no-constructor-return


    return swiper;
  }

  enable() {
    const swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;

    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }

    swiper.emit('enable');
  }

  disable() {
    const swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;

    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }

    swiper.emit('disable');
  }

  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min = swiper.minTranslate();
    const max = swiper.maxTranslate();
    const current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const cls = swiper.el.className.split(' ').filter(className => {
      return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', cls.join(' '));
  }

  getSlideClasses(slideEl) {
    const swiper = this;
    if (swiper.destroyed) return '';
    return slideEl.className.split(' ').filter(className => {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  }

  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const updates = [];
    swiper.slides.each(slideEl => {
      const classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  }

  slidesPerViewDynamic(view = 'current', exact = false) {
    const swiper = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;

    if (params.centeredSlides) {
      let slideSize = slides[activeIndex].swiperSlideSize;
      let breakLoop;

      for (let i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }

      for (let i = activeIndex - 1; i >= 0; i -= 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      // eslint-disable-next-line
      if (view === 'current') {
        for (let i = activeIndex + 1; i < slides.length; i += 1) {
          const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;

          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        // previous
        for (let i = activeIndex - 1; i >= 0; i -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;

          if (slideInView) {
            spv += 1;
          }
        }
      }
    }

    return spv;
  }

  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed) return;
    const {
      snapGrid,
      params
    } = swiper; // Breakpoints

    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();

    function setTranslate() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    let translated;

    if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
      setTranslate();

      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }

      if (!translated) {
        setTranslate();
      }
    }

    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }

    swiper.emit('update');
  }

  changeDirection(newDirection, needUpdate = true) {
    const swiper = this;
    const currentDirection = swiper.params.direction;

    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }

    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }

    swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.each(slideEl => {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  }

  changeLanguageDirection(direction) {
    const swiper = this;
    if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
    swiper.rtl = direction === 'rtl';
    swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;

    if (swiper.rtl) {
      swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'rtl';
    } else {
      swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'ltr';
    }

    swiper.update();
  }

  mount(el) {
    const swiper = this;
    if (swiper.mounted) return true; // Find el

    const $el = $(el || swiper.params.el);
    el = $el[0];

    if (!el) {
      return false;
    }

    el.swiper = swiper;

    const getWrapperSelector = () => {
      return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
    };

    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = $(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

        res.children = options => $el.children(options);

        return res;
      }

      if (!$el.children) {
        return $($el).children(getWrapperSelector());
      }

      return $el.children(getWrapperSelector());
    }; // Find Wrapper


    let $wrapperEl = getWrapper();

    if ($wrapperEl.length === 0 && swiper.params.createElements) {
      const document = getDocument();
      const wrapper = document.createElement('div');
      $wrapperEl = $(wrapper);
      wrapper.className = swiper.params.wrapperClass;
      $el.append(wrapper);
      $el.children(`.${swiper.params.slideClass}`).each(slideEl => {
        $wrapperEl.append(slideEl);
      });
    }

    Object.assign(swiper, {
      $el,
      el,
      $wrapperEl,
      wrapperEl: $wrapperEl[0],
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box'
    });
    return true;
  }

  init(el) {
    const swiper = this;
    if (swiper.initialized) return swiper;
    const mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit'); // Set breakpoint

    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    } // Add Classes


    swiper.addClasses(); // Create loop

    if (swiper.params.loop) {
      swiper.loopCreate();
    } // Update size


    swiper.updateSize(); // Update slides

    swiper.updateSlides();

    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    } // Set Grab Cursor


    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    } // Slide To Initial Slide


    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    } // Attach events


    swiper.attachEvents(); // Init Flag

    swiper.initialized = true; // Emit

    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  }

  destroy(deleteInstance = true, cleanStyles = true) {
    const swiper = this;
    const {
      params,
      $el,
      $wrapperEl,
      slides
    } = swiper;

    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }

    swiper.emit('beforeDestroy'); // Init Flag

    swiper.initialized = false; // Detach events

    swiper.detachEvents(); // Destroy loop

    if (params.loop) {
      swiper.loopDestroy();
    } // Cleanup styles


    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr('style');
      $wrapperEl.removeAttr('style');

      if (slides && slides.length) {
        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
      }
    }

    swiper.emit('destroy'); // Detach emitter events

    Object.keys(swiper.eventsListeners).forEach(eventName => {
      swiper.off(eventName);
    });

    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      deleteProps(swiper);
    }

    swiper.destroyed = true;
    return null;
  }

  static extendDefaults(newDefaults) {
    extend$1(extendedDefaults, newDefaults);
  }

  static get extendedDefaults() {
    return extendedDefaults;
  }

  static get defaults() {
    return defaults;
  }

  static installModule(mod) {
    if (!Swiper$1.prototype.__modules__) Swiper$1.prototype.__modules__ = [];
    const modules = Swiper$1.prototype.__modules__;

    if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }

  static use(module) {
    if (Array.isArray(module)) {
      module.forEach(m => Swiper$1.installModule(m));
      return Swiper$1;
    }

    Swiper$1.installModule(module);
    return Swiper$1;
  }

}

Object.keys(prototypes).forEach(prototypeGroup => {
  Object.keys(prototypes[prototypeGroup]).forEach(protoMethod => {
    Swiper$1.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper$1.use([Resize, Observer]);

function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  const document = getDocument();

  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach(key => {
      if (!params[key] && params.auto === true) {
        let element = swiper.$el.children(`.${checkProps[key]}`)[0];

        if (!element) {
          element = document.createElement('div');
          element.className = checkProps[key];
          swiper.$el.append(element);
        }

        params[key] = element;
        originalParams[key] = element;
      }
    });
  }

  return params;
}

function classesToSelector(classes = '') {
  return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.')}`;
}

function Pagination({
  swiper,
  extendParams,
  on,
  emit
}) {
  const pfx = 'swiper-pagination';
  extendParams({
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: number => number,
      formatFractionTotal: number => number,
      bulletClass: `${pfx}-bullet`,
      bulletActiveClass: `${pfx}-bullet-active`,
      modifierClass: `${pfx}-`,
      currentClass: `${pfx}-current`,
      totalClass: `${pfx}-total`,
      hiddenClass: `${pfx}-hidden`,
      progressbarFillClass: `${pfx}-progressbar-fill`,
      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
      clickableClass: `${pfx}-clickable`,
      lockClass: `${pfx}-lock`,
      horizontalClass: `${pfx}-horizontal`,
      verticalClass: `${pfx}-vertical`,
      paginationDisabledClass: `${pfx}-disabled`
    }
  });
  swiper.pagination = {
    el: null,
    $el: null,
    bullets: []
  };
  let bulletSize;
  let dynamicBulletIndex = 0;

  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
  }

  function setSideBullets($bulletEl, position) {
    const {
      bulletActiveClass
    } = swiper.params.pagination;
    $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
  }

  function update() {
    // Render || Update Pagination bullets/items
    const rtl = swiper.rtl;
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const $el = swiper.pagination.$el; // Current/Total

    let current;
    const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex;
      let lastIndex;
      let midIndex;

      if (params.dynamicBullets) {
        bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', `${bulletSize * (params.dynamicMainBullets + 4)}px`);

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);

          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }

        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass(['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(suffix => `${params.bulletActiveClass}${suffix}`).join(' '));

      if ($el.length > 1) {
        bullets.each(bullet => {
          const $bullet = $(bullet);
          const bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(`${params.bulletActiveClass}-main`);
            }

            if (bulletIndex === firstIndex) {
              setSideBullets($bullet, 'prev');
            }

            if (bulletIndex === lastIndex) {
              setSideBullets($bullet, 'next');
            }
          }
        });
      } else {
        const $bullet = bullets.eq(current);
        const bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          const $firstDisplayedBullet = bullets.eq(firstIndex);
          const $lastDisplayedBullet = bullets.eq(lastIndex);

          for (let i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length) {
              for (let i = params.dynamicMainBullets; i >= 0; i -= 1) {
                bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
            } else {
              setSideBullets($firstDisplayedBullet, 'prev');
              setSideBullets($lastDisplayedBullet, 'next');
            }
          } else {
            setSideBullets($firstDisplayedBullet, 'prev');
            setSideBullets($lastDisplayedBullet, 'next');
          }
        }
      }

      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        const offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
      }
    }

    if (params.type === 'fraction') {
      $el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      let progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      const scale = (current + 1) / total;
      let scaleX = 1;
      let scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find(classesToSelector(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      emit('paginationRender', $el[0]);
    } else {
      emit('paginationUpdate', $el[0]);
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  }

  function render() {
    // Render Container
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const $el = swiper.pagination.$el;
    let paginationHTML = '';

    if (params.type === 'bullets') {
      let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }

      for (let i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      emit('paginationRender', swiper.pagination.$el[0]);
    }
  }

  function init() {
    swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: 'swiper-pagination'
    });
    const params = swiper.params.pagination;
    if (!params.el) return;
    let $el = $(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper

      if ($el.length > 1) {
        $el = $el.filter(el => {
          if ($(el).parents('.swiper')[0] !== swiper.el) return false;
          return true;
        });
      }
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);
    $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
      dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', classesToSelector(params.bulletClass), function onClick(e) {
        e.preventDefault();
        let index = $(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    Object.assign(swiper.pagination, {
      $el,
      el: $el[0]
    });

    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  }

  function destroy() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', classesToSelector(params.bulletClass));
    }
  }

  on('init', () => {
    if (swiper.params.pagination.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      render();
      update();
    }
  });
  on('activeIndexChange', () => {
    if (swiper.params.loop) {
      update();
    } else if (typeof swiper.snapIndex === 'undefined') {
      update();
    }
  });
  on('snapIndexChange', () => {
    if (!swiper.params.loop) {
      update();
    }
  });
  on('slidesLengthChange', () => {
    if (swiper.params.loop) {
      render();
      update();
    }
  });
  on('snapGridLengthChange', () => {
    if (!swiper.params.loop) {
      render();
      update();
    }
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    const {
      $el
    } = swiper.pagination;

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
    }
  });
  on('lock unlock', () => {
    update();
  });
  on('click', (_s, e) => {
    const targetEl = e.target;
    const {
      $el
    } = swiper.pagination;

    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !$(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
      const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);

      if (isHidden === true) {
        emit('paginationShow');
      } else {
        emit('paginationHide');
      }

      $el.toggleClass(swiper.params.pagination.hiddenClass);
    }
  });

  const enable = () => {
    swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);

    if (swiper.pagination.$el) {
      swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
    }

    init();
    render();
    update();
  };

  const disable = () => {
    swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);

    if (swiper.pagination.$el) {
      swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
    }

    destroy();
  };

  Object.assign(swiper.pagination, {
    enable,
    disable,
    render,
    update,
    init,
    destroy
  });
}

/* eslint no-underscore-dangle: "off" */
function Autoplay({
  swiper,
  extendParams,
  on,
  emit
}) {
  let timeout;
  swiper.autoplay = {
    running: false,
    paused: false
  };
  extendParams({
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  });

  function run() {
    if (!swiper.size) {
      swiper.autoplay.running = false;
      swiper.autoplay.paused = false;
      return;
    }

    const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    let delay = swiper.params.autoplay.delay;

    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }

    clearTimeout(timeout);
    timeout = nextTick(() => {
      let autoplayResult;

      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit('autoplay');
        } else if (!swiper.isBeginning) {
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          emit('autoplay');
        } else {
          stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit('autoplay');
      } else if (!swiper.isEnd) {
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit('autoplay');
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
        emit('autoplay');
      } else {
        stop();
      }

      if (swiper.params.cssMode && swiper.autoplay.running) run();else if (autoplayResult === false) {
        run();
      }
    }, delay);
  }

  function start() {
    if (typeof timeout !== 'undefined') return false;
    if (swiper.autoplay.running) return false;
    swiper.autoplay.running = true;
    emit('autoplayStart');
    run();
    return true;
  }

  function stop() {
    if (!swiper.autoplay.running) return false;
    if (typeof timeout === 'undefined') return false;

    if (timeout) {
      clearTimeout(timeout);
      timeout = undefined;
    }

    swiper.autoplay.running = false;
    emit('autoplayStop');
    return true;
  }

  function pause(speed) {
    if (!swiper.autoplay.running) return;
    if (swiper.autoplay.paused) return;
    if (timeout) clearTimeout(timeout);
    swiper.autoplay.paused = true;

    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      run();
    } else {
      ['transitionend', 'webkitTransitionEnd'].forEach(event => {
        swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
      });
    }
  }

  function onVisibilityChange() {
    const document = getDocument();

    if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
      pause();
    }

    if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
      run();
      swiper.autoplay.paused = false;
    }
  }

  function onTransitionEnd(e) {
    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
    if (e.target !== swiper.$wrapperEl[0]) return;
    ['transitionend', 'webkitTransitionEnd'].forEach(event => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
    swiper.autoplay.paused = false;

    if (!swiper.autoplay.running) {
      stop();
    } else {
      run();
    }
  }

  function onMouseEnter() {
    if (swiper.params.autoplay.disableOnInteraction) {
      stop();
    } else {
      emit('autoplayPause');
      pause();
    }

    ['transitionend', 'webkitTransitionEnd'].forEach(event => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
  }

  function onMouseLeave() {
    if (swiper.params.autoplay.disableOnInteraction) {
      return;
    }

    swiper.autoplay.paused = false;
    emit('autoplayResume');
    run();
  }

  function attachMouseEvents() {
    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.$el.on('mouseenter', onMouseEnter);
      swiper.$el.on('mouseleave', onMouseLeave);
    }
  }

  function detachMouseEvents() {
    swiper.$el.off('mouseenter', onMouseEnter);
    swiper.$el.off('mouseleave', onMouseLeave);
  }

  on('init', () => {
    if (swiper.params.autoplay.enabled) {
      start();
      const document = getDocument();
      document.addEventListener('visibilitychange', onVisibilityChange);
      attachMouseEvents();
    }
  });
  on('beforeTransitionStart', (_s, speed, internal) => {
    if (swiper.autoplay.running) {
      if (internal || !swiper.params.autoplay.disableOnInteraction) {
        swiper.autoplay.pause(speed);
      } else {
        stop();
      }
    }
  });
  on('sliderFirstMove', () => {
    if (swiper.autoplay.running) {
      if (swiper.params.autoplay.disableOnInteraction) {
        stop();
      } else {
        pause();
      }
    }
  });
  on('touchEnd', () => {
    if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
      run();
    }
  });
  on('destroy', () => {
    detachMouseEvents();

    if (swiper.autoplay.running) {
      stop();
    }

    const document = getDocument();
    document.removeEventListener('visibilitychange', onVisibilityChange);
  });
  Object.assign(swiper.autoplay, {
    pause,
    run,
    start,
    stop
  });
}

function isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function extend(target, src) {
  const noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(key => noExtend.indexOf(key) < 0).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}

function needsNavigation(params = {}) {
  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}

function needsPagination(params = {}) {
  return params.pagination && typeof params.pagination.el === 'undefined';
}

function needsScrollbar(params = {}) {
  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}

function uniqueClasses(classNames = '') {
  const classes = classNames.split(' ').map(c => c.trim()).filter(c => !!c);
  const unique = [];
  classes.forEach(c => {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}

/* underscore in name -> watch for changes */
const paramsList = ['modules', 'init', '_direction', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', '_spaceBetween', '_slidesPerView', 'maxBackfaceHiddenSlides', '_grid', '_slidesPerGroup', '_slidesPerGroupSkip', '_slidesPerGroupAuto', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_preloadImages', 'updateOnImagesReady', '_loop', '_loopAdditionalSlides', '_loopedSlides', '_loopedSlidesLimit', '_loopFillGroupWithBlank', 'loopPreventsSlide', '_rewind', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideBlankClass', 'slideActiveClass', 'slideDuplicateActiveClass', 'slideVisibleClass', 'slideDuplicateClass', 'slideNextClass', 'slideDuplicateNextClass', 'slidePrevClass', 'slideDuplicatePrevClass', 'wrapperClass', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren', // modules
'a11y', '_autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'creativeEffect', 'cardsEffect', 'hashNavigation', 'history', 'keyboard', 'lazy', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom'];

function getParams(obj = {}, splitEvents = true) {
  const params = {
    on: {}
  };
  const events = {};
  const passedParams = {};
  extend(params, Swiper$1.defaults);
  extend(params, Swiper$1.extendedDefaults);
  params._emitClasses = true;
  params.init = false;
  const rest = {};
  const allowedParams = paramsList.map(key => key.replace(/_/, ''));
  const plainObj = Object.assign({}, obj);
  Object.keys(plainObj).forEach(key => {
    if (typeof obj[key] === 'undefined') return;

    if (allowedParams.indexOf(key) >= 0) {
      if (isObject(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend(params[key], obj[key]);
        extend(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      if (splitEvents) {
        events[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      } else {
        params.on[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      }
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(key => {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params,
    passedParams,
    rest,
    events
  };
}

function mountSwiper({
  el,
  nextEl,
  prevEl,
  paginationEl,
  scrollbarEl,
  swiper
}, swiperParams) {
  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }

  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }

  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }

  swiper.init(el);
}

const calcLoopedSlides = (slides, swiperParams) => {
  let slidesPerViewParams = swiperParams.slidesPerView;

  if (swiperParams.breakpoints) {
    const breakpoint = Swiper$1.prototype.getBreakpoint(swiperParams.breakpoints);
    const breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;

    if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
      slidesPerViewParams = breakpointOnlyParams.slidesPerView;
    }
  }

  let loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
  loopedSlides += swiperParams.loopAdditionalSlides;

  if (loopedSlides > slides.length && swiperParams.loopedSlidesLimit) {
    loopedSlides = slides.length;
  }

  return loopedSlides;
};

function renderLoop(swiper, slides, swiperParams) {
  const modifiedSlides = slides.map((child, index) => {
    return /*#__PURE__*/React__default.cloneElement(child, {
      swiper,
      'data-swiper-slide-index': index
    });
  });

  function duplicateSlide(child, index, position) {
    return /*#__PURE__*/React__default.cloneElement(child, {
      key: `${child.key}-duplicate-${index}-${position}`,
      className: `${child.props.className || ''} ${swiperParams.slideDuplicateClass}`
    });
  }

  if (swiperParams.loopFillGroupWithBlank) {
    const blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;

    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
      for (let i = 0; i < blankSlidesNum; i += 1) {
        const blankSlide = /*#__PURE__*/React__default.createElement("div", {
          className: `${swiperParams.slideClass} ${swiperParams.slideBlankClass}`
        });
        modifiedSlides.push(blankSlide);
      }
    }
  }

  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
    swiperParams.loopedSlides = modifiedSlides.length;
  }

  const loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
  const prependSlides = [];
  const appendSlides = [];

  for (let i = 0; i < loopedSlides; i += 1) {
    const index = i - Math.floor(i / modifiedSlides.length) * modifiedSlides.length;
    appendSlides.push(duplicateSlide(modifiedSlides[index], i, 'append'));
    prependSlides.unshift(duplicateSlide(modifiedSlides[modifiedSlides.length - index - 1], i, 'prepend'));
  }

  if (swiper) {
    swiper.loopedSlides = loopedSlides;
  }

  return [...prependSlides, ...modifiedSlides, ...appendSlides];
}

function getChangedParams(swiperParams, oldParams, children, oldChildren, getKey) {
  const keys = [];
  if (!oldParams) return keys;

  const addKey = key => {
    if (keys.indexOf(key) < 0) keys.push(key);
  };

  if (children && oldChildren) {
    const oldChildrenKeys = oldChildren.map(getKey);
    const childrenKeys = children.map(getKey);
    if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
    if (oldChildren.length !== children.length) addKey('children');
  }

  const watchParams = paramsList.filter(key => key[0] === '_').map(key => key.replace(/_/, ''));
  watchParams.forEach(key => {
    if (key in swiperParams && key in oldParams) {
      if (isObject(swiperParams[key]) && isObject(oldParams[key])) {
        const newKeys = Object.keys(swiperParams[key]);
        const oldKeys = Object.keys(oldParams[key]);

        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(newKey => {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(oldKey => {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}

function isChildSwiperSlide(child) {
  return child.type && child.type.displayName && child.type.displayName.includes('SwiperSlide');
}

function processChildren(c) {
  const slides = [];
  React__default.Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(slide => slides.push(slide));
    }
  });
  return slides;
}

function getChildren(c) {
  const slides = [];
  const slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  React__default.Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      const foundSlides = processChildren(child.props.children);

      if (foundSlides.length > 0) {
        foundSlides.forEach(slide => slides.push(slide));
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides,
    slots
  };
}

function updateSwiper({
  swiper,
  slides,
  passedParams,
  changedParams,
  nextEl,
  prevEl,
  scrollbarEl,
  paginationEl
}) {
  const updateParams = changedParams.filter(key => key !== 'children' && key !== 'direction');
  const {
    params: currentParams,
    pagination,
    navigation,
    scrollbar,
    virtual,
    thumbs
  } = swiper;
  let needThumbsInit;
  let needControllerInit;
  let needPaginationInit;
  let needScrollbarInit;
  let needNavigationInit;

  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }

  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }

  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }

  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }

  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }

  const destroyModule = mod => {
    if (!swiper[mod]) return;
    swiper[mod].destroy();

    if (mod === 'navigation') {
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };

  updateParams.forEach(key => {
    if (isObject(currentParams[key]) && isObject(passedParams[key])) {
      extend(currentParams[key], passedParams[key]);
    } else {
      const newValue = passedParams[key];

      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });

  if (updateParams.includes('controller') && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (changedParams.includes('children') && slides && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes('children') && swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (needThumbsInit) {
    const initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }

  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (needPaginationInit) {
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }

  if (needScrollbarInit) {
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }

  if (needNavigationInit) {
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }

  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }

  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }

  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }

  swiper.update();
}

function renderVirtual(swiper, slides, virtualData) {
  if (!virtualData) return null;
  const style = swiper.isHorizontal() ? {
    [swiper.rtlTranslate ? 'right' : 'left']: `${virtualData.offset}px`
  } : {
    top: `${virtualData.offset}px`
  };
  return slides.filter((child, index) => index >= virtualData.from && index <= virtualData.to).map(child => {
    return /*#__PURE__*/React__default.cloneElement(child, {
      swiper,
      style
    });
  });
}

const updateOnVirtualData = swiper => {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();

  if (swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
};

function useIsomorphicLayoutEffect(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return useEffect(callback, deps);
  return useLayoutEffect(callback, deps);
}

const SwiperSlideContext = /*#__PURE__*/createContext(null);
const SwiperContext = /*#__PURE__*/createContext(null);
const useSwiper = () => {
  return useContext(SwiperContext);
};

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
const Swiper = /*#__PURE__*/forwardRef(function (_temp, externalElRef) {
  let {
    className,
    tag: Tag = 'div',
    wrapperTag: WrapperTag = 'div',
    children,
    onSwiper,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  let eventsAssigned = false;
  const [containerClasses, setContainerClasses] = useState('swiper');
  const [virtualData, setVirtualData] = useState(null);
  const [breakpointChanged, setBreakpointChanged] = useState(false);
  const initializedRef = useRef(false);
  const swiperElRef = useRef(null);
  const swiperRef = useRef(null);
  const oldPassedParamsRef = useRef(null);
  const oldSlides = useRef(null);
  const nextElRef = useRef(null);
  const prevElRef = useRef(null);
  const paginationElRef = useRef(null);
  const scrollbarElRef = useRef(null);
  const {
    params: swiperParams,
    passedParams,
    rest: restProps,
    events
  } = getParams(rest);
  const {
    slides,
    slots
  } = getChildren(children);

  const onBeforeBreakpoint = () => {
    setBreakpointChanged(!breakpointChanged);
  };

  Object.assign(swiperParams.on, {
    _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }

  });

  const initSwiper = () => {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    swiperRef.current = new Swiper$1(swiperParams);

    swiperRef.current.loopCreate = () => {};

    swiperRef.current.loopDestroy = () => {};

    if (swiperParams.loop) {
      swiperRef.current.loopedSlides = calcLoopedSlides(slides, swiperParams);
    }

    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      const extendWith = {
        cache: false,
        slides,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend(swiperRef.current.params.virtual, extendWith);
      extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  };

  if (!swiperElRef.current) {
    initSwiper();
  } // Listen for breakpoints change


  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }

  const attachEvents = () => {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };

  const detachEvents = () => {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };

  useEffect(() => {
    return () => {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  }); // set initialized flag

  useEffect(() => {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  }); // mount swiper

  useIsomorphicLayoutEffect(() => {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }

    if (!swiperElRef.current) return;

    if (swiperRef.current.destroyed) {
      initSwiper();
    }

    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper) onSwiper(swiperRef.current); // eslint-disable-next-line

    return () => {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []); // watch for params change

  useIsomorphicLayoutEffect(() => {
    attachEvents();
    const changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, c => c.key);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;

    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides,
        passedParams,
        changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }

    return () => {
      detachEvents();
    };
  }); // update on virtual update

  useIsomorphicLayoutEffect(() => {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]); // bypass swiper instance to slides

  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }

    if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) {
      return slides.map(child => {
        return /*#__PURE__*/React__default.cloneElement(child, {
          swiper: swiperRef.current
        });
      });
    }

    return renderLoop(swiperRef.current, slides, swiperParams);
  }

  return /*#__PURE__*/React__default.createElement(Tag, _extends$1({
    ref: swiperElRef,
    className: uniqueClasses(`${containerClasses}${className ? ` ${className}` : ''}`)
  }, restProps), /*#__PURE__*/React__default.createElement(SwiperContext.Provider, {
    value: swiperRef.current
  }, slots['container-start'], /*#__PURE__*/React__default.createElement(WrapperTag, {
    className: "swiper-wrapper"
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), needsNavigation(swiperParams) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /*#__PURE__*/React__default.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /*#__PURE__*/React__default.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), slots['container-end']));
});
Swiper.displayName = 'Swiper';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SwiperSlide = /*#__PURE__*/forwardRef(function (_temp, externalRef) {
  let {
    tag: Tag = 'div',
    children,
    className = '',
    swiper,
    zoom,
    virtualIndex,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  const slideElRef = useRef(null);
  const [slideClasses, setSlideClasses] = useState('swiper-slide');

  function updateClasses(_s, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }

  useIsomorphicLayoutEffect(() => {
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }

    if (!slideElRef.current || !swiper) {
      return;
    }

    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }

      return;
    }

    swiper.on('_slideClass', updateClasses); // eslint-disable-next-line

    return () => {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  useIsomorphicLayoutEffect(() => {
    if (swiper && slideElRef.current && !swiper.destroyed) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  const slideData = {
    isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
    isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
    isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
    isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
    isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
  };

  const renderChildren = () => {
    return typeof children === 'function' ? children(slideData) : children;
  };

  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    ref: slideElRef,
    className: uniqueClasses(`${slideClasses}${className ? ` ${className}` : ''}`),
    "data-swiper-slide-index": virtualIndex
  }, rest), /*#__PURE__*/React__default.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, zoom ? /*#__PURE__*/React__default.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren()) : renderChildren()));
});
SwiperSlide.displayName = 'SwiperSlide';

var _AngleByDirection;
var DEFAULT_GRADIENT_COLOR = 'rgba(0, 0, 0, 0.6)';
var DEFAULT_ARROW_COLOR = '#e3e8f0';
var AngleByDirection = (_AngleByDirection = {}, _defineProperty(_AngleByDirection, Directions.Left, '90deg'), _defineProperty(_AngleByDirection, Directions.Right, '270deg'), _AngleByDirection);
var StyledArrow = styled.button.withConfig({
  displayName: "Arrow__StyledArrow",
  componentId: "sc-1pm77v-0"
})(["display:grid;align-items:center;justify-content:center;position:absolute;top:0;", " z-index:1;width:auto;height:100%;margin:0;padding:0 20px;border:none;outline:none;font-size:50px;cursor:pointer;color:", ";background:linear-gradient( ", ",", ",transparent );transition:opacity 500ms;opacity:0;&&&.swiper-button-disabled{opacity:0;cursor:auto;pointer-events:none;}& svg{opacity:0.75;}&:hover svg{opacity:1;}"], function (_ref) {
  var _ref$gutter = _ref.gutter,
    gutter = _ref$gutter === void 0 ? 0 : _ref$gutter,
    direction = _ref.direction;
  return direction === Directions.Left ? "left: -".concat(gutter / 2, "rem;") : "right: -".concat(gutter / 2, "rem;");
}, function (_ref2) {
  var _theme$color;
  var theme = _ref2.theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$color = theme.color) === null || _theme$color === void 0 ? void 0 : _theme$color.pageParagraphForeground) || DEFAULT_ARROW_COLOR;
}, function (_ref3) {
  var direction = _ref3.direction;
  return AngleByDirection[direction];
}, function (_ref4) {
  var _theme$color2;
  var theme = _ref4.theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$color2 = theme.color) === null || _theme$color2 === void 0 ? void 0 : _theme$color2.pageBackground) || DEFAULT_GRADIENT_COLOR;
});
StyledArrow.displayName = 'StyledArrow';
var ArrowFactory = function ArrowFactory(Icon) {
  var Arrow = /*#__PURE__*/forwardRef(function (_ref5, ref) {
    var direction = _ref5.direction,
      _ref5$onClick = _ref5.onClick,
      onClick = _ref5$onClick === void 0 ? NOOP : _ref5$onClick;
    var swiper = useSwiper();

    // throttle arrow clicks
    var throttledOnClick = useMemo(function () {
      return lodash_throttle(onClick, 250, {
        trailing: false
      });
    }, [onClick]);

    // pass the swiper to the onClick handler, same way Swiper's own event handlers get it
    var forwardClick = useCallback(function () {
      return throttledOnClick(swiper);
    }, [swiper, throttledOnClick]);
    return /*#__PURE__*/React__default.createElement(StyledArrow, {
      direction: direction,
      onClick: forwardClick,
      ref: ref,
      "data-cy": "Slider_Arrow_StyledArrow"
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: direction.toLowerCase(),
      "data-cy": "Slider_Arrow_Icon"
    }));
  });
  Arrow.displayName = 'Arrow';
  Arrow.propTypes = {
    direction: PropTypes__default.oneOf([Directions.Left, Directions.Right]).isRequired,
    onClick: PropTypes__default.func
  };
  return Arrow;
};

/**
 * Finds a value in a responsive prop, for a given breakpoint.
 * If a breakpoint isn't specified, returns the first bigger one.
 * @param {object} obj Responsive prop object: { xs: 1, md: 3, xxl: 5 }
 * @param {BreakpointKeys} breakpoint Breakpoint key.
 * @returns {any} The value found at the given breakpoint or the following bigger one.
 */
var findOrBigger = function findOrBigger() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var breakpoint = arguments.length > 1 ? arguments[1] : undefined;
  var findIndex = breakpointOrder.indexOf(breakpoint);
  for (var index = findIndex; index < breakpointOrder.length; index += 1) {
    var value = obj[breakpointOrder[index]];
    if (value) {
      return value;
    }
  }
};

/**
 * Calculates the responsive breakpoint settings for a slider.
 * @param {object} params
 * @param {object} params.weightSum Responsive prop containing weight sums for breakpoints: { xs: 1, md: 3, xxl: 5 }
 * @param {object} params.templateWeights Responsive prop containing item template weights for breakpoints: { md: 1, xxl: 1.5 }
 * @param {object} params.contentInset Object with left and right responsive props containing content insets for breakpoints: { left: { md: 1 }, right: { md: 1} }
 * @param {boolean} params.centerMode Is center mode enabled?
 * @param {boolean} params.pageMode Is page mode enabled?
 * @param {number} params.swiperWidth Width of the swiper in pixels.
 * @param {number} params.spaceBetween Gutter size of the swiper.
 * @returns {object} Breakpoints object expected by swiper.
 */
var getBreakpoints = function getBreakpoints(_ref) {
  var weightSum = _ref.weightSum,
    templateWeights = _ref.templateWeights,
    contentInset = _ref.contentInset,
    centerMode = _ref.centerMode,
    pageMode = _ref.pageMode,
    swiperWidth = _ref.swiperWidth,
    spaceBetween = _ref.spaceBetween;
  // re-mapping slidesPerView to the minimum breakpoint as swiper expects it, like:
  // {
  //   0:    { slidesPerView: 1, ... }
  //   576:  { slidesPerView: 2, ... }
  //   768:  { slidesPerView: 3, ... }
  //   992:  { slidesPerView: 4, ... }
  //   1200: { slidesPerView: 5, ... }
  //   1600: { slidesPerView: 6, ... }
  // }
  var result = {};
  var order = ['zero'].concat(_toConsumableArray(breakpointOrder));
  for (var index = 0; index < order.length - 1; index += 1) {
    var currSize = index === 0 ? 0 : breakpoints$1[order[index]];
    var nextBreakpoint = order[index + 1];

    // calculate the intended number of slides based on the weights
    var currWeightSum = findOrBigger(weightSum, nextBreakpoint);
    var currTemplateWeight = findOrBigger(templateWeights, nextBreakpoint);
    var intendedSlides = currWeightSum / currTemplateWeight;

    // find content insets
    var insetLeft = findOrBigger(contentInset.left, nextBreakpoint) || 0;
    var insetRight = findOrBigger(contentInset.right, nextBreakpoint) || 0;

    // calculate final item width, considering content insets
    var allGaps = (Math.ceil(intendedSlides) - 1) * spaceBetween;
    var allInsets = insetLeft + insetRight;
    var itemWidth = (swiperWidth - allInsets - allGaps) / intendedSlides;

    // final number of slides, increased to account for the insets
    var slides = intendedSlides + allInsets / itemWidth;

    // number of fully visible slides
    var wholeSlides = centerMode ? Math.trunc((intendedSlides - 1) / 2) * 2 + 1 : Math.trunc(intendedSlides);
    result[currSize] = {
      slidesPerView: slides,
      slidesPerGroup: 1,
      slidesOffsetBefore: insetLeft,
      slidesOffsetAfter: insetRight,
      // custom info for Slider. not used by Swiper.
      _scrollAmount: pageMode ? 1 : wholeSlides
    };
  }
  return result;
};

var DEFAULT_DOT_COLOR = '#FFFFFF';
var OPACITY_DEFAULT = 0.3;
var OPACITY_ACTIVE = 1;
var fadeIn = keyframes(['from { opacity:0; } to { opacity:1; }']);

// Positions and styles the pagination dots
var DotsContainer = styled.div.withConfig({
  displayName: "DotsContainer",
  componentId: "sc-d1xu1s-0"
})(["position:absolute;overflow:hidden;margin-bottom:", "rem;", " ", " text-align:center;z-index:2;opacity:0;animation:500ms linear 500ms forwards ", ";&&{bottom:0;}& > .swiper-pagination-bullet{background-color:", ";opacity:", ";}& > .swiper-pagination-bullet:hover{opacity:", ";cursor:pointer;}& > .swiper-pagination-bullet-active{opacity:", ";}"], rem(32), styleUntilBreakpoint(BreakpointKeys.MD, "margin-bottom: ".concat(rem(24), "rem;")), styleUntilBreakpoint(BreakpointKeys.XS, "margin-bottom: ".concat(rem(16), "rem;")), fadeIn, function (_ref) {
  var _theme$color;
  var theme = _ref.theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$color = theme.color) === null || _theme$color === void 0 ? void 0 : _theme$color.imageOverlayHeadingForeground) || DEFAULT_DOT_COLOR;
}, OPACITY_DEFAULT, OPACITY_ACTIVE, OPACITY_ACTIVE);

// we can't use the Navigation module because we need to override the sliding
// behavior, so we can slide multiple slides despite slidesPerGroup have to be 1
// to prevent group snapping bugs.

var sleep = function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};
var loopFix = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(swiper) {
    return regenerator.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve) {
            swiper.once('loopFix', resolve);
            swiper.loopFix();
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function loopFix(_x) {
    return _ref.apply(this, arguments);
  };
}();
var slidePage = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(swiper, direction) {
    var _scrollAmount, slideDelta;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(swiper._isLoopFixing || swiper.destroyed)) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return");
        case 2:
          _scrollAmount = swiper.params.breakpoints[swiper.currentBreakpoint]._scrollAmount;
          slideDelta = direction * _scrollAmount;
          if (!swiper.params.loop) {
            _context2.next = 14;
            break;
          }
          // store a flag on the swiper instance to prevent another swipe attempt while loop fixing.
          swiper._isLoopFixing = true;
          _context2.prev = 6;
          _context2.next = 9;
          return loopFix(swiper);
        case 9:
          _context2.next = 11;
          return sleep(10);
        case 11:
          _context2.prev = 11;
          swiper._isLoopFixing = false;
          return _context2.finish(11);
        case 14:
          swiper.slideTo(swiper.activeIndex + slideDelta);
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[6,, 11, 14]]);
  }));
  return function slidePage(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Slide to the previous page.
 * @param {Swiper} swiper The Swiper instance.
 * @returns void
 */
var slideToPreviousPage = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(swiper) {
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", slidePage(swiper, -1));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function slideToPreviousPage(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Slide to the next page.
 * @param {Swiper} swiper The Swiper instance.
 * @returns void
 */
var slideToNextPage = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(swiper) {
    return regenerator.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", slidePage(swiper, 1));
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function slideToNextPage(_x5) {
    return _ref4.apply(this, arguments);
  };
}();

// Stylelint: Expected selector ".selector32 .swiper .swiper-slide" to come before selector ".selector31 .swiper .swiper-slide:hover"
var cssHoverZoom = css$1(["overflow-x:clip;.swiper{overflow:visible;.swiper-slide{transition-duration:150ms;transition-property:transform,box-shadow;&:hover{transform:scale(1.2);box-shadow:0 0 1rem #0006;z-index:1;}}}"]);
var cssActiveZoom = css$1(["overflow-x:clip;.swiper{overflow:visible;.swiper-slide{transition-duration:", "ms;transition-property:transform,box-shadow;&.swiper-slide-active{transform:scale(1.2);box-shadow:0 0 1rem #0006;z-index:1;}}}"], function (_ref) {
  var speed = _ref.speed;
  return speed;
});

// workaround for safari flicker on slide transition end.
// swiper issue: https://github.com/nolimits4web/swiper/issues/3527
// it degrades performance, so we only want it on Safari, destop and mobile.
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var cssSafariFlickerFix = css$1([".swiper-slide{transform:translate3d(0,0,0);}"]);
var SwiperContainer = styled.div.withConfig({
  displayName: "SwiperContainer",
  componentId: "sc-bgemm1-0"
})(["box-sizing:border-box;width:100%;user-select:none;:hover ", "{opacity:1;}&&&& .swiper-pagination-bullet{transition-duration:", "ms;transition-property:transform,-webkit-transform,left,opacity;}& .swiper-wrapper{will-change:transform;}", " ", " ", ""], StyledArrow, function (_ref2) {
  var speed = _ref2.speed;
  return speed;
}, function (_ref3) {
  var hoverZoom = _ref3.hoverZoom;
  return hoverZoom && cssHoverZoom;
}, function (_ref4) {
  var activeZoom = _ref4.activeZoom;
  return activeZoom && cssActiveZoom;
}, isSafari && cssSafariFlickerFix);
SwiperContainer.propTypes = {
  speed: PropTypes__default.number.isRequired,
  hoverZoom: PropTypes__default.bool,
  activeZoom: PropTypes__default.bool
};
SwiperContainer.displayName = 'SwiperContainer';

// update navigation button classes with DOM manipulation, the same way the Navigation module would
var updateNavigationButton = function updateNavigationButton(swiper, button, disabled) {
  if (!button) {
    return;
  }
  // if the swiper is disabled, the nav buttons should be too
  disabled || (disabled = !swiper.enabled);
  // update disabled class
  button.classList[disabled ? 'add' : 'remove']('swiper-button-disabled');
  if (button && button.tagName === 'BUTTON') {
    button.disabled = disabled;
  }

  // update lock class
  if (swiper.params.watchOverflow && swiper.enabled) {
    button.classList[swiper.isLocked ? 'add' : 'remove']('swiper-button-lock');
  }
};

/**
 * Update disabled and locked classes on navigation buttons.
 * Based on the same code from Swiper, but we have to do it ourselves, so we can control scroll amount.
 * @param {Swiper} swiper The swiper instance.
 * @param {HTMLButtonElement} prevButton The previous button.
 * @param {HTMLButtonElement} nextButton The next button.
 */
var updateNavigationButtons = function updateNavigationButtons(swiper, prevButton, nextButton) {
  updateNavigationButton(swiper, prevButton, swiper.isBeginning && !swiper.params.rewind && !swiper.params.loop);
  updateNavigationButton(swiper, nextButton, swiper.isEnd && !swiper.params.rewind && !swiper.params.loop);
};

var mapTemplatesToItems = function mapTemplatesToItems(items, itemTemplates) {
  return (items || []).map(function (item, index) {
    return {
      key: item.id,
      templateRule: getItemTemplate(item, index, itemTemplates),
      item: item
    };
  });
};

var getPaginationStartIndex = function getPaginationStartIndex(index, pageSize) {
  return Math.floor(index / pageSize) * pageSize;
};
var getDefaultInfo = function getDefaultInfo(hasMore, total) {
  return {
    hasMore: hasMore,
    total: total,
    pending: false,
    pageStartIndex: 0,
    lastItemsLength: 0,
    realIndexBeforeItemsUpdate: undefined
  };
};

/**
 * Hook for fetching more items.
 * @param {Object} params Object with the following props.
 * @param {Object} params.data Data prop from Slider.
 * @param {Array} params.itemTemplateRules Item template rules.
 * @param {string} params.serviceId serviceId string.
 * @param {Function} params.fetchSliderPage Slider fetcher function.
 * @param {boolean} params.repeated Repeated prop from Slider.
 * @returns {Object} Object with pagination functions.
 */
var usePagination = function usePagination(_ref) {
  var data = _ref.data,
    itemTemplateRules = _ref.itemTemplateRules,
    serviceId = _ref.serviceId,
    fetchSliderPage = _ref.fetchSliderPage,
    repeated = _ref.repeated;
  var feed = data.feed,
    collectionId = data.collectionId,
    _data$pageInfo = data.pageInfo,
    pageInfo = _data$pageInfo === void 0 ? {} : _data$pageInfo,
    initial = data.initial;
  var hasMoreInitial = pageInfo.hasMore,
    pageSize = pageInfo.pageSize,
    totalInitial = pageInfo.total;
  var info = useRef(getDefaultInfo(hasMoreInitial, totalInitial));
  var fetchPageData = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(start) {
      var opts, pageData, error, res;
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            opts = {
              start: start,
              size: pageSize
            };
            _context.prev = 1;
            _context.next = 4;
            return fetchSliderPage({
              feed: feed,
              collectionId: collectionId,
              serviceId: serviceId,
              opts: opts,
              componentType: 'SLIDER'
            });
          case 4:
            res = _context.sent;
            pageData = res.data || [];
            error = res.error;
            info.current.total = res.pageInfo.total;
            _context.next = 14;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            pageData = [];
            error = _context.t0;
          case 14:
            if (!(error || !pageData.length)) {
              _context.next = 18;
              break;
            }
            info.current.hasMore = false;
            info.current.pending = false;
            return _context.abrupt("return", []);
          case 18:
            return _context.abrupt("return", pageData);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 10]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [collectionId, serviceId, feed, fetchSliderPage, pageSize]);
  var getLastItems = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
    var res, lastItems;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(!hasMoreInitial || info.current.hasMore === false || !repeated)) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", []);
        case 2:
          _context2.next = 4;
          return fetchPageData(getPaginationStartIndex(info.current.total - 1, pageSize));
        case 4:
          res = _context2.sent;
          lastItems = mapTemplatesToItems(res, itemTemplateRules);
          info.current.lastItemsLength = lastItems.length;
          return _context2.abrupt("return", lastItems);
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [fetchPageData, hasMoreInitial, itemTemplateRules, pageSize, repeated]);
  var getSliderPage = useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(start, items) {
      var _info$current, hasMore, pending, pageData, itemsToAdd, firstItems, lastItems, newItems;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _info$current = info.current, hasMore = _info$current.hasMore, pending = _info$current.pending;
            if (!(!hasMore || pending)) {
              _context3.next = 3;
              break;
            }
            return _context3.abrupt("return");
          case 3:
            info.current.pending = true;
            _context3.next = 6;
            return fetchPageData(start);
          case 6:
            pageData = _context3.sent;
            itemsToAdd = mapTemplatesToItems(pageData, itemTemplateRules);
            firstItems = items.slice(0, start);
            lastItems = items.slice(items.length - info.current.lastItemsLength);
            newItems = [].concat(_toConsumableArray(firstItems), _toConsumableArray(itemsToAdd), _toConsumableArray(lastItems));
            info.current.hasMore = newItems.length < info.current.total;
            info.current.pending = false;
            return _context3.abrupt("return", newItems);
          case 14:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }(), [fetchPageData, itemTemplateRules]);
  var initialize = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
    var _yield$Promise$all, _yield$Promise$all2, _yield$Promise$all2$, firstItems, lastItems;
    return regenerator.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          info.current = getDefaultInfo(hasMoreInitial, totalInitial);
          _context4.t0 = Promise;
          if (!(initial !== null && initial !== void 0 && initial.length)) {
            _context4.next = 6;
            break;
          }
          _context4.t1 = mapTemplatesToItems(initial, itemTemplateRules);
          _context4.next = 9;
          break;
        case 6:
          _context4.next = 8;
          return getSliderPage(0, []);
        case 8:
          _context4.t1 = _context4.sent;
        case 9:
          _context4.t2 = _context4.t1;
          _context4.t3 =
          // lastItems: repeated carousels show part of the last item, we need to fetch the last page of data
          getLastItems();
          _context4.t4 = [_context4.t2, _context4.t3];
          _context4.next = 14;
          return _context4.t0.all.call(_context4.t0, _context4.t4);
        case 14:
          _yield$Promise$all = _context4.sent;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
          _yield$Promise$all2$ = _yield$Promise$all2[0];
          firstItems = _yield$Promise$all2$ === void 0 ? [] : _yield$Promise$all2$;
          lastItems = _yield$Promise$all2[1];
          return _context4.abrupt("return", [].concat(_toConsumableArray(firstItems), _toConsumableArray(lastItems)));
        case 20:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  })), [getLastItems, initial, hasMoreInitial, totalInitial, itemTemplateRules, getSliderPage]);
  var getNextPageIfNeeded = useCallback( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(index, items, slidesPerView) {
      var lastItemsLength, twoPages, twoPagesAhead, startIndex, pageStartIndex, isFirstFetch, isAlreadyFetched;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            lastItemsLength = info.current.lastItemsLength;
            twoPages = slidesPerView * 2;
            twoPagesAhead = index + twoPages;
            if (!(index + lastItemsLength + 1 >= info.current.total || twoPagesAhead < items.length - lastItemsLength || lastItemsLength && index >= items.length - lastItemsLength)) {
              _context5.next = 5;
              break;
            }
            return _context5.abrupt("return");
          case 5:
            startIndex = items.length ? twoPagesAhead : 0;
            pageStartIndex = getPaginationStartIndex(startIndex, pageSize);
            isFirstFetch = !items.length && info.current.pageStartIndex === 0;
            isAlreadyFetched = info.current.pageStartIndex === pageStartIndex;
            if (!(!isFirstFetch && isAlreadyFetched)) {
              _context5.next = 11;
              break;
            }
            return _context5.abrupt("return");
          case 11:
            info.current.pageStartIndex = pageStartIndex;
            return _context5.abrupt("return", getSliderPage(pageStartIndex, items));
          case 13:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x4, _x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }(), [getSliderPage, pageSize]);
  return useMemo(function () {
    return {
      initialize: initialize,
      getNextPageIfNeeded: getNextPageIfNeeded
    };
  }, [getNextPageIfNeeded, initialize]);
};

var _excluded$3 = ["id", "key", "templateRule", "item"];
var SPEED = 500; // transition speed (ms)
var THRESHOLD = 5; // threshold before click to swipe begins (px)
var PLACEHOLDER_ITEMS = 10; // number of placeholder items to show before initial fetch
var INTERSECTION_MARGIN = '20%'; // root margin for intersection observer (margin-like, px or %)

var SliderFactory = function SliderFactory(Item, Icon) {
  var factoryFetcher = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultFetcher;
  var rootElement = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : document;
  var Arrow = ArrowFactory(Icon);
  var renderItems = function renderItems(_ref) {
    var items = _ref.items,
      placeholders = _ref.placeholders,
      actions = _ref.actions,
      v2Templates = _ref.v2Templates,
      formFactorTemplateProperties = _ref.formFactorTemplateProperties,
      observerRootElement = _ref.observerRootElement,
      context = _ref.context,
      showPlaceholders = _ref.showPlaceholders,
      baseItemTemplate = _ref.baseItemTemplate;
    if (showPlaceholders && !placeholders.length) {
      var _baseItemTemplate$asp;
      return /*#__PURE__*/React__default.createElement(SwiperSlide, {
        key: "item-placeholder",
        "data-cy": "Slider_Slider_SwiperSlide"
      }, /*#__PURE__*/React__default.createElement(ItemWrapper, {
        $aspectRatio: (_baseItemTemplate$asp = baseItemTemplate.aspectRatios) === null || _baseItemTemplate$asp === void 0 ? void 0 : _baseItemTemplate$asp.xxl,
        "data-cy": "Slider_Slider_ItemWrapper"
      }));
    }
    var itemsToRender = showPlaceholders ? placeholders : items;
    return itemsToRender.map(function (_ref2, index) {
      var _template$aspectRatio;
      var id = _ref2.id,
        key = _ref2.key,
        _ref2$templateRule = _ref2.templateRule,
        _ref2$templateRule2 = _ref2$templateRule === void 0 ? {} : _ref2$templateRule,
        template = _ref2$templateRule2.template,
        _ref2$item = _ref2.item,
        item = _ref2$item === void 0 ? {} : _ref2$item,
        rest = _objectWithoutProperties(_ref2, _excluded$3);
      return /*#__PURE__*/React__default.createElement(SwiperSlide, {
        key: id || key || "item-".concat(index),
        "data-cy": "Slider_Slider_SwiperSlide"
      }, /*#__PURE__*/React__default.createElement(ItemWrapper, {
        $aspectRatio: (_template$aspectRatio = template.aspectRatios) === null || _template$aspectRatio === void 0 ? void 0 : _template$aspectRatio.xxl,
        "data-cy": "Slider_Slider_ItemWrapper"
      }, /*#__PURE__*/React__default.createElement(Item, _extends$3({}, dataDyn(context.item), {
        context: _extends$3({}, context, {
          item: item,
          itemIndex: index
        }),
        formFactorTemplateProperties: formFactorTemplateProperties
        // This property is currently used only in the Image component to fix lazy loading
        // Slider elements container needs to be set as the root element for the Intersection Observer
        // to trigger whenever the elements in the Slider enters the viewport.
        // TODO#lazyloading: Revisit this logic at some point. There must be a better way of handling this.
        ,
        observerRootElement: observerRootElement,
        template: template,
        v2Templates: v2Templates
      }, rest, {
        actions: actions,
        "aria-label": item === null || item === void 0 ? void 0 : item.title,
        "data-cy": "Slider_Slider_Item"
      }))));
    });
  };
  var Slider = function Slider(props) {
    var _items$, _items$$context, _swiperRef$current$pa, _swiperRef$current, _swiperRef$current$pa2;
    var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      items = _useState2[0],
      setItems = _useState2[1];
    var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      placeholders = _useState4[0],
      setPlaceholders = _useState4[1];
    var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isReady = _useState6[0],
      setIsReady = _useState6[1];
    var containerRef = useRef(null);
    var swiperRef = useRef(null);
    var navigationPrevRef = useRef(null);
    var navigationNextRef = useRef(null);
    var paginationDotsRef = useRef(null);
    var isEmpty = !items.length;
    var _props$data = props.data,
      data = _props$data === void 0 ? {} : _props$data,
      _props$properties = props.properties,
      properties = _props$properties === void 0 ? {} : _props$properties,
      itemTemplateRules = props.itemTemplateRules,
      context = props.context,
      _props$actions = props.actions,
      actions = _props$actions === void 0 ? {} : _props$actions,
      v2Templates = props.v2Templates,
      formFactorTemplateProperties = props.formFactorTemplateProperties,
      templateId = props.templateId,
      _props$fetcher = props.fetcher,
      fetchSliderPage = _props$fetcher === void 0 ? factoryFetcher : _props$fetcher,
      _props$onRemoveContai = props.onRemoveContainer,
      onRemoveContainer = _props$onRemoveContai === void 0 ? NOOP : _props$onRemoveContai;
    var gutter = properties.gutter,
      weightSum = properties.weightSum,
      _properties$contentIn = properties.contentInset,
      contentInset = _properties$contentIn === void 0 ? {} : _properties$contentIn,
      autoSlide = properties.autoSlide,
      repeated = properties.repeated,
      _properties$centerMod = properties.centerMode,
      centerMode = _properties$centerMod === void 0 ? false : _properties$centerMod,
      _properties$pageMode = properties.pageMode,
      pageMode = _properties$pageMode === void 0 ? false : _properties$pageMode,
      _properties$paginatio = properties.paginationIndicator,
      _properties$paginatio2 = _properties$paginatio === void 0 ? {} : _properties$paginatio,
      _properties$paginatio3 = _properties$paginatio2.enabled,
      showPaginationDots = _properties$paginatio3 === void 0 ? false : _properties$paginatio3,
      _properties$experimen = properties.experimental,
      experimental = _properties$experimen === void 0 ? {} : _properties$experimen;
    var gutterRem = gutterSizesRem[gutter] || 0;

    // it's technically possible that different items have different template weights (via conditional template rules).
    // currently, there is no feature or specification that would require that. for now, we can assume that all items
    // have the same template weight, and we can use just the first item's.
    var firstTemplateRule = getItemTemplate((_items$ = items[0]) === null || _items$ === void 0 ? void 0 : (_items$$context = _items$.context) === null || _items$$context === void 0 ? void 0 : _items$$context.item, 0, itemTemplateRules, !items.length);
    var _ref3 = firstTemplateRule || {},
      templateWeights = _ref3.templateWeights;

    // is this a touch input device?
    var isTouchMode = window.matchMedia('(pointer:coarse)').matches;

    // no hover zoom on touch devices
    var hoverZoomEnabled = experimental.hoverZoom && !isTouchMode;

    // pagination dots options
    var pagination = showPaginationDots && {
      el: paginationDotsRef.current,
      dynamicBullets: true,
      dynamicMainBullets: 1,
      clickable: true
    };

    // autoplay (aka autoSlide) options
    var autoplay = (autoSlide === null || autoSlide === void 0 ? void 0 : autoSlide.interval) > 0 && {
      delay: autoSlide.interval,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    };
    var serviceId = context.serviceId;

    // this is for pagination in the sense of fetching more items.
    // as opposed to the `Pagination` swiper module which is for the pagination indicator dots.
    var paginationController = usePagination({
      data: data,
      itemTemplateRules: itemTemplateRules,
      serviceId: serviceId,
      fetchSliderPage: fetchSliderPage,
      repeated: repeated
    });

    // placeholder items
    var showPlaceholders = !items.length;
    var baseItemTemplate = itemTemplateRules[0].template;

    // update responsive breakpoint settings
    var updateBreakpoints = useCallback(function (swiper) {
      var swiperWidth = swiper.width,
        spaceBetween = swiper.params.spaceBetween;
      swiper.params.breakpoints = getBreakpoints({
        weightSum: weightSum,
        templateWeights: templateWeights,
        contentInset: contentInset,
        centerMode: centerMode,
        pageMode: pageMode,
        swiperWidth: swiperWidth,
        spaceBetween: spaceBetween
      });
      // workaround: force `update` despite `currentBreakpoint` didn't change
      swiper.currentBreakpoint = false;
      swiper.update();
    }, [centerMode, contentInset, templateWeights, pageMode, weightSum]);

    // update after the number of items changed
    var handleItemsChange = useCallback(function (swiper) {
      if (!items.length) {
        return;
      }

      // when we fetch more items, the amount of loopedSlides change, which makes our current activeIndex wrong.
      if (repeated) {
        swiper.activeIndex = swiper.realIndex + swiper.loopedSlides;
      }

      // to make sure previous slides are shown, we have to fix the loop after the number of slides change
      if (centerMode && repeated) {
        swiper.loopFix();
      }

      // update pagination
      // workaround: we need setTimeout to make sure the changes above take effect before this.
      setTimeout(function () {
        var _swiper$pagination, _swiper$pagination$up;
        return (_swiper$pagination = swiper.pagination) === null || _swiper$pagination === void 0 ? void 0 : (_swiper$pagination$up = _swiper$pagination.update) === null || _swiper$pagination$up === void 0 ? void 0 : _swiper$pagination$up.call(_swiper$pagination);
      });
    }, [items, centerMode, repeated]);

    // fetch the next page when needed
    var fetchMoreIfNeeded = useCallback( /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(swiper) {
        var realIndex, slidesPerView, lastVisibleIndex, newItems;
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              realIndex = swiper.realIndex;
              slidesPerView = swiper.params.slidesPerView;
              if (slidesPerView) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              lastVisibleIndex = Math.min(centerMode ? realIndex + (slidesPerView - 1) / 2 : realIndex + slidesPerView, items.length);
              _context.next = 7;
              return paginationController.getNextPageIfNeeded(lastVisibleIndex, items, slidesPerView);
            case 7:
              newItems = _context.sent;
              if (newItems) {
                swiper.enabled = true;
                swiper.once('slideChangeTransitionEnd', function () {
                  setItems(newItems);
                });
              }
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }(), [centerMode, items, paginationController]);

    // if no initial data, fetch it when first entering the view
    useIntersection({
      targetRef: containerRef,
      rootMargin: INTERSECTION_MARGIN,
      rootElement: rootElement,
      onFirstEnterView: useCallback(function () {
        if (items.length) {
          return;
        }
        if (!placeholders.length) {
          // Fill the slider with placeholders while we wait for the data to come back
          setPlaceholders(createItemPlaceholders(items.length ? 0 : PLACEHOLDER_ITEMS, itemTemplateRules[0].template, context).placeholders);
        }
        paginationController.initialize().then(function (initialItems) {
          if ((initialItems === null || initialItems === void 0 ? void 0 : initialItems.length) === 0) {
            onRemoveContainer();
            return;
          }
          swiperRef.current.enabled = true;
          setItems(initialItems);
        })["catch"](function () {
          onRemoveContainer();
        });
      }, [items.length, placeholders.length, itemTemplateRules, context, paginationController, onRemoveContainer])
    });

    // update navigation button states
    var updateNavigation = useCallback(function (swiper) {
      updateNavigationButtons(swiper, navigationPrevRef.current, navigationNextRef.current);
    }, []);

    // update slide transform origins, so slides can scale inwards for hover zoom
    var updateTransformOrigins = useCallback(function (swiper) {
      if (hoverZoomEnabled) {
        var slides = swiper.visibleSlides || [];
        var length = slides.length;
        slides.forEach(function (slide, index) {
          var originX = length <= 1 ? 0 : Math.round(index * 100 / (length - 1));
          slide.style.transformOrigin = "".concat(originX, "% center");
        });
      }
    }, [hoverZoomEnabled]);

    // set the swiper ref and do initial fixes after swiper init
    var swiperInitialised = useCallback(function (swiper) {
      if (showPlaceholders) {
        swiper.disable();
      }
      swiperRef.current = swiper;
      updateBreakpoints(swiper);
      handleItemsChange(swiper);
    }, [showPlaceholders, updateBreakpoints, handleItemsChange]);

    // after swiper render
    var swiperUpdated = useCallback(function (swiper) {
      if (!isReady && !isEmpty) {
        // set the ready flag after the first non-empty render
        setIsReady(true);
      }
      updateNavigation(swiper);
    }, [isReady, isEmpty, updateNavigation]);
    var initial = data.initial;
    var prevTemplateId = useRef(templateId);
    var prevInitial = useRef(initial);
    var prevWeightSum = useRef(weightSum);
    var isMounted = useRef(true);
    useEffect(function () {
      return function () {
        isMounted.current = false;
      };
    }, []);

    // this effect handles a few updates required for Admin UI only
    // let's discuss how to handle this in a more elegant way
    // if the effect grows any larger, consider splitting it
    // and moving everything into a separate hook
    useEffect(function () {
      var didTemplateIdChange = prevTemplateId.current !== templateId;
      var didInitialChange = prevInitial.current !== initial;
      var didWeightSumChange = prevWeightSum.current !== weightSum;

      // Admin UI needs to re-init the Slider when either template id or initial data changes
      if (didTemplateIdChange || didInitialChange) {
        prevTemplateId.current = templateId;
        prevInitial.current = initial;
        paginationController.initialize().then(function (initialItems) {
          if (isMounted.current) {
            swiperRef.current.enabled = true;
            setItems(initialItems);
          }
        });
      }

      // Admin UI needs to update the breakpoints when weight sum changes
      if (didWeightSumChange && swiperRef.current) {
        prevWeightSum.current = weightSum;
        updateBreakpoints(swiperRef.current);
      }
    }, [templateId, initial, context, weightSum, paginationController, updateBreakpoints]);

    // how many duplicated slides we need to support swiping/repeated/centerMode
    // we should try to keep this at a minimum to avoid crashes on mobile due to memory issues
    var slidesPerView = (_swiperRef$current$pa = (_swiperRef$current = swiperRef.current) === null || _swiperRef$current === void 0 ? void 0 : (_swiperRef$current$pa2 = _swiperRef$current.params) === null || _swiperRef$current$pa2 === void 0 ? void 0 : _swiperRef$current$pa2.slidesPerView) !== null && _swiperRef$current$pa !== void 0 ? _swiperRef$current$pa : 1;
    var loopedSlides = repeated ? slidesPerView : 0;
    loopedSlides += loopedSlides > 1 && centerMode ? 1 : 0;
    return /*#__PURE__*/React__default.createElement(SwiperContainer, {
      activeZoom: experimental.activeZoom,
      hoverZoom: hoverZoomEnabled,
      ref: containerRef,
      speed: SPEED,
      "data-cy": "Slider_Slider_SwiperContainer"
    }, /*#__PURE__*/React__default.createElement(Swiper, {
      autoplay: autoplay,
      centerInsufficientSlides: false,
      centeredSlides: centerMode,
      loop: repeated,
      loopedSlides: loopedSlides,
      modules: [Pagination, Autoplay],
      onFromEdge: updateNavigation,
      onLock: updateNavigation,
      onProgress: updateTransformOrigins,
      onRealIndexChange: fetchMoreIfNeeded,
      onResize: updateBreakpoints,
      onSlidesLengthChange: handleItemsChange,
      onSwiper: swiperInitialised,
      onToEdge: updateNavigation,
      onUnlock: updateNavigation,
      onUpdate: swiperUpdated,
      pagination: pagination,
      preventInteractionOnTransition: true,
      spaceBetween: remToPx(gutterRem),
      speed: SPEED,
      threshold: THRESHOLD,
      touchStartPreventDefault: false,
      watchSlidesProgress: hoverZoomEnabled,
      "data-cy": "Slider_Slider_Swiper"
    }, renderItems({
      items: items,
      placeholders: placeholders,
      actions: actions,
      v2Templates: v2Templates,
      formFactorTemplateProperties: formFactorTemplateProperties,
      observerRootElement: containerRef.current,
      context: context,
      showPlaceholders: showPlaceholders,
      baseItemTemplate: baseItemTemplate
    }), /*#__PURE__*/React__default.createElement(Arrow, {
      direction: Directions.Left,
      onClick: slideToPreviousPage,
      ref: navigationPrevRef,
      slot: "container-end",
      "data-cy": "Slider_Slider_Arrow"
    }), /*#__PURE__*/React__default.createElement(Arrow, {
      direction: Directions.Right,
      onClick: slideToNextPage,
      ref: navigationNextRef,
      slot: "container-end",
      "data-cy": "Slider_Slider_Arrow"
    }), showPaginationDots && /*#__PURE__*/React__default.createElement(DotsContainer, {
      isReady: isReady,
      ref: paginationDotsRef,
      slot: "container-end",
      "data-cy": "Slider_Slider_DotsContainer"
    })));
  };
  Slider.displayName = 'Slider';
  Slider.propTypes = {
    id: PropTypes__default.string,
    actions: actionsPropType,
    context: PropTypes__default.shape({
      serviceId: PropTypes__default.string,
      theme: PropTypes__default.object
    }),
    data: PropTypes__default.shape({
      collectionId: PropTypes__default.string,
      feed: PropTypes__default.string,
      initial: PropTypes__default.arrayOf(PropTypes__default.shape({
        id: PropTypes__default.string
      })),
      pageInfo: PropTypes__default.shape({
        hasMore: PropTypes__default.bool,
        page: PropTypes__default.number,
        pageSize: PropTypes__default.number,
        total: PropTypes__default.number
      })
    }),
    properties: PropTypes__default.shape({
      gutter: PropTypes__default.string,
      weightSum: responsivePropType(PropTypes__default.number),
      autoSlide: PropTypes__default.shape({
        interval: PropTypes__default.number
      }),
      repeated: PropTypes__default.bool,
      centerMode: PropTypes__default.bool,
      pageMode: PropTypes__default.bool,
      paginationIndicator: PropTypes__default.shape({
        enabled: PropTypes__default.bool
      }),
      contentInset: PropTypes__default.shape({
        left: responsivePropType(PropTypes__default.number),
        right: responsivePropType(PropTypes__default.number)
      }),
      experimental: PropTypes__default.shape({
        hoverZoom: PropTypes__default.bool,
        activeZoom: PropTypes__default.bool
      })
    }),
    itemTemplateRules: PropTypes__default.arrayOf(PropTypes__default.shape({
      template: PropTypes__default.object
    })),
    options: PropTypes__default.shape({
      currentBreakpoint: PropTypes__default.oneOf(breakpointOrder)
    }),
    v2Templates: PropTypes__default.object,
    formFactorTemplateProperties: PropTypes__default.object,
    templateId: PropTypes__default.string,
    fetcher: PropTypes__default.func,
    onRemoveContainer: PropTypes__default.func
  };
  return Slider;
};

var _excluded$2 = ["applyCornerRadius", "hoverZoomContainer", "aspectRatios"];
var StackContainer = styled(function (props) {
  return /*#__PURE__*/React__default.createElement("div", _extends$3({}, filterProperties(props), {
    "data-cy": "Stack_Stack_div"
  }));
}).withConfig({
  displayName: "Stack__StackContainer",
  componentId: "sc-1bpq5ut-0"
})(["position:relative;overflow:hidden;", " ", ""], generalUtils, function (_ref) {
  var $corner = _ref.$corner;
  return "border-radius: ".concat($corner || 0, "rem;");
});
StackContainer.displayName = 'StackContainer';
var StackLayer = styled.div.withConfig({
  displayName: "Stack__StackLayer",
  componentId: "sc-1bpq5ut-1"
})(["position:absolute;top:0;left:0;bottom:0;right:0;", " &:empty{display:none;}"], function (_ref2) {
  var $corner = _ref2.$corner;
  return "border-radius: ".concat($corner || 0, "rem;");
});
StackLayer.displayName = 'StackLayer';
var AspectRatioContainer = styled.div.withConfig({
  displayName: "Stack__AspectRatioContainer",
  componentId: "sc-1bpq5ut-2"
})(["width:100%;"]);
AspectRatioContainer.displayName = 'AspectRatioContainer';
var Stack = function Stack(props) {
  var className = props.className,
    childrenProp = props.children,
    _props$properties = props.properties,
    properties = _props$properties === void 0 ? {} : _props$properties,
    _props$actions = props.actions,
    actions = _props$actions === void 0 ? {} : _props$actions,
    _props$context = props.context,
    context = _props$context === void 0 ? {} : _props$context;
  var ariaProps = filterAriaProperties(props);

  // It's like this because we don't want to pass applyCornerRadius and hoverZoomContainer to the div element
  properties.applyCornerRadius;
    var hoverZoomContainer = properties.hoverZoomContainer,
    aspectRatios = properties.aspectRatios,
    restProps = _objectWithoutProperties(properties, _excluded$2);
  // The original children prop is not an array, if there is only one child. Make it an array.
  var children = React__default.Children.map(childrenProp, function (c) {
    return c;
  });
  if (!children.length) {
    return null;
  }
  var cornerRadiusRem = getCornerRadiusRem(properties, context.theme);
  var isHoverZoomContainer = String(hoverZoomContainer) === 'true';
  var child = children[0];
  if (aspectRatios !== null && aspectRatios !== void 0 && aspectRatios.xxl) {
    child = /*#__PURE__*/React__default.createElement(AspectRatioContainer, {
      "data-cy": "Stack_Stack_AspectRatioContainer"
    }, /*#__PURE__*/React__default.createElement(AspectRatio, {
      aspectRatio: aspectRatios === null || aspectRatios === void 0 ? void 0 : aspectRatios.xxl,
      cornerRadiusRem: cornerRadiusRem,
      position: "inherit",
      "data-cy": "Stack_Stack_AspectRatio"
    }, child));
  }
  return /*#__PURE__*/React__default.createElement(StackContainer, _extends$3({}, dataDyn(props), {
    className: classNames(className, isHoverZoomContainer && 'hoverZoomContainer')
  }, restProps, ariaProps, eventHandlers(context, actions, properties.action), {
    $corner: cornerRadiusRem,
    "data-cy": "Stack_Stack_StackContainer"
  }), child, children.slice(1).map(function (node) {
    return node && /*#__PURE__*/React__default.createElement(StackLayer, {
      $corner: cornerRadiusRem,
      key: node.key,
      "data-cy": "Stack_Stack_StackLayer"
    }, node);
  }));
};
Stack.displayName = 'Stack';
Stack.propTypes = {
  className: PropTypes__default.string,
  children: PropTypes__default.oneOfType([PropTypes__default.arrayOf(PropTypes__default.node), PropTypes__default.node]),
  properties: PropTypes__default.shape({
    // Size of the component when it is placed within a group with multiple components.
    weight: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.object]),
    width: PropTypes__default.oneOf(Object.values(HeightAndWidthTypes)),
    height: PropTypes__default.oneOf(Object.values(HeightAndWidthTypes)),
    contentWidth: responsivePropType(PropTypes__default.number),
    contentHeight: responsivePropType(PropTypes__default.number),
    cornerRadius: PropTypes__default.oneOf(Object.values(CornerRadius)),
    applyCornerRadius: PropTypes__default.bool,
    action: actionPropType,
    // Temporary undocumented prop to enable simplified hover zoom. Can be string "true" if coming through container props.
    hoverZoomContainer: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.string])
  }),
  actions: actionsPropType,
  context: PropTypes__default.object
};

var _DefaultBaseComponent, _extends3;
var ComponentType = {
  Container: 'CONTAINER',
  ListContainers: 'LIST_CONTAINERS',
  ContainerCollection: 'CONTAINER_COLLECTION',
  PaginationIndicator: 'PAGINATION_INDICATOR',
  Slider: 'SLIDER',
  Grid: 'GRID',
  Group: 'GROUP',
  Stack: 'STACK',
  Text: 'TEXT',
  Button: 'BUTTON',
  Image: 'IMAGE',
  Icon: 'ICON',
  MultiView: 'MULTI_VIEW',
  ProgressBar: 'PROGRESS_BAR'
};
var DefaultBaseComponents = (_DefaultBaseComponent = {}, _defineProperty(_DefaultBaseComponent, ComponentType.Text, function (_ref) {
  var textClasses = _ref.textClasses,
    translations = _ref.translations,
    translate = _ref.translate;
  return TextFactory(textClasses, translations, translate);
}), _defineProperty(_DefaultBaseComponent, ComponentType.Image, function (_ref2) {
  var rootElement = _ref2.rootElement;
  return ImageFactory(rootElement);
}), _defineProperty(_DefaultBaseComponent, ComponentType.Button, function (_ref3) {
  var ButtonBase = _ref3.ButtonBase,
    IconBase = _ref3.IconBase,
    textClasses = _ref3.textClasses,
    translations = _ref3.translations,
    translate = _ref3.translate;
  return ButtonFactory(ButtonBase, IconBase, textClasses, translations, translate);
}), _defineProperty(_DefaultBaseComponent, ComponentType.Icon, function (_ref4) {
  var IconBase = _ref4.IconBase,
    parentalSystem = _ref4.parentalSystem;
  return IconFactory(IconBase, parentalSystem);
}), _defineProperty(_DefaultBaseComponent, ComponentType.Stack, function () {
  return Stack;
}), _defineProperty(_DefaultBaseComponent, ComponentType.Group, function () {
  return Group$1;
}), _defineProperty(_DefaultBaseComponent, ComponentType.ProgressBar, function () {
  return ProgressBar;
}), _DefaultBaseComponent);
var DefaultPageComponents = _extends$3({}, DefaultBaseComponents, _defineProperty({}, ComponentType.ContainerCollection, function (_ref5) {
  var renderer = _ref5.renderer;
  return ContainerCollectionFactory(renderer);
}));
var DefaultContainerComponents = _extends$3({}, DefaultBaseComponents, (_extends3 = {}, _defineProperty(_extends3, ComponentType.Grid, function (_ref6) {
  var renderer = _ref6.renderer,
    IconBase = _ref6.IconBase,
    fetchSliderPage = _ref6.fetchSliderPage,
    rootElement = _ref6.rootElement;
  return GridFactory(renderer, IconBase, fetchSliderPage, rootElement);
}), _defineProperty(_extends3, ComponentType.Slider, function (_ref7) {
  var renderer = _ref7.renderer,
    IconBase = _ref7.IconBase,
    fetchSliderPage = _ref7.fetchSliderPage,
    rootElement = _ref7.rootElement;
  return SliderFactory(renderer, IconBase, fetchSliderPage, rootElement);
}), _defineProperty(_extends3, ComponentType.MultiView, function (_ref8) {
  var renderer = _ref8.renderer,
    IconBase = _ref8.IconBase,
    textClasses = _ref8.textClasses,
    translations = _ref8.translations,
    translate = _ref8.translate,
    fetchSliderPage = _ref8.fetchSliderPage;
  return MultiViewFactory(renderer, IconBase, textClasses, translations, translate, fetchSliderPage);
}), _extends3));
var DefaultItemComponents = DefaultBaseComponents;

var _excluded$1 = ["templates", "template", "v2Templates", "formFactorTemplateProperties"];
var parseTemplate = function parseTemplate(cb) {
  return function (opts) {
    var formFactor = opts.formFactor,
      formFactorTemplates = opts.formFactorTemplates,
      v2Templates = opts.v2Templates;
    if (!formFactorTemplates[formFactor]) {
      throw new Error("no template found for ".concat(formFactor));
    }
    if (v2Templates) {
      // v2 API
      var id = formFactorTemplates[formFactor].id;
      if (!id || !v2Templates[id]) {
        throw new Error("no template found with ID ".concat(id));
      }
      cb(v2Templates[id]);
      return;
    }

    // v1 API + form-factor filter
    cb(formFactorTemplates[formFactor]);
  };
};
var inheritFormFactorTemplateProperties = function inheritFormFactorTemplateProperties(cb) {
  return function (opts) {
    var formFactor = opts.formFactor,
      formFactorTemplates = opts.formFactorTemplates,
      inheritedFormFactorTemplateProperties = opts.inheritedFormFactorTemplateProperties;
    if (!formFactorTemplates[formFactor]) {
      throw new Error("no template found for ".concat(formFactor));
    }
    var formFactorTemplateProperties = formFactorTemplates[formFactor].properties;
    cb(_extends$3({}, inheritedFormFactorTemplateProperties, formFactorTemplateProperties));
  };
};
var withTemplateParsing = function withTemplateParsing(Component, formFactor, v2Templates) {
  var TemplateParser = function TemplateParser(_ref) {
    var formFactorTemplates = _ref.templates,
      v1Template = _ref.template,
      _v2Templates = _ref.v2Templates,
      formFactorTemplateProperties = _ref.formFactorTemplateProperties,
      rest = _objectWithoutProperties(_ref, _excluded$1);
    var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      parsedTemplate = _useState2[0],
      setParsedTemplate = _useState2[1];
    var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      inheritedFormFactorTemplateProperties = _useState4[0],
      setInheritedFormFactorTemplateProperties = _useState4[1];
    useEffect(function () {
      if (v1Template) {
        setParsedTemplate(v1Template);
      } else {
        parseTemplate(setParsedTemplate)({
          formFactor: formFactor,
          formFactorTemplates: formFactorTemplates,
          v2Templates: _v2Templates || v2Templates
        });
      }
    }, [formFactorTemplates, v1Template, _v2Templates]);
    useEffect(function () {
      if (formFactorTemplates) {
        inheritFormFactorTemplateProperties(setInheritedFormFactorTemplateProperties)({
          formFactor: formFactor,
          formFactorTemplates: formFactorTemplates,
          inheritedFormFactorTemplateProperties: formFactorTemplateProperties
        });
      } else {
        setInheritedFormFactorTemplateProperties(formFactorTemplateProperties || {});
      }
    }, [formFactorTemplates, formFactorTemplateProperties]);
    if (!parsedTemplate || !inheritedFormFactorTemplateProperties) {
      return null;
    }
    return /*#__PURE__*/React__default.createElement(Component, _extends$3({
      formFactorTemplateProperties: inheritedFormFactorTemplateProperties,
      template: parsedTemplate,
      v2Templates: _v2Templates || v2Templates
    }, rest, {
      "data-cy": "Builder_withTemplateParsing_Component"
    }));
  };
  TemplateParser.propTypes = {
    templates: PropTypes__default.object,
    template: PropTypes__default.object,
    v2Templates: PropTypes__default.object,
    formFactorTemplateProperties: PropTypes__default.object
  };
  TemplateParser.displayName = "withTemplateParser(".concat(Component.displayName || 'COMPONENT_HAS_NO_NAME', ")");
  return TemplateParser;
};

var _excluded = ["id", "component", "formFactorTemplateProperties", "context", "ratio", "tabIndex", "aria-label"],
  _excluded2 = ["type", "children", "properties"],
  _excluded3 = ["template", "v2Templates", "formFactorTemplateProperties", "context", "data-dyn"];
var TemplateContextKey = {
  Page: 'page',
  Container: 'container'
};
var sharedPropTypes = {
  className: PropTypes__default.string,
  context: PropTypes__default.shape({
    translations: PropTypes__default.object,
    user: PropTypes__default.object,
    params: PropTypes__default.object,
    item: PropTypes__default.object
  }),
  actions: PropTypes__default.shape({
    // function that takes an event string.
    onEvent: PropTypes__default.func
  }),
  options: PropTypes__default.shape({})
};

// root context passed to the Page component by the Client
var rootContext;
var TemplateRenderFactory = function TemplateRenderFactory(componentMap, formFactor, v2Templates, templateContextKey, rootElement) {
  var ComponentRenderer = function ComponentRenderer(_ref) {
    var _rootContext;
    _ref.id;
      var component = _ref.component,
      formFactorTemplateProperties = _ref.formFactorTemplateProperties,
      context = _ref.context;
      _ref.ratio;
      _ref.tabIndex;
      var ariaLabel = _ref['aria-label'],
      rest = _objectWithoutProperties(_ref, _excluded);
    // if the root context has an item, we are on a details page.
    context.isDetailsPage = !!((_rootContext = rootContext) !== null && _rootContext !== void 0 && _rootContext.item);
    if (!component || !isVisible(component, context)) {
      return null;
    }
    var type = component.type,
      _component$children = component.children,
      children = _component$children === void 0 ? [] : _component$children,
      _component$properties = component.properties,
      componentProperties = _component$properties === void 0 ? {} : _component$properties,
      restOfComponent = _objectWithoutProperties(component, _excluded2);
    var action = componentProperties.action;
    var aria = {
      'aria-label': ariaLabel,
      tabIndex: action ? 0 : -1,
      role: action ? 'button' : null
    };
    var Component = componentMap[type];
    if (!Component) {
      console.error('Unsupported component type', type);
      return null;
    }
    var properties = _extends$3({}, formFactorTemplateProperties, componentProperties);
    var commonProps = {
      formFactorTemplateProperties: formFactorTemplateProperties,
      context: context
    };
    return /*#__PURE__*/React__default.createElement(Component, _extends$3({
      type: type
    }, rest, _extends$3({}, restOfComponent, {
      properties: properties
    }), aria, commonProps, {
      "data-cy": "Builder_TemplateRenderFactory_Component"
    }), children.map(function (child, index) {
      return /*#__PURE__*/React__default.createElement(ComponentRenderer, _extends$3({
        component: child,
        key: child.id || index
      }, commonProps, rest, {
        "data-cy": "Builder_TemplateRenderFactory_ComponentRenderer"
      }));
    }));
  };
  ComponentRenderer.displayName = 'ComponentRenderer';
  ComponentRenderer.propTypes = _extends$3({}, sharedPropTypes, {
    component: PropTypes__default.object
  });
  var TemplateRenderer = function TemplateRenderer(_ref2) {
    var _rootContext2;
    var _ref2$template = _ref2.template,
      _ref2$template2 = _ref2$template === void 0 ? {} : _ref2$template,
      component = _ref2$template2.component,
      aspectRatio = _ref2$template2.aspectRatio,
      _ref2$template2$aspec = _ref2$template2.aspectRatios,
      aspectRatios = _ref2$template2$aspec === void 0 ? {} : _ref2$template2$aspec,
      _ref2$v2Templates = _ref2.v2Templates,
      _v2Templates = _ref2$v2Templates === void 0 ? v2Templates : _ref2$v2Templates,
      formFactorTemplateProperties = _ref2.formFactorTemplateProperties,
      context = _ref2.context,
      dataDyn = _ref2['data-dyn'],
      rest = _objectWithoutProperties(_ref2, _excluded3);
    // if we are a page renderer, let's remember the root context.
    if (templateContextKey === TemplateContextKey.Page) {
      rootContext = context;
    }
    // if the root context has an item, we are on a details page.
    context.isDetailsPage = !!((_rootContext2 = rootContext) !== null && _rootContext2 !== void 0 && _rootContext2.item);
    var extendedContext = templateContextKey ? _extends$3({}, context, _defineProperty({}, templateContextKey, _extends$3({}, context === null || context === void 0 ? void 0 : context[templateContextKey], formFactorTemplateProperties))) : context || {};
    if (!component) {
      return null;
    }
    var componentRendererProps = _extends$3({
      component: component,
      formFactor: formFactor,
      v2Templates: _v2Templates,
      formFactorTemplateProperties: formFactorTemplateProperties,
      context: extendedContext,
      rootElement: rootElement
    }, rest);
    var databoundAspectRatio = applyDatabinding({
      // TODO: make the aspect ratio selection based on breakpoint
      value: aspectRatio || aspectRatios.xxl,
      context: extendedContext
    });
    if (!databoundAspectRatio) {
      return /*#__PURE__*/React__default.createElement(ComponentRenderer, _extends$3({}, componentRendererProps, {
        "data-cy": "Builder_TemplateRenderFactory_ComponentRenderer"
      }));
    }

    /**
     * AspectRatio will use absolute positioning so any cornerRadius applied on parent will be lost.
     * Apply same cornerRadius again on AspectRatio to maintain cornerRadius.
     * Component will apply its own cornerRadius if present, which may or may not be same as parent.
     */
    var cornerRadiusRem = cornerRadiiRem[formFactorTemplateProperties === null || formFactorTemplateProperties === void 0 ? void 0 : formFactorTemplateProperties.cornerRadius] || 0;
    return /*#__PURE__*/React__default.createElement(AspectRatio, {
      aspectRatio: databoundAspectRatio,
      cornerRadiusRem: cornerRadiusRem,
      "data-dyn": dataDyn,
      "data-cy": "Builder_TemplateRenderFactory_AspectRatio"
    }, /*#__PURE__*/React__default.createElement(ComponentRenderer, _extends$3({}, componentRendererProps, {
      "data-cy": "Builder_TemplateRenderFactory_ComponentRenderer"
    })));
  };
  TemplateRenderer.displayName = 'TemplateRenderer';
  TemplateRenderer.propTypes = _extends$3({}, sharedPropTypes, {
    template: PropTypes__default.shape({
      component: PropTypes__default.object
    })
  });
  return withTemplateParsing(TemplateRenderer, formFactor, v2Templates);
};

var buildComponents = function buildComponents(components, options) {
  return Object.keys(components).reduce(function (result, key) {
    result[key] = components[key](options);
    return result;
  }, {});
};
var defaultFetchSliderPage = function defaultFetchSliderPage() {
  console.error('No fetcher provided. Set it with `Builder.setFetchSliderPage`.');
  return Promise.resolve({
    collection: {
      id: ''
    },
    data: [],
    pageInfo: {
      total: 0,
      hasMore: false,
      page: 1,
      pageSize: 20
    }
  });
};

/**
 * Builds high level dynamic ui components.
 *
 * const DynamicUi = new OneDynamicUiBuilder({ ... })
 *  .setPageComponents({ ... })
 *  .setContainerComponents({ ... })
 *  .setItemComponents({ ... })
 *  .build();
 */
var Builder = /*#__PURE__*/function () {
  function Builder() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      templateRenderFactory = _ref.templateRenderFactory;
    _classCallCheck(this, Builder);
    this.templateRenderFactory = templateRenderFactory || TemplateRenderFactory;
    this.pageComponents = DefaultPageComponents;
    this.containerComponents = DefaultContainerComponents;
    this.itemComponents = DefaultItemComponents;
    this.iconBase = DefaultIcon;
    this.fontConfig = undefined;
    this.translations = undefined;
    this.translate = undefined;
    this.parentalSystem = undefined;
    this.fetchSliderPage = defaultFetchSliderPage;
    this.formFactor = FormFactor.Desktop;
    this.fontScaleOptions = defaultFontScaleOptions;
    this.v2Templates = undefined;
    this.rootElement = document;
  }

  /**
   * Set a map between component type name and the component's Factory
   *
   * Set the map of page component types.
   *
   * @param {*} components a map where key is the component type enum and the value is a Component Factory.
   * The Factory receives an option object with the "renderer"(in this case the container template renderer), "buttonBase" and "iconBase".
   */
  _createClass(Builder, [{
    key: "setPageComponents",
    value: function setPageComponents(components) {
      this.pageComponents = components;
      return this;
    }
  }, {
    key: "setContainerComponents",
    value: function setContainerComponents(components) {
      this.containerComponents = components;
      return this;
    }
  }, {
    key: "setItemComponents",
    value: function setItemComponents(components) {
      this.itemComponents = components;
      return this;
    }
  }, {
    key: "addPageComponents",
    value: function addPageComponents(components) {
      Object.assign(this.pageComponents, components);
      return this;
    }
  }, {
    key: "addContainerComponents",
    value: function addContainerComponents(components) {
      Object.assign(this.containerComponents, components);
      return this;
    }
  }, {
    key: "addItemComponents",
    value: function addItemComponents(components) {
      Object.assign(this.itemComponents, components);
      return this;
    }
  }, {
    key: "setButtonBase",
    value: function setButtonBase(ButtonBase) {
      this.buttonBase = ButtonBase;
      return this;
    }
  }, {
    key: "setIconBase",
    value: function setIconBase(IconBase) {
      this.iconBase = IconBase;
      return this;
    }
  }, {
    key: "setFontConfig",
    value: function setFontConfig(fontConfig) {
      this.fontConfig = fontConfig;
      return this;
    }
  }, {
    key: "setTranslations",
    value: function setTranslations(translations) {
      this.translations = translations;
      return this;
    }
  }, {
    key: "setTranslationMethod",
    value: function setTranslationMethod(translate) {
      this.translate = translate;
      return this;
    }
  }, {
    key: "setParentalSystem",
    value: function setParentalSystem(parentalSystem) {
      this.parentalSystem = parentalSystem;
      return this;
    }
  }, {
    key: "setFetchSliderPage",
    value: function setFetchSliderPage(fetchSliderPage) {
      this.fetchSliderPage = fetchSliderPage;
      return this;
    }
  }, {
    key: "setFormFactor",
    value: function setFormFactor(formFactor) {
      this.formFactor = formFactor;
      return this;
    }
  }, {
    key: "setFontScaleOptions",
    value: function setFontScaleOptions(fontScaleOptions) {
      this.fontScaleOptions = fontScaleOptions;
      return this;
    }
  }, {
    key: "setV2Templates",
    value: function setV2Templates(v2Templates) {
      this.v2Templates = v2Templates;
      return this;
    }
  }, {
    key: "setRootElement",
    value: function setRootElement(rootElement) {
      this.rootElement = rootElement;
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      var baseOptions = {
        ButtonBase: this.buttonBase,
        IconBase: this.iconBase,
        translations: this.translations,
        translate: this.translate,
        textClasses: this.fontConfig && parseTextClasses(this.fontConfig, this.fontScaleOptions[this.formFactor]),
        parentalSystem: this.parentalSystem,
        fetchSliderPage: this.fetchSliderPage,
        rootElement: this.rootElement
      };
      // Builds the template renderer which we can inject to our Item Factory.
      var itemTemplateRenderer = this.templateRenderFactory(buildComponents(this.itemComponents, baseOptions));
      itemTemplateRenderer.displayName = 'ItemTemplateRenderer';
      var itemRenderer = ItemFactory(itemTemplateRenderer);
      itemRenderer.displayName = 'ItemRenderer';
      var containerRenderer = this.templateRenderFactory(buildComponents(this.containerComponents, _extends$3({}, baseOptions, {
        renderer: itemRenderer
      })), this.formFactor, this.v2Templates);
      containerRenderer.displayName = 'ContainerRenderer';
      var itemAndContainerRenderer = this.templateRenderFactory(buildComponents(this.containerComponents, _extends$3({}, baseOptions, {
        renderer: containerRenderer
      })), this.formFactor, this.v2Templates, TemplateContextKey.Container);
      itemAndContainerRenderer.displayName = 'ItemAndContainerRenderer';
      var pageRenderer = this.templateRenderFactory(buildComponents(this.pageComponents, _extends$3({}, baseOptions, {
        renderer: itemAndContainerRenderer
      })), this.formFactor, this.v2Templates, TemplateContextKey.Page);
      pageRenderer.displayName = 'PageRenderer';
      return {
        Page: pageRenderer,
        Container: itemAndContainerRenderer,
        Item: itemRenderer
      };
    }
  }]);
  return Builder;
}();

var inherits = createCommonjsModule(function (module) {
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _inherits = unwrapExports(inherits);

var assertThisInitialized = createCommonjsModule(function (module) {
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(assertThisInitialized);

var possibleConstructorReturn = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _possibleConstructorReturn = unwrapExports(possibleConstructorReturn);

var getPrototypeOf = createCommonjsModule(function (module) {
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _getPrototypeOf = unwrapExports(getPrototypeOf);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var initialState = {
  error: null,
  info: null
};
var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inherits(ErrorBoundary, _Component);
  var _super = _createSuper(ErrorBoundary);
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _super.call(this, props);
    _this.state = initialState;
    return _this;
  }
  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      var onError = this.props.onError;
      if (isFunction$1(onError)) {
        onError.call(this, error, info ? info.componentStack : '');
      }
      this.setState({
        error: error,
        info: info
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      // if the re-render key changed, let's reset the error and let the children re-render.
      // this is for dismissing the error after the user did something, like logged in, navigated away, etc.
      var hasError = Boolean(this.state.error);
      var prevKey = this.props.rerenderKey;
      var nextKey = nextProps.rerenderKey;
      if (hasError && prevKey !== nextKey) {
        this.setState(initialState);
      }
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        FallbackComponent = _this$props.FallbackComponent;
      var _this$state = this.state,
        error = _this$state.error,
        info = _this$state.info;
      if (error !== null) {
        return FallbackComponent ? /*#__PURE__*/React__default.createElement(FallbackComponent, {
          componentStack: info ? info.componentStack : '',
          error: error,
          "data-cy": "ErrorBoundary_ErrorBoundary_FallbackComponent"
        }) : null;
      }
      return children || null;
    }
  }]);
  return ErrorBoundary;
}(Component);
ErrorBoundary.propTypes = {
  children: PropTypes__default.element,
  FallbackComponent: PropTypes__default.func,
  rerenderKey: PropTypes__default.string,
  onError: PropTypes__default.func
};
ErrorBoundary.displayName = 'ErrorBoundary';

export { ActionDestinationTypes, ActionKind, ActionTypes, Alignment, AuthView, Builder, Button, ConditionTypes, ContentModes, CornerRadius, DefaultBaseComponents, DefaultContainerComponents, DefaultItemComponents, DefaultPageComponents, Directions, ErrorBoundary, FontSizesRem, FormattingTypes, GravityTypes, GridFactory, GridItem, GutterSize, HeightAndWidthTypes, DefaultIcon as Icon, IconFactory, IconPositions, IconSize, IconSizesRem, IconStyles, IconSubTypes, ImageFactory, MediaType, Placeholder, Positions, ScrollDetector, ScrollDetectorPosition, SizeTypes, SliderFactory, Spinner, TemplateContextKey, alignmentMap, appendQueryParameters, applyDatabinding, classNames, cloneDeep_1 as cloneDeep, convertBindingToKeyPath, convertLiteralValue, cornerRadiiRem, createItemPlaceholders, dataDyn, databindObject, evaluateByType, evaluateCondition, eventHandlers, exists, filterAriaProperties, filterProperties, formatDuration, formatValue, fromRgbaHexToRgba, fromRgbaToHex, generalUtils, get, getCornerRadiusRem, getItemTemplate, getMappedViewSize, getTemplateValue, gradientDirectionMap, gravityMap, growthMap, gutterSizesRem, isTypeViewSize, isValidHexColor, isValidRgb, isVisible, rem, remToPx, setSizes, themeColor, useIntersection, viewSizeMap, withDataType };
//# sourceMappingURL=index.es.js.map
